export const BarangayList = [
    // { province: "Abra", city: "Bangued", barangayList: [] },
    // { province: "Abra", city: "Boliney", barangayList: [] },
    // { province: "Abra", city: "Bucay", barangayList: [] },
    // { province: "Abra", city: "Bucloc", barangayList: [] },
    // { province: "Abra", city: "Daguioman", barangayList: [] },
    // { province: "Abra", city: "Danglas", barangayList: [] },
    // { province: "Abra", city: "Dolores", barangayList: [] },
    // { province: "Abra", city: "La Paz", barangayList: [] },
    // { province: "Abra", city: "Lacub", barangayList: [] },
    // { province: "Abra", city: "Lagangilang", barangayList: [] },
    // { province: "Abra", city: "Lagayan", barangayList: [] },
    // { province: "Abra", city: "Langiden", barangayList: [] },
    // { province: "Abra", city: "Licuan-Baay (Licuan)", barangayList: [] },
    // { province: "Abra", city: "Luba", barangayList: [] },
    // { province: "Abra", city: "Malibcong", barangayList: [] },
    // { province: "Abra", city: "Manabo", barangayList: [] },
    // { province: "Abra", city: "Peñarrubia", barangayList: [] },
    // { province: "Abra", city: "Pidigan", barangayList: [] },
    // { province: "Abra", city: "Pilar", barangayList: [] },
    // { province: "Abra", city: "Sallapadan", barangayList: [] },
    // { province: "Abra", city: "San Isidro", barangayList: [] },
    // { province: "Abra", city: "San Juan", barangayList: [] },
    // { province: "Abra", city: "San Quintin", barangayList: [] },
    // { province: "Abra", city: "Tayum", barangayList: [] },
    // { province: "Abra", city: "Tineg", barangayList: [] },
    // { province: "Abra", city: "Tubo", barangayList: [] },
    // { province: "Abra", city: "Villaviciosa", barangayList: [] },
    // { province: "Agusan del Norte", city: "Buenavista", barangayList: [] },
    // { province: "Agusan del Norte", city: "Butuan", barangayList: [] },
    // { province: "Agusan del Norte", city: "Cabadbaran", barangayList: [] },
    // { province: "Agusan del Norte", city: "Carmen", barangayList: [] },
    // { province: "Agusan del Norte", city: "Jabonga", barangayList: [] },
    // { province: "Agusan del Norte", city: "Kitcharao", barangayList: [] },
    // { province: "Agusan del Norte", city: "Las Nieves", barangayList: [] },
    // { province: "Agusan del Norte", city: "Magallanes", barangayList: [] },
    // { province: "Agusan del Norte", city: "Nasipit", barangayList: [] },
    // { province: "Agusan del Norte", city: "Remedios T. Romualdez", barangayList: [] },
    // { province: "Agusan del Norte", city: "Santiago", barangayList: [] },
    // { province: "Agusan del Norte", city: "Tubay", barangayList: [] },
    { province: "Agusan del Sur", city: "Bayugan", barangayList: [
        "Berseba", "Bucac", "Cagbas", "Calaitan", "Canayugan", "Charito", "Claro Cortez", "Fili", "Gamao", "Getsemane",
        "Grace Estate", "Hamogaway", "Katipunan", "Mabuhay", "Magkiangkang", "Mahayag", "Marcelina", "Maygatasan", "Montivesta",
        "Mt. Ararat", "Mt. Carmel", "Mt. Olive", "New Salem", "Noli", "Osmeña", "Panaytay", "Pinagalaan", "Poblacion",
        "Sagmone", "Saguma", "Salvacion", "San Agustin", "San Isidro", "San Juan", "Santa Irene", "Santa Teresita",
        "Santo Niño", "Taglatawan", "Taglibas", "Tagubay", "Verdu", "Villa Undayon", "Wawa",
    ] },
    { province: "Agusan del Sur", city: "Bunawan", barangayList: [
        "Bunawan Brook", "Consuelo", "Imelda", "Libertad", "Mambalili", "Nueva Era", "Poblacion", "San Andres", "San Marcos", "San Teodoro",
    ] },
    { province: "Agusan del Sur", city: "Esperanza", barangayList: [
        "Agsabu", "Aguinaldo", "Anolingan", "Bakingking", "Balubo", "Bentahon", "Bunaguit", "Catmonon", "Cebulan", "Concordia",
        "Crossing Luna", "Cubo", "Dakutan", "Duangan", "Guadalupe", "Guibonon", "Hawilian", "Kalabuan", "Kinamaybay", "Labao",
        "Langag", "Maasin", "Mac-Arthur", "Mahagcot", "Maliwanag", "Milagros", "Nato", "New Gingoog", "Odiong", "Oro", "Piglawigan",
        "Poblacion", "Remedios", "Salug", "San Isidro", "San Jose", "San Toribio", "San Vicente", "Santa Fe", "Segunda",
        "Sinakungan", "Tagabase", "Taganahaw", "Tagbalili", "Tahina", "Tandang Sora", "Valentina",
    ] },
    { province: "Agusan del Sur", city: "La Paz", barangayList: [
        "Angeles", "Bataan", "Comota", "Halapitan", "Kasapa II", "Langasian", "Lydia", "Osmeña, Sr.", "Panagangan",
        "Poblacion", "Sabang Adgawan", "Sagunto", "San Patricio", "Valentina", "Villa Paz",
    ] },
    { province: "Agusan del Sur", city: "Loreto", barangayList: [
        "Binucayan", "Johnson", "Kasapa", "Katipunan", "Kauswagan", "Magaud", "Nueva Gracia", "Poblacion", "Sabud", "San Isidro",
        "San Mariano", "San Vicente", "Santa Teresa", "Santo Niño", "Santo Tomas", "Violanta", "Waloe",
    ] },
    { province: "Agusan del Sur", city: "Prosperidad", barangayList: [
        "Aurora", "Awa", "Azpetia", "La Caridad", "La Perian", "La Purisima", "La Suerte", "La Union", "Las Navas",
        "Libertad", "Los Arcos", "Lucena", "Mabuhay", "Magsaysay", "Mapaga", "Napo", "New Maug", "Patin-ay",
        "Poblacion (Bahbah)", "Salimbogaon", "Salvacion", "San Joaquin", "San Jose", "San Lorenzo", "San Martin",
        "San Pedro", "San Rafael", "San Roque", "San Salvador", "San Vicente", "Santa Irene", "Santa Maria",
    ] },
    { province: "Agusan del Sur", city: "Rosario", barangayList: [
        "Bayugan 3", "Cabantao", "Cabawan", "Libuac", "Maligaya", "Marfil", "Novele", "Poblacion", "Santa Cruz",
        "Tagbayagan", "Wasi-an",
    ] },
    { province: "Agusan del Sur", city: "San Francisco", barangayList: [
        "Alegria", "Barangay 1 (Poblacion)", "Barangay 2 (Poblacion)", "Barangay 3 (Poblacion)", "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)", "Bayugan 2", "Bitan-agan", "Borbon", "Buenasuerte", "Caimpugan", "Das-agan",
        "Ebro", "Hubang", "Karaus", "Ladgadan", "Lapinigan", "Lucac", "Mate", "New Visayas", "Ormaca", "Pasta",
        "Pisa-an", "Rizal", "San Isidro", "Santa Ana", "Tagapua",
    ] },
    // { province: "Agusan del Sur", city: "San Luis", barangayList: [] },
    // { province: "Agusan del Sur", city: "Santa Josefa", barangayList: [] },
    // { province: "Agusan del Sur", city: "Sibagat", barangayList: [] },
    // { province: "Agusan del Sur", city: "Talacogon", barangayList: [] },
    // { province: "Agusan del Sur", city: "Trento", barangayList: [] },
    // { province: "Agusan del Sur", city: "Veruela", barangayList: [] },
    { province: "Aklan", city: "Altavas", barangayList: [
        "Cabangila","Cabugao","Catmon","Dalipdip","Ginictan","Linayasan","Lumaynay","Lupo","Man-up","Odiong","Poblacion",
        "Quinasay-an","Talon","Tibiao",
    ] },
    { province: "Aklan", city: "Balete", barangayList: [
        "Aranas","Arcangel","Calizo","Cortes","Feliciano","Fulgencio","Guanko","Morales","Oquendo","Poblacion",
    ] },
    { province: "Aklan", city: "Banga", barangayList: [
        "Agbanawan","Bacan","Badiangan","Cerrudo","Cupang","Daguitan","Daja Norte","Daja Sur","Dingle","Jumarap",
        "Lapnag","Libas","Linabuan Sur","Mambog","Mangan","Muguing","Pagsanghan","Palale","Poblacion","Polo",
        "Polocate","San Isidro","Sibalew","Sigcay","Taba-ao","Tabayon","Tinapuay","Torralba","Ugsod","Venturanza",
    ] },
    { province: "Aklan", city: "Batan", barangayList: [
        "Ambolong","Angas","Bay-ang","Cabugao","Caiyang","Camaligan","Camanci","Ipil","Lalab","Lupit","Magpag-ong",
        "Magubahay","Mambuquiao","Man-up","Mandong","Napti","Palay","Poblacion","Songcolan","Tabon",
    ] },
    { province: "Aklan", city: "Buruanga", barangayList: [
        "Alegria","Bagongbayan","Balusbos","Bel-is","Cabugan","El Progreso","Habana","Katipunan","Mayapay","Nazareth",
        "Panilongan","Poblacion","Santander","Tag-osip","Tigum",
    ] },
    { province: "Aklan", city: "Ibajay", barangayList: [
        "Agbago","Agdugayan","Antipolo","Aparicio","Aquino","Aslum","Bagacay","Batuan","Buenavista","Bugtongbato",
        "Cabugao","Capilijan","Colongcolong","Laguinbanua","Mabusao","Malindog","Maloco","Mina-a","Monlaque",
        "Naile","Naisud","Naligusan","Ondoy","Poblacion","Polo","Regador","Rivera","Rizal","San Isidro","San Jose",
        "Santa Cruz","Tagbaya","Tul-ang","Unat","Yawan",
    ] },
    { province: "Aklan", city: "Kalibo", barangayList: [
        "Andagao","Bachaw Norte","Bachaw Sur","Briones","Buswang New","Buswang Old","Caano","Estancia","Linabuan Norte",
        "Mabilo","Mobo","Nalook","Poblacion","Pook","Tigayon","Tinigaw",
    ] },
    { province: "Aklan", city: "Lezo", barangayList: [
        "Agcawilan","Bagto","Bugasongan","Carugdog","Cogon","Ibao","Mina","Poblacion","Santa Cruz","Santa Cruz Bigaa",
        "Silakat-Nonok","Tayhawan",
    ] },
    { province: "Aklan", city: "Libacao", barangayList: [
        "Agmailig","Alfonso XII","Batobato","Bonza","Calacabian","Calamcan","Can-Awan","Casit-an","Dalagsa-an",
        "Guadalupe","Janlud","Julita","Luctoga","Magugba","Manika","Ogsip","Ortega","Oyang","Pampango","Pinonoy",
        "Poblacion","Rivera","Rosal","Sibalew",
    ] },
    { province: "Aklan", city: "Madalag", barangayList: [
        "Alaminos","Alas-as","Bacyang","Balactasan","Cabangahan","Cabilawan","Catabana","Dit-Ana","Galicia","Guinatu-an",
        "Logohon","Mamba","Maria Cristina","Medina","Mercedes","Napnot","Pang-itan","Paningayan","Panipiason",
        "Poblacion","San Jose","Singay","Talangban","Talimagao","Tigbawan",
    ] },
    { province: "Aklan", city: "Makato", barangayList: [
        "Agbalogo","Aglucay","Alibagon","Bagong Barrio","Baybay","Cabatanga","Cajilo","Calangcang","Calimbajan",
        "Castillo","Cayangwan","Dumga","Libang","Mantiguib","Poblacion","Tibiawan","Tina","Tugas",
    ] },
    { province: "Aklan", city: "Malay", barangayList: [
        "Argao","Balabag","Balusbus","Cabulihan","Caticlan","Cogon","Cubay Norte","Cubay Sur","Dumlog","Manoc-Manoc",
        "Motag","Naasog","Nabaoy","Napaan","Poblacion","Sambiray","Yapak",
    ] },
    { province: "Aklan", city: "Malinao", barangayList: [
        "Banaybanay","Biga-a","Bulabud","Cabayugan","Capataga","Cogon","Dangcalan","Kinalangay Nuevo","Kinalangay Viejo",
        "Lilo-an","Malandayon","Manhanip","Navitas","Osman","Poblacion","Rosario","San Dimas","San Ramon","San Roque",
        "Sipac","Sugnod","Tambuan","Tigpalas",
    ] },
    { province: "Aklan", city: "Nabas", barangayList: [
        "Alimbo-Baybay","Buenafortuna","Buenasuerte","Buenavista","Gibon","Habana","Laserna","Libertad","Magallanes",
        "Matabana","Nagustan","Pawa","Pinatuad","Poblacion","Rizal","Solido","Tagororoc","Toledo","Unidos","Union",
    ] },
    { province: "Aklan", city: "New Washington", barangayList: [
        "Candelaria","Cawayan","Dumaguit","Fatima","Guinbaliwan","Jalas","Jugas","Lawa-an","Mabilo","Mataphao",
        "Ochando","Pinamuk-an","Poblacion","Polo","Puis","Tambak",
    ] },
    { province: "Aklan", city: "Numancia", barangayList: [
        "Albasan","Aliputos","Badio","Bubog","Bulwang","Camanci Norte","Camanci Sur","Dongon East","Dongon West",
        "Joyao-Joyao","Laguinbanua East","Laguinbanua West","Marianos","Navitas","Poblacion","Pusiw","Tabangka",
    ] },
    { province: "Aklan", city: "Tangalan", barangayList: [
        "Afga","Baybay","Dapdap","Dumatad","Jawili","Lanipga","Napatag","Panayakan","Poblacion","Pudiot","Tagas",
        "Tamalagon","Tamokoe","Tondog","Vivo",
    ] },
    { province: "Albay", city: "Bacacay", barangayList: [
        "Baclayon","Banao","Barangay 1 (Poblacion)","Barangay 2 (Poblacion)","Barangay 3 (Poblacion)","Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)","Barangay 6 (Poblacion)","Barangay 7 (Poblacion)","Barangay 8 (Poblacion)",
        "Barangay 9 (Poblacion)","Barangay 10 (Poblacion)","Barangay 11 (Poblacion)","Barangay 12 (Poblacion)",
        "Barangay 13 (Poblacion)","Barangay 14 (Poblacion)","Bariw","Basud","Bayandong","Bonga (Upper)","Buang",
        "Busdac (San Jose)","Cabasan","Cagbulacao","Cagraray","Cajogutan","Cawayan","Damacan","Gubat Ilawod",
        "Gubat Iraya","Hindi","Igang","Langaton","Manaet","Mapulang Daga","Mataas","Misibis","Nahapunan","Namanday",
        "Namantao","Napao","Panarayon","Pigcobohan","Pili Ilawod","Pili Iraya","Pongco (Lower Bonga)","San Pablo",
        "San Pedro","Sogod","Sula","Tambilagao (Tambognon)","Tambongon (Tambilagao)","Tanagan","Uson",
        "Vinisitahan-Basud (Mainland)","Vinisitahan-Napao (Island)",
    ] },
    { province: "Albay", city: "Camalig", barangayList: [
        "Anoling","Baligang","Bantonan","Barangay 1 (Poblacion)","Barangay 2 (Poblacion)","Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)","Barangay 5 (Poblacion)","Barangay 6 (Poblacion)","Barangay 7 (Poblacion)","Bariw",
        "Binanderahan","Binitayan","Bongabong","Cabagñan","Cabraran Pequeño","Caguiba","Calabidongan","Comun",
        "Cotmon","Del Rosario","Gapo","Gotob","Ilawod","Iluluan","Libod","Ligban","Mabunga","Magogon","Manawan",
        "Maninila","Mina","Miti","Palanog","Panoypoy","Pariaan","Quinartilan","Quirangay","Quitinday","Salugan",
        "Solong","Sua","Sumlang","Tagaytay","Tagoytoy","Taladong","Taloto","Taplacon","Tinago","Tumpa",
    ] },
    { province: "Albay", city: "Daraga", barangayList: [
        "Alcala","Alobo","Anislag","Bagumbayan","Balinad","Bañadero","Bañag","Bascaran","Bigao","Binitayan","Bongalon",
        "Budiao","Burgos","Busay","Canarom","Cullat","de la Paz","Dinoronan","Gabawan","Gapo","Ibaugan","Ilawod",
        "Inarado","Kidaco","Kilicao","Kimantong","Kinawitan","Kiwalo","Lacag","Mabini","Malabog","Malobago","Maopi",
        "Market Area","Maroroy","Matnog","Mayon","Mi-isi","Nabasan","Namantao","Pandan","Peñafrancia","Sagpon",
        "Salvacion","San Rafael","San Ramon","San Roque","San Vicente Grande","San Vicente Pequeño","Sipi",
        "Tabon-tabon","Tagas","Talahib","Villahermosa",
    ] },
    { province: "Albay", city: "Guinobatan", barangayList: [
        "Agpay","Balite","Banao","Batbat","Binogsacan Lower","Binogsacan Upper","Bololo","Bubulusan","Calzada",
        "Catomag","Doña Mercedes","Doña Tomasa (Magatol)","Ilawod","Inamnan Grande","Inamnan Pequeño","Inascan",
        "Iraya","Lomacao","Maguiron","Maipon","Malabnig","Malipo","Malobago","Maninila","Mapaco","Marcial O. Rañola (Cabaloaon)",
        "Masarawag","Mauraro","Minto","Morera","Muladbucad Grande","Muladbucad Pequeño","Ongo","Palanas","Poblacion",
        "Pood","Quibongbongan","Quitago","San Francisco","San Jose (Ogsong)","San Rafael","Sinungtan","Tandarora",
        "Travesia",
    ] },
    { province: "Albay", city: "Jovellar", barangayList: [
        "Aurora Poblacion (Barangay 6)","Bagacay","Bautista","Cabraran","Calzada Poblacion (Barangay 7)","Del Rosario",
        "Estrella","Florista","Mabini Poblacion (Barangay 2)","Magsaysay Poblacion (Barangay 4)","Mamlad","Maogog",
        "Mercado Poblacion (Barangay 5)","Plaza Poblacion (Barangay 3)","Quitinday Poblacion (Barangay 8)",
        "Rizal Poblacion (Barangay 1)","Salvacion","San Isidro","San Roque","San Vicente","Sinagaran","Villa Paz",
        "White Deer Poblacion (Barangay 9)",
    ] },
    { province: "Albay", city: "Legazpi City", barangayList: [
        "Barangay 10-Cabugao","Barangay 11-Maoyod Poblacion","Barangay 12-Tula-tula","Barangay 13-Ilawod West Poblacion",
        "Barangay 14-Ilawod Poblacion","Barangay 15-Ilawod East Poblacion","Barangay 16-Kawit-East Washington Drive",
        "Barangay 17-Rizal Street, Ilawod","Barangay 18-Cabagñan West","Barangay 19-Cabagñan","Barangay 1-Em's Barrio",
        "Barangay 20-Cabagñan East","Barangay 21-Binanuahan West","Barangay 22-Binanuahan East","Barangay 23-Imperial Court Subd.",
        "Barangay 24-Rizal Street","Barangay 25-Lapu-lapu","Barangay 26-Dinagaan","Barangay 27-Victory Village South",
        "Barangay 28-Victory Village North","Barangay 29-Sabang","Barangay 2-Em's Barrio South","Barangay 30-Pigcale",
        "Barangay 31-Centro-Baybay","Barangay 32-San Roque","Barangay 33-PNR-Peñaranda St.-Iraya","Barangay 34-Oro Site-Magallanes St.",
        "Barangay 35-Tinago","Barangay 36-Kapantawan","Barangay 37-Bitano","Barangay 38-Gogon","Barangay 39-Bonot",
        "Barangay 3-Em's Barrio East","Barangay 40-Cruzada","Barangay 41-Bogtong","Barangay 42-Rawis","Barangay 43-Tamaoyan",
        "Barangay 44-Pawa","Barangay 45-Dita","Barangay 46-San Joaquin","Barangay 47-Arimbay","Barangay 48-Bagong Abre",
        "Barangay 49-Bigaa","Barangay 4-Sagpon Poblacion","Barangay 50-Padang","Barangay 51-Buyuan","Barangay 52-Matanag",
        "Barangay 53-Bonga","Barangay 54-Mabinit","Barangay 55-Estanza","Barangay 56-Taysan","Barangay 57-Dap-dap",
        "Barangay 58-Buragwis","Barangay 59-Puro","Barangay 5-Sagmin Poblacion","Barangay 60-Lamba","Barangay 61-Maslog",
        "Barangay 62-Homapon","Barangay 63-Mariawa","Barangay 64-Bagacay","Barangay 65-Imalnod","Barangay 66-Banquerohan",
        "Barangay 67-Bariis","Barangay 68-San Francisco","Barangay 69-Buenavista","Barangay 6-Bañadero Poblacion",
        "Barangay 70-Cagbacong","Barangay 7-Baño","Barangay 8-Bagumbayan","Barangay 9-Pinaric",
    ] },
    { province: "Albay", city: "Libon", barangayList: [
        "Alongong","Apud","Bacolod","Bariw","Bonbon","Buga","Bulusan","Burabod","Caguscos","East Carisac","Harigue",
        "Libtong","Linao","Mabayawas","Macabugos","Magallang","Malabiga","Marayag","Matara","Molosbolos","Natasan",
        "Niño Jesus (Santo Niño Jesus)","Nogpo","Pantao","Rawis","Sagrada Familia","Salvacion","Sampongan","San Agustin",
        "San Antonio","San Isidro","San Jose","San Pascual","San Ramon","San Vicente","Santa Cruz","Talin-Talin",
        "Tambo Walis","Villa Petrona","West Carisac","Zone I (Poblacion)","Zone II (Poblacion)","Zone III (Poblacion)",
        "Zone IV (Poblacion)","Zone V (Poblacion)","Zone VI (Poblacion)","Zone VII (Poblacion)",
    ] },
    { province: "Albay", city: "Ligao", barangayList: [
        "Abella","Allang","Amtic","Bacong","Bagumbayan (Poblacion)","Balanac","Baligang","Barayong","Basag","Batang",
        "Bay","Binanowan","Binatagan (Poblacion)","Bobonsuran","Bonga","Busac","Busay","Cabarian","Calzada (Poblacion)",
        "Catburawan","Cavasi (Poblacion)","Culliat","Dunao (Poblacion)","Francia","Guilid (Poblacion)","Herrera(Poblacion)",
        "Layon","Macalidong","Mahaba","Malama","Maonon","Nasisi","Nabonton","Oma-Oma","Palapas","Pandan","Paulba",
        "Paulog","Pinamaniquian","Pinit","Ranao-Ranao","San Vicente","Santa Cruz (Poblacion)","Tagpo (Poblacion)",
        "Tambo","Tandarora","Tastas","Tinago (Poblacion)","Tinampo","Tiongson","Tomolin (Poblacion)","Tuburan (Poblacion)",
        "Tula-Tula Grande","Tula-Tula Pequeño","Tupas",
    ] },
    { province: "Albay", city: "Malilipot", barangayList: [
        "Barangay I (Poblacion)","Barangay II (Poblacion)","Barangay III (Poblacion)","Barangay IV (Poblacion)",
        "Barangay V (Poblacion)","Binitayan","Calbayog","Canaway","Salvacion","San Antonio Santicon (Poblacion)",
        "San Antonio Sulong","San Francisco","San Isidro Ilawod","San Isidro Iraya","San Jose","San Roque",
        "Santa Cruz","Santa Teresa",
    ] },
    { province: "Albay", city: "Malinao", barangayList: [
        "Awang","Bagatangki","Bagumbayan","Balading","Balza","Bariw","Baybay","Bulang","Burabod","Cabunturan",
        "Comun","Diaro","Estancia","Jonop","Labnig","Libod","Malolos","Matalipni","Ogob","Pawa","Payahan","Poblacion",
        "Quinarabasahan","Santa Elena","Soa","Sugcad","Tagoytoy","Tanawan","Tuliw",
    ] },
    { province: "Albay", city: "Manito", barangayList: [
        "Balabagon","Balasbas","Bamban","Buyo","Cabacongan","Cabit","Cawayan","Cawit","Holugan","It-Ba (Poblacion)",
        "Malobago","Manumbalay","Nagotgot","Pawa","Tinapian",
    ] },
    { province: "Albay", city: "Oas", barangayList: [
        "Badbad","Badian","Bagsa","Bagumbayan","Balogo","Banao","Bangiawon","Bogtong","Bongoran","Busac","Cadawag",
        "Cagmanaba","Calaguimit","Calpi","Calzada","Camagong","Casinagan","Centro Poblacion","Coliat","Del Rosario",
        "Gumabao","Ilaor Norte","Ilaor Sur","Iraya Norte","Iraya Sur","Manga","Maporong","Maramba","Matambo","Mayag",
        "Mayao","Moroponros","Nagas","Obaliw-Rinas","Pistola","Ramay","Rizal","Saban","San Agustin","San Antonio",
        "San Isidro","San Jose","San Juan","San Miguel","San Pascual (Nale)","San Ramon","San Vicente (Suca)",
        "Tablon","Talisay","Talongog","Tapel","Tobgon","Tobog",
    ] },
    { province: "Albay", city: "Pio Duran", barangayList: [
        "Alabangpuro","Banawan (Binawan)","Barangay I (Poblacion)","Barangay II (Poblacion)","Barangay III (Poblacion)",
        "Barangay IV (Poblacion)","Barangay V (Poblacion)","Barangay V (Poblacion)","Basicao Coastal","Basicao Interior",
        "Binodegahan","Buenavista","Buyo","Caratagan","Cuyaoyao","Flores","La Medalla","Lawinon","Macasitas","Malapay",
        "Malidong","Mamlad","Marigondon","Matanglad","Nablangbulod","Oringon","Palapas","Panganiran","Rawis","Salvacion",
        "Santo Cristo","Sukip","Tibabo",
    ] },
    { province: "Albay", city: "Polangui", barangayList: [
        "Agos","Alnay","Alomon","Amoguis","Anopol","Apad","Balaba","Balangibang","Balinad","Basud","Buyo","Centro Occidental",
        "Centro Oriental","Cepres","Cotmon","Cotnogan","Danao","Gabon","Gamot","Itaran","Kinale","Kinuartelan",
        "La Medalla","Lanigay","La Purisima","Lidong","Lourdes","Magpanambo","Magurang","Matacon","Maynaga","Maysua",
        "Mendez","Napo","Pinagdapugan","Pintor (Binangbangan)","Ponso","Salvacion","San Roque","Santicon","Santa Cruz",
        "Santa Teresita","Sugcad","Ubaliw",
    ] },
    { province: "Albay", city: "Rapu-Rapu", barangayList: [
        "Bagaobawan","Batan","Bilbao","Binosawan","Bogtong","Buenavista","Buhatan","Calanaga","Caracaran","Carogcog",
        "Dap-Dap","Gaba","Galicia","Guadalupe","Hamorawon","Lagundi","Liguan","Linao","Malobago","Mananao","Mancao",
        "Manila","Masaga","Morocborocan","Nagcalsot","Pagcolbon","Poblacion","Sagrada","San Ramon","Santa Barbara",
        "Tinocawan","Tinopan","Viga","Villahermosa","Rural","Urban",
    ] },
    { province: "Albay", city: "Santo Domingo", barangayList: [
        "Alimsog","Bagong San Roque","Buhatan","Calayucay","Del Rosario Poblacion (Barangay 3)","Fidel Surtida","Lidong",
        "Market Site Poblacion (Barangay 9)","Nagsiya Poblacion (Barangay 8)","Pandayan Poblacion (Barangay 10)",
        "Salvacion","San Andres","San Fernando","San Francisco Poblacion (Barangay 1)","San Isidro","San Juan Poblacion (Barangay 2)",
        "San Pedro Poblacion (Barangay 5)","San Rafael Poblacion (Barangay 7)","San Roque","San Vicente Poblacion (Barangay 6)",
        "Santa Misericordia","Santo Domingo Poblacion (Barangay 4)","Santo Niño",
    ] },
    { province: "Albay", city: "Tabaco", barangayList: [
        "Agnas (San Miguel Island)","Bacolod","Bangkilingan","Bantayan","Baranghawon","Basagan","Basud (Pob.)","Bogñabong",
        "Bombon (Pob.)","Bonot","San Isidro","Buang","Buhian","Cabagñan","Cobo","Comon","Cormidal","Divino Rostro (Pob.)",
        "Fatima","Guinobat","Hacienda (San Miguel Island)","Magapo","Mariroc","Matagbac","Oras","Oson","Panal","Pawa",
        "Pinagbobong","Quinale Cabasan (Pob.)","Quinastillojan","Rawis (San Miguel Island)","Sagurong (San Miguel Island)",
        "Salvacion","San Antonio","San Carlos","San Juan (Pob.)","San Lorenzo","San Ramon","San Roque","San Vicente",
        "Santo Cristo (Pob.)","Sua-Igot","Tabiguian","Tagas","Tayhi (Pob.)","Visita (San Miguel Island)",
    ] },
    { province: "Albay", city: "Tiwi", barangayList: [
        "Bagumbayan","Bariis","Baybay","Belen (Malabog)","Biyong","Bolo","Cale","Cararayan","Coro-coro","Dap-dap",
        "Gajo","Joroan","Libjo","Libtong","Matalibong","Maynonong","Mayong","Misibis","Naga","Nagas","Oyama","Putsan",
        "San Bernardo","Sogod","Tigbi (Poblacion)",
    ] },
    { province: "Antique", city: "Anini-y", barangayList: [
        "Bayo Grande","Bayo Pequeño","Butuan","Casay, Anini-y","Casay Viejo","Iba","Milagrosa (Igbarabatuan)",
        "Igpalge","Igtumarom","Lisub A","Lisub B","Mabuyong","Magdalena","Nasuli C","Nato","Poblacion","Sagua",
        "Salvacion","San Francisco (Dapdap)","San Ramon","San Roque","Tagaytay","Talisayan",
    ] },
    { province: "Antique", city: "Barbaza", barangayList: [
        "Baghari","Bahuyan","Beri","Biga-a","Binangbang","Binangbang Centro","Binanu-an","Cadiao","Calapadan","Capoyuan",
        "Cubay","Embrangga-an","Esparar","Gua","Idao","Igpalge","Igtunarum","Integasan","Ipil","Jinalinan","Lanas",
        "Langcaon (Evelio Javier)","Lisub","Lombuyan","Mablad","Magtulis","Marigne","Mayabay","Mayos","Nalusdan",
        "Narirong","Palma","Poblacion","San Antonio","San Ramon","Soligao","Tabongtabong","Tig-Alaran","Yapo",
    ] },
    { province: "Antique", city: "Belison", barangayList: [
        "Borocboroc","Buenavista","Concepcion","Delima","Ipil","Maradiona","Mojon","Poblacion","Rombang","Salvacion","Sinaja",
    ] },
    { province: "Antique", city: "Bugasong", barangayList: [
        "Anilawan","Arangote","Bagtason","Camangahan","Centro Ilawod (Poblacion)","Centro Ilaya (Poblacion)","Centro Pojo (Poblacion)",
        "Cubay North","Cubay South","Guija","Igbalangao","Igsoro","Ilaures","Jinalinan","Lacayon","Maray","Paliwan",
        "Pangalcagan","Sabang East","Sabang West","Tagudtud North","Tagudtud South","Talisay","Tica","Tono-an","Yapu",
        "Zaragoza",
    ] },
    { province: "Antique", city: "Caluya", barangayList: [
        "Alegria","Bacong","Banago","Bonbon","Dawis","Dionela","Harigue","Hininga-an","Imba","Masanag","Poblacion",
        "Sabang","Salamento","Semirara","Sibato","Sibay","Sibolo","Tinogboc",
    ] },
    { province: "Antique", city: "Culasi", barangayList: [
        "Alojipan","Bagacay","Balac-balac","Batbatan Island","Batonan Norte","Batonan Sur","Bita","Bitadton Norte",
        "Bitadton Sur","Buenavista","Buhi","Camancijan","Caridad","Carit-an","Centro Norte (Poblacion)","Centro Poblacion",
        "Centro Sur (Poblacion)","Condes","Esperanza","Fe","Flores","Jalandoni","Janlagasi","Lamputong","Lipata",
        "Magsaysay (Balua)","Malacañang","Malalison Island","Maniguin","Naba","Osorio","Paningayan","Salde","San Antonio",
        "San Gregorio","San Juan","San Luis","San Pascual","San Vicente","Simbola","Tigbobolo","Tinabusan","Tomao",
        "Valderama",
    ] },
    { province: "Antique", city: "Hamtic", barangayList: [
        "Apdo","Asluman","Banawon","Bia-an","Bongbongan I-II","Bongbongan III","Botbot","Budbudan","Buhang","Calacja I",
        "Calacja II","Calala","Cantulan","Caridad","Caromangay","Casalngan","Dangcalan","Del Pilar","Fabrica","Funda",
        "General Fullon (Tina)","Gov. Evelio B. Javier (Lanag)","Guintas","Igbical","Igbucagay","Inabasan","Ingwan-Batangan",
        "La Paz","Linaban","Malandog","Mapatag","Masanag","Nalihawan","Pamandayan (Botbot)","Pasu-Jungao","Piape I",
        "Piape II","Piape III","Pili 1, 2, 3","Poblacion 1","Poblacion 2","Poblacion 3","Poblacion 4","Poblacion 5",
        "Pu-ao","Suloc","Villavert-Jimenez",
    ] },
    { province: "Antique", city: "Laua-an", barangayList: [
        "Bagongbayan","Banban","Bongbongan","Cabariwan","Cadajug","Canituan","Capnayan","Casit-an","Guiamon",
        "Guinbanga-an","Guisijan","Igtadiao","Intao","Jaguikican","Jinalinan","Lactudan","Latazon","Laua-an",
        "Liberato","Lindero","Liya-liya","Loon","Lugta","Lupa-an","Magyapo","Maria","Mauno","Maybunga","Necesito (Paniatan)",
        "Oloc","Omlot","Pandanan","Paningayan","Pascuala","Poblacion (Centro)","San Ramon","Santiago","Tibacan",
        "Tigunhao","Virginia",
    ] },
    { province: "Antique", city: "Libertad", barangayList: [
        "Barusbus","Bulanao","Centro Este (Poblacion)","Centro Weste (Poblacion)","Codiong","Cubay","Igcagay","Inyawan",
        "Lindero","Maramig","Pajo","Panangkilon","Paz","Pucio","San Roque","Taboc","Tinigbas","Tinindugan","Union",
    ] },
    { province: "Antique", city: "Pandan", barangayList: [
        "Aracay","Badiangan","Bagumbayan","Baybay","Botbot","Buang","Cabugao","Candari","Carmen","Centro Norte (Poblacion)",
        "Centro Sur (Poblacion)","Dionela","Dumrog","Duyong","Fragante","Guia","Idiacacan","Jinalinan","Luhod-Bayang",
        "Maadios","Mag-aba","Napuid","Nauring","Patria","Perfecta","San Andres","San Joaquin","Santa Ana","Santa Cruz",
        "Santa Fe","Santo Rosario","Talisay","Tingib","Zaldivar",
    ] },
    { province: "Antique", city: "Patnongon", barangayList: [
        "Alvañiz","Amparo","Apgahan","Aureliana","Badiangan","Bernaldo A. Julagting (Bitas)","Carit-an","Cuyapiao",
        "Gella","Igbarawan","Igbobon","Igburi","La Rioja","Mabasa","Macarina","Magarang","Magsaysay","Padang",
        "Pandanan","Patlabawon","Poblacion","Quezon","Salaguiawan","Samalague","San Rafael","Tamayoc","Tigbalogo",
        "Tobias Fornier","Villa Crespo","Villa Cruz","Villa Elio","Villa Flores","Villa Laua-an","Villa Sal",
        "Villa Salomon","Vista Alegre",
    ] },
    { province: "Antique", city: "San Jose de Buenavista", barangayList: [
        "Atabay","Badiang","Barangay 1 (Poblacion)","Barangay 2 (Poblacion)","Barangay 3 (Poblacion)","Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)","Barangay 6 (Poblacion)","Barangay 7 (Poblacion)","Barangay 8 (Poblacion)","Bariri",
        "Bugarot (Catungan-Bugarot)","Cansadan (Cansadan-Tubudan)","Durog","Funda-Dalipe","Igbonglo","Inabasan",
        "Madrangca","Magcalon","Malaiba","Maybato Norte","Maybato Sur","Mojon","Pantao","San Angel","San Fernando",
        "San Pedro","Supa",
    ] },
    { province: "Antique", city: "San Remigio", barangayList: [
        "Agricula","Alegria","Aningalan","Atabay","Bagumbayan","Baladjay","Banbanan","Barangbang","Bawang","Bugo",
        "Bulan-bulan","Cabiawan","Cabunga-an","Cadolonan","Carawisan I","Carawisan II","Carmelo I","Carmelo II",
        "General Fullon","General Luna","Iguirindon","Insubuan","La Union","Lapak","Lumpatan","Magdalena",
        "Maragubdub","Nagbangi I (Amatong)","Nagbangi II","Nasuli","Orquia (Igcatumbal)","Osorio I","Osorio II",
        "Panpanan I","Panpanan II","Poblacion (Calag-itan)","Ramon Magsaysay","Rizal","San Rafael","Sinundolan",
        "Sumaray","Trinidad","Tubudan","Vilvar","Walker",
    ] },
    { province: "Antique", city: "Sebaste", barangayList: [
        "Abiera","Aguila","Alegre","Aras-Asan","Bacalan","Callan","Idio","Nauhon","P. Javier","Poblacion",
    ] },
    { province: "Antique", city: "Sibalom", barangayList: [
        "Alangan","Bari","Biga-a","Bongbongan I","Bongbongan II","Bongsod","Bontol","Bugnay","Bulalacao","Cabanbanan",
        "Cabariuan","Cabladan","Cadoldolan","Calo-oy","Calog","Catmon","Catungan I","Catungan II","Catungan III",
        "Catungan IV","Cubay-Napultan","Cubay-Sermon","District I (Poblacion)","District II (Poblacion)","District III (Poblacion)",
        "District IV (Poblacion)","Egaña","Esperanza I","Esperanza II","Esperanza III","Igcococ","Igdagmay","Igdalaquit",
        "Iglanot","Igpanolong","Igparas","Igsuming","Ilabas","Imparayan","Inabasan","Indag-an","Initan","Insarayan",
        "Lacaron","Lagdo","Lambayagan","Luna","Luyang","Maasin","Mabini","Millamena","Mojon","Nagdayao","Nazareth",
        "Odiong","Olaga","Pangpang","Panlagangan","Pantao","Pasong","Pis-Anan","Rombang","Salvacion","San Juan",
        "Sido","Solong","Tabongtabong","Tig-Ohot","Tigbalua I","Tigbalua II","Tordesillas","Tulatula",
        "Valentin Grasparil (Bad-as)","Villafont","Villahermosa","Villar",
    ] },
    { province: "Antique", city: "Tibiao", barangayList: [
        "Alegre (Lawihaw)","Amar (Sangyadan)","Bandoja (Lupa-an)","Castillo (Igtonarum)","Esparagoza (Ungyon)",
        "Importante (Balantian)","La Paz (Langawon)","Malabor (Burok Burok)","Martinez (Lamnugan)","Natividad (Kulangi)",
        "Pitac (San Dionisio)","Poblacion","Salazar (Mamara/Hinonghinong)","San Francisco Norte (Tumangtang)","San Francisco Sur (Butarog)",
        "San Isidro (Gingay)","Santa Ana (Payatpat)","Santa Justa (Kubay)","Santo Rosario (Karapunan)","Tigbaboy","Tuno",
    ] },
    { province: "Antique", city: "Tobias Fornier", barangayList: [
        "Abaca","Aras-Asan","Arobo","Atabay","Atiotes","Bagumbayan","Balloscas","Balud","Barasanan A","Barasanan B","Barasanan C",
        "Bariri","Camandagan","Cato-ogan","Danawan","Diclum","Fatima","Gamad (Igdamacio)","Igbalogo","Igbangcal-A",
        "Igbangcal-B","Igbangcal-C","Igcabuad","Igcadac","Igcado","Igcalawagan","Igcapuyas","Igcasicad (San Pedro)",
        "Igdalaguit","Igdanlog","Igdurarog","Igtugas","Lawigan","Lindero","Manaling (Cata-an)","Masayo","Nagsubuan",
        "Nasuli-A (San Ramon)","Opsan (San Jose)","Paciencia","Poblacion Norte","Poblacion Sur","Portillo","Quezon",
        "Salamague (Santa Maria)","Santo Tomas","Tacbuyan","Tene","Villaflor","Ysulat",
    ] },
    { province: "Antique", city: "Valderrama", barangayList: [
        "Alon","Bakiang","Binanogan","Borocboroc","Bugnay","Buluangan I","Buluangan II","Bunsod","Busog","Cananghan",
        "Canipayan","Cansilayan","Culyat","Iglinab","Igmasandig","Lublub","Manlacbo","Pandanan","San Agustin",
        "Takas (Poblacion)","Tigmamale","Ubos (Poblacion)",
    ] },
    { province: "Apayao", city: "Calanasan", barangayList: [
        "Butao","Cadaclan","Don Roque Ablan Sr.","Eleazar","Eva Puzon","Kabugawan","Langnao","Lubong","Macalino",
        "Naguilian","Namaltugan","Poblacion","Sabangan","Santa Elena","Santa Filomena","Tanglagan","Tubang","Tubongan",
    ] },
    { province: "Apayao", city: "Conner", barangayList: [
        "Allangigan","Banban","Buluan","Caglayan (New Poblacion)","Calafug","Cupis","Daga","Guinaang","Guinamgaman",
        "Ili","Karikitan","Katablangan","Malama","Manag","Mawegui","Nabuangan","Paddaoan","Puguin","Ripang (Old Poblacion)",
        "Sacpil","Talifugo",
    ] },
    { province: "Apayao", city: "Flora", barangayList: [
        "Allig","Anninipan","Atok","Bagutong","Balasi","Balluyan","Malayugan","Mallig","Malubibit Norte","Malubibit Sur",
        "Poblacion East","Poblacion West","San Jose","Santa Maria","Tamalunog","Upper Atok (Coliman)",
    ] },
    { province: "Apayao", city: "Kabugao", barangayList: [
        "Badduat","Baliwanan","Bulu","Cabetayan","Dagara","Dibagat","Karagawan","Kumao","Laco","Lenneng (Liyyeng)",
        "Lucab","Luttuacan","Madatag","Madduang","Magabta","Maragat","Musimut","Nagbabalayan","Poblacion","Tuyangan","Waga",
    ] },
    { province: "Apayao", city: "Luna", barangayList: [
        "Bacsay","Cagandungan","Calabigan","Cangisitan","Capagaypayan","Dagupan","Lappa","Luyon","Marag","Poblacion",
        "Quirino","Salvacion","San Francisco","San Gregorio","San Isidro Norte","San Isidro Sur","San Sebastian",
        "Santa Lina","Shalom","Tumog","Turod","Zumigui",
    ] },
    { province: "Apayao", city: "Pudtol", barangayList: [
        "Aga","Alem","Amado","Aurora","Cabatacan","Cacalaggan","Capannikian","Doña Loreta","Emilia","Imelda","Lower Maton",
        "Lt. Balag","Lydia","Malibang","Mataguisi","Poblacion","San Antonio (Pugo)","San Jose","San Luis",
        "San Mariano","Swan","Upper Maton",
    ] },
    { province: "Apayao", city: "Santa Marcela", barangayList: [
        "Barocboc","Consuelo","Emiliana","Imelda (Sipa Annex)","Malekkeg","Marcela (Poblacion)","Nueva","Panay","San Antonio",
        "San Carlos","San Juan","San Mariano","Sipa Proper",
    ] },
    { province: "Aurora", city: "Baler", barangayList: [
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Barangay III (Poblacion)",
        "Barangay IV (Poblacion)",
        "Barangay V (Poblacion)",
        "Buhangin",
        "Calabuanan",
        "Obligacion",
        "Pingit",
        "Reserva",
        "Sabang",
        "Suclayin",
        "Zabali",
    ] },
    { province: "Aurora", city: "Casiguran", barangayList: [
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Barangay 6 (Poblacion)",
        "Barangay 7 (Poblacion)",
        "Barangay 8 (Poblacion)",
        "Bianuan",
        "Calabgan",
        "Calangcuasan",
        "Calantas",
        "Cozo",
        "Culat",
        "Dibacong",
        "Dibet",
        "Ditinagyan",
        "Esperanza",
        "Esteves",
        "Lual",
        "Marikit",
        "San Ildefonso",
        "Tabas",
        "Tinib",
    ] },
    { province: "Aurora", city: "Dilasag", barangayList: [
        "Diagyan",
        "Dicabasan",
        "Dilaguidi",
        "Dimaseset",
        "Diniog",
        "Esperanza",
        "Lawang",
        "Maligaya (Poblacion)",
        "Manggitahan",
        "Masagana (Poblacion)",
        "Ura",
    ] },
    { province: "Aurora", city: "Dinalungan", barangayList: [
        "Abuleg",
        "Zone I (Poblacion)",
        "Zone II (Poblacion)",
        "Nipoo (Bulo)",
        "Dibaraybay",
        "Ditawini",
        "Mapalad",
        "Paleg",
        "Simbahan",
    ] },
    { province: "Aurora", city: "Dingalan", barangayList: [
        "Aplaya",
        "Butas Na Bato",
        "Matawe (Cabog)",
        "Caragsacan",
        "Davildavilan",
        "Dikapanikian",
        "Ibona",
        "Paltic",
        "Poblacion",
        "Tanawan",
        "Umiray (Malamig)",
    ] },
    { province: "Aurora", city: "Dipaculao", barangayList: [
        "Bayabas",
        "Borlongan",
        "Buenavista",
        "Calaocan",
        "Diamanen",
        "Dianed",
        "Diarabasin",
        "Dibutunan",
        "Dimabuno",
        "Dinadiawan",
        "Ditale",
        "Gupa",
        "Ipil",
        "Laboy",
        "Lipit",
        "Lobbot",
        "Maligaya",
        "Mijares",
        "Mucdol",
        "North Poblacion",
        "Puangi",
        "Salay",
        "Sapangkawayan",
        "South Poblacion",
        "Toytoyan",
    ] },
    { province: "Aurora", city: "Maria Aurora", barangayList: [
        "Alcala",
        "Bagtu",
        "Bangco",
        "Bannawag",
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Barangay III (Poblacion)",
        "Barangay IV (Poblacion)",
        "Baubo",
        "Bayanihan",
        "Bazal",
        "Cabituculan East",
        "Cabituculan West",
        "Cadayacan",
        "Debucao",
        "Decoliat",
        "Detailen",
        "Diaat",
        "Dialatman",
        "Diaman",
        "Dianawan",
        "Dikildit",
        "Dimanpudso",
        "Diome",
        "Estonilo",
        "Florida",
        "Galintuja",
        "Malasin",
        "Ponglo",
        "Quirino",
        "Ramada",
        "San Joaquin",
        "San Jose",
        "San Juan",
        "San Leonardo",
        "Santa Lucia",
        "Santo Tomas",
        "Suguit",
        "Villa Aurora",
        "Wenceslao",
    ] },
    { province: "Aurora", city: "San Luis", barangayList: [
        "Bacong",
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Barangay III (Poblacion)",
        "Barangay IV (Poblacion)",
        "Dibalo",
        "Dibayabay",
        "Dibut",
        "Dikapinisan",
        "Dimanayat",
        "Diteki",
        "Ditumabo",
        "L. Pimentel",
        "Nonong Senior",
        "Real",
        "San Isidro",
        "San Jose",
        "Zarah",
    ] },
    // { province: "Basilan", city: "", barangayList: [] },
    { province: "Bataan", city: "Abucay", barangayList: [
        "Bangkal",
        "Calaylayan (Poblacion)",
        "Capitangan",
        "Gabon",
        "Laon (Poblacion)",
        "Mabatang",
        "Omboy",
        "Salian",
        "Wawa (Poblacion)",
    ] },
    { province: "Bataan", city: "Bagac", barangayList: [
        "Atilano L. Ricardo",
        "Bagumbayan (Poblacion)",
        "Banawang",
        "Binuangan",
        "Binukawan",
        "Ibaba",
        "Ibis",
        "Pag-asa (Wawa-Sibacan)",
        "Parang",
        "Paysawan",
        "Quinawan",
        "San Antonio",
        "Saysain",
        "Tabing-Ilog (Poblacion)",
    ] },
    { province: "Bataan", city: "Balanga", barangayList: [
        "Bagumbayan",
        "Cabog-Cabog",
        "Munting Batangas (Cadre)",
        "Cataning",
        "Central",
        "Cupang Proper",
        "Cupang West",
        "Dangcol (Bernabe)",
        "Ibayo",
        "Malabia",
        "Poblacion Barcenas",
        "Puerto Rivas Ibaba",
        "Puerto Rivas Itaas",
        "Puerto Rivas Lote",
        "San Jose",
        "Sibacan",
        "Camacho",
        "Talisay",
        "Tanato",
        "Tenejero",
        "Tortugas",
        "Tuyo",
        "Bagong Silang",
        "Cupang North",
        "Doña Francisca",
    ] },
    { province: "Bataan", city: "Dinalupihan", barangayList: [
        "Aquino",
        "Bangal",
        "Bayan-bayanan",
        "Bonifacio (Poblacion)",
        "Burgos (Poblacion)",
        "Colo",
        "Daang Bago",
        "Dalao",
        "Del Pilar (Poblacion)",
        "Gen. Luna (Poblacion)",
        "Gomez (Poblacion)",
        "Happy Valley",
        "Jose C. Payumo, Jr.",
        "Kataasan",
        "Layac",
        "Luacan",
        "Mabini Ext. (Poblacion)",
        "Mabini Proper (Poblacion)",
        "Magsaysay",
        "Maligaya",
        "Naparing",
        "New San Jose",
        "Old San Jose",
        "Padre Dandan (Poblacion)",
        "Pag-asa",
        "Pagalanggang",
        "Payangan",
        "Pentor",
        "Pinulot",
        "Pita",
        "Rizal (Poblacion)",
        "Roosevelt",
        "Roxas (Poblacion)",
        "Saguing",
        "San Benito",
        "San Isidro (Poblacion)",
        "San Pablo",
        "San Ramon",
        "San Simon",
        "Santa Isabel (Tabacan)",
        "Santo Niño",
        "Sapang Balas",
        "Torres (Poblacion)",
        "Tubo-tubo",
        "Tucop",
        "Zamora (Poblacion)",
    ] },
    { province: "Bataan", city: "Hermosa", barangayList: [
        "A. Rivera (Poblacion)",
        "Almacen",
        "Bacong",
        "Balsic",
        "Bamban",
        "Burgos-Soliman (Poblacion)",
        "Cataning (Poblacion)",
        "Culis",
        "Daungan (Poblacion)",
        "Judge Roman Cruz Sr. (Mandama)",
        "Mabiga",
        "Mabuco",
        "Maite",
        "Mambog - Mandama",
        "Palihan",
        "Pandatung",
        "Pulo",
        "Saba",
        "Sacrifice Valley",
        "San Pedro (Poblacion)",
        "Santo Cristo (Poblacion)",
        "Sumalo",
        "Tipo",
    ] },
    { province: "Bataan", city: "Limay", barangayList: [
        "Alangan",
        "Duale",
        "Kitang I",
        "Kitang 2 & Luz",
        "Lamao",
        "Landing",
        "Poblacion",
        "Reformista",
        "San Francisco de Asis",
        "Saint Francis II",
        "Townsite",
        "Wawa",
    ] },
    { province: "Bataan", city: "Mariveles", barangayList: [
        "Alas-asin",
        "Alion",
        "Balon-Anito",
        "Baseco Country (Nassco)",
        "Batangas II",
        "Biaan",
        "Cabcaben",
        "Camaya",
        "Ipag",
        "Lucanin",
        "Malaya",
        "Maligaya",
        "Mt. View",
        "Poblacion",
        "San Carlos",
        "San Isidro",
        "Sisiman",
        "Townsite",
    ] },
    { province: "Bataan", city: "Morong", barangayList: [
        "Binaritan",
        "Mabayo",
        "Nagbalayong",
        "Poblacion",
        "Sabang",
    ] },
    { province: "Bataan", city: "Orani", barangayList: [
        "Apollo",
        "Bagong Paraiso (Poblacion)",
        "Balut (Poblacion)",
        "Bayan (Poblacion)",
        "Calero (Poblacion)",
        "Centro I (Poblacion)",
        "Centro II (Poblacion)",
        "Dona",
        "Kabalutan",
        "Kaparangan",
        "Maria Fe",
        "Masantol",
        "Mulawin",
        "Pag-asa",
        "Paking-Carbonero (Poblacion)",
        "Palihan (Poblacion)",
        "Pantalan Bago (Poblacion)",
        "Pantalan Luma (Poblacion)",
        "Parang Parang (Poblacion)",
        "Puksuan",
        "Sibul",
        "Silahis",
        "Tagumpay",
        "Tala",
        "Talimundoc",
        "Tapulao",
        "Tenejero (Poblacion)",
        "Tugatog",
        "Wawa (Poblacion)",
    ] },
    { province: "Bataan", city: "Orion", barangayList: [
        "Arellano (Poblacion)",
        "Bagumbayan (Poblacion)",
        "Balagtas (Poblacion)",
        "Balut (Poblacion)",
        "Bantan",
        "Bilolo",
        "Calungusan",
        "Camachile",
        "Daang Bago (Poblacion)",
        "Daang Bilolo (Poblacion)",
        "Daang Pare",
        "General Lim (Kaput)",
        "Kapunitan",
        "Lati (Poblacion)",
        "Lusungan (Poblacion)",
        "Puting Buhangin",
        "Sabatan (Poblacion)",
        "San Vicente (Poblacion)",
        "Santa Elena (Poblacion)",
        "Santo Domingo (Poblacion)",
        "Villa Angeles (Poblacion)",
        "Wakas (Poblacion)",
        "Wawa (Poblacion)",
    ] },
    { province: "Bataan", city: "Pilar", barangayList: [
        "Ala-uli",
        "Bagumbayan",
        "Balut I",
        "Balut II",
        "Bantan Munti",
        "Burgos",
        "Del Rosario (Poblacion)",
        "Diwa",
        "Landing",
        "Liyang",
        "Nagwaling",
        "Panilao",
        "Pantingan",
        "Poblacion",
        "Rizal (Poblacion)",
        "Santa Rosa",
        "Wakas North",
        "Wakas South",
        "Wawa",
    ] },
    { province: "Bataan", city: "Samal", barangayList: [
        "East Calaguiman (Poblacion)",
        "East Daang Bago (Poblacion)",
        "Gugo",
        "Ibaba (Poblacion)",
        "Imelda",
        "Lalawigan",
        "Palili",
        "San Juan (Poblacion)",
        "San Roque (Poblacion)",
        "Santa Lucia",
        "Sapa",
        "Tabing Ilog",
        "West Calaguiman (Poblacion)",
        "West Daang Bago (Poblacion)",
    ] },
    // { province: "Batanes", city: "", barangayList: [] },
    { province: "Batangas", city: "Agoncillo", barangayList: [
        "Adia",
        "Bagong Sikat",
        "Balangon",
        "Bangin",
        "Banyaga",
        "Barigon",
        "Bilibinwang",
        "Coral na Munti",
        "Guitna",
        "Mabini",
        "Pamiga",
        "Panhulan",
        "Pansipit",
        "Poblacion",
        "Pook",
        "San Jacinto",
        "San Teodoro",
        "Santa Cruz",
        "Santo Tomas",
        "Subic Ibaba",
        "Subic Ilaya",
    ] },
    { province: "Batangas", city: "Alitagtag", barangayList: [
        "Balagbag",
        "Concepcion",
        "Concordia",
        "Dalipit East",
        "Dalipit West",
        "Dominador East",
        "Dominador West",
        "Munlawin Norte",
        "Salvador Agito",
        "Muzon Primero",
        "Muzon Segundo",
        "Pinagkurusan",
        "Ping-As",
        "Poblacion East",
        "Poblacion West",
        "San Jose",
        "San Juan",
        "Santa Cruz",
        "Tadlac",
    ] },
    { province: "Batangas", city: "Balayan", barangayList: [
        "Baclaran",
        "Barangay 1 (Poblacion)",
        "Barangay 10 (Poblacion)",
        "Barangay 11 (Poblacion)",
        "Barangay 12 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Barangay 6 (Poblacion)",
        "Barangay 7 (Poblacion)",
        "Barangay 8 (Poblacion)",
        "Barangay 9 (Poblacion)",
        "Calan",
        "Caloocan",
        "Calzada",
        "Canda",
        "Carenahan",
        "Caybunga",
        "Cayponce",
        "Dalig",
        "Dao",
        "Dilao",
        "Duhatan",
        "Durungao",
        "Gimalas",
        "Gumamela",
        "Lagnas",
        "Lanatan",
        "Langgangan",
        "Lucban Putol",
        "Lucban Pook",
        "Magabe",
        "Malalay",
        "Munting Tubig",
        "Navotas",
        "Patugo",
        "Palikpikan",
        "Pooc",
        "Sambat",
        "Sampaga",
        "San Juan",
        "San Piro",
        "Santol",
        "Sukol",
        "Tactac",
        "Taludtud",
        "Tanggoy",
    ] },
    { province: "Batangas", city: "Balete", barangayList: [
        "Alangilan",
        "Calawit",
        "Looc",
        "Magapi",
        "Makina",
        "Malabanan",
        "Paligawan",
        "Palsara",
        "Poblacion",
        "Sala",
        "Sampalocan",
        "Solis",
        "San Sebastian",
    ] },
    { province: "Batangas", city: "Batangas City", barangayList: [
        "Barangay 1 (Pob.)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Barangay 6 (Poblacion)",
        "Barangay 7 (Poblacion)",
        "Barangay 8 (Poblacion)",
        "Barangay 9 (Poblacion)",
        "Barangay 10 (Poblacion)",
        "Barangay 11 (Poblacion)",
        "Barangay 12 (Poblacion)",
        "Barangay 13 (Poblacion)",
        "Barangay 14 (Poblacion)",
        "Barangay 15 (Poblacion)",
        "Barangay 16 (Poblacion)",
        "Barangay 17 (Poblacion)",
        "Barangay 18 (Poblacion)",
        "Barangay 19 (Poblacion)",
        "Barangay 20 (Poblacion)",
        "Barangay 21 (Poblacion)",
        "Barangay 22 (Poblacion)",
        "Barangay 23 (Poblacion)",
        "Barangay 24 (Poblacion)",
        "Alangilan",
        "Balagtas",
        "Balete",
        "Banaba Center",
        "Banaba Kanluran",
        "Banaba Silangan",
        "Banaba Ibaba",
        "Bilogo",
        "Bolbok",
        "Bukal",
        "Calicanto",
        "Catandala",
        "Concepcion",
        "Conde Itaas",
        "Conde Labak",
        "Cuta",
        "Dalig",
        "Dela Paz",
        "Dela Paz Pulot Aplaya",
        "Dela Paz Pulot Itaas",
        "Domoclay",
        "Dumantay",
        "Gulod Itaas",
        "Gulod Labak",
        "Haligue Kanluran",
        "Haligue Silangan",
        "Ilijan",
        "Kumba",
        "Kumintang Ibaba",
        "Kumintang Ilaya",
        "Libjo",
        "Liponpon, Verde Island",
        "Maapas",
        "Mahabang Dahilig",
        "Mahabang Parang",
        "Mahacot Kanluran",
        "Mahacot Silangan",
        "Malalim",
        "Malibayo",
        "Malitam",
        "Maruclap",
        "Mabacong (Matoco)",
        "Pagkilatan",
        "Paharang Kanluran",
        "Paharang Silangan",
        "Pallocan Kanluran",
        "Pallocan Silangan",
        "Pinamucan Proper",
        "Pinamucan Ibaba",
        "Pinamucan Silangan",
        "Sampaga",
        "San Agapito, Verde Island",
        "San Agustin Kanluran, Verde Island",
        "San Agustin Silangan, Verde Island",
        "San Andres, Verde Island",
        "San Antonio, Verde Island",
        "San Isidro",
        "San Jose Sico",
        "San Miguel",
        "San Pedro",
        "Santa Clara",
        "Santa Rita Aplaya",
        "Santa Rita Karsada",
        "Santo Domingo",
        "Santo Niño",
        "Simlong",
        "Sirang Lupa",
        "Sorosoro Ibaba",
        "Sorosoro Ilaya",
        "Sorosoro Karsada",
        "Tabangao Aplaya (Tabango Proper)",
        "Tabangao Ambulong",
        "Tabangao Dao",
        "Talahib Pandayan",
        "Talahib Payapa",
        "Talumpok Kanluran",
        "Talumpok Silangan",
        "Tinga Itaas",
        "Tinga Labak",
        "Tulo",
        "Verde Island",
        "Wawa",
    ] },
    { province: "Batangas", city: "Bauan", barangayList: [
        "Alagao",
        "Aplaya",
        "As‑Is",
        "Bagong Silang",
        "Baguilawa",
        "Balayong",
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Barangay III (Poblacion)",
        "Barangay IV (Poblacion)",
        "Bolo",
        "Colvo",
        "Cupang",
        "Durungao",
        "Gulibay",
        "Inicbulan",
        "Locloc",
        "Magalang‑Galang",
        "Malindig",
        "Manalupang",
        "Manghinao Proper",
        "Manghinao Uno",
        "New Danglayan",
        "Orense",
        "Pitugo",
        "Rizal",
        "Sampaguita",
        "San Agustin",
        "San Andres Proper",
        "San Andres Uno",
        "San Diego",
        "San Miguel",
        "San Pablo",
        "San Pedro",
        "San Roque",
        "San Teodoro",
        "San Vicente",
        "Santa Maria",
        "Santo Domingo",
        "Sinala",
    ] },
    { province: "Batangas", city: "Calaca", barangayList: [
        "Bagong Tubig",
        "Baclas",
        "Balimbing",
        "Bambang",
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Barangay 6 (Poblacion)",
        "Bisaya",
        "Cahil",
        "Caluangan",
        "Calantas",
        "Camastilisan",
        "Coral ni Lopez (Sugod)",
        "Coral ni Bacal",
        "Dacanlao",
        "Dila",
        "Loma",
        "Lumbang Calzada",
        "Lumbang na Bata",
        "Lumbang na Matanda",
        "Madalunot",
        "Makina",
        "Matipok",
        "Munting Coral",
        "Niyugan",
        "Pantay",
        "Puting Bato West",
        "Puting Kahoy",
        "Puting Bato East",
        "Quisumbing",
        "Salong",
        "San Rafael",
        "Sinisian",
        "Taklang Anak",
        "Talisay",
        "Tamayo",
        "Timbain",
    ] },
    { province: "Batangas", city: "Calatagan", barangayList: [
        "Bagong Silang",
        "Baha",
        "Balibago",
        "Balitoc",
        "Biga",
        "Bucal",
        "Carlosa",
        "Carretunan",
        "Encarnacion",
        "Gulod",
        "Hukay",
        "Lucsuhin",
        "Luya",
        "Paraiso",
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Quilitisan",
        "Real",
        "Sambungan",
        "Santa Ana",
        "Talibayog",
        "Talisay",
        "Tanagan",
    ] },
    { province: "Batangas", city: "Cuenca", barangayList: [
        "Balagbag",
        "Bungahan",
        "Calumayin",
        "Dalipit East",
        "Dalipit West",
        "Dita",
        "Don Juan",
        "Emmanuel",
        "Ibabao",
        "Labac",
        "Pinagkaisahan",
        "San Felipe",
        "San Isidro",
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Barangay 6 (Poblacion)",
        "Barangay 7 (Poblacion)",
        "Barangay 8 (Poblacion)",
    ] },
    { province: "Batangas", city: "Ibaan", barangayList: [
        "Bago",
        "Balanga",
        "Bungahan",
        "Calamias",
        "Catandala",
        "Coliat",
        "Dayapan",
        "Lapu‑lapu",
        "Lucsuhin",
        "Mabalor",
        "Malainin",
        "Matala",
        "Munting‑Tubig",
        "Palindan",
        "Pangao",
        "Panghayaan",
        "Poblacion",
        "Quilo",
        "Sabang",
        "Salaban I",
        "San Agustin",
        "Sandalan",
        "Santo Niño",
        "Talaibon",
        "Tulay na Patpat",
        "Salaban II",
    ] },
    { province: "Batangas", city: "Laurel", barangayList: [
        "As‑Is",
        "Balakilong",
        "Berinayan",
        "Bugaan East",
        "Bugaan West",
        "Buso‑buso",
        "Dayap Itaas",
        "Gulod",
        "J. Leviste",
        "Molinete",
        "Niyugan",
        "Paliparan",
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "San Gabriel",
        "San Gregorio",
        "Santa Maria",
        "Ticub",
    ] },
    { province: "Batangas", city: "Lemery", barangayList: [
        "Anak‑Dagat",
        "Arumahan",
        "Ayao‑iyao",
        "Bagong Pook",
        "Bagong Sikat",
        "Balanga",
        "Bukal",
        "Cahilan I",
        "Cahilan II",
        "Dayapan",
        "Dita",
        "Gulod",
        "Lucky",
        "Maguihan",
        "Mahabang Dahilig",
        "Mahayahay",
        "Maigsing Dahilig",
        "Maligaya",
        "Malinis",
        "Masalisi",
        "Mataas na Bayan",
        "Matingain I",
        "Matingain II",
        "Mayasang",
        "Niogan",
        "Nonong Casto",
        "Palanas",
        "Payapa Ibaba",
        "Payapa Ilaya",
        "District I (Poblacion)",
        "District II (Poblacion)",
        "District III (Poblacion)",
        "District IV (Poblacion)",
        "Rizal",
        "Sambal Ibaba",
        "Sambal Ilaya",
        "San Isidro Ibaba",
        "San Isidro Itaas",
        "Sangalang",
        "Talaga",
        "Tubigan",
        "Tubuan",
        "Wawa Ibaba",
        "Wawa Ilaya",
        "Sinisian East",
        "Sinisian West",
    ] },
    { province: "Batangas", city: "Lian", barangayList: [
        "Bagong Pook",
        "Balibago",
        "Binubusan",
        "Bungahan",
        "Cumba",
        "Humayingan",
        "Kapito",
        "Lumaniag",
        "Luyahan",
        "Malaruhatan",
        "Matabungkay",
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Prenza",
        "Puting‑Kahoy",
        "San Diego",
    ] },
    { province: "Batangas", city: "Lipa", barangayList: [
        "Balintawak",
        "Bugtong na Pulo",
        "Bulacnin",
        "Dagatan",
        "Inosluban",
        "Lumbang",
        "Marawoy",
        "Plaridel",
        "Pusil",
        "San Lucas",
        "Talisay",
        "Adya",
        "Anilao",
        "Anilao-Labac",
        "Bolbok",
        "Calamias",
        "Cumba",
        "Kayumanggi",
        "Lodlod",
        "Mabini",
        "Malagonlong",
        "Pagolingin Bata",
        "Pagolingin East",
        "Pagolingin West",
        "Quezon",
        "Rizal",
        "Sampaguita",
        "San Guillermo",
        "San Sebastian (Balagbag)",
        "Antipolo Del Norte",
        "Antipolo Del Sur",
        "Latag",
        "Malitlit",
        "Muntingpulo",
        "Pinagkawitan",
        "Sabang",
        "San Benito",
        "San Celestino",
        "San Francisco",
        "San Isidro (formerly Sapac)",
        "San Jose",
        "Santo Niño",
        "Santo Toribio",
        "Tangob",
        "Tipacan",
        "Bagong Pook",
        "Banaybanay",
        "Bulaklakan",
        "Duhatan",
        "Fernando Air Base",
        "Halang",
        "Mataas Na Lupa",
        "Pangao",
        "Pinagtongulan",
        "San Carlos",
        "San Salvador",
        "Sico",
        "Tambo",
        "Tangway",
        "Tibig",
        "Poblacion Barangay 1",
        "Poblacion Barangay 2",
        "Poblacion Barangay 3",
        "Poblacion Barangay 4",
        "Poblacion Barangay 5",
        "Poblacion Barangay 6",
        "Poblacion Barangay 7",
        "Poblacion Barangay 8",
        "Poblacion Barangay 9",
        "Poblacion Barangay 9-A",
        "Poblacion Barangay 10",
        "Poblacion Barangay 11",
        "Poblacion Barangay 12",
    ] },
    { province: "Batangas", city: "Lobo", barangayList: [
        "Apar",
        "Balatbat",
        "Balibago",
        "Banalo",
        "Biga",
        "Bignay",
        "Calo",
        "Calumpit",
        "Fabrica",
        "Jaybanga",
        "Lagadlarin",
        "Mabilog na Bundok",
        "Malabrigo",
        "Malalim na Sanog",
        "Malapad na Parang",
        "Masaguitsit",
        "Nagtalongtong",
        "Nagtoctoc",
        "Olo‑olo",
        "Pinaghawanan",
        "San Miguel",
        "San Nicolas",
        "Sawang",
        "Soloc",
        "Tayuman",
        "Poblacion",
    ] },
    { province: "Batangas", city: "Mabini", barangayList: [
        "Anilao Proper",
        "Anilao East",
        "Bagalangit",
        "Bulacan",
        "Calamias",
        "Estrella",
        "Gasang",
        "Laurel",
        "Ligaya",
        "Mainaga",
        "Mainit",
        "Majuben",
        "Malimatoc I",
        "Malimatoc II",
        "Nag‑Iba",
        "Pilahan",
        "Poblacion",
        "Pulang Lupa",
        "Pulong Anahao",
        "Pulong Balibaguhan",
        "Pulong Niogan",
        "Saguing",
        "Sampaguita",
        "San Francisco",
        "San Jose",
        "San Juan",
        "San Teodoro",
        "Santa Ana",
        "Santa Mesa",
        "Santo Niño",
        "Santo Tomas",
        "Solo",
        "Talaga Proper",
        "Talaga East",
    ] },
    { province: "Batangas", city: "Malvar", barangayList: [
        "Bagong Pook",
        "Bilucao (San Isidro Western)",
        "Bulihan",
        "San Gregorio",
        "Luta del Norte",
        "Luta del Sur",
        "Poblacion",
        "San Andres",
        "San Fernando",
        "San Isidro East",
        "San Juan",
        "San Pedro II (Western)",
        "San Pedro I (Eastern)",
        "San Pioquinto",
        "Santiago",
    ] },
    { province: "Batangas", city: "Mataasnakahoy", barangayList: [
        "District I (Poblacion)",
        "District II (Poblacion)",
        "District III (Poblacion)",
        "District IV (Poblacion)",
        "Bayorbor",
        "Bubuyan",
        "Calingatan",
        "Kinalaglagan",
        "Loob",
        "Lumang Lipa",
        "Manggahan",
        "Nangkaan",
        "San Sebastian",
        "Santol",
        "Upa",
        "Barangay II‑A (Poblacion)",
    ] },
    { province: "Batangas", city: "Nasugbu", barangayList: [
        "Aga",
        "Balaytigui",
        "Banilad",
        "Barangay 10 (Poblacion)",
        "Barangay 11 (Poblacion)",
        "Barangay 12 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Barangay 6 (Poblacion)",
        "Barangay 7 (Poblacion)",
        "Barangay 8 (Poblacion)",
        "Barangay 9 (Poblacion)",
        "Bilaran",
        "Bucana",
        "Bulihan",
        "Bunducan",
        "Butucan",
        "Calayo",
        "Catandaan",
        "Kaylaway",
        "Kayrilaw",
        "Cogunan",
        "Dayap",
        "Latag",
        "Looc",
        "Lumbangan",
        "Malapad na Bato",
        "Mataas na Pulo",
        "Maugat",
        "Munting Indan",
        "Natipuan",
        "Pantalan",
        "Papaya",
        "Putat",
        "Reparo",
        "Talangan",
        "Tumalim",
        "Utod",
        "Wawa",
        "Barangay 1 (Poblacion)",
    ] },
    { province: "Batangas", city: "Padre Garcia", barangayList: [
        "Banaba",
        "Banaybanay",
        "Bawi",
        "Bukal",
        "Castillo",
        "Cawongan",
        "Manggas",
        "Maugat East",
        "Maugat West",
        "Pansol",
        "Payapa",
        "Poblacion",
        "Quilo‑quilo North",
        "Quilo‑quilo South",
        "San Felipe",
        "San Miguel",
        "Tamak",
        "Tangob",
    ] },
    { province: "Batangas", city: "Rosario", barangayList: [
        "Alupay",
        "Antipolo",
        "Bagong Pook",
        "Balibago",
        "Bayawang",
        "Baybayin",
        "Bulihan",
        "Cahigam",
        "Calantas",
        "Colongan",
        "Itlugan",
        "Lumbangan",
        "Maalas‑As",
        "Mabato",
        "Mabunga",
        "Macalamcam A",
        "Macalamcam B",
        "Malaya",
        "Maligaya",
        "Marilag",
        "Masaya",
        "Matamis",
        "Mavalor",
        "Mayuro",
        "Namuco",
        "Namunga",
        "Natu",
        "Nasi",
        "Palakpak",
        "Pinagsibaan",
        "Barangay A (Poblacion)",
        "Barangay B (Poblacion)",
        "Barangay C (Poblacion)",
        "Barangay D (Poblacion)",
        "Barangay E (Poblacion)",
        "Putingkahoy",
        "Quilib",
        "Salao",
        "San Carlos",
        "San Ignacio",
        "San Isidro",
        "San Jose",
        "San Roque",
        "Santa Cruz",
        "Timbugan",
        "Tiquiwan",
        "Leviste (Tubahan)",
        "Tulos",
    ] },
    { province: "Batangas", city: "San Jose", barangayList: [
        "Alupay",
        "Antipolo",
        "Bagong Pook",
        "Balibago",
        "Bayawang",
        "Baybayin",
        "Bulihan",
        "Cahigam",
        "Calantas",
        "Colongan",
        "Itlugan",
        "Lumbangan",
        "Maalas‑As",
        "Mabato",
        "Mabunga",
        "Macalamcam A",
        "Macalamcam B",
        "Malaya",
        "Maligaya",
        "Marilag",
        "Masaya",
        "Matamis",
        "Mavalor",
        "Mayuro",
        "Namuco",
        "Namunga",
        "Natu",
        "Nasi",
        "Palakpak",
        "Pinagsibaan",
        "Barangay A (Poblacion)",
        "Barangay B (Poblacion)",
        "Barangay C (Poblacion)",
        "Barangay D (Poblacion)",
        "Barangay E (Poblacion)",
        "Putingkahoy",
        "Quilib",
        "Salao",
        "San Carlos",
        "San Ignacio",
        "San Isidro",
        "San Jose",
        "San Roque",
        "Santa Cruz",
        "Timbugan",
        "Tiquiwan",
        "Leviste (Tubahan)",
        "Tulos",
    ] },
    { province: "Batangas", city: "San Juan", barangayList: [
        "Abung",
        "Balagbag",
        "Barualte",
        "Bataan",
        "Buhay na Sapa",
        "Bulsa",
        "Calicanto",
        "Calitcalit",
        "Calubcub I",
        "Calubcub II",
        "Catmon",
        "Coloconto",
        "Escribano",
        "Hugom",
        "Imelda (Tubog)",
        "Janaojanao",
        "Laiya‑Ibabao",
        "Laiya‑Aplaya",
        "Libato",
        "Lipahan",
        "Mabalanoy",
        "Nagsaulay",
        "Maraykit",
        "Muzon",
        "Palahanan I",
        "Palahanan II",
        "Palingowak",
        "Pinagbayanan",
        "Poblacion",
        "Poctol",
        "Pulangbato",
        "Putingbuhangin",
        "Quipot",
        "Sampiro",
        "Sapangan",
        "Sico I",
        "Sico II",
        "Subukin",
        "Talahiban I",
        "Talahiban II",
        "Ticalan",
        "Tipaz",
    ] },
    { province: "Batangas", city: "San Luis", barangayList: [
        "Abiacao",
        "Bagong Tubig",
        "Balagtasin",
        "Balite",
        "Banoyo",
        "Boboy",
        "Bonliw",
        "Calumpang West",
        "Calumpang East",
        "Dulangan",
        "Durungao",
        "Locloc",
        "Luya",
        "Mahabang Parang",
        "Manggahan",
        "Muzon",
        "San Antonio",
        "San Isidro",
        "San Jose",
        "San Martin",
        "Santa Monica",
        "Taliba",
        "Talon",
        "Tejero",
        "Tungal",
        "Poblacion",
    ] },
    { province: "Batangas", city: "San Nicolas", barangayList: [
        "Abelo",
        "Balete",
        "Baluk‑baluk",
        "Bancoro",
        "Bangin",
        "Calangay",
        "Hipit",
        "Maabud North",
        "Maabud South",
        "Munlawin",
        "Pansipit",
        "Poblacion",
        "Santo Niño",
        "Sinturisan",
        "Tagudtod",
        "Talang",
        "Alas‑as",
        "Pulang‑Bato",
    ] },
    { province: "Batangas", city: "San Pascual", barangayList: [
        "Alalum",
        "Antipolo",
        "Balimbing",
        "Banaba",
        "Bayanan",
        "Danglayan",
        "Del Pilar",
        "Gelerang Kawayan",
        "Ilat North",
        "Ilat South",
        "Kaingin",
        "Laurel",
        "Malaking Pook",
        "Mataas na Lupa",
        "Natunuan North",
        "Natunuan South",
        "Padre Castillo",
        "Palsahingin",
        "Pila",
        "Poblacion",
        "Pook ni Banal",
        "Pook ni Kapitan",
        "Resplandor",
        "Sambat",
        "San Antonio",
        "San Mariano",
        "San Mateo",
        "Santa Elena",
        "Santo Niño",
    ] },
    { province: "Batangas", city: "Santa Teresita", barangayList: [
        "Antipolo",
        "Bihis",
        "Burol",
        "Calayaan",
        "Calumala",
        "Cuta East",
        "Cutang Cawayan",
        "Irukan",
        "Pacifico",
        "Poblacion I",
        "Saimsim",
        "Sampa",
        "Sinipian",
        "Tambo Ibaba",
        "Tambo Ilaya",
        "Poblacion II",
        "Poblacion III",
    ] },
    { province: "Batangas", city: "Santo Tomas", barangayList: [
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Barangay III (Poblacion)",
        "Barangay IV (Poblacion)",
        "San Agustin",
        "San Antonio",
        "San Bartolome",
        "San Felix",
        "San Fernando",
        "San Francisco",
        "San Isidro Norte",
        "San Isidro Sur",
        "San Joaquin",
        "San Jose",
        "San Juan",
        "San Luis",
        "San Miguel",
        "San Pablo",
        "San Pedro",
        "San Rafael",
        "San Roque",
        "San Vicente",
        "Santa Ana",
        "Santa Anastacia",
        "Santa Clara",
        "Santa Cruz",
        "Santa Elena",
        "Santa Maria",
        "Santiago",
        "Santa Teresita",
    ] },
    { province: "Batangas", city: "Taal", barangayList: [
        "Apacay",
        "Balisong",
        "Bihis",
        "Bolbok",
        "Buli",
        "Butong",
        "Carasuche",
        "Cawit",
        "Caysasay",
        "Cubamba",
        "Cultihan",
        "Gahol",
        "Halang",
        "Iba",
        "Ilog",
        "Imamawo",
        "Ipil",
        "Luntal",
        "Mahabang Lodlod",
        "Niogan",
        "Pansol",
        "Poblacion 11",
        "Poblacion 1",
        "Poblacion 10",
        "Poblacion 12",
        "Poblacion 2",
        "Poblacion 3",
        "Poblacion 4",
        "Poblacion 5",
        "Poblacion 6",
        "Poblacion 7",
        "Poblacion 8",
        "Poblacion 9",
        "Pook",
        "Seiran",
        "Laguile",
        "Latag",
        "Tierra Alta",
        "Tulo",
        "Tatlong Maria",
        "Poblacion 13",
        "Poblacion 14",
    ] },
    { province: "Batangas", city: "Talisay", barangayList: [
        "Aya",
        "Balas",
        "Banga",
        "Buco",
        "Caloocan",
        "Leynes",
        "Miranda",
        "Poblacion Barangay 1",
        "Poblacion Barangay 2",
        "Poblacion Barangay 3",
        "Poblacion Barangay 4",
        "Poblacion Barangay 5",
        "Poblacion Barangay 6",
        "Poblacion Barangay 7",
        "Poblacion Barangay 8",
        "Quiling",
        "Sampaloc",
        "San Guillermo",
        "Santa Maria",
        "Tranca",
        "Tumaway",
    ] },
    { province: "Batangas", city: "Tanauan", barangayList: [
        "Altura Bata",
        "Altura Matanda",
        "Altura South",
        "Ambulong",
        "Bañadero",
        "Bagbag",
        "Bagumbayan",
        "Balele",
        "Banjo East",
        "Banjo Laurel (Banjo West)",
        "Bilogbilog",
        "Boot",
        "Cale",
        "Darasa",
        "Gonzales",
        "Hidalgo",
        "Janopol Occidental",
        "Janopol Oriental",
        "Laurel",
        "Luyos",
        "Mabini",
        "Malaking Pulo",
        "Maria Paz",
        "Maugat",
        "Montaña (Ik-ik)",
        "Natatas",
        "Pagaspas",
        "Pantay Matanda",
        "Pantay Bata",
        "Barangay 1",
        "Barangay 2",
        "Barangay 3",
        "Barangay 4",
        "Barangay 5",
        "Barangay 6",
        "Barangay 7",
        "Sala",
        "Sambat",
        "San Jose",
        "Santol (Doña Jacoba Garcia)",
        "Santor",
        "Sulpoc",
        "Suplang",
        "Talaga",
        "Tinurik",
        "Trapiche",
        "Ulango",
        "Wawa",
    ] },
    { province: "Batangas", city: "Taysan", barangayList: [
        "Bacao",
        "Bilogo",
        "Bukal",
        "Dagatan",
        "Guinhawa",
        "Laurel",
        "Mabayabas",
        "Mahanadiong",
        "Mapulo",
        "Mataas na Lupa",
        "Pag‑Asa",
        "Panghayaan",
        "Piña",
        "Pinagbayanan",
        "Poblacion East",
        "Poblacion West",
        "San Isidro",
        "San Marcelino",
        "Santo Niño",
        "Tilambo",
    ] },
    { province: "Batangas", city: "Tingloy", barangayList: [
        "Corona",
        "Gamao",
        "Makawayan",
        "Marikaban",
        "Papaya",
        "Pisa",
        "Barangay 13 (Poblacion 1)",
        "Barangay 14 (Poblacion 2)",
        "Barangay 15 (Poblacion 3)",
        "San Isidro",
        "San Jose",
        "San Juan",
        "San Pedro",
        "Santo Tomas",
        "Talahib",
        "Talahib",
    ] },
    { province: "Batangas", city: "Tuy", barangayList: [
        "Acle",
        "Bayudbud",
        "Bolboc",
        "Dalima",
        "Dao",
        "Guinhawa",
        "Lumbangan",
        "Luntal",
        "Magahis",
        "Malibu",
        "Mataywanac",
        "Palincaro",
        "Luna (Poblacion)",
        "Burgos (Poblacion)",
        "Rizal (Poblacion)",
        "Rillo (Poblacion)",
        "Putol",
        "Sabang",
        "San Jose",
        "Talon",
        "Toong",
        "Tuyon‑tuyon",
    ] },
    // { province: "Benguet", city: "", barangayList: [] },
    // { province: "Biliran", city: "", barangayList: [] },
    // { province: "Bohol", city: "", barangayList: [] },
    // { province: "Bukidnon", city: "", barangayList: [] },
    { province: "Bulacan", city: "Angat", barangayList: [
        "Banaban",
        "Baybay",
        "Binagbag",
        "Donacion",
        "Encanto",
        "Laog",
        "Marungko",
        "Niugan",
        "Paltok",
        "Pulong Yantok",
        "San Roque (Poblacion)",
        "Santa Cruz (Poblacion)",
        "Santa Lucia",
        "Santo Cristo (Poblacion)",
        "Sulucan",
        "Taboc",
    ] },
    { province: "Bulacan", city: "Balagtas", barangayList: [
        "Borol 2nd",
        "Borol 1st",
        "Dalig",
        "Longos",
        "Panginay",
        "Pulong Gubat",
        "San Juan",
        "Santol",
        "Wawa (Poblacion)",
    ] },
    { province: "Bulacan", city: "Baliuag", barangayList: [
        "Bagong Nayon",
        "Barangca",
        "Calantipay",
        "Catulinan",
        "Concepcion",
        "Hinukay",
        "Makinabang",
        "Matangtubig",
        "Pagala",
        "Paitan",
        "Piel",
        "Pinagbarilan",
        "Poblacion.",
        "Sabang",
        "San Jose",
        "San Roque",
        "Santa Barbara",
        "Santo Cristo",
        "Santo Niño",
        "Subic",
        "Sulivan",
        "Tangos",
        "Tarcan",
        "Tiaong",
        "Tibag",
        "Tilapayong",
        "Virgen delas Flores",
    ] },
    { province: "Bulacan", city: "Bocaue", barangayList: [
        "Antipona",
        "Bagumbayan",
        "Bambang",
        "Batia",
        "Biñang 1st",
        "Biñang 2nd",
        "Bolacan",
        "Bundukan",
        "Bunlo",
        "Caingin",
        "Duhat",
        "Igulot",
        "Lolomboy",
        "Poblacion",
        "Sulucan",
        "Taal",
        "Tambobong",
        "Turo",
        "Wakas",
    ] },
    { province: "Bulacan", city: "Bulakan", barangayList: [
        "Bagumbayan",
        "Balubad",
        "Bambang",
        "Matungao",
        "Maysantol",
        "Perez",
        "Pitpitan",
        "San Francisco",
        "San Jose (Poblacion)",
        "San Nicolas",
        "Santa Ana",
        "Santa Ines",
        "Taliptip",
        "Tibig",
    ] },
    { province: "Bulacan", city: "Bustos", barangayList: [
        "Bonga Mayor",
        "Bonga Menor",
        "Buisan",
        "Camachilihan",
        "Cambaog",
        "Catacte",
        "Liciada",
        "Malamig",
        "Malawak",
        "Poblacion",
        "San Pedro",
        "Talampas",
        "Tanawan",
        "Tibagan",
    ] },
    { province: "Bulacan", city: "Calumpit", barangayList: [
        "Balite",
        "Balungao",
        "Buguion",
        "Bulusan",
        "Calizon",
        "Calumpang",
        "Caniogan",
        "Corazon",
        "Frances",
        "Gatbuca",
        "Gugo",
        "Iba Este",
        "Iba Oeste",
        "Longos",
        "Meysulao",
        "Meyto",
        "Palimbang",
        "Panducot",
        "Pio Cruzcosa",
        "Poblacion",
        "Pungo",
        "San Jose",
        "San Marcos",
        "San Miguel",
        "Santa Lucia",
        "Santo Niño",
        "Sapang Bayan",
        "Sergio Bayan",
        "Sucol",
    ] },
    { province: "Bulacan", city: "Doña Remedios Trinidad", barangayList: [
        "Bayabas",
        "Kabayunan",
        "Camachin",
        "Camachile",
        "Kalawakan",
        "Pulong Sampalok (Poblacion)",
        "Talbak",
        "Sapang Bulak",
    ] },
    { province: "Bulacan", city: "Guiguinto", barangayList: [
        "Cutcut",
        "Daungan",
        "Ilang‑Ilang",
        "Malis",
        "Panginay",
        "Poblacion",
        "Pritil",
        "Pulong Gubat",
        "Santa Cruz",
        "Santa Rita",
        "Tabang",
        "Tabe",
        "Tiaong",
        "Tuktukan",
    ] },
    { province: "Bulacan", city: "Hagonoy", barangayList: [
        "Abulalas",
        "Carillo",
        "Iba",
        "Mercado",
        "Palapat",
        "Pugad",
        "Sagrada Familia",
        "San Agustin",
        "San Isidro",
        "San Jose",
        "San Juan",
        "San Miguel",
        "San Nicolas",
        "San Pablo",
        "San Pascual",
        "San Pedro",
        "San Roque",
        "San Sebastian",
        "Santa Cruz",
        "Santa Elena",
        "Santa Monica",
        "Santo Niño (Poblacion)",
        "Santo Rosario",
        "Tampok",
        "Tibaguin",
        "Iba‑Ibayo",
    ] },
    { province: "Bulacan", city: "Malolos", barangayList: [
        "Anilao",
        "Atlag",
        "Babatnin",
        "Bagna",
        "Bagong Bayan",
        "Balayong",
        "Balite",
        "Bangkal",
        "Barihan",
        "Bulihan",
        "Bungahan",
        "Caingin",
        "Calero",
        "Caliligawan",
        "Canalate",
        "Caniogan",
        "Catmon",
        "Cofradia",
        "Dakila",
        "Guinhawa",
        "Ligas",
        "Liang",
        "Longos",
        "Look 1st",
        "Look 2nd",
        "Lugam",
        "Mabolo",
        "Mambog",
        "Masile",
        "Matimbo",
        "Mojon",
        "Namayan",
        "Niugan",
        "Pamarawan",
        "Panasahan",
        "Pinagbakahan",
        "San Agustin",
        "San Gabriel",
        "San Juan",
        "San Pablo",
        "San Vicente (Poblacion)",
        "Santiago",
        "Santisima Trinidad",
        "Santo Cristo",
        "Santo Niño (Poblacion)",
        "Santo Rosario (Poblacion)",
        "Santor",
        "Sumapang Bata",
        "Sumapang Matanda",
        "Taal",
        "Tikay",
    ] },
    { province: "Bulacan", city: "Marilao", barangayList: [
        "Abangan Norte",
        "Abangan Sur",
        "Ibayo",
        "Lambakin",
        "Lias",
        "Loma de Gato",
        "Nagbalon",
        "Patubig",
        "Poblacion I",
        "Poblacion II",
        "Prenza I",
        "Prenza II",
        "Santa Rosa I",
        "Santa Rosa II",
        "Saog",
        "Tabing Ilog",
    ] },
    { province: "Bulacan", city: "Meycauayan", barangayList: [
        "Bagbaguin",
        "Bahay Pare",
        "Bancal",
        "Banga",
        "Bayugo",
        "Caingin",
        "Calvario",
        "Camalig",
        "Hulo",
        "Iba",
        "Langka",
        "Lawa",
        "Libtong",
        "Liputan",
        "Longos",
        "Malhacan",
        "Pajo",
        "Pandayan",
        "Pantoc",
        "Perez",
        "Poblacion",
        "Saluysoy",
        "Saint Francis (Gasak)",
        "Tugatog",
        "Ubihan",
        "Zamora",
    ] },
    { province: "Bulacan", city: "Norzagaray", barangayList: [
        "Bangkal",
        "Baraka",
        "Bigte",
        "Bitungol",
        "Matictic",
        "Minuyan",
        "Partida",
        "Pinagtulayan",
        "Poblacion",
        "San Mateo",
        "Tigbe",
        "San Lorenzo",
        "Friendship Village Resources (FVR)",
    ] },
    { province: "Bulacan", city: "Obando", barangayList: [
        "Binuangan",
        "Catanghalan",
        "Hulo",
        "Lawa",
        "Salambao",
        "Paco",
        "Pag‑asa (Poblacion)",
        "Paliwas",
        "Panghulo",
        "San Pascual",
        "Tawiran",
    ] },
    { province: "Bulacan", city: "Pandi", barangayList: [
        "Bagbaguin",
        "Bagong Barrio",
        "Bunsuran III",
        "Bunsuran I",
        "Bunsuran II",
        "Cacarong Bata",
        "Cacarong Matanda",
        "Cupang",
        "Malibong Bata",
        "Malibong Matanda",
        "Manatal",
        "Mapulang Lupa",
        "Masagana",
        "Masuso",
        "Pinagkuartelan",
        "Poblacion",
        "Real de Cacarong",
        "San Roque",
        "Siling Bata",
        "Siling Matanda",
        "Baka‑bakahan",
        "Santo Niño",
    ] },
    { province: "Bulacan", city: "Paombong", barangayList: [
        "Binakod ",
        "Kapitangan",
        "Malumot",
        "Masukol",
        "Pinalagdan",
        "Poblacion",
        "San Isidro I",
        "San Isidro II",
        "San Jose ",
        "San Roque",
        "San Vicente",
        "Santa Cruz",
        "Santo Niño ",
        "Santo Rosario",
    ] },
    { province: "Bulacan", city: "Plaridel", barangayList: [
        "Agnaya",
        "Bagong Silang",
        "Banga I",
        "Banga II",
        "Bintog",
        "Bulihan",
        "Culianin",
        "Dampol",
        "Lagundi",
        "Lalangan",
        "Lumang Bayan",
        "Parulan",
        "Poblacion",
        "Rueda",
        "San Jose",
        "Santa Ines",
        "Santo Niño",
        "Sipat",
        "Tabang",
    ] },
    { province: "Bulacan", city: "Pulilan", barangayList: [
        "Balatong A",
        "Balatong B",
        "Cutcot",
        "Dampol 1st",
        "Dampol 2nd A",
        "Dampol 2nd B",
        "Dulong Malabon",
        "Inaon",
        "Longos",
        "Lumbac",
        "Paltao",
        "Peñabatan",
        "Poblacion",
        "Sta Peregrina",
        "Sto Cristo",
        "Taal",
        "Tabon",
        "Tinejero",
        "Tibag",
    ] },
    { province: "Bulacan", city: "San Ildefonso", barangayList: [
        "Akle",
        "Alagao",
        "Anyatam",
        "Bagong Barrio",
        "Basuit",
        "Bubulong Munti",
        "Bubulong Malaki",
        "Buhol na Mangga",
        "Bulusukan",
        "Calasag",
        "Calawitan",
        "Casalat",
        "Gabihan",
        "Garlang",
        "Lapnit",
        "Maasim",
        "Makapilapil",
        "Malipampang",
        "Matimbubong",
        "Nabaong Garlang",
        "Palapala",
        "Pasong Bangkal",
        "Pinaod",
        "Poblacion",
        "Pulong Tamo",
        "San Juan",
        "Santa Catalina Bata",
        "Santa Catalina Matanda",
        "Sapang Dayap",
        "Sapang Putik",
        "Sapang Putol",
        "Sumandig",
        "Telapatio",
        "Upig",
        "Umpucan",
        "Mataas na Parang",
    ] },
    { province: "Bulacan", city: "San Jose del Monte", barangayList: [
        "Ciudad Real",
        "Dulong Bayan",
        "Francisco Homes-Guijo",
        "Francisco Homes-Mulawin",
        "Francisco Homes-Narra",
        "Francisco Homes-Yakal",
        "Gaya-Gaya",
        "Graceville",
        "Gumaoc-Central",
        "Gumaoc-East",
        "Gumaoc-West",
        "Kaybanban",
        "Kaypian",
        "Maharlika",
        "Muzón",
        "Paradise III",
        "Población",
        "Población I",
        "San Isidro",
        "San Manuel",
        "San Roque",
        "Santo Cristo",
        "Tungkong Mangga",
        "Minuyan I",
        "Minuyan II",
        "Minuyan III",
        "Minuyan IV",
        "Minuyan V",
        "Bagong Buhay I",
        "Bagong Buhay II",
        "Bagong Buhay III",
        "San Martín I",
        "San Martín II",
        "San Martín III",
        "San Martín IV",
        "Santa Cruz I",
        "Santa Cruz II",
        "Santa Cruz III",
        "Santa Cruz IV",
        "Santa Cruz V",
        "Fátima I",
        "Fátima II",
        "Fátima III",
        "Fátima IV",
        "Fátima V",
        "San Pedro",
        "Citrus",
        "San Rafael I",
        "San Rafael II",
        "San Rafael III",
        "San Rafael IV",
        "San Rafael V",
        "Assumption",
        "Lawang Pari",
        "Santo Niño I",
        "Santo Niño II",
        "St. Martin de Porres",
        "Sapang Palay Proper",
        "Minuyan Proper",
    ] },
    { province: "Bulacan", city: "San Miguel", barangayList: [
        "Bagong Silang",
        "Balaong",
        "Balite",
        "Bantog",
        "Bardias",
        "Baritan",
        "Batasan Bata",
        "Batasan Matanda",
        "Biak‑na‑Bato",
        "Biclat",
        "Buga",
        "Buliran",
        "Bulualto",
        "Calumpang",
        "Cambio",
        "Camias",
        "Ilog‑Bulo",
        "King Kabayo",
        "Labne",
        "Lambakin",
        "Magmarale",
        "Malibay",
        "Mandile",
        "Masalipit",
        "Pacalag",
        "Paliwasan",
        "Partida",
        "Pinambaran",
        "Poblacion",
        "Pulong Bayabas",
        "Sacdalan",
        "Salacot",
        "Salangan",
        "San Agustin",
        "San Jose",
        "San Juan",
        "San Vicente",
        "Santa Ines",
        "Santa Lucia",
        "Santa Rita Bata",
        "Santa Rita Matanda",
        "Sapang",
        "Sibul",
        "Tartaro",
        "Tibagan",
        "Bagong Pag‑asa",
        "Pulong Duhat",
        "Maligaya",
    ] },
    { province: "Bulacan", city: "San Rafael", barangayList: [
        "BMA‑Balagtas",
        "Banca‑banca",
        "Caingin",
        "Coral na Bato",
        "Cruz na Daan",
        "Dagat‑dagatan",
        "Diliman I",
        "Diliman II",
        "Capihan",
        "Libis",
        "Lico",
        "Maasim",
        "Mabalas‑balas",
        "Maguinao",
        "Maronguillo",
        "Paco",
        "Pansumaloc",
        "Pantubig",
        "Pasong Bangkal",
        "Pasong Callos",
        "Pasong Intsik",
        "Pinacpinacan",
        "Poblacion",
        "Pulo",
        "Pulong Bayabas",
        "Salapungan",
        "Sampaloc",
        "San Agustin",
        "San Roque",
        "Talacsan",
        "Tambubong",
        "Tukod",
        "Ulingao",
        "Sapang Pahalang",
    ] },
    { province: "Bulacan", city: "Santa Maria", barangayList: [
        "Bagbaguin",
        "Balasing",
        "Buenavista",
        "Bulac",
        "Camangyanan",
        "Catmon",
        "Cay Pombo",
        "Caysio",
        "Guyong",
        "Lalakhan",
        "Mag-asawang Sapa",
        "Mahabang Parang",
        "Manggahan",
        "Parada",
        "Población",
        "Pulong Buhangin",
        "San Gabriel",
        "San Jose Patag",
        "San Vicente",
        "Santa Clara",
        "Santa Cruz",
        "Silangan",
        "Tabing Bakod",
        "Tumana",
    ] },
    // { province: "Cagayan", city: "", barangayList: [] },
    // { province: "Camarines Norte", city: "", barangayList: [] },
    { province: "Camarines Sur", city: "Baao", barangayList: [
        "Agdangan Pob. (San Cayetano)",
        "Antipolo",
        "Bagumbayan",
        "Cristo Rey",
        "Del Pilar",
        "Del Rosario (Poblacion)",
        "Iyagan",
        "La Medalla",
        "Caranday (La Purisima)",
        "Lourdes",
        "Nababarera",
        "Sagrada",
        "Salvacion",
        "San Antonio (Buluang)",
        "San Francisco (Poblacion)",
        "San Isidro (Oras)",
        "San Jose (Poblacion)",
        "San Juan",
        "San Nicolas (Poblacion)",
        "San Rafael (Ikpan)",
        "Pugay (San Rafael/San Jose)",
        "San Ramon (Poblacion)",
        "San Roque (Poblacion)",
        "San Vicente",
        "Santa Cruz (Poblacion)",
        "Santa Eulalia",
        "Santa Isabel",
        "Santa Teresa (Vega)",
        "Santa Teresita (Tara-tara)",
        "Tapol",
    ] },
    { province: "Camarines Sur", city: "Balatan", barangayList: [
        "Cabanbanan",
        "Cabungan",
        "Camangahan",
        "Cayogcog",
        "Coguit",
        "Duran",
        "Laganac",
        "Luluasan",
        "Montenegro ",
        "Pararao (Parao)",
        "Siramag (Poblacion)",
        "Pulang Daga",
        "Sagrada Nacacale",
        "San Francisco",
        "Santiago Nacacale",
        "Tapayas",
        "Tomatarayo",
    ] },
    { province: "Camarines Sur", city: "Bato", barangayList: [
        "Agos",
        "Bacolod",
        "Buluang",
        "Caricot",
        "Cawacagan",
        "Cotmon",
        "Cristo Rey",
        "Del Rosario",
        "Divina Pastora (Poblacion)",
        "Goyudan",
        "Lobong",
        "Lubigan",
        "Mainit",
        "Manga (Mangga)",
        "Masoli",
        "Neighborhood",
        "Niño Jesus",
        "Pagatpatan",
        "Palo",
        "Payak",
        "Sagrada (Sagrada Familia)",
        "Salvacion",
        "San Isidro",
        "San Juan",
        "San Miguel",
        "San Rafael (Poblacion)",
        "San Roque",
        "San Vicente",
        "Santa Cruz (Poblacion)",
        "Santiago (Poblacion)",
        "Sooc",
        "Tagpolo",
        "Tres Reyes (Poblacion)",
    ] },
    { province: "Camarines Sur", city: "Bombon", barangayList: [
        "Pagao (San Juan)",
        "San Antonio",
        "San Francisco",
        "San Isidro (Poblacion)",
        "San Jose (Poblacion)",
        "San Roque (Poblacion)",
        "Santo Domingo",
        "Siembre",
    ] },
    { province: "Camarines Sur", city: "Buhi", barangayList: [
        "The Poblacion",
        "The Lake/Mt. Asog sector",
        "the Road/cross road sector",
        "The Mountain sector",
        "The Malangkaw Sector",
    ] },
    { province: "Camarines Sur", city: "Bula", barangayList: [
        "Bagoladio",
        "Bagumbayan",
        "Balaogan",
        "Caorasan",
        "Casugad",
        "Causip",
        "Fabrica",
        "Inoyonan",
        "Itangon",
        "Kinalabasahan",
        "La Purisima",
        "La Victoria",
        "Lanipga",
        "Lubgan",
        "Ombao Heights",
        "Ombao Polpog",
        "Palsong",
        "Panoypoyan",
        "Pawili",
        "Sagrada (Sagrada Familia)",
        "Salvacion (Poblacion)",
        "San Agustin",
        "San Francisco",
        "San Isidro",
        "San Jose",
        "San Miguel",
        "San Ramon",
        "San Roque (Poblacion)",
        "San Roque Heights",
        "Santa Elena",
        "Santo Domingo",
        "Santo Niño",
        "Taisan",
    ] },
    { province: "Camarines Sur", city: "Cabusao", barangayList: [
        "Barceloneta",
        "Biong",
        "Camagong",
        "Castillo",
        "New Poblacion",
        "Pandan",
        "San Pedro",
        "Santa Cruz",
        "Santa Lutgarda",
    ] },
    { province: "Camarines Sur", city: "Calabanga", barangayList: [
        "Balatasan",
        "Balombon",
        "Balongay",
        "Belen",
        "Bigaas",
        "Binanuaanan Grande",
        "Binanuaanan Pequeño",
        "Binaliw",
        "Bonot-Santa Rosa",
        "Burabod",
        "Cabanbanan",
        "Cagsao",
        "Camuning",
        "Comaguingking",
        "Del Carmen",
        "Dominorog",
        "Fabrica",
        "Harubay",
        "La Purisima (Quipayo)",
        "Lugsad",
        "Manguiring",
        "Pagatpat",
        "Paolbo",
        "Pinada",
        "Punta Tarawal",
        "Quinale",
        "Sabang",
        "Salvacion-Baybay",
        "San Antonio Poblacion",
        "San Antonio (Quipayo)",
        "San Bernardino",
        "San Francisco",
        "San Isidro",
        "San Lucas",
        "San Miguel",
        "San Pablo",
        "San Roque",
        "San Vicente",
        "Santa Cruz Poblacion",
        "Santa Cruz (Quipayo)",
        "Santa Isabel",
        "Santa Salud",
        "Santo Domingo",
        "Santo Niño (Quipayo)",
        "Siba-o",
        "Sibobo",
        "Sogod",
        "Tomagodtod",
    ] },
    { province: "Camarines Sur", city: "Camaligan", barangayList: [
        "Dugcal",
        "Marupit",
        "San Francisco",
        "San Francisco",
        "San Juan-San Ramon (Poblacion)",
        "San Lucas (Poblacion)",
        "San Marcos (Poblacion)",
        "San Mateo (Poblacion)",
        "San Roque",
        "Santo Domingo (Poblacion)",
        "Santo Tomas (Poblacion)",
        "Sua",
        "Tarosanan",
    ] },
    { province: "Camarines Sur", city: "Canaman", barangayList: [
        "Baras (Poblacion)",
        "Del Rosario",
        "Dinaga (Poblacion)",
        "Fundado",
        "Haring",
        "Iquin",
        "Linaga",
        "Mangayawan",
        "Palo",
        "Pangpang (Poblacion)",
        "Poro",
        "San Agustin",
        "San Francisco",
        "San Jose East",
        "San Jose West",
        "San Juan",
        "San Nicolas",
        "San Roque",
        "San Vicente",
        "Santa Cruz (Poblacion)",
        "Santa Teresita",
        "Sua",
        "Talidtid",
        "Tibgao (Poblacion)",
    ] },
    { province: "Camarines Sur", city: "Caramoan", barangayList: [
        "Agaas",
        "Antolon",
        "Bacgong",
        "Bahay",
        "Bikal",
        "Binanuahan",
        "Cabacongan",
        "Cadong",
        "Colongcogong",
        "Canatuan",
        "Caputatan",
        "Gogon",
        "Daraga",
        "Gata",
        "Gibgos",
        "Guijalo",
        "Hanopol",
        "Hanoy",
        "Haponan",
        "Ilawod",
        "Ili-Centro",
        "Lidong",
        "Lubas",
        "Malabog",
        "Maligaya",
        "Mampirao",
        "Mandiclum",
        "Maqueda",
        "Minalaba",
        "Oring",
        "Oroc-Osoc",
        "Pagolinan",
        "Pandanan",
        "Paniman",
        "Patag-Belen",
        "Pili-Centro",
        "Pili-Tabiguian",
        "Poloan",
        "Salvacion",
        "San Roque",
        "San Vicente",
        "Santa Cruz",
        "Solnopan (Poblacion)",
        "Tabgon",
        "Tabiguian",
        "Tabog",
        "Tawog",
        "Toboan",
        "Terogo",
    ] },
    { province: "Camarines Sur", city: "Del Gallego", barangayList: [
        "Bagong Silang",
        "Bucal",
        "Cabasag",
        "Comadaycaday",
        "Domagondong",
        "Kinalangan",
        "Comadogcadog",
        "Mabini",
        "Magais I",
        "Magais II",
        "Mansalaya",
        "Nagkalit",
        "Palaspas",
        "Pamplona",
        "Pasay",
        "Pinagdapian",
        "Pinugusan",
        "Zone I Fatima (Poblacion)",
        "Zone II San Antonio (Poblacion)",
        "Poblacion Zone III",
        "Sabang",
        "Salvacion",
        "San Juan",
        "San Pablo",
        "Santa Rita I",
        "Santa Rita II",
        "Peñafrancia (Sinagawsawan)",
        "Sinuknipan I",
        "Sinuknipan II",
        "Sugsugin",
        "Tabion",
        "Tomagoktok",
    ] },
    { province: "Camarines Sur", city: "Gainza", barangayList: [
        "Cagbunga",
        "Dahilig",
        "Loob",
        "Malbong",
        "Namuat",
        "Sampaloc",
        "District I (poblacion)",
        "District II (poblacion)",
    ] },
    { province: "Camarines Sur", city: "Garchitorena", barangayList: [
        "Ason (Anson)",
        "Bahi",
        "Binagasbasan",
        "Burabod",
        "Cagamutan",
        "Cagnipa",
        "Canlong",
        "Dangla",
        "Del Pilar",
        "Denrica",
        "Harrison",
        "Mansangat",
        "Pambuhan",
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Barangay III (Poblacion)",
        "Barangay IV (Poblacion)",
        "Sagrada",
        "Salvacion",
        "San Vicente",
        "Sumaoy",
        "Tamiawon",
        "Toytoy",
    ] },
    { province: "Camarines Sur", city: "Goa", barangayList: [
        "Abucayan",
        "Bagumbayan Grande (Poblacion)",
        "Bagumbayan Pequeño (Poblacion)",
        "Balaynan",
        "Belen (Poblacion)",
        "Buyo",
        "Cagaycay",
        "Catagbacan",
        "Digdigon",
        "Gimaga",
        "Halawig-Gogon",
        "Hiwacloy",
        "La Purisima (Poblacion)",
        "Lamon",
        "Matacla",
        "Maymatan",
        "Maysalay",
        "Napawon",
        "Panday (Poblacion)",
        "Payatan",
        "Pinaglabanan",
        "Salog",
        "San Benito (Poblacion)",
        "San Isidro West",
        "San Isidro (Poblacion)",
        "San Jose (Poblacion)",
        "San Juan Bautista (Poblacion)",
        "San Juan Evangelista (Poblacion)",
        "San Pedro (formerly Aroro)",
        "Scout Fuentebella (West)",
        "Tabgon",
        "Tagongtong",
        "Tamban (Mabini)",
        "Taytay",
    ] },
    { province: "Camarines Sur", city: "Iriga", barangayList: [
        "Antipolo",
        "Cristo Rey",
        "Del Rosario (Banao)",
        "Francia",
        "La Anunciacion",
        "La Medalla",
        "La Purisima",
        "La Trinidad",
        "Niño Jesus",
        "Perpetual Help",
        "Sagrada",
        "Salvacion",
        "San Agustin",
        "San Andres",
        "San Antonio",
        "San Francisco",
        "San Isidro",
        "San Jose",
        "San Juan",
        "San Miguel",
        "San Nicolas",
        "San Pedro",
        "San Rafael",
        "San Ramon",
        "San Roque",
        "Santiago",
        "San Vicente Norte",
        "San Vicente Sur",
        "Santa Cruz Norte",
        "Santa Cruz Sur",
        "Santa Elena",
        "Santa Isabel",
        "Santa Maria",
        "Santa Teresita",
        "Santo Domingo",
        "Santo Niño",
    ] },
    { province: "Camarines Sur", city: "Lagonoy", barangayList: [
        "Agosais",
        "Agpo-Camagong-Tabog",
        "Amoguis",
        "Bocogan",
        "Balaton",
        "Binanuahan",
        "Burabod",
        "Cabotonan",
        "Dahat",
        "Del Carmen",
        "Genorangan",
        "Gimagtocon",
        "Gubat",
        "Guibahoy",
        "Himanag",
        "Kinahologan",
        "Loho",
        "Manamoc",
        "Mangogon",
        "Mapid",
        "Olas",
        "Omalo",
        "Panagan",
        "Panicuan",
        "Pinamihagan",
        "San Francisco (Poblacion)",
        "San Isidro",
        "San Isidro Sur (Poblacion)",
        "San Isidro Norte (Poblacion)",
        "San Rafael",
        "San Ramon",
        "San Roque",
        "San Sebastian",
        "San Vicente (Poblacion)",
        "Santa Cruz",
        "Santa Maria (Poblacion)",
        "Saripongpong (Poblacion)",
        "Sipaco",
    ] },
    { province: "Camarines Sur", city: "Libmanan", barangayList: [
        "Aslong",
        "Awayan",
        "Bagacay",
        "Bagadion",
        "Bagamelon",
        "Bagumbayan",
        "Bahao",
        "Bahay",
        "Beguito Nuevo",
        "Beguito Viejo",
        "Bigajo Norte",
        "Bigajo Sur",
        "Bikal",
        "Busak",
        "Caima",
        "Calabnigan",
        "Camambugan",
        "Cambalidio",
        "Candami",
        "Candato",
        "Cawayan",
        "Concepcion",
        "Cuyapi",
        "Danawan",
        "Duang Niog",
        "Handong",
        "Ibid",
        "Inalahan",
        "Labao",
        "Libod I",
        "Libod II",
        "Loba-loba",
        "Mabini",
        "Malansad Nuevo",
        "Malansad Viejo",
        "Malbogon",
        "Malinao",
        "Mambalite",
        "Mambayawas",
        "Mambulo Nuevo",
        "Mambulo Viejo",
        "Mancawayan",
        "Mandacanan",
        "Mantalisay",
        "Padlos",
        "Pag-Oring Nuevo",
        "Pag-Oring Viejo",
        "Palangon",
        "Palong",
        "Patag",
        "Planza",
        "Poblacion",
        "Potot",
        "Puro-Batia",
        "Rongos",
        "Salvacion",
        "San Isidro",
        "San Juan",
        "San Pablo",
        "San Vicente",
        "Sibujo",
        "Sigamot",
        "Station-Church Site",
        "Taban-Fundado",
        "Tampuhan",
        "Tanag",
        "Tarum",
        "Tinalmud Nuevo",
        "Tinalmud Viejo",
        "Tinanquihan",
        "Udok",
        "Umalo",
        "Uson",
        "Villasocorro",
        "Villadima (Santa Cruz)",
    ] },
    { province: "Camarines Sur", city: "Lupi", barangayList: [
        "Alleomar",
        "Bagangan Sr.",
        "Bagong Sikat",
        "Bel-Cruz",
        "Bangon",
        "Barrera Jr.",
        "Barrera Sr.",
        "Belwang",
        "Buenasuerte",
        "Bulawan Jr.",
        "Bulawan Sr.",
        "Cabutagan",
        "Casay",
        "Colacling (Del Rosario)",
        "Cristo Rey",
        "Del Carmen",
        "Haguimit",
        "Halubán (Pigbasagan)",
        "Kaibigan",
        "La Purísima",
        "Lourdes",
        "Mangcawayan",
        "Napolidan",
        "Población",
        "Polantuna",
        "Sagrada",
        "Salvación",
        "San Isidro",
        "San José",
        "San Pedro",
        "San Rafael Norte",
        "San Rafael Sur",
        "San Ramon",
        "San Vicente",
        "Sooc",
        "Tanawán",
        "Tible",
        "Tapi (Lupi Nuevo)",
    ] },
    { province: "Camarines Sur", city: "Magarao", barangayList: [
        "Barobaybay",
        "Bell (Poblacion)",
        "Carangcang",
        "Carigsa",
        "Casuray",
        "Monserrat (Poblacion)",
        "Ponong",
        "San Francisco (Poblacion)",
        "San Isidro (Poblacion)",
        "San Juan (Poblacion)",
        "San Miguel",
        "San Pantaleon (Poblacion)",
        "Santa Lucia (Poblacion)",
        "Santa Rosa",
        "Santo Tomas (Poblacion)",
    ] },
    { province: "Camarines Sur", city: "Milaor", barangayList: [
        "Alimbuyog",
        "Amparado (Pob)",
        "Balagbag",
        "Borongborongan",
        "Cabugao",
        "Capucnasan",
        "Dalipay",
        "Del Rosario (Pob)",
        "Flordeliz",
        "Lipot",
        "Mayaopayawan",
        "Maycatmon",
        "Maydaso",
        "San Antonio",
        "San Jose (Pob)",
        "San Miguel (Pob)",
        "San Roque (Pob)",
        "San Vicente (Pob)",
        "Santo Domingo (Pob)",
        "Tarusanan",
    ] },
    { province: "Camarines Sur", city: "Minalabac", barangayList: [
        "Antipolo",
        "Bagolatao",
        "Bagongbong",
        "Baliuag Nuevo",
        "Baliuag Viejo",
        "Catanusan",
        "Del Carmen-Del Rosario (Poblacion)",
        "Del Socorro",
        "Hamoraon",
        "Hobo",
        "Irayang Solong",
        "Magadap",
        "Malitbog",
        "Manapao",
        "Mataoroc",
        "Sagrada (Sagrada Familia)",
        "Salingogon",
        "San Antonio",
        "San Felipe-Santiago (Poblacion)",
        "San Francisco (Poblacion)",
        "San Jose",
        "San Juan-San Lorenzo (Poblacion)",
        "Taban",
        "Tariric",
        "Timbang",
    ] },
    { province: "Camarines Sur", city: "Nabua", barangayList: [
        "Angustia (Angustia Inapatan)",
        "Antipolo Old",
        "Antipolo Young",
        "Aro-aldao",
        "Bustrac",
        "Inapatan (Del Rosario Inapatan)",
        "Dolorosa (Dolorosa Inapatan)",
        "Duran (Jesus Duran)",
        "La Purisima (Agupit)",
        "Lourdes Old",
        "Lourdes Young",
        "La Opinion",
        "Paloyon Oriental",
        "Paloyon Proper (Sagrada Paloyon)",
        "Salvacion Que Gatos",
        "San Antonio (Poblacion)",
        "San Antonio Ogbon",
        "San Esteban (Poblacion)",
        "San Francisco (Poblacion)",
        "San Isidro (Poblacion)",
        "San Isidro Inapatan",
        "Malawag (San Jose Malawag)",
        "San Jose (San Jose Pangaraon)",
        "San Juan (Poblacion)",
        "San Luis (Poblacion)",
        "San Miguel (Poblacion)",
        "San Nicolas (Poblacion)",
        "San Roque (Poblacion)",
        "San Roque Madawon",
        "San Roque Sagumay",
        "San Vicente Gorong-Gorong",
        "San Vicente Ogbon",
        "Santa Barbara (Maliban)",
        "Santa Cruz",
        "Santa Elena Baras",
        "Santa Lucia Baras",
        "Santiago Old",
        "Santiago Young",
        "Santo Domingo",
        "Tandaay",
        "Topas Proper",
        "Topas Sogod",
    ] },
    { province: "Camarines Sur", city: "Naga", barangayList: [
        "Abella",
        "Bagumbayan Norte",
        "Bagumbayan Sur",
        "Balatas",
        "Calauag",
        "Cararayan",
        "Carolina",
        "Concepcion Grande",
        "Concepcion Pequeña",
        "Dayangdang",
        "Del Rosario",
        "Dinaga",
        "Igualdad Interior",
        "Lerma",
        "Liboton",
        "Mabolo",
        "Pacol",
        "Panicuason",
        "Peñafrancia",
        "Sabang",
        "San Felipe",
        "San Francisco",
        "San Isidro",
        "Santa Cruz",
        "Tabuco",
        "Tinago",
        "Triangulo",
    ] },
    { province: "Camarines Sur", city: "Ocampo", barangayList: [
        "Ayugan",
        "Cabariwan",
        "Cagmanaba",
        "Del Rosario",
        "Gatbo",
        "Guinaban",
        "Hanawan",
        "Hibago",
        "La Purisima Nuevo",
        "May-Ogob",
        "New Moriones",
        "Old Moriones",
        "Pinit",
        "Poblacion Central",
        "Poblacion East",
        "Poblacion West",
        "Salvacion",
        "San Antonio",
        "San Francisco",
        "San Jose Oras",
        "San Roque Commonal",
        "San Vicente",
        "Santa Cruz",
        "Santo Niño",
        "Villaflorida",
    ] },
    { province: "Camarines Sur", city: "Pamplona", barangayList: [
        "Batang",
        "Burabod",
        "Cagbibi",
        "Cagbunga",
        "Calawat",
        "Del Rosario",
        "Patong",
        "Poblacion",
        "Salvacion",
        "San Gabriel",
        "San Isidro",
        "San Rafael",
        "San Ramon",
        "San Vicente",
        "Veneracion (Taguilid)",
        "Tambo",
        "Tampadong",
    ] },
    { province: "Camarines Sur", city: "Pasacao", barangayList: [
        "Antipolo",
        "Bagong Silang",
        "Bahay",
        "Balogo",
        "Caranan",
        "Cuco",
        "Dalupaon",
        "Hubo",
        "Itulan",
        "Macad (Hebrio Lourdes)",
        "Odicon",
        "Quitang",
        "Salvacion",
        "San Antonio",
        "San Cirilo (Poblacion)",
        "Santa Rosa Del Norte (Poblacion)",
        "Santa Rosa Del Sur (Poblacion)",
        "Tilnac",
        "Tinalmud",
    ] },
    { province: "Camarines Sur", city: "Pili", barangayList: [
        "Anayan",
        "Bagong Sirang",
        "Binanuaanan",
        "Binobong",
        "Cadlan (Provincial Center)",
        "Caroyroyan",
        "Curry",
        "Del Rosario",
        "Himaao",
        "La Purisima",
        "New San Roque",
        "Old San Roque (Poblacion)",
        "Palestina",
    ] },
    { province: "Camarines Sur", city: "Presentacion", barangayList: [
        "Ayugao",
        "Bagong Sirang",
        "Baliguian",
        "Bantugan",
        "Bicalen",
        "Bitaogan",
        "Buenavista",
        "Bulalacao",
        "Cagnipa",
        "Lagha",
        "Lidong",
        "Liwacsa",
        "Maangas",
        "Pagsangaan",
        "Patrocinio (Dalhugan)",
        "Pili",
        "Santa Maria (Poblacion)",
        "Tanauan",
    ] },
    { province: "Camarines Sur", city: "Ragay", barangayList: [
        "Agao-ao",
        "Agrupacion",
        "Amomokpok",
        "Apad",
        "Apale",
        "Banga Caves",
        "Baya",
        "Binahan Proper",
        "Binahan Upper",
        "Buenasuerte",
        "Cabadisan",
        "Cabinitan",
        "Cabugao",
        "Caditaan",
        "Cale",
        "Godofredo Reyes Sr.(Catabang)",
        "Catabangan Proper",
        "Inandawa",
        "Laguio",
        "Lanipga-Cawayan",
        "Liboro",
        "Lohong",
        "Lower Omon",
        "Lower Santa Cruz",
        "Panaytayan",
        "Panaytayan Nuevo",
        "Patalunan",
        "Poblacion Ilaod",
        "Poblacion Iraya",
        "Port Junction Norte",
        "Port Junction Sur",
        "Salvacion",
        "Samay",
        "San Rafael",
        "F. Simeon (Pugod)",
        "Tagbac",
        "Upper Omon",
        "Upper Santa Cruz",
    ] },
    { province: "Camarines Sur", city: "Sagñay", barangayList: [
        "Aniog",
        "Atulayan",
        "Bongalon",
        "Buracan",
        "Catalotoan",
        "Del Carmen (Poblacion)",
        "Kilantaao",
        "Kilomaon",
        "Mabca",
        "Minadongjol",
        "Nato",
        "Patitinan",
        "San Antonio (Poblacion)",
        "San Isidro (Poblacion)",
        "San Roque (Poblacion)",
        "Santo Niño",
        "Sibaguan",
        "Tinorongan",
        "Turague",
    ] },
    { province: "Camarines Sur", city: "San Fernando", barangayList: [
        "Alianza",
        "Beberon",
        "Bical",
        "Bocal",
        "Bonifacio (Poblacion)",
        "Buenavista (Poblacion)",
        "Calascagas",
        "Cotmo",
        "Daculang Tubig",
        "Del Pilar (Poblacion)",
        "Gñaran",
        "Grijalvo",
        "Lupi",
        "Maragñi",
        "Pamukid",
        "Pinamasagan",
        "Pipian",
        "Planza",
        "Rizal (Poblacion)",
        "San Joaquin",
        "Santa Cruz",
        "Tagpocol",
    ] },
    { province: "Camarines Sur", city: "San Jose", barangayList: [
        "Del Carmen (Poblacion)",
        "San Antonio (Poblacion)",
        "San Juan (Poblacion)",
        "San Vicente (Poblacion)",
        "Santa Cruz (Poblacion)",
        "Soledad (Poblacion)",
        "Adiangao",
        "Bagacay",
        "Bahay",
        "Boclod",
        "Calalahan",
        "Calawit",
        "Camagong",
        "Catalotoan",
        "Danlog",
        "Dolo",
        "Kinalansan",
        "Mampirao",
        "Manzana",
        "Minoro",
        "Palale",
        "Ponglon",
        "Pugay",
        "Sabang",
        "Salogon",
        "Tagas",
        "Tambangan",
        "Telegrafo",
        "Tominawog",
    ] },
    { province: "Camarines Sur", city: "Sipocot", barangayList: [
        "Aldezar",
        "Alteza",
        "Anib",
        "Awayan",
        "Azucena",
        "Bagong Sirang",
        "Binahian",
        "Bolo Sur",
        "Bolo Norte",
        "Bulan",
        "Bulawan",
        "Cabuyao",
        "Caima",
        "Calagbangan",
        "Calampinay",
        "Carayrayan",
        "Cotmo",
        "Gabi",
        "Gaongan",
        "Impig",
        "Lipilip",
        "Lubigan Jr.",
        "Lubigan Sr.",
        "Malaguico",
        "Malubago",
        "Manangle",
        "Mangga",
        "Mangapo",
        "Manlubang",
        "Mantila",
        "North Centro (Poblacion)",
        "North Villazar",
        "Sagrada Familia",
        "Salanda",
        "Salvacion",
        "San Isidro",
        "San Vicente",
        "Serranzana",
        "South Centro (Poblacion)",
        "South Villazar",
        "Taisan",
        "Tara",
        "Tible",
        "Tula-tula",
        "Vigaan",
        "Yabo",
    ] },
    { province: "Camarines Sur", city: "Siruma", barangayList: [
        "Bagong Sirang",
        "Bahao",
        "Boboan",
        "Butawanan",
        "Cabugao",
        "Fundado",
        "Homestead",
        "La Purisima",
        "Mabuhay",
        "Malaconini",
        "Matandang Siruma",
        "Nalayahan",
        "Pinitan",
        "Poblacion",
        "Pamintan-Bantilan",
        "Salvacion",
        "San Andres",
        "San Ramon (Daldagon)",
        "Sulpa",
        "Tandoc",
        "Tongo-Bantigue",
        "Vito",
    ] },
    { province: "Camarines Sur", city: "Tigaon", barangayList: [
        "Abo",
        "Cabalinadan",
        "Caraycayon",
        "Casuna",
        "Consocep",
        "Coyaoyao",
        "Gaao",
        "Gingaroy",
        "Gubat",
        "Huyonhuyon",
        "Libod",
        "Mabalodbalod",
        "May-Anao",
        "Panagan",
        "Poblacion",
        "Salvacion",
        "San Antonio",
        "San Francisco",
        "San Miguel",
        "San Rafael",
        "Talojongon",
        "Tinawagan",
        "Vinagre",
    ] },
    { province: "Camarines Sur", city: "Tinambac", barangayList: [
        "Agay-Ayan",
        "Antipolo",
        "Bagacay",
        "Banga",
        "Bolaobalite",
        "Bani",
        "Bataan",
        "Binalay (Poblacion)",
        "Buenavista",
        "Buyo",
        "Cagliliog",
        "Caloco",
        "Camagong",
        "Canayonan",
        "Cawaynan",
        "Daligan",
        "Filarca (Poblacion)",
        "La Purisima (Poblacion)",
        "Lupi",
        "Magsaysay (Camp 4)",
        "Magtang",
        "Malibtong",
        "Mananao",
        "La Medalla (Mile 9)",
        "New Caaluan",
        "Olag Grande",
        "Olag Pequeño",
        "Old Caaluan",
        "Pag-Asa",
        "Pantat",
        "Sagrada (Camp 6)",
        "Salvacion",
        "San Antonio",
        "San Isidro (Poblacion)",
        "San Jose (Tiltilan)",
        "San Pascual (Poblacion)",
        "San Ramon (Camp 7)",
        "San Roque",
        "San Vicente",
        "Santa Cruz (Poblacion)",
        "Sogod",
        "Tambang",
        "Tierra Nevada",
        "Union",
        "Salvacion Poblacion",
    ] },
    // { province: "Camiguin", city: "", barangayList: [] },
    // { province: "Capiz", city: "", barangayList: [] },
    // { province: "Catanduanes", city: "", barangayList: [] },
    { province: "Cavite", city: "Alfonso", barangayList: [
        "Amuyong",
        "Bilog",
        "Buck Estate",
        "Esperanza Ibaba",
        "Esperanza Ilaya",
        "Kaysuyo (Kaytitinga IV)",
        "Kaytitinga I",
        "Kaytitinga II",
        "Kaytitinga III",
        "Luksuhin Ibaba",
        "Luksuhin Ilaya",
        "Mangas I",
        "Mangas II",
        "Marahan I",
        "Marahan II",
        "Matagbak I",
        "Matagbak II",
        "Pajo",
        "Palumlum",
        "Poblacion I",
        "Poblacion II",
        "Poblacion III",
        "Poblacion IV",
        "Poblacion V",
        "Santa Teresa (Pulyok and Kaytayo)",
        "Sicat",
        "Sinaliw Malaki",
        "Sinaliw Munti",
        "Sulsugin",
        "Taywanak Ibaba",
        "Taywanak Ilaya",
        "Upli",
    ] },
    { province: "Cavite", city: "Amadeo", barangayList: [
        "Banaybanay",
        "Buho",
        "Bucal",
        "Dagatan",
        "Halang",
        "Loma",
        "Maitim I",
        "Maymangga",
        "Minantok Kanluran",
        "Minantok Silangan",
        "Pangil",
        "Barangay I (Pob.)",
        "Barangay II (Pob.)",
        "Barangay III (Pob.)",
        "Barangay IV (Pob.)",
        "Barangay V (Pob.)",
        "Barangay VI (Pob.)",
        "Barangay VII (Pob.)",
        "Barangay VIII (Pob.)",
        "Barangay IX (Pob.)",
        "Barangay X (Pob.)",
        "Barangay XI (Pob.)",
        "Barangay XII (Pob.)",
        "Salaban",
        "Talon",
        "Tamacan",
    ] },
    { province: "Cavite", city: "Bacoor", barangayList: [
        "Alima",
        "Aniban I",
        "Aniban II",
        "Aniban III",
        "Aniban IV",
        "Aniban V",
        "Banalo",
        "Camposanto",
        "Daang Bukid",
        "Digman",
        "Dulong Bayan",
        "Habay I",
        "Habay II",
        "Kaingin",
        "Ligas I",
        "Ligas II",
        "Ligas III",
        "Mabolo I",
        "Mabolo II",
        "Mabolo III",
        "Maliksi I",
        "Maliksi II",
        "Maliksi III",
        "Niog I",
        "Niog II",
        "Niog III",
        "Panapaan I",
        "Panapaan II",
        "Panapaan III",
        "Panapaan IV",
        "Panapaan V",
        "Panapaan VI",
        "Panapaan VII",
        "Panapaan VIII",
        "Real I",
        "Real II",
        "Salinas I",
        "Salinas II",
        "Salinas III",
        "Salinas IV",
        "San Nicolas I",
        "San Nicolas II",
        "San Nicolas III",
        "Sineguelasan",
        "Tabing Dagat (Poblacion)",
        "Talaba I",
        "Talaba II",
        "Talaba III",
        "Talaba IV",
        "Talaba V",
        "Talaba VI",
        "Talaba VII",
        "Zapote I",
        "Zapote II",
        "Zapote III",
        "Zapote IV",
        "Zapote V (Longos)",
    ] },
    { province: "Cavite", city: "Carmona", barangayList: [
        "Bancal",
        "Cabilang Baybay",
        "Lantic",
        "Mabuhay",
        "Maduya",
        "Milagrosa",
        "Poblacion 1",
        "Poblacion 2",
        "Poblacion 3",
        "Poblacion 4",
        "Poblacion 5",
        "Poblacion 6",
        "Poblacion 7",
        "Rosario",
    ] },
    { province: "Cavite", city: "Cavite City", barangayList: [
        "Barangay 1 (Hen. M. Alvarez)",
        "Barangay 2 (Hen. C. Tirona)",
        "Barangay 3 (Hen. E. Aguinaldo)",
        "Barangay 4 (Hen. M. Trias)",
        "Barangay 5 (Hen. E. Evangelista)",
        "Barangay 6 (Diego Silang)",
        "Barangay 7 (Kapitan Kong)",
        "Barangay 8 (Manuel S. Rojas)",
        "Barangay 9 (Kanaway)",
        "Barangay 10-M (Kingfisher)",
        "Barangay 10-A (Kingfisher A)",
        "Barangay 10-B (Kingfisher B)",
        "Barangay 11 (Lawin)",
        "Barangay 12 (Love Bird)",
        "Barangay 13 (Aguila)",
        "Barangay 14 (Loro)",
        "Barangay 15 (Kilyawan)",
        "Barangay 16 (Martines)",
        "Barangay 17 (Kalapati)",
        "Barangay 18 (Maya/Pisces)",
        "Barangay 19 (Gemini)",
        "Barangay 20 (Virgo)",
        "Barangay 21 (Scorpio)",
        "Barangay 22 (Leo)",
        "Barangay 22-A (Leo A)",
        "Barangay 23 (Aquarius)",
        "Barangay 24 (Libra)",
        "Barangay 25 (Capricorn)",
        "Barangay 26 (Cancer)",
        "Barangay 27 (Sagitarius)",
        "Barangay 28 (Taurus)",
        "Barangay 29 (Lao-lao/Aries)",
        "Barangay 29-A (Lao-lao A/Aries A)",
        "Barangay 30 (Bid-bid)",
        "Barangay 31 (Maya-maya)",
        "Barangay 32 (Salay-salay)",
        "Barangay 33 (Buwan-buwan)",
        "Barangay 34 (Lapu-lapu)",
        "Barangay 35 (Hasa-hasa)",
        "Barangay 36 (Sap-Sap)",
        "Barangay 36-A (Sap-sap A)",
        "Barangay 37-M (Cadena de Amor)",
        "Barangay 37-A (Cadena de Amor A)",
        "Barangay 38 (Sampaguita)",
        "Barangay 38-A (Sampaguita A)",
        "Barangay 39 (Jasmin)",
        "Barangay 40 (Gumamela)",
        "Barangay 41 (Rosal)",
        "Barangay 42 (Pinagbuklod)",
        "Barangay 42-A (Pinagbuklod A)",
        "Barangay 42-B (Pinagbuklod B)",
        "Barangay 42-C (Pinagbuklod C)",
        "Barangay 43 (Pinagpala)",
        "Barangay 44 (Maligaya)",
        "Barangay 45 (Kaunlaran)",
        "Barangay 45-A (Kaunlaran A)",
        "Barangay 46 (Sinagtala)",
        "Barangay 47 (Pagkakaisa)",
        "Barangay 47-A (Pagkakaisa A)",
        "Barangay 47-B (Pagkakaisa B)",
        "Barangay 48 (Narra)",
        "Barangay 48-A (Narra A)",
        "Barangay 49 (Akasya)",
        "Barangay 49-A (Akasya A)",
        "Barangay 50 (Kabalyero)",
        "Barangay 51 (Kamagong)",
        "Barangay 52 (Ipil)",
        "Barangay 53 (Yakal)",
        "Barangay 53-A (Yakal A)Air Force",
        "Barangay 53-B (Yakal B)Navy",
        "Barangay 54-A (Pechay A)",
        "Barangay 54-M (Pechay)",
        "Barangay 55 (Ampalaya)",
        "Barangay 56 (Labanos)",
        "Barangay 57 (Repolyo)",
        "Barangay 58 (Patola)",
        "Barangay 58-A (Patola A)",
        "Barangay 59 (Sitaw)",
        "Barangay 60 (Letsugas)",
        "Barangay 61 (Talong; Poblacion)",
        "Barangay 61-A (Talong A; Poblacion)",
        "Barangay 62 (Kangkong; Poblacion)",
        "Barangay 62-A (Kangkong A; Poblacion)",
        "Barangay 62-B (Kangkong B; Poblacion)",
    ] },
    { province: "Cavite", city: "Dasmariñas", barangayList: [
        "Burol Main",
        "Burol I",
        "Burol II",
        "Burol III",
        "Datu Esmael (Bago-A-Ingud)",
        "Emmanuel Bergado I",
        "Emmanuel Bergado II",
        "Fatima I",
        "Fatima II",
        "Fatima III",
        "H-2 (Santa Veronica)",
        "Langkaan I (Humayao)",
        "Langkaan II",
        "Luzviminda I",
        "Luzviminda II",
        "Paliparan I",
        "Paliparan II",
        "Paliparan III",
        "Sabang",
        "Salawag",
        "Saint Peter I",
        "Saint Peter II",
        "Salitran I",
        "Salitran II",
        "Salitran III",
        "Salitran IV",
        "Sampaloc I (Pala-Pala)",
        "Sampaloc II (Bucal/Malinta)",
        "Sampaloc III (Piela)",
        "Sampaloc IV (Talisayan/Bautista)",
        "Sampaloc V (New Era)",
        "San Agustin I",
        "San Agustin II (R. Tirona)",
        "San Agustin III",
        "San Andres I",
        "San Andres II",
        "San Antonio De Padua I",
        "San Antonio De Padua II",
        "San Dionisio",
        "San Esteban",
        "San Francisco I",
        "San Francisco II",
        "San Isidro Labrador I",
        "San Isidro Labrador II",
        "San Jose",
        "San Juan",
        "San Lorenzo Ruiz I",
        "San Lorenzo Ruiz II",
        "San Luis I",
        "San Luis II",
        "San Manuel I",
        "San Manuel II",
        "San Mateo",
        "San Miguel I",
        "San Miguel II",
        "San Nicolas I",
        "San Nicolas II",
        "San Roque",
        "San Simon",
        "Santa Cristina I",
        "Santa Cristina II",
        "Santa Cruz I",
        "Santa Cruz II",
        "Santa Fe",
        "Santa Lucia",
        "Santa Maria",
        "Santo Cristo",
        "Santo Niño I",
        "Santo Niño II",
        "Victoria Reyes",
        "Zone I",
        "Zone I-A",
        "Zone II",
        "Zone III",
        "Zone IV",
    ] },
    { province: "Cavite", city: "General Emilio Aguinaldo", barangayList: [
        "Dalusag",
        "Batas Dao",
        "Castaños Cerca",
        "Castaños Lejos",
        "Kabulusan",
        "Kaymisas",
        "Kaypaaba",
        "Lumipa",
        "Narvaez",
        "Tabora",
        "Poblacion 1",
        "Poblacion 2",
        "Poblacion 3",
        "Poblacion 4",
    ] },
    { province: "Cavite", city: "General Mariano Alvarez", barangayList: [
        "Aldiano Olaes (Area F)",
        "Poblacion 1 (Area I)",
        "Poblacion 2 (Area I)",
        "Poblacion 3 (Area I)",
        "Poblacion 4 (Area I)",
        "Poblacion 5 (Area G)",
        "Benjamin Tirona (Area D)",
        "Bernardo Pulido (Area H)",
        "Epifanio Malia (Area D)",
        "Francisco De Castro ",
        "Francisco Reyes ",
        "Fiorello Calimag (Area C)",
        "Gavino Maderan (Area J)",
        "Gregoria De Jesus",
        "Inocencio Salud (Area F)",
        "Jacinto Lumbreras (Area J)",
        "Kapitan Kua (Area F)",
        "Koronel Jose P. Elises (Area E)",
        "Macario Dacon (Area D)",
        "Marcelino Memije (Area H)",
        "Nicolasa Virata ",
        "Pantaleon Granados (Area G)",
        "Ramon Cruz Sr. (Area J)",
        "San Gabriel (Area K)",
        "San Jose ",
        "Severino De Las Alas (Area J)",
        "Tiniente Tiago",
    ] },
    { province: "Cavite", city: "General Trias", barangayList: [
        "Alingaro",
        "Arnaldo",
        "Bacao I",
        "Bacao II",
        "Bagumbayan",
        "Biclatan",
        "Buenavista I",
        "Buenavista II",
        "Buenavista III",
        "Corregidor",
        "Dulongbayan",
        "Governor Ferrer",
        "Javalera",
        "Manggahan",
        "Navarro",
        "Panungyanan",
        "Pasong Camachile I",
        "Pasong Camachile II",
        "Pasong Kawayan I",
        "Pasong Kawayan II",
        "Pinagtipunan",
        "Prinza",
        "Sampalucan",
        "Santiago",
        "San Francisco",
        "San Gabriel",
        "San Juan I (Poblacion)",
        "San Juan II",
        "Santa Clara",
        "Tapia",
        "Tejero",
        "Vibora",
        "1896th (Poblacion)",
    ] },
    { province: "Cavite", city: "Imus", barangayList: [
        "Alapan I-A",
        "Alapan I-B",
        "Alapan I-C",
        "Alapan II-A",
        "Alapan II-B",
        "Anabu I-A",
        "Anabu I-B",
        "Anabu I-C",
        "Anabu I-D",
        "Anabu I-E",
        "Anabu I-F",
        "Anabu I-G",
        "Anabu II-A",
        "Anabu II-B",
        "Anabu II-C",
        "Anabu II-D",
        "Anabu II-E",
        "Anabu II-F",
        "Bagong Silang (Bahayang Pag-asa)",
        "Bayan Luma I",
        "Bayan Luma II",
        "Bayan Luma III",
        "Bayan Luma IV",
        "Bayan Luma V",
        "Bayan Luma VI",
        "Bayan Luma VII",
        "Bayan Luma VIII",
        "Bayan Luma IX",
        "Bucandala I",
        "Bucandala II",
        "Bucandala III",
        "Bucandala IV",
        "Bucandala V",
        "Buhay na Tubig",
        "Carsadang Bago I",
        "Carsadang Bago II",
        "Magdalo",
        "Maharlika",
        "Malagasang I-A",
        "Malagasang I-B",
        "Malagasang I-C",
        "Malagasang I-D",
        "Malagasang I-E",
        "Malagasang I-F",
        "Malagasang I-G",
        "Malagasang II-A",
        "Malagasang II-B",
        "Malagasang II-C",
        "Malagasang II-D",
        "Malagasang II-E",
        "Malagasang II-F",
        "Malagasang II-G",
        "Mariano Espeleta I",
        "Mariano Espeleta II",
        "Mariano Espeleta III",
        "Medicion I-A",
        "Medicion I-B",
        "Medicion I-C",
        "Medicion I-D",
        "Medicion II-A",
        "Medicion II-B",
        "Medicion II-C",
        "Medicion II-D",
        "Medicion II-E",
        "Medicion II-F",
        "Pag-asa I",
        "Pag-asa II",
        "Pag-asa III",
        "Palico I",
        "Palico II",
        "Palico III",
        "Palico IV",
        "Pasong Buaya I",
        "Pasong Buaya II",
        "Pinagbuklod",
        "Poblacion I-A",
        "Poblacion I-B",
        "Poblacion I-C",
        "Poblacion II-A",
        "Poblacion II-B",
        "Poblacion III-A",
        "Poblacion III-B",
        "Poblacion IV-A",
        "Poblacion IV-B",
        "Poblacion IV-C",
        "Poblacion IV-D",
        "Tanzang Luma I",
        "Tanzang Luma II",
        "Tanzang Luma III",
        "Tanzang Luma IV (Southern City)",
        "Tanzang Luma V",
        "Tanzang Luma VI",
        "Toclong I-A",
        "Toclong I-B",
        "Toclong I-C",
        "Toclong II-A",
        "Toclong II-B",
    ] },
    { province: "Cavite", city: "Indang", barangayList: [
        "Agus-os",
        "Alulod",
        "Banaba Cerca",
        "Banaba Lejos",
        "Bancod",
        "Buna Cerca",
        "Buna Lejos",
        "Calumpang Cerca",
        "Calumpang Lejos",
        "Carasuchi",
        "Kayquit I",
        "Daine I",
        "Guyam Malaki",
        "Guyam Munti",
        "Harasan",
        "Kaytambog",
        "Limbon",
        "Lumampong Balagbag",
        "Lumampong Halayhay",
        "Mahabangkahoy Lejos",
        "Mahabangkahoy Cerca",
        "Poblacion 1",
        "Poblacion 2",
        "Poblacion 3",
        "Poblacion 4",
        "Pulo",
        "Tambo Balagbag",
        "Tambo Ilaya",
        "Tambo Malaki",
        "Tambo Kulit",
        "Buna Lejos II",
        "Daine II",
        "Kayquit II",
        "Kayquit III",
        "Kaytapos",
        "Mataas na Lupa",
    ] },
    { province: "Cavite", city: "Kawit", barangayList: [
        "Balsahan-Bisita",
        "Batong Dalig",
        "Binakayan-Aplaya",
        "Binakayan-Kanluran",
        "Congbalay-Legaspi",
        "Gahak",
        "Kaingen",
        "Magdalo (Putol)",
        "Manggahan-Lawin",
        "Marulas",
        "Panamitan",
        "Poblacion",
        "Pulvorista/Polvorista",
        "Samala-Marquez",
        "San Sebastian",
        "Santa Isabel",
        "Tabon I",
        "Tabon II",
        "Tabon III",
        "Toclong ",
        "Tramo-Bantayan",
        "Wakas I",
        "Wakas II",
    ] },
    { province: "Cavite", city: "Magallanes", barangayList: [
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Barangay III (Poblacion)",
        "Barangay IV (Poblacion)",
        "Barangay V (Poblacion)",
        "Cabulusan",
        "Ramirez",
        "San Agustin",
        "Urdaneta ",
        "Bendita I",
        "Bendita II",
        "Caluangan",
        "Baliwag",
        "Pacheco",
        "Medina",
        "Tua",
    ] },
    { province: "Cavite", city: "Maragondon", barangayList: [
        "Bucal 1",
        "Bucal 2",
        "Bucal 3A",
        "Bucal 3B",
        "Bucal 4A",
        "Bucal 4B",
        "Caingin Pob.",
        "Garita 1A",
        "Garita 1B",
        "Layong Mabilog",
        "Mabato",
        "Pantihan 1 (Balayungan)",
        "Pantihan 2",
        "Pantihan 3 (Pook na Munti)",
        "Pantihan 4 (Pulo ni Sara)",
        "Santa Mercedes (Patungan)",
        "Pinagsanhan A (Ibayo)",
        "Pinagsanhan B (Ibayo)",
        "Poblacion 1A",
        "Poblacion 1B",
        "Poblacion 2A",
        "Poblacion 2B",
        "San Miguel A (Caputatan)",
        "San Miguel B (Caputatan)",
        "Talipusngo",
        "Tulay Silangan (Mabacao)",
        "Tulay Kanluran (Mabacao)",
    ] },
    { province: "Cavite", city: "Mendez", barangayList: [
        "Anuling Lejos I (Anuling)",
        "Asis I",
        "Galicia I",
        "Palocpoc I",
        "Panungyan I",
        "Poblacion I (Barangay I)",
        "Poblacion II (Barangay II)",
        "Poblacion III (Barangay III)",
        "Poblacion IV (Barangay IV)",
        "Poblacion V (Barangay V)",
        "Poblacion VI (Barangay VI)",
        "Poblacion VII (Barangay VII)",
        "Anuling Cerca I",
        "Anuling Cerca II",
        "Anuling Lejos II",
        "Asis II",
        "Asis III",
        "Banayad",
        "Bukal",
        "Galicia II",
        "Galicia III",
        "Miguel Mojica",
        "Palocpoc II",
        "Panungyan II",
    ] },
    { province: "Cavite", city: "Naic", barangayList: [
        "Bagong Kalsada",
        "Balsahan",
        "Bancaan",
        "Bucana Malaki",
        "Bucana Sasahan",
        "Calubcob",
        "Capt. C. Nazareno (Poblacion)",
        "Gomez-Zamora (Poblacion)",
        "Halang",
        "Humbac",
        "Ibayo Estacion",
        "Ibayo Silangan",
        "Kanluran Rizal",
        "La Toria",
        "Labac",
        "Mabolo",
        "Malainen Bago",
        "Malainen Luma",
        "Maquina",
        "Molino",
        "Munting Mapino",
        "Muzon",
        "Palangue 2 (Palangue Adlawan)",
        "Palangue 3 (Chelsea)",
        "Palangue Central",
        "Sabang",
        "San Roque",
        "Santulan",
        "Sapa",
        "Timalan Balsahan",
        "Timalan Concepcion",
    ] },
    { province: "Cavite", city: "Noveleta", barangayList: [
        "Magdiwang",
        "Poblacion",
        "Salcedo 1",
        "San Antonio 1",
        "San Rafael 1",
        "San Rafael 2",
        "San Jose 1",
        "Santa Rosa 1",
        "Salcedo 2",
        "San Antonio 2",
        "San Jose 2",
        "San Juan 1",
        "San Juan 2",
        "San Rafael 3",
        "San Rafael 4",
        "Santa Rosa 2",
    ] },
    { province: "Cavite", city: "Rosario", barangayList: [
        "Bagbag I",
        "Bagbag II",
        "Kanluran",
        "Ligtong I",
        "Ligtong II",
        "Ligtong III",
        "Ligtong IV",
        "Muzon I",
        "Muzon II",
        "Poblacion",
        "Sapa I",
        "Sapa II",
        "Sapa III",
        "Sapa IV",
        "Silangan I",
        "Silangan II",
        "Tejeros Convention",
        "Wawa I",
        "Wawa II",
        "Wawa III",
    ] },
    { province: "Cavite", city: "Silang", barangayList: [
        "Acacia",
        "Adlas",
        "Anahaw 1 ",
        "Anahaw 2 ",
        "Balite 1",
        "Balite 2",
        "Balubad",
        "Banaba",
        "Batas",
        "Sitio Ilang-Ilang",
        "Sitio Kasuyan",
        "Biga 1",
        "Biga 2",
        "Biluso",
        "Bucal",
        "Buho",
        "Bulihan",
        "Cabangaan",
        "Carmen",
        "Hoyo",
        "Hukay",
        "Iba",
        "Inchican",
        "Ipil 1 ",
        "Ipil 2 ",
        "Kalubkob",
        "Kaong",
        "Lalaan I",
        "Lalaan II",
        "Sitio Lingat",
        "Sitio Balayunan",
        "Litlit",
        "Sitio Maynilaan",
        "Lucsuhin",
        "Lumil",
        "Maguyam",
        "Malabag",
        "Malaking Burol",
        "Malaking Tatiao",
        "Munting Ilog",
        "Narra 1",
        "Narra 2 ",
        "Narra 3",
        "Paligawan",
        "Pasong Langka",
        "Poblacion Barangay 1",
        "Poblacion Barangay 2",
        "Poblacion Barangay 3",
        "Poblacion Barangay 4",
        "Poblacion Barangay 5",
        "Pooc 1",
        "Pooc 2",
        "Pulong Bunga",
        "Pulong Saging",
        "Puting Kahoy",
        "Sabutan",
        "San Miguel 1",
        "San Miguel 2",
        "San Vicente 1",
        "San Vicente 2",
        "Santol",
        "Tartaria",
        "Tibig",
        "Toledo",
        "Tubuan 1",
        "Tubuan 2",
        "Tubuan 3",
        "Ulat",
        "Yakal",
    ] },
    { province: "Cavite", city: "Tagaytay", barangayList: [
        "Asisan",
        "Bagong Tubig",
        "Calabuso",
        "Dapdap East",
        "Dapdap West",
        "Francisco",
        "Guinhawa North",
        "Guinhawa South",
        "Iruhin East",
        "Iruhin South",
        "Iruhin West",
        "Kaybagal Central",
        "Kaybagal North",
        "Kaybagal South (Poblacion)",
        "Mag-Asawang Ilat",
        "Maharlika East",
        "Maharlika West",
        "Maitim 2nd Central",
        "Maitim 2nd East",
        "Maitim 2nd West",
        "Mendez Crossing East",
        "Mendez Crossing West",
        "Neogan",
        "Patutong Malaki North",
        "Patutong Malaki South",
        "Sambong",
        "San Jose",
        "Silang Junction North",
        "Silang Junction South",
        "Sungay East",
        "Sungay West",
        "Tolentino East",
        "Tolentino West",
        "Zambal",
    ] },
    { province: "Cavite", city: "Tanza", barangayList: [
        "Amaya 1",
        "Amaya 2",
        "Amaya 3",
        "Amaya 4",
        "Amaya 5",
        "Amaya 6",
        "Amaya 7",
        "Bagtas",
        "Biga",
        "Biwas",
        "Bucal",
        "Bunga",
        "Calibuyo",
        "Capipisa",
        "Daang Amaya 1",
        "Daang Amaya 2",
        "Daang Amaya 3",
        "Halayhay",
        "Julugan 1",
        "Julugan 2",
        "Julugan 3",
        "Julugan 4",
        "Julugan 5",
        "Julugan 6",
        "Julugan 7",
        "Julugan 8",
        "Lambingan",
        "Mulawin",
        "Paradahan 1",
        "Paradahan 2",
        "Poblacion 1",
        "Poblacion 2",
        "Poblacion 3",
        "Poblacion 4",
        "Punta 1",
        "Punta 2",
        "Sahud Ulan",
        "Sanja Mayor",
        "Santol",
        "Tanauan",
        "Tres Cruses",
    ] },
    { province: "Cavite", city: "Ternate", barangayList: [
        "Bucana",
        "Población 1 (Barangay 1)",
        "Población 2 (Barangay 2)",
        "Población 3 (Barangay 3)",
        "San José",
        "San Juan 1",
        "Sapang 1",
        "Población 1 A",
        "San Juan 2",
        "Sapang 2",
    ] },
    { province: "Cavite", city: "Trece Martires", barangayList: [
        "Cabezas",
        "Cabuco",
        "De Ocampo",
        "Lallana",
        "San Agustin (Poblacion)",
        "Osorio",
        "Conchu",
        "Hugo Perez",
        "Aguado",
        "Gregorio",
        "Inocencio",
        "Lapidario",
        "Luciano (Poblacion)",
    ] },
    { province: "Cebu", city: "Alcantara", barangayList: [
        "Cabadiangan",
        "Cabil‑isan",
        "Candabong",
        "Lawaan",
        "Manga",
        "Palanas",
        "Poblacion",
        "Polo",
        "Salagmaya",
    ] },
    { province: "Cebu", city: "Alcoy", barangayList: [
        "Atabay",
        "Daan-Lungsod",
        "Guiwang",
        "Nug‑as",
        "Pasol",
        "Poblacion",
        "Pugalo",
        "San Agustin",
    ] },
    { province: "Cebu", city: "Alegria", barangayList: [
        "Compostela",
        "Guadalupe",
        "Legaspi",
        "Lepanto",
        "Madridejos",
        "Montpeller",
        "Poblacion",
        "Santa Filomena",
        "Valencia",
    ] },
    { province: "Cebu", city: "Aloguinsan", barangayList: [
        "Angilan",
        "Bojo",
        "Bonbon",
        "Esperanza",
        "Kandingan",
        "Kantabogon",
        "Kawasan",
        "Olango",
        "Poblacion",
        "Punay",
        "Rosario",
        "Saksak",
        "Tampa‑an",
        "Toyokon",
        "Zaragosa",
    ] },
    { province: "Cebu", city: "Argao", barangayList: [
        "Alambijud",
        "Anajao",
        "Apo",
        "Balaas",
        "Balisong",
        "Binlod",
        "Bogo",
        "Bug‑ot",
        "Bulasa",
        "Butong",
        "Calagasan",
        "Canbantug",
        "Canbanua",
        "Cansuje",
        "Capio‑an",
        "Casay",
        "Catang",
        "Colawin",
        "Conalum",
        "Guiwanon",
        "Gutlang",
        "Jampang",
        "Jomgao",
        "Lamacan",
        "Langtad",
        "Langub",
        "Lapay",
        "Lengigon",
        "Linut‑od",
        "Mabasa",
        "Mandilikit",
        "Mompeller",
        "Panadtaran",
        "Poblacion",
        "Sua",
        "Sumaguan",
        "Tabayag",
        "Talaga",
        "Talaytay",
        "Talo‑ot",
        "Tiguib",
        "Tulang",
        "Tulic",
        "Ubaub",
        "Usmad",
    ] },
    { province: "Cebu", city: "Asturias", barangayList: [
        "Agbanga",
        "Agtugop",
        "Bago",
        "Bairan",
        "Banban",
        "Baye",
        "Bog‑o",
        "Kaluangan",
        "Lanao",
        "Langub",
        "Looc Norte",
        "Lunas",
        "Magcalape",
        "Manguiao",
        "New Bago",
        "Owak",
        "Poblacion",
        "Saksak",
        "San Isidro",
        "San Roque",
        "Santa Lucia",
        "Santa Rita",
        "Tag‑amakan",
        "Tagbubonga",
        "Tubigagmanok",
        "Tubod",
        "Ubogon",
    ] },
    { province: "Cebu", city: "Badian", barangayList: [
        "Alawijao",
        "Balhaan",
        "Banhigan",
        "Basak",
        "Basiao",
        "Bato",
        "Bugas",
        "Calangcang",
        "Candiis",
        "Dagatan",
        "Dobdob",
        "Ginablan",
        "Lambug",
        "Malabago",
        "Malhiao",
        "Manduyong",
        "Matutinao",
        "Patong",
        "Poblacion",
        "Sanlagan",
        "Santicon",
        "Sohoton",
        "Sulsugan",
        "Talayong",
        "Taytay",
        "Tigbao",
        "Tiguib",
        "Tubod",
        "Zaragosa",
    ] },
    { province: "Cebu", city: "Balamban", barangayList: [
        "Abucayan",
        "Aliwanay",
        "Arpili",
        "Baliwagan (Poblacion)",
        "Bayong",
        "Biasong",
        "Buanoy",
        "Cabagdalan",
        "Cabasiangan",
        "Cambuhawe",
        "Cansomoroy",
        "Cantibas",
        "Cantuod",
        "Duangan",
        "Gaas",
        "Ginatilan",
        "Hingatmonan",
        "Lamesa",
        "Liki",
        "Luca",
        "Matun‑og",
        "Nangka",
        "Pondol",
        "Prenza",
        "Santa Cruz-Santo Niño (Poblacion)",
        "Singsing",
        "Sunog (Magsaysay)",
        "Vito",
    ] },
    { province: "Cebu", city: "Bantayan", barangayList: [
        "Atop-atop",
        "Baigad",
        "Bantigue (Poblacion)",
        "Baod",
        "Binaobao (Poblacion)",
        "Botigues",
        "Doong",
        "Guiwanon",
        "Hilotongan",
        "Kabac",
        "Kabangbang",
        "Kampingganon",
        "Kangkaibe",
        "Lipayran",
        "Luyongbaybay",
        "Mojon",
        "Obo‑ob",
        "Patao",
        "Putian",
        "Sillon",
        "Suba (Poblacion)",
        "Sulangan",
        "Sungko",
        "Tamiao",
        "Ticad (Poblacion)",
    ] },
    { province: "Cebu", city: "Barili", barangayList: [
        "Azucena",
        "Bagakay",
        "Balao",
        "Bolocboloc",
        "Budbud",
        "Bugtong Kawayan",
        "Cabcaban",
        "Cagay",
        "Campangga",
        "Candugay",
        "Dakit",
        "Giloctog",
        "Giwanon",
        "Guibuangan",
        "Gunting",
        "Hilasgasan",
        "Japitan",
        "Kalubihan",
        "Kangdampas",
        "Luhod",
        "Lupo",
        "Luyo",
        "Maghanoy",
        "Maigang",
        "Malolos",
        "Mantalongon",
        "Mantayupan",
        "Mayana",
        "Minolos",
        "Nabunturan",
        "Nasipit",
        "Pancil",
        "Pangpang",
        "Paril",
        "Patupat",
        "Poblacion",
        "San Rafael",
        "Santa Ana",
        "Sayaw",
        "Tal‑ot",
        "Tubod",
        "Vito",
    ] },
    { province: "Cebu", city: "Bogo", barangayList: [
        "Anonang Norte",
        "Anonang Sur",
        "Banban",
        "Binabag",
        "Bungtod (Poblacion)",
        "Carbon (Poblacion)",
        "Cayang",
        "Cogon (Poblacion)",
        "Dakit",
        "Don Pedro Rodriguez",
        "Gairan",
        "Guadalupe",
        "Lapaz",
        "La Purisima Concepcion (Poblacion)",
        "Libertad",
        "Lourdes (Poblacion)",
        "Malingin",
        "Marangog",
        "Nailon",
        "Odlot",
        "Pandan (Pandan Heights)",
        "Polambato",
        "Sambag (Poblacion)",
        "San Vicente (Poblacion)",
        "Santo Niño",
        "Santo Rosario (Poblacion)",
        "Siocon",
        "Sudlonon",
        "Taytayan",
    ] },
    { province: "Cebu", city: "Boljoon", barangayList: [
        "Arbor",
        "Baclayan",
        "El Pardo",
        "Granada",
        "Lower Becerril",
        "Lunop",
        "Nangka",
        "Poblacion",
        "San Antonio",
        "South Granada",
        "Upper Becerril",
    ] },
    { province: "Cebu", city: "Borbon", barangayList: [
        "Bagacay",
        "Bili",
        "Bingay",
        "Bongdo",
        "Bongdo Gua",
        "Bongoyan",
        "Cadaruhan",
        "Cajel",
        "Campusong",
        "Clavera",
        "Don Gregorio Antigua (Taytayan)",
        "Laaw",
        "Lugo",
        "Managase",
        "Poblacion",
        "Sagay",
        "San Jose",
        "Tabunan",
        "Tagnucan",
    ] },
    { province: "Cebu", city: "Carcar", barangayList: [
        "Bolinawan",
        "Buenavista",
        "Calidngan",
        "Can‑asujan",
        "Guadalupe",
        "Liburon",
        "Napo",
        "Ocaña",
        "Perrelos",
        "Poblacion I",
        "Poblacion II",
        "Poblacion III",
        "Tuyom",
        "Valencia",
        "Valladolid",
    ] },
    { province: "Cebu", city: "Carmen", barangayList: [
        "Baring",
        "Cantipay",
        "Cantukong",
        "Cantumog",
        "Caurasan",
        "Cogon East",
        "Cogon West",
        "Corte",
        "Dawis Norte",
        "Dawis Sur",
        "Hagnaya",
        "Ipil",
        "Lanipga",
        "Liboron",
        "Lower Natimao‑an",
        "Luyang",
        "Poblacion",
        "Puente",
        "Sac‑on",
        "Triumfo",
        "Upper Natimao‑an",
    ] },
    { province: "Cebu", city: "Catmon", barangayList: [
        "Agsuwao",
        "Amancion",
        "Anapog",
        "Bactas",
        "Basak",
        "Binongkalan",
        "Bongyas",
        "Cabungaan",
        "Cambangkaya",
        "Can‑ibuang",
        "Catmondaan",
        "Corazon (Poblacion)",
        "Duyan",
        "Flores (Poblacion)",
        "Ginabucan",
        "Macaas",
        "Panalipan",
        "San Jose Pob. (Catadman)",
        "Tabili",
        "Tinabyonan",
    ] },
    { province: "Cebu", city: "Cebu City", barangayList: [
        "Adlaon",
        "Agsungot",
        "Apas",
        "Babag",
        "Bacayan",
        "Banilad",
        "Basak Pardo",
        "Basak San Nicolas",
        "Binaliw",
        "Bonbon",
        "Budlaan",
        "Buhisan",
        "Bulacao (Bulacao Pardo)",
        "Buot-Taop (Buot‑Taup Pardo)",
        "Busay",
        "Calamba",
        "Cambinocot",
        "Capitol Site",
        "Carreta",
        "Cogon Pardo",
        "Cogon‑Ramos",
        "Day‑as",
        "Duljo Fatima",
        "Ermita",
        "Guadalupe",
        "Guba",
        "Hipodromo",
        "Inayawan (Inayawan Pardo)",
        "Kalubihan",
        "Kalunasan",
        "Kamagayan",
        "Kamputhaw (Camputhaw)",
        "Kasambagan",
        "Kinasang‑an (Kinasang‑an Pardo)",
        "Labangon",
        "Lahug",
        "Lorega‑San Miguel",
        "Lusaran",
        "Luz",
        "Mabini",
        "Mabolo",
        "Malubog",
        "Mambaling",
        "Pahina Central",
        "Pahina San Nicolas",
        "Pamutan",
        "Parian",
        "Paril",
        "Pasil",
        "Pit‑os",
        "Poblacion Pardo",
        "Pulangbato",
        "Pung‑ol Sibugay",
        "Punta Princesa",
        "Quiot (Quiot Pardo)",
        "Sambag I",
        "Sambag II",
        "San Antonio",
        "San Jose",
        "San Nicolas Proper",
        "San Roque",
        "Santa Cruz",
        "Santo Niño",
        "Sapangdaku",
        "Sawang Calero",
        "Sinsin",
        "Sirao",
        "Suba (Suba San Nicolas)",
        "Sudlon I",
        "Sudlon II",
        "T. Padilla",
        "Tabunan",
        "Tag‑bao",
        "Talamban",
        "Taptap",
        "Tejero (Villa Gonzalo)",
        "Tinago",
        "Tisa",
        "Toong (To‑ong Pardo)",
        "Zapatera",
    ] },
    { province: "Cebu", city: "Compostela", barangayList: [
        "Bagalnga",
        "Basak",
        "Buluang",
        "Cabadiangan",
        "Cambayog",
        "Canamucan",
        "Cogon",
        "Dapdap",
        "Estaca",
        "Lupa",
        "Magay",
        "Mulao",
        "Panangban",
        "Poblacion",
        "Tag‑ube",
        "Tamiao",
        "Tubigan",
    ] },
    { province: "Cebu", city: "Consolacion", barangayList: [
        "Cabangahan",
        "Cansaga",
        "Casili",
        "Danglag",
        "Garing",
        "Jugan",
        "Lamac",
        "Lanipga",
        "Nangka",
        "Panas",
        "Panoypoy",
        "Pitogo",
        "Poblacion Occidental",
        "Poblacion Oriental",
        "Polog",
        "Pulpogan",
        "Sacsac",
        "Tayud",
        "Tilhaong",
        "Tolotolo",
        "Tugbongan",
    ] },
    { province: "Cebu", city: "Cordova", barangayList: [
        "Alegria",
        "Bangbang",
        "Buagsong",
        "Catarman",
        "Cogon",
        "Dapitan",
        "Day‑as",
        "Gabi",
        "Gilutongan",
        "Ibabao",
        "Pilipog",
        "Poblacion",
        "San Miguel",
    ] },
    { province: "Cebu", city: "Daanbantayan", barangayList: [
        "Aguho",
        "Bagay",
        "Bakhawan",
        "Bateria",
        "Bitoon",
        "Calape",
        "Carnaza",
        "Dalingding",
        "Lanao",
        "Logon",
        "Malbago",
        "Malingin",
        "Maya",
        "Pajo",
        "Paypay",
        "Poblacion",
        "Talisay",
        "Tapilon",
        "Tinubdan",
        "Tominjao",
    ] },
    { province: "Cebu", city: "Dalaguete", barangayList: [
        "Ablayan",
        "Babayongan",
        "Balud",
        "Banhigan",
        "Bulak",
        "Caleriohan",
        "Caliongan",
        "Casay",
        "Catolohan",
        "Cawayan",
        "Consolacion",
        "Coro",
        "Dugyan",
        "Dumalan",
        "Jolomaynon",
        "Lanao",
        "Langkas",
        "Lumbang",
        "Malones",
        "Maloray",
        "Mananggal",
        "Manlapay",
        "Mantalongon",
        "Nalhub",
        "Obo",
        "Obong",
        "Panas",
        "Poblacion",
        "Sacsac",
        "Salug",
        "Tabon",
        "Tapun",
        "Tuba",
    ] },
    { province: "Cebu", city: "Danao", barangayList: [
        "Baliang",
        "Bayabas",
        "Binaliw",
        "Cabungahan",
        "Cagat-Lamac",
        "Cahumayan",
        "Cambanay",
        "Cambubho",
        "Cogon-Cruz",
        "Danasan",
        "Dungga",
        "Dunggoan",
        "Guinacot",
        "Guinsay",
        "Ibo",
        "Langosig",
        "Lawaan",
        "Licos",
        "Looc",
        "Magtagobtob",
        "Malapoc",
        "Manlayag",
        "Mantija",
        "Masaba",
        "Maslog",
        "Nangka",
        "Oguis",
        "Pili",
        "Poblacion",
        "Quisol",
        "Sabang",
        "Sacsac",
        "Sandayong Norte",
        "Sandayong Sur",
        "Santa Rosa",
        "Santican",
        "Sibacan",
        "Suba",
        "Taboc",
        "Taytay",
        "Togonon",
        "Tuburan Sur",
    ] },
    { province: "Cebu", city: "Dumanjug", barangayList: [
        "Balaygtiki",
        "Bitoon",
        "Bulak",
        "Bullogan",
        "Calaboon",
        "Camboang",
        "Candabong",
        "Cogon",
        "Cotcoton",
        "Doldol",
        "Ilaya (Poblacion)",
        "Kabalaasnan",
        "Kabatbatan",
        "Kambanog",
        "Kang‑actol",
        "Kanghalo",
        "Kanghumaod",
        "Kanguha",
        "Kantangkas",
        "Kanyuko",
        "Kolabtingon",
        "Lamak",
        "Lawaan",
        "Liong",
        "Manlapay",
        "Masa",
        "Matalao",
        "Paculob",
        "Panlaan",
        "Pawa",
        "Poblacion Central",
        "Poblacion Looc",
        "Poblacion Sima",
        "Tangil",
        "Tapon",
        "Tubod-Bitoon",
        "Tubod-Dugoan",
    ] },
    { province: "Cebu", city: "Ginatilan", barangayList: [
        "Anao",
        "Cagsing",
        "Calabawan",
        "Cambagte",
        "Campisong",
        "Canorong",
        "Guiwanon",
        "Looc",
        "Malatbo",
        "Mangaco",
        "Palanas",
        "Poblacion",
        "Salamanca",
        "San Roque",
    ] },
    { province: "Cebu", city: "Lapu-Lapu City", barangayList: [
        "Agus",
        "Babag",
        "Bankal",
        "Baring",
        "Basak",
        "Buaya",
        "Calawisan",
        "Canjulao",
        "Caubian",
        "Caw‑oy",
        "Cawhagan",
        "Gun‑ob",
        "Ibo",
        "Looc",
        "Mactan",
        "Maribago",
        "Marigondon",
        "Pajac",
        "Pajo",
        "Pangan‑an",
        "Poblacion[a]",
        "Punta Engaño",
        "Pusok",
        "Sabang",
        "San Vicente",
        "Santa Rosa",
        "Subabasbas",
        "Talima",
        "Tingo",
        "Tungasan",
    ] },
    { province: "Cebu", city: "Liloan", barangayList: [
        "Cabadiangan",
        "Calero",
        "Catarman",
        "Cotcot",
        "Jubay",
        "Lataban",
        "Mulao",
        "Poblacion",
        "San Roque",
        "San Vicente",
        "Santa Cruz",
        "Tabla",
        "Tayud",
        "Yati",
    ] },
    { province: "Cebu", city: "Madridejos", barangayList: [
        "Bunakan",
        "Kangwayan",
        "Kaongkod",
        "Kodia",
        "Maalat",
        "Malbago",
        "Mancilang",
        "Pili",
        "Poblacion",
        "San Agustin",
        "Tabagak",
        "Talangnan",
        "Tarong",
        "Tugas",
    ] },
    { province: "Cebu", city: "Malabuyoc", barangayList: [
        "Armeña (Cansilongan)",
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion) 1173",
        "Cerdeña (Ansan)",
        "Labrador (Bulod)",
        "Lombo",
        "Looc",
        "Mahanlud",
        "Mindanao (Pajo)",
        "Montañeza (Inamlang)",
        "Salmeron (Bulok)",
        "Santo Niño (Salering)",
        "Sorsogon (Balikmaya)",
        "Tolosa (Calatagan)",
    ] },
    { province: "Cebu", city: "Mandaue", barangayList: [
        "Alang-alang",
        "Bakilid",
        "Banilad",
        "Basak",
        "Cabancalan",
        "Cambaro",
        "Canduman",
        "Casili",
        "Casuntingan",
        "Centro (Poblacion)",
        "Cubacub",
        "Guizo",
        "Ibabao-Estancia",
        "Jagobiao",
        "Labogon",
        "Looc",
        "Maguikay",
        "Mantuyong",
        "Opao",
        "Paknaan",
        "Pagsabungan",
        "Subangdaku",
        "Tabok",
        "Tawason",
        "Tingub",
        "Tipolo",
        "Umapad",
    ] },
    { province: "Cebu", city: "Medellin", barangayList: [
        "Antipolo",
        "Canhabagat",
        "Caputatan Norte",
        "Caputatan Sur",
        "Curva",
        "Daanlungsod",
        "Dalingding Sur",
        "Dayhagon",
        "Don Virgilio Gonzales",
        "Gibitngil",
        "Kawit",
        "Lamintak Norte",
        "Lamintak Sur",
        "Luy‑a",
        "Maharuhay",
        "Mahawak",
        "Panugnawan",
        "Poblacion",
        "Tindog",
    ] },
    { province: "Cebu", city: "Minglanilla", barangayList: [
        "Cadulawan",
        "Calajo‑an",
        "Camp 7",
        "Camp 8",
        "Cuanos",
        "Guindaruhan",
        "Linao (Linao-Lipata)",
        "Manduang",
        "Pakigne",
        "Poblacion Ward 1",
        "Poblacion Ward 2",
        "Poblacion Ward 3",
        "Poblacion Ward 4",
        "Tubod",
        "Tulay",
        "Tunghaan",
        "Tungkil",
        "Tungkop",
        "Vito",
    ] },
    { province: "Cebu", city: "Moalboal", barangayList: [
        "Agbalanga",
        "Bala",
        "Balabagon",
        "Basdiot",
        "Batadbatad",
        "Bugho",
        "Buguil",
        "Busay",
        "Lanao",
        "Poblacion East",
        "Poblacion West",
        "Saavedra",
        "Tomonoy",
        "Tuble",
        "Tunga",
    ] },
    { province: "Cebu", city: "Naga", barangayList: [
        "Alpaco",
        "Bairan",
        "Balirong",
        "Cabungahan",
        "Cantao‑an",
        "Central Poblacion",
        "Cogon",
        "Colon",
        "East Poblacion",
        "Inayagan",
        "Inoburan",
        "Jaguimit",
        "Lanas",
        "Langtad",
        "Lutac",
        "Mainit",
        "Mayana",
        "Naalad",
        "North Poblacion",
        "Pangdan",
        "Patag",
        "South Poblacion",
        "Tagjaguimit",
        "Tangke",
        "Tinaan",
        "Tuyan",
        "Uling",
        "West Poblacion",
    ] },
    { province: "Cebu", city: "Oslob", barangayList: [
        "Alo",
        "Bangcogon",
        "Bonbon",
        "Calumpang",
        "Can‑ukban",
        "Canangca‑an",
        "Cansalo‑ay",
        "Cañang",
        "Daanlungsod",
        "Gawi",
        "Hagdan",
        "Lagunde",
        "Looc",
        "Luka",
        "Mainit",
        "Manlum",
        "Nueva Caceres",
        "Poblacion",
        "Pungtod",
        "Tan‑awan",
        "Tumalog",
    ] },
    { province: "Cebu", city: "Pilar", barangayList: [
        "Biasong",
        "Cawit",
        "Dapdap",
        "Esperanza",
        "Imelda",
        "Lanao",
        "Lower Poblacion",
        "Moabog",
        "Montserrat",
        "San Isidro",
        "San Juan",
        "Upper Poblacion",
        "Villahermosa",
    ] },
    { province: "Cebu", city: "Pinamungajan", barangayList: [
        "Anislag",
        "Anopog",
        "Binabag",
        "Buhingtubig",
        "Busay",
        "Butong",
        "Cabiangon/Cabinyagan",
        "Camugao",
        "Duangan",
        "Guimbawian",
        "Lamac",
        "Lut‑od",
        "Mangoto",
        "Opao",
        "Pandacan",
        "Poblacion",
        "Punod",
        "Rizal",
        "Sacsac",
        "Sambagon",
        "Sibago",
        "Tajao",
        "Tangub",
        "Tanibag",
        "Tupas",
        "Tutay",
    ] },
    { province: "Cebu", city: "Poro", barangayList: [
        "Adela",
        "Altavista",
        "Cagcagan",
        "Cansabusab",
        "Daan Paz",
        "Eastern Poblacion",
        "Esperanza",
        "Libertad",
        "Mabini",
        "Mercedes",
        "Pagsa",
        "Paz",
        "Rizal",
        "San Jose",
        "Santa Rita",
        "Teguis",
        "Western Poblacion",
    ] },
    { province: "Cebu", city: "Ronda", barangayList: [
        "Butong",
        "Can‑abuhon",
        "Canduling",
        "Cansalonoy",
        "Cansayahon",
        "Ilaya",
        "Langin",
        "Libo‑o",
        "Malalay",
        "Palanas",
        "Poblacion",
        "Santa Cruz",
        "Tupas",
        "Vive",
    ] },
    { province: "Cebu", city: "Samboan", barangayList: [
        "Basak",
        "Bonbon",
        "Bulangsuran",
        "Calatagan",
        "Cambigong",
        "Camburoy",
        "Canorong",
        "Colase",
        "Dalahikan",
        "Jumangpas",
        "Monteverde",
        "Poblacion",
        "San Sebastian (Bato)",
        "Suba",
        "Tangbo",
    ] },
    { province: "Cebu", city: "San Fernando", barangayList: [
        "Balud",
        "Balungag",
        "Basak",
        "Bugho",
        "Cabatbatan",
        "Green Hills",
        "Ilaya",
        "Lantawan",
        "Liburon",
        "Magsico",
        "Panadtaran",
        "Pitalo",
        "Poblacion North",
        "Poblacion South",
        "San Isidro",
        "Sangat",
        "Tabionan",
        "Tananas",
        "Tinubdan",
        "Tonggo",
        "Tubod",
    ] },
    { province: "Cebu", city: "San Francisco", barangayList: [
        "Cabunga‑an",
        "Campo",
        "Consuelo",
        "Esperanza",
        "Himensulan",
        "Montealegre",
        "Northern Poblacion",
        "San Isidro",
        "Santa Cruz",
        "Santiago",
        "Sonog",
        "Southern Poblacion",
        "Unidos",
        "Union",
        "Western Poblacion",
    ] },
    { province: "Cebu", city: "San Remigio", barangayList: [
        "Anapog",
        "Argawanon",
        "Bagtic",
        "Bancasan",
        "Batad",
        "Busogon",
        "Calambua",
        "Canagahan",
        "Dapdap",
        "Gawaygaway",
        "Hagnaya",
        "Kayam",
        "Kinawahan",
        "Lambusan",
        "Lawis",
        "Libaong",
        "Looc",
        "Luyang",
        "Mano",
        "Poblacion",
        "Punta",
        "Sab‑a",
        "San Miguel",
        "Tacup",
        "Tambongon",
        "To‑ong",
        "Victoria",
    ] },
    { province: "Cebu", city: "Santa Fe", barangayList: [
        "Balidbid",
        "Hagdan",
        "Hilantagaan",
        "Kinatarkan",
        "Langub",
        "Maricaban",
        "Okoy",
        "Poblacion",
        "Pooc",
        "Talisay",
    ] },
    { province: "Cebu", city: "Santander", barangayList: [
        "Bunlan",
        "Cabutongan",
        "Candamiang",
        "Canlumacad",
        "Liloan",
        "Lip‑tong",
        "Looc",
        "Pasil",
        "Poblacion",
        "Talisay",
    ] },
    { province: "Cebu", city: "Sibonga", barangayList: [
        "Abugon",
        "Bae",
        "Bagacay",
        "Bahay",
        "Banlot",
        "Basak",
        "Bato",
        "Cagay",
        "Can‑aga",
        "Candaguit",
        "Cantolaroy",
        "Dugoan",
        "Guimbangco‑an",
        "Lamacan",
        "Libo",
        "Lindogon",
        "Magcagong",
        "Manatad",
        "Mangyan",
        "Papan",
        "Poblacion",
        "Sabang",
        "Sayao",
        "Simala",
        "Tubod",
    ] },
    { province: "Cebu", city: "Sogod", barangayList: [
        "Ampongol",
        "Bagakay",
        "Bagatayam",
        "Bawo",
        "Cabalawan",
        "Cabangahan",
        "Calumboyan",
        "Dakit",
        "Damolog",
        "Ibabao",
        "Liki",
        "Lubo",
        "Mohon",
        "Nahus‑an",
        "Pansoy",
        "Poblacion",
        "Tabunok",
        "Takay",
    ] },
    { province: "Cebu", city: "Tabogon", barangayList: [
        "Alang‑alang",
        "Caduawan",
        "Camoboan",
        "Canaocanao",
        "Combado",
        "Daantabogon",
        "Ilihan",
        "Kal‑anan",
        "Labangon",
        "Libjo",
        "Loong",
        "Mabuli",
        "Managase",
        "Manlagtang",
        "Maslog",
        "Muabog",
        "Pio",
        "Poblacion",
        "Salag",
        "Sambag",
        "San Isidro",
        "San Vicente",
        "Somosa",
        "Taba‑ao",
        "Tapul",
    ] },
    { province: "Cebu", city: "Tabuelan", barangayList: [
        "Bongon",
        "Dalid",
        "Kanlim‑ao",
        "Kanluhagon",
        "Kantubaon",
        "Mabunao",
        "Maravilla",
        "Olivo",
        "Poblacion",
        "Tabunok",
        "Tigbawan",
        "Villahermosa",
    ] },
    { province: "Cebu", city: "Talisay", barangayList: [
        "Biasong",
        "Bulacao",
        "Candulawan",
        "Camp IV",
        "Cansojong",
        "Dumlog",
        "Jaclupan",
        "Lagtang",
        "Lawaan I",
        "Lawaan II",
        "Lawaan III",
        "Linao",
        "Maghaway",
        "Manipis",
        "Mohon",
        "Poblacion",
        "Pooc",
        "San Isidro",
        "San Roque",
        "Tabunok",
        "Tangke",
        "Tapul",
    ] },
    { province: "Cebu", city: "Toledo", barangayList: [
        "Awihao",
        "Bagakay",
        "Bato",
        "Biga",
        "Bulongan",
        "Bunga",
        "Cabitoonan",
        "Calongcalong",
        "Cambang‑ug",
        "Camp 8",
        "Canlumampao",
        "Cantabaco",
        "Capitan Claudio",
        "Carmen",
        "Daanglungsod",
        "Don Andres Soriano (Lutopan)",
        "Dumlog",
        "Gen. Climaco (Malubog)",
        "Ibo",
        "Ilihan",
        "Juan Climaco, Sr. (Magdugo)",
        "Landahan",
        "Loay",
        "Luray II",
        "Matab‑ang",
        "Media Once",
        "Pangamihan",
        "Poblacion",
        "Poog",
        "Putingbato",
        "Sagay",
        "Sam‑ang",
        "Sangi",
        "Santo Niño (Mainggit)",
        "Subayon",
        "Talavera",
        "Tubod",
        "Tungkay",
    ] },
    { province: "Cebu", city: "Tuburan", barangayList: [
        "Alegria",
        "Amatugan",
        "Antipolo",
        "Apalan",
        "Bagasawe",
        "Bakyawan",
        "Bangkito",
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Barangay III (Poblacion)",
        "Barangay IV (Poblacion)",
        "Barangay V (Poblacion)",
        "Barangay VI (Poblacion)",
        "Barangay VII (Poblacion)",
        "Barangay VIII (Poblacion)",
        "Bulwang",
        "Caridad",
        "Carmelo",
        "Cogon",
        "Colonia",
        "Daan Lungsod",
        "Fortaliza",
        "Ga‑ang",
        "Gimama‑a",
        "Jagbuaya",
        "Kabangkalan",
        "Kabkaban",
        "Kagba‑o",
        "Kalangahan",
        "Kamansi",
        "Kampoot",
        "Kan‑an",
        "Kanlunsing",
        "Kansi",
        "Kaorasan",
        "Libo",
        "Lusong",
        "Macupa",
        "Mag‑alwa",
        "Mag‑antoy",
        "Mag‑atubang",
        "Maghan‑ay",
        "Mangga",
        "Marmol",
        "Molobolo",
        "Montealegre",
        "Putat",
        "San Juan",
        "Sandayong",
        "Santo Niño",
        "Siotes",
        "Sumon",
        "Tominjao",
        "Tomugpa",
    ] },
    { province: "Cebu", city: "Tudela", barangayList: [
        "Buenavista",
        "Calmante",
        "Daan Secante",
        "General",
        "McArthur",
        "Northern Poblacion",
        "Puertobello",
        "Santander",
        "Secante Bag‑o",
        "Southern Poblacion",
        "Villahermosa",
    ] },
    // { province: "Cotabato", city: "", barangayList: [] },
    // { province: "Davao de Oro", city: "", barangayList: [] },
    // { province: "Davao del Norte", city: "", barangayList: [] },
    // { province: "Davao del Sur", city: "", barangayList: [] },
    // { province: "Davao Occidental", city: "", barangayList: [] },
    // { province: "Davao Oriental", city: "", barangayList: [] },
    // { province: "Dinagat Islands", city: "", barangayList: [] },
    // { province: "Eastern Samar", city: "", barangayList: [] },
    // { province: "Guimaras", city: "", barangayList: [] },
    // { province: "Ifugao", city: "", barangayList: [] },
    // { province: "Ilocos Norte", city: "", barangayList: [] },
    // { province: "Ilocos Sur", city: "", barangayList: [] },
    { province: "Iloilo", city: "Ajuy", barangayList: [
        "Adcadarao",
        "Agbobolo",
        "Badiangan",
        "Barrido",
        "Bato Biasong",
        "Bay-ang",
        "Bucana Bunglas",
        "Central",
        "Culasi",
        "Lanjagan",
        "Luca",
        "Malayu-an",
        "Mangorocoro",
        "Nasidman",
        "Pantalan Nabaye",
        "Pantalan Navarro",
        "Pedada",
        "Pili",
        "Pinantan Diel",
        "Pinantan Elizalde",
        "Pinay Espinosa",
        "Poblacion",
        "Progreso",
        "Puente Bunglas",
        "Punta Buri",
        "Rojas",
        "San Antonio",
        "Silagon",
        "Santo Rosario",
        "Tagubanhan",
        "Taguhangin",
        "Tanduyan",
        "Tipacla",
        "Tubogan",
    ] },
    { province: "Iloilo", city: "Alimodian", barangayList: [
        "Abang-abang",
        "Agsing",
        "Atabay",
        "Ba-ong",
        "Baguingin-Lanot",
        "Bagsakan",
        "Bagumbayan-Ilajas",
        "Balabago",
        "Ban-ag",
        "Bancal",
        "Binalud",
        "Bugang",
        "Buhay",
        "Bulod",
        "Cabacanan Proper",
        "Cabacanan Rizal",
        "Cagay",
        "Coline",
        "Coline-Dalag",
        "Cunsad",
        "Cuyad",
        "Dalid",
        "Dao",
        "Gines",
        "Ginomoy",
        "Ingwan",
        "Laylayan",
        "Lico",
        "Luan-luan",
        "Malamhay",
        "Malamboy-Bondolan",
        "Mambawi",
        "Manasa",
        "Manduyog",
        "Pajo",
        "Pianda-an Norte",
        "Pianda-an Sur",
        "Poblacion",
        "Punong",
        "Quinaspan",
        "Sinamay",
        "Sulong",
        "Taban-Manguining",
        "Tabug",
        "Tarug",
        "Tugaslon",
        "Ubodan",
        "Ugbo",
        "Ulay-Bugang",
        "Ulay-Hinablan",
        "Umingan",
    ] },
    { province: "Iloilo", city: "Anilao", barangayList: [
        "Agbatuan",
        "Badiang",
        "Balabag",
        "Balunos",
        "Cag-an",
        "Camiros",
        "Sambag Culob",
        "Dangula-an",
        "Guipis",
        "Manganese",
        "Medina",
        "Mostro",
        "Palaypay",
        "Pantalan",
        "Poblacion",
        "San Carlos",
        "San Juan Crisostomo",
        "Santa Rita",
        "Santo Rosario",
        "Serallo",
        "Vista Alegre",
    ] },
    { province: "Iloilo", city: "Badiangan", barangayList: [
        "Agusipan",
        "Astorga",
        "Bingauan",
        "Bita-oyan",
        "Botong",
        "Budiawe",
        "Cabanga-an",
        "Cabayogan",
        "Calansanan",
        "Catubig",
        "Guinawahan",
        "Ilongbukid",
        "Indorohan",
        "Iniligan",
        "Latawan",
        "Linayuan",
        "Mainguit",
        "Malublub",
        "Manaolan",
        "Mapili Grande",
        "Mapili Sanjo",
        "Odiongan",
        "Poblacion",
        "San Julian",
        "Sariri",
        "Sianon",
        "Sinuagan",
        "Talaba",
        "Tamocol",
        "Teneclan",
        "Tina",
    ] },
    { province: "Iloilo", city: "Balasan", barangayList: [
        "Aranjuez",
        "Bacolod",
        "Balanti-an",
        "Batuan",
        "Cabalic",
        "Camambugan",
        "Dolores",
        "Gimamanay",
        "Ipil",
        "Kinalkalan",
        "Lawis",
        "Malapoc",
        "Mamhut Norte",
        "Mamhut Sur",
        "Maya",
        "Pani-an",
        "Poblacion Norte",
        "Poblacion Sur",
        "Quiasan",
        "Salong",
        "Salvacion",
        "Tingui-an",
        "Zaragosa",
    ] },
    { province: "Iloilo", city: "Banate", barangayList: [
        "Alacaygan",
        "Bariga",
        "Belen",
        "Bobon",
        "Bularan",
        "Carmelo",
        "De La Paz",
        "Dugwakan",
        "Juanico",
        "Libertad",
        "Magdalo",
        "Managopaya",
        "Merced",
        "Poblacion",
        "San Salvador",
        "Talokgangan",
        "Zona Sur",
        "Fuentes",
    ] },
    { province: "Iloilo", city: "Barotac Nuevo", barangayList: [
        "Acuit",
        "Agcuyawan Calsada",
        "Agcuyawan Pulo",
        "Bagongbong",
        "Baras",
        "Bungca",
        "Cabilauan",
        "Cruz",
        "Guintas",
        "Igbong",
        "Ilaud Poblacion",
        "Ilaya Poblacion",
        "Jalaud",
        "Lagubang",
        "Lanas",
        "Lico-an",
        "Linao",
        "Monpon",
        "Palaciawan",
        "Patag",
        "Salihid",
        "So-ol",
        "Sohoton",
        "Tabuc-Suba",
        "Tabucan",
        "Talisay",
        "Tinorian",
        "Tiwi",
        "Tubungan",
    ] },
    { province: "Iloilo", city: "Barotac Viejo", barangayList: [
        "Bugnay",
        "California",
        "Del Pilar",
        "De la Peña",
        "General Luna",
        "La Fortuna",
        "Lipata",
        "Natividad",
        "Nueva Invencion",
        "Nueva Sevilla",
        "Poblacion",
        "Puerto Princesa",
        "Rizal",
        "San Antonio",
        "San Fernando",
        "San Francisco",
        "San Geronimo",
        "San Juan",
        "San Lucas",
        "San Miguel",
        "San Roque",
        "Santiago",
        "Santo Domingo",
        "Santo Tomas",
        "Ugasan",
        "Vista Alegre",
    ] },
    { province: "Iloilo", city: "Batad", barangayList: [
        "Alapasco",
        "Alinsolong",
        "Banban",
        "Batad Viejo",
        "Binon-an",
        "Bolhog",
        "Bulak Norte",
        "Bulak Sur",
        "Cabagohan",
        "Calangag",
        "Caw-i",
        "Drancalan",
        "Embarcadero",
        "Hamod",
        "Malico",
        "Nangka",
        "Pasayan",
        "Poblacion",
        "Quiazan Florete",
        "Quiazan Lopez",
        "Salong",
        "Santa Ana",
        "Tanao",
        "Tapi-an",
    ] },
    { province: "Iloilo", city: "Bingawan", barangayList: [
        "Agba-o",
        "Alabidhan",
        "Bulabog ",
        "Cairohan",
        "Guinhulacan",
        "Inamyungan",
        "Malitbog Ilawod",
        "Malitbog Ilaya",
        "Ngingi-an",
        "Poblacion ",
        "Quinangyana",
        "Quinar-Upan",
        "Tapacon ",
        "Tubod",
    ] },
    { province: "Iloilo", city: "Cabatuan", barangayList: [
        "Acao",
        "Amerang",
        "Amurao",
        "Anuang",
        "Ayaman",
        "Ayong",
        "Bacan",
        "Balabag",
        "Baluyan",
        "Banguit",
        "Bulay",
        "Cadoldolan",
        "Cagban",
        "Calawagan",
        "Calayo",
        "Duyan-Duyan",
        "Gaub",
        "Gines Interior",
        "Gines Patag",
        "Guibuangan Tigbauan",
        "Inabasan",
        "Inaca",
        "Inaladan",
        "Ingas",
        "Ito Norte",
        "Ito Sur",
        "Janipaan Central",
        "Janipaan Este",
        "Janipaan Oeste",
        "Janipaan Olo",
        "Jelicuon Lusaya",
        "Jelicuon Montinola",
        "Lag-an",
        "Leong",
        "Lutac",
        "Manguna",
        "Maraguit",
        "Morubuan",
        "Pacatin",
        "Pagotpot",
        "Pamul-ogan",
        "Pamuringao Proper",
        "Pamuringao Garrido",
        "Zone I Pob. (Barangay 1)",
        "Zone II Pob. (Barangay 2)",
        "Zone III Pob. (Barangay 3)",
        "Zone IV Pob. (Barangay 4)",
        "Zone V Pob. (Barangay 5)",
        "Zone VI Pob. (Barangay 6)",
        "Zone VII Pob. (Barangay 7)",
        "Zone VIII Pob. (Barangay 8)",
        "Zone IX Pob. (Barangay 9)",
        "Zone X Pob. (Barangay 10)",
        "Zone XI Pob. (Barangay 11)",
        "Pungtod",
        "Puyas",
        "Salacay",
        "Sulanga",
        "Tabucan",
        "Tacdangan",
        "Talanghauan",
        "Tigbauan Road",
        "Tinio-an",
        "Tiring",
        "Tupol Central",
        "Tupol Este",
        "Tupol Oeste",
        "Tuy-an",
    ] },
    { province: "Iloilo", city: "Calinog", barangayList: [
        "Agcalaga",
        "Aglibacao",
        "Aglonok",
        "Alibunan",
        "Badlan Grande",
        "Badlan Pequeño",
        "Badu",
        "Balaticon",
        "Banban Grande",
        "Banban Pequeño",
        "Binolosan Grande",
        "Binolosan Pequeño",
        "Cabagiao",
        "Cabugao",
        "Cahigon",
        "Barrio Calinog",
        "Camalongo",
        "Canabajan",
        "Caratagan",
        "Carvasana",
        "Dalid",
        "Datagan",
        "Gama Grande",
        "Gama Pequeño",
        "Garangan",
        "Guinbonyugan",
        "Guiso",
        "Hilwan",
        "Impalidan",
        "Ipil",
        "Jamin-ay",
        "Lampaya",
        "Libot",
        "Lonoy",
        "Malaguinabot",
        "Malag-It",
        "Malapawe",
        "Malitbog Centro",
        "Mambiranan",
        "Manaripay",
        "Marandig",
        "Masaroy",
        "Maspasan",
        "Nalbugan",
        "Owak",
        "Poblacion Centro",
        "Poblacion Delgado",
        "Poblacion Rizal Ilaud",
        "Poblacion Ilaya",
        "Baje San Julian",
        "San Nicolas",
        "Simsiman",
        "Tabucan",
        "Tahing",
        "Tibiao",
        "Tigbayog",
        "Toyungan",
        "Ulayan",
        "Supanga",
    ] },
    { province: "Iloilo", city: "Carles", barangayList: [
        "Abong",
        "Alipata (Sicogon Island)",
        "Asluman (Gigantes Norte)",
        "Bancal",
        "Barangcalan",
        "Barosbos",
        "Punta Batuanan",
        "Binuluangan",
        "Bito-on",
        "Bolo",
        "Buaya (Sicogon Island)",
        "Buenavista",
        "Isla De Cana",
        "Cabilao Grande",
        "Cabilao Pequeño",
        "Cabuguana",
        "Cawayan",
        "Dayhagan",
        "Gabi (Gigantes Sur)",
        "Granada (Gigantes Norte)",
        "Guinticgan",
        "Lantangan (Gigantes Sur)",
        "Manlot (Manlot Island)",
        "Nalumsan",
        "Pantalan",
        "Poblacion",
        "Punta (Bolocawe)",
        "San Fernando (Sicogon Island)",
        "Tabugon",
        "Talingting",
        "Tarong",
        "Tinigban",
        "Tupaz",
    ] },
    { province: "Iloilo", city: "Concepcion", barangayList: [
        "Aglosong",
        "Agnaga",
        "Bacjawan Norte",
        "Bacjawan Sur",
        "Bagongon",
        "Batiti",
        "Botlog",
        "Calamigan",
        "Dungon",
        "Igbon",
        "Jamul-awon",
        "Lo-ong",
        "Macalbang",
        "Macatunao",
        "Malangabang",
        "Maliogliog",
        "Nińo",
        "Nipa",
        "Plandico",
        "Poblacion",
        "Polopińa (Bulubadiangan Island)",
        "Salvacion",
        "Talotu-an",
        "Tambaliza (Pan de Azucar Island)",
        "Tamis-ac",
    ] },
    { province: "Iloilo", city: "Dingle", barangayList: [
        "Abangay",
        "Agsalanan",
        "Agtatacay",
        "Alegria",
        "Bongloy",
        "Buenavista",
        "Caguyuman",
        "Calicuang",
        "Camambugan",
        "Dawis",
        "Ginalinan Nuevo",
        "Ginalinan Viejo",
        "Gutao",
        "Ilajas",
        "Libo-o",
        "Licu-an",
        "Lincud",
        "Matangharon",
        "Moroboro",
        "Namatay",
        "Nazuni",
        "Pandan",
        "Potolan",
        "San Jose",
        "San Matias",
        "Siniba-an",
        "Tabugon",
        "Tambunac",
        "Tanghawan",
        "Tiguib",
        "Tinocuan",
        "Tulatula-an",
        "Poblacion",
    ] },
    { province: "Iloilo", city: "Dueñas", barangayList: [
        "Agutayan",
        "Angare",
        "Anjawan",
        "Baac",
        "Bagongbong",
        "Balangigan",
        "Balingasag",
        "Banugan",
        "Batuan",
        "Bita",
        "Buenavista",
        "Bugtongan",
        "Cabudian",
        "Calaca-an",
        "Calang",
        "Calawinan",
        "Capaycapay",
        "Capuling",
        "Catig",
        "Dila-an",
        "Fundacion",
        "Inadlawan",
        "Jagdong",
        "Jaguimit",
        "Lacadon",
        "Luag",
        "Malusgod",
        "Maribuyong",
        "Minanga",
        "Monpon",
        "Navalas",
        "Pader",
        "Pandan",
        "Ponong Grande",
        "Ponong Pequeño",
        "Purog",
        "Romblon",
        "San Isidro",
        "Santo Niño",
        "Sawe",
        "Taminla",
        "Tinocuan",
        "Tipolo",
        "Poblacion A",
        "Poblacion B",
        "Poblacion C",
        "Poblacion D",     
    ] },
    { province: "Iloilo", city: "Dumangas", barangayList: [
        "Burgos-Regidor (Poblacion)",
        "Aurora-del Pilar (Poblacion)",
        "Buenaflor-Embarcadero (Poblacion)",
        "Lopez Jaena-Rizal (Poblacion)",
        "J.M. Basa-Mabini Bonifacio (Poblacion)",
        "Bacay",
        "Bacong",
        "Balabag",
        "Balud",
        "Bantud",
        "Bantud Fabrica",
        "Baras",
        "Barasan",
        "Bolilao",
        "Calao",
        "Cali",
        "Cansilayan",
        "Capaliz",
        "Cayos",
        "Compayan",
        "Dacutan",
        "Ermita",
        "PD Monfort South (Guinsampanan)",
        "Ilaya 1st",
        "Ilaya 2nd",
        "Ilaya 3rd",
        "Jardin",
        "Lacturan",
        "PD Monfort North (Lublub)",
        "Managuit",
        "Maquina",
        "Nanding Lopez",
        "Pagdugue",
        "Paloc Bigque",
        "Paloc Sool",
        "Patlad",
        "Pulao",
        "Rosario",
        "Sapao",
        "Sulangan",
        "Tabucan",
        "Talusan",
        "Tambobo",
        "Tamboilan",
        "Victorias",
    ] },
    { province: "Iloilo", city: "Estancia", barangayList: [
        "Lumbia (Ana Cuenca)",
        "Bayas",
        "Bayuyan",
        "Botongon",
        "Bulaqueña",
        "Calapdan",
        "Cano-an",
        "Daan Banua",
        "Daculan",
        "Gogo",
        "Jolog",
        "Loguingot",
        "Malbog",
        "Manipulon",
        "Pa-on",
        "Pani-an",
        "Poblacion Zone 1",
        "Lonoy (Roman Mosqueda)",
        "San Roque",
        "Santa Ana",
        "Tabu-an",
        "Tacbuyan",
        "Tanza",
        "Poblacion Zone II",
        "Poblacion Zone III",
    ] },
    { province: "Iloilo", city: "Guimbal", barangayList: [
        "Anono-o",
        "Bacong",
        "Baras",
        "Binanua-an",
        "Bongol San Miguel",
        "Bongol San Vicente",
        "Bulad",
        "Buluangan",
        "Cabasi",
        "Cabubugan",
        "Calampitao",
        "Camangahan",
        "Igcocolo",
        "Iyasan",
        "Lubacan",
        "Nahapay",
        "Nalundan",
        "Nanga",
        "Nito-an",
        "Particion",
        "Sipitan-Badiang",
        "Santa Rosa-Laguna",
        "Bagumbayan",
        "Balantad-Carlos Fruto",
        "Burgos-Gengos",
        "Generosa-Cristobal Colon",
        "Gerona-Gimeno",
        "Girado-Magsaysay",
        "Gotera",
        "Libo-on Gonzales",
        "Pescadores",
        "Rizal-Tuguisan",
        "Torreblanca-Blumentritt",
    ] },
    { province: "Iloilo", city: "Igbaras", barangayList: [
        "Alameda",
        "Amorogtong",
        "Anilawan",
        "Bagacay",
        "Bagacayan",
        "Bagay",
        "Balibagan",
        "Barasan",
        "Binanua-an",
        "Boclod",
        "Buenavista",
        "Buga",
        "Bugnay",
        "Calampitao",
        "Cale",
        "Corucuan",
        "Catiringan",
        "Igcabugao",
        "Igpigus",
        "Igtalongon",
        "Indaluyon",
        "Jovellar",
        "Kinagdan",
        "Lab-on",
        "Lacay Dol-Dol",
        "Lumangan",
        "Lutungan",
        "Mantangon",
        "Mulangan",
        "Pasong",
        "Passi",
        "Pinaopawan",
        "Barangay 1 Poblacion",
        "Barangay 2 Poblacion",
        "Barangay 3 Poblacion",
        "Barangay 4 Poblacion",
        "Barangay 5 Poblacion",
        "Barangay 6 Poblacion",
        "Riro-an",
        "San Ambrosio",
        "Santa Barbara",
        "Signe",
        "Tabiac",
        "Talayatay",
        "Taytay",
        "Tigbanaba",
    ] },
    { province: "Iloilo", city: "Iloilo City", barangayList: [
        "Bonifacio",
        "Calaparan",
        "Dulonan",
        "Mohon",
        "Quezon",
        "San José",
        "Santa Cruz",
        "Santa Filomina",
        "Santo Domingo",
        "Santo Niño Norte",
        "Santo Niño Sur",
        "Sooc",
        "Yulo Drive",
        "Arsenal Aduana",
        "Baybay Tanza",
        "Bonifacio Tanza",
        "Concepcion-Montes",
        "Danao",
        "Delgado-Jalandoni-Bagumbayan",
        "Edganzon",
        "Flores",
        "General Hughes-Montes",
        "Gloria",
        "Hipodromo",
        "Inday",
        "Jalandoni-Wilson",
        "Kahirupan",
        "Kauswagan",
        "Legaspi dela Rama",
        "Liberation",
        "Mabolo-Delgado",
        "Magsaysay",
        "Malipayon-Delgado",
        "Maria Clara",
        "Monica Blumentritt",
        "Muelle Loney-Montes",
        "Nonoy",
        "Ortiz",
        "Osmeña",
        "President Roxas",
        "Rima-Rizal",
        "Rizal Estanzuela",
        "Rizal Ibarra",
        "Rizal Palapala I",
        "Rizal Palapala II",
        "Roxas Village",
        "Sampaguita",
        "San Agustin",
        "San Felix",
        "San Jose",
        "Santo Rosario-Duran",
        "Tanza-Esperanza",
        "Timawa Tanza I",
        "Timawa Tanza II",
        "Veterans Village",
        "Villa Anita",
        "Yulo-Arroyo",
        "Zamora-Melliza",
        "Arguelles",
        "Balabago",
        "Balantang",
        "Benedicto",
        "Bito-on",
        "Buhang",
        "Buntatala",
        "Calubihan",
        "Camalig",
        "Claudio Castilla El-98",
        "Cuartero",
        "Cubay",
        "Democracia",
        "Desamparados",
        "Dungon A",
        "Dungon B",
        "Fajardo",
        "Javellana",
        "Lanit",
        "Libertad Santa Isabel",
        "Lopez Jaena",
        "Luna",
        "M.H. del Pilar",
        "M.V. Hechanova",
        "Ma. Cristina",
        "Montinola",
        "Our Lady of Fatima",
        "Our Lady of Lourdes",
        "Quintin Salas",
        "Sambag",
        "San Isidro",
        "San Jose",
        "San Pedro",
        "San Roque",
        "San Vicente",
        "Seminario",
        "Simon Ledesma",
        "Tabuc Suba",
        "Tacas",
        "Tagbak",
        "Taytay",
        "Ungka",
        "Aguinaldo",
        "Baldoza",
        "Bantud",
        "Banuyao",
        "Burgos-Mabini-Plaza",
        "Caingin",
        "Divinagracia",
        "Gustilo",
        "Hinactacan",
        "Ingore",
        "Jereos",
        "Laguda",
        "Lopez Jaena Norte",
        "Lopez Jaena Sur",
        "Luna",
        "MacArthur",
        "Magdalo",
        "Magsaysay Village",
        "Nabitasan",
        "Railway",
        "Rizal",
        "San Isidro",
        "San Nicolas",
        "Tabuc Suba",
        "Alalasan",
        "Bo. Obrero",
        "Don Esteban",
        "Jalandoni Estate",
        "Lapuz Norte",
        "Lapuz Sur",
        "Libertad",
        "Loboc",
        "Mansaya",
        "Progreso",
        "Punong",
        "Sinikway",
        "Abeto Mirasol Taft South (Quirino Abeto)",
        "Airport (Tabucan Airport)",
        "Bakhaw",
        "Bolilao",
        "Buhang Taft North",
        "Calahunan",
        "Dungon C",
        "Guzman-Jesena",
        "Hibao-an Norte",
        "Hibao-an Sur",
        "Navais",
        "Oñate de Leon",
        "Pale Benedicto Rizal",
        "PHHC Block 17",
        "PHHC Block 22 NHA",
        "San Rafael",
        "Santa Rosa",
        "Tabucan",
        "Calumpang",
        "Cochero",
        "Compania",
        "East Baluarte",
        "East Timawa",
        "Habog-Habog Salvacion",
        "Infante",
        "Kasingkasing",
        "Katilingban",
        "Molo Boulevard",
        "North Avanceña",
        "North Baluarte",
        "North Fundidor",
        "North San Jose",
        "Poblacion",
        "San Antonio",
        "San Juan",
        "San Pedro",
        "South Baluarte",
        "South Fundidor",
        "South San Jose",
        "Taal",
        "Tap-oc",
        "West Habog-Habog",
        "West Timawa",
    ] },
    { province: "Iloilo", city: "Janiuay", barangayList: [
        "Abangay",
        "Agcarope",
        "Aglobong",
        "Aguingay",
        "Anhawan",
        "Atimonan",
        "Balanac",
        "Barasalon",
        "Bongol",
        "Cabantog",
        "Calmay",
        "Canawili",
        "Canawillian",
        "Caranas",
        "Caraudan",
        "Carigangan",
        "Cunsad",
        "Dabong",
        "Damires",
        "Damo-ong",
        "Danao",
        "Gines",
        "Guadalupe",
        "Jibolo",
        "Kuyot",
        "Madong",
        "Manacabac",
        "Mangil",
        "Matag-ub",
        "Monte-Magapa",
        "Pangilihan",
        "Panuran",
        "Pararinga",
        "Patong-patong",
        "Quipot",
        "Santo Tomas",
        "Sarawag",
        "Tambal",
        "Tamu-an",
        "Tiringanan",
        "Tolarucan",
        "Tuburan",
        "Ubian",
        "Yabon",
        "Aquino Nobleza East (Poblacion)",
        "Aquino Nobleza West (Poblacion)",
        "R. Armada (Poblacion)",
        "Concepcion Pob. (D.G. Abordo)",
        "Golgota (Poblacion)",
        "Locsin (Poblacion)",
        "Don T. Lutero Center (Poblacion)",
        "Don T. Lutero East (Poblacion)",
        "Don T. Lutero West Pob",
        "Crispin Salazar North (Poblacion)",
        "Crispin Salazar South (Poblacion)",
        "San Julian (Poblacion)",
        "San Pedro (Poblacion)",
        "Santa Rita (Poblacion)",
        "Capt. A. Tirador (Poblacion)",
        "S. M. Villa (Poblacion)",
    ] },
    { province: "Iloilo", city: "Lambunao", barangayList: [
        "Agsirab",
        "Agtuman",
        "Alugmawa",
        "Badiangan",
        "Bagongbong",
        "Balagiao",
        "Banban",
        "Bansag",
        "Bayuco",
        "Binaba-an Armada",
        "Binaba-an Labayno",
        "Binaba-an Limoso",
        "Binaba-an Portigo",
        "Binaba-an Tirador",
        "Bonbon",
        "Bontoc",
        "Buri",
        "Burirao",
        "Buwang",
        "Cabatangan",
        "Cabugao",
        "Cabunlawan",
        "Caguisanan",
        "Caloy-ahan",
        "Caninguan",
        "Capangyan",
        "Cayan Este",
        "Cayan Oeste",
        "Corot-on",
        "Coto",
        "Cubay",
        "Cunarum",
        "Daanbanwa",
        "Gines",
        "Hipgos",
        "Jayubo",
        "Jorog",
        "Lanot Grande",
        "Lanot Pequeño",
        "Legayada",
        "Lumanay (Daanbanwa I)",
        "Madarag",
        "Magbato",
        "Maite Grande",
        "Maite Pequeño",
        "Malag-it",
        "Manaulan",
        "Maribong",
        "Marong",
        "Misi",
        "Natividad",
        "Pajo",
        "Pandan",
        "Panuran",
        "Pasig",
        "Patag",
        "Poblacion Ilawod",
        "Poblacion Ilaya",
        "Poong",
        "Pughanan",
        "Pungsod",
        "Quiling",
        "Sagcup",
        "San Gregorio",
        "Sibacungan",
        "Sibaguan",
        "Simsiman",
        "Supoc",
        "Tampucao",
        "Tranghawan",
        "Tubungan",
        "Tuburan",
        "Walang",
    ] },
    { province: "Iloilo", city: "Leganes", barangayList: [
        "M.V. Hechanova (Balabago)",
        "Bigke",
        "Buntatala",
        "Cagamutan Norte",
        "Cagamutan Sur",
        "Calaboa",
        "Camangay",
        "Cari Mayor",
        "Cari Minor",
        "Gua-an",
        "Guihaman",
        "Guinobatan",
        "Guintas",
        "Lapayon",
        "Nabitasan",
        "Napnud",
        "Poblacion",
        "San Vicente",
    ] },
    { province: "Iloilo", city: "Lemery", barangayList: [
        "Agpipili",
        "Alcantara",
        "Almeñana (aka Tuguis)",
        "Anabo",
        "Bankal",
        "Buenavista",
        "Cabantohan",
        "Capiñahan",
        "Dalipe",
        "Dapdapan",
        "Gerongan",
        "Imbaulan",
        "Layogbato",
        "Marapal",
        "Milan",
        "Nagsulang",
        "Nasapahan",
        "Omio",
        "Pacuan",
        "Poblacion NW Zone",
        "Poblacion SE Zone",
        "Pontoc",
        "San Antonio",
        "San Diego",
        "San Jose Moto",
        "Sepanton",
        "Sincua",
        "Tabunan",
        "Tugas",
        "Velasco",
        "Yawyawan",
    ] },
    { province: "Iloilo", city: "Leon", barangayList: [
        "Agboy Norte",
        "Agboy Sur",
        "Agta",
        "Ambulong",
        "Anonang",
        "Apian",
        "Avanzada",
        "Awis",
        "Ayabang",
        "Ayubo",
        "Bacolod",
        "Baje",
        "Banagan",
        "Barangbang",
        "Barasan",
        "Bayag Norte",
        "Bayag Sur",
        "Binolbog",
        "Biri Norte",
        "Biri Sur",
        "Bobon",
        "Bucari",
        "Buenavista",
        "Buga",
        "Bulad",
        "Bulwang",
        "Cabolo-an",
        "Cabunga-an",
        "Cabutongan",
        "Cagay",
        "Camandag",
        "Camando",
        "Cananaman",
        "Capt. Fernando",
        "Carara-an",
        "Carolina",
        "Cawilihan",
        "Coyugan Norte",
        "Coyugan Sur",
        "Danao",
        "Dorog",
        "Dusacan",
        "Gines",
        "Gumboc",
        "Igcadios",
        "Ingay",
        "Isian Norte",
        "Isian Victoria",
        "Jamog Gines",
        "Lanag",
        "Lang-og",
        "Ligtos",
        "Lonoc",
        "Lampaya",
        "Magcapay",
        "Maliao",
        "Malublub",
        "Manampunay",
        "Marirong",
        "Mina",
        "Mocol",
        "Nagbangi",
        "Nalbang",
        "Odong-odong",
        "Oluangan",
        "Omambong",
        "Paoy",
        "Pandan",
        "Panginman",
        "Pepe",
        "Poblacion",
        "Paga",
        "Salngan",
        "Samlague",
        "Siol Norte",
        "Siol Sur",
        "Tacuyong Norte",
        "Tacuyong Sur",
        "Tagsing",
        "Talacuan",
        "Ticuan",
        "Tina-an Norte",
        "Tina-an Sur",
        "Tunguan",
        "Tu-og",
    ] },
    { province: "Iloilo", city: "Maasin", barangayList: [
        "Abay",
        "Abilay",
        "AGROCEL Pob.(Aguinaldo-Roxas-Celso)",
        "Amerang",
        "Bagacay East",
        "Bacuranan",
        "Bagacay West",
        "Bug-ot",
        "Bolo",
        "Bulay",
        "Buntalan",
        "Burak",
        "Cabangcalan",
        "Cabatac",
        "Caigon",
        "Cananghan",
        "Canawili",
        "Dagami",
        "Daja",
        "Dalusan",
        "DELCAR Pob. (Delgado-Cartagena)",
        "Inabasan",
        "Layog",
        "Liñagan Calsada",
        "Liñagan Tacas",
        "Linab",
        "MABRIZ Pob. (Mabini-Rizal)",
        "Magsaysay",
        "Mandog",
        "Miapa",
        "Nagba",
        "Nasaka",
        "Naslo-Bucao",
        "Nasuli",
        "Panalian",
        "Piandaan East",
        "Piandaan West",
        "Pispis",
        "Punong",
        "Sinubsuban",
        "Siwalo",
        "Santa Rita",
        "Subog",
        "THT & P Pob. (Taft-Hughes-Thompson-del Pilar)",
        "Tigbauan",
        "Trangka",
        "Tubang",
        "Tulahong",
        "Tuy-an East",
        "Tuy-an West",
        "Ubian",
    ] },
    { province: "Iloilo", city: "Miagao", barangayList: [
        "Agdum",
        "Aguiauan",
        "Alimodias",
        "Awang",
        "Bacauan",
        "Bacolod",
        "Bagumbayan",
        "Banbanan",
        "Banga",
        "Bangladan",
        "Banuyao",
        "Baraclayan",
        "Bariri",
        "Baybay Norte (Poblacion)",
        "Baybay Sur (Poblacion)",
        "Belen",
        "Bolho (Poblacion)",
        "Bolocaue",
        "Buenavista Norte",
        "Buenavista Sur",
        "Bugtong Lumangan",
        "Bugtong Naulid",
        "Cabalaunan",
        "Cabangcalan",
        "Cabunotan",
        "Cadoldolan",
        "Cagbang",
        "Caitib",
        "Calagtangan",
        "Calampitao",
        "Cavite",
        "Cawayanan",
        "Cubay",
        "Cubay Ubos",
        "Dalije",
        "Damilisan",
        "Dawog",
        "Diday",
        "Dingle",
        "Durog",
        "Frantilla",
        "Fundacion",
        "Gines",
        "Guibongan",
        "Igbita",
        "Igbugo",
        "Igcabidio",
        "Igcabito-on",
        "Igcatambor",
        "Igdalaquit",
        "Igdulaca",
        "Igpajo",
        "Igpandan",
        "Igpuro",
        "Igpuro-Bariri",
        "Igsoligue",
        "Igtuba",
        "Ilog-ilog",
        "Indag-an",
        "Kirayan Norte",
        "Kirayan Sur",
        "Kirayan Tacas",
        "La Consolacion",
        "Lacadon",
        "Lanutan",
        "Lumangan",
        "Mabayan",
        "Maduyo",
        "Malagyan",
        "Mambatad",
        "Maninila",
        "Maricolcol",
        "Maringyan",
        "Mat-y (Poblacion)",
        "Matalngon",
        "Naclub",
        "Nam-o Sur",
        "Nam-o Norte",
        "Narat-an",
        "Narorogan",
        "Naulid",
        "Olango",
        "Ongyod",
        "Onop",
        "Oya-oy",
        "Oyungan",
        "Palaca",
        "Paro-on",
        "Potrido",
        "Pudpud",
        "Pungtod Monteclaro",
        "Pungtod Naulid",
        "Sag-on",
        "San Fernando",
        "San Jose",
        "San Rafael",
        "Sapa (Poblacion)",
        "Saring",
        "Sibucao",
        "Taal",
        "Tabunacan",
        "Tacas (Poblacion)",
        "Tambong",
        "Tan-agan",
        "Tatoy",
        "Ticdalan",
        "Tig-amaga",
        "Tig-Apog-Apog",
        "Tigbagacay",
        "Tiglawa",
        "Tigmalapad",
        "Tigmarabo",
        "To-og",
        "Tugura-ao",
        "Tumagboc",
        "Ubos Ilawod (Poblacion)",
        "Ubos Ilaya (Poblacion)",
        "Valencia",
        "Wayang",
    ] },
    { province: "Iloilo", city: "Mina", barangayList: [
        "Abat",
        "Agmanaphao",
        "Amiroy",
        "Badiangan",
        "Bangac",
        "Cabalabaguan",
        "Capul-an",
        "Dala",
        "Guibuangan",
        "Janipa-an West",
        "Janipa-an East",
        "Mina East (Poblacion)",
        "Mina West (Poblacion)",
        "Nasirum",
        "Naumuan",
        "Singay",
        "Talibong Grande",
        "Talibong Pequeño",
        "Tipolo",
        "Tolarucan",
        "Tumay",
        "Yugot",
    ] },
    { province: "Iloilo", city: "New Lucena", barangayList: [
        "Baclayan",
        "Badiang",
        "Balabag",
        "Bilidan",
        "Bita-og Gaja",
        "Bololacao",
        "Burot",
        "Cabilauan",
        "Cabugao",
        "Cagban",
        "Calumbuyan",
        "Damires",
        "Dawis",
        "General Delgado",
        "Guinobatan",
        "Janipa-an Oeste",
        "Jelicuon Este",
        "Jelicuon Oeste",
        "Pasil",
        "Poblacion",
        "Wari-wari",
    ] },
    { province: "Iloilo", city: "Oton", barangayList: [
        "Abilay Norte",
        "Abilay Sur",
        "Alegre",
        "Batuan Ilaud",
        "Batuan Ilaya",
        "Bita Norte",
        "Bita Sur",
        "Botong",
        "Buray",
        "Cabanbanan",
        "Cabolo-an Norte",
        "Cabolo-an Sur",
        "Cadinglian",
        "Cagbang",
        "Calam-isan",
        "Galang",
        "Lambuyao",
        "Mambog",
        "Pakiad",
        "Poblacion East",
        "Poblacion North",
        "Poblacion South",
        "Poblacion West",
        "Pulo Maestra Vita",
        "Rizal",
        "Salngan",
        "Sambaludan",
        "San Antonio",
        "San Nicolas",
        "Santa Clara",
        "Santa Monica",
        "Santa Rita",
        "Tagbac Norte",
        "Tagbac Sur",
        "Trapiche",
        "Tuburan",
        "Turog-Turog",
    ] },
    { province: "Iloilo", city: "Passi", barangayList: [
        "Agdahon",
        "Agdayao",
        "Aglalana",
        "Agtabo",
        "Agtambo",
        "Alimono",
        "Arac",
        "Ayuyan",
        "Bacuranan",
        "Bagacay",
        "Batu",
        "Bayan",
        "Bitaogan",
        "Buenavista ",
        "Buyo",
        "Cabunga",
        "Cadilang",
        "Cairojan",
        "Dalicanan",
        "Gemat-y",
        "Gemumua-Agahon",
        "Gegacjac",
        "Gines Viejo",
        "Imbang Grande",
        "Jaguimitan",
        "Libo-o",
        "Maasin",
        "Magdungao",
        "Malag-it Grande",
        "Malag-it Pequeño",
        "Mambiranan Grande",
        "Mambiranan Pequeño",
        "Man-it",
        "Mantulang",
        "Mulapula",
        "Nueva Union",
        "Pangi",
        "Pagaypay",
        "Poblacion Ilawod",
        "Poblacion Ilaya",
        "Punong",
        "Quinagaringan Grande",
        "Quinagaringan Pequeño",
        "Sablogon",
        "Salngan",
        "Santo Tomas",
        "Sarapan",
        "Tagubong",
        "Talongonan",
        "Tubod",
        "Tuburan",
    ] },
    { province: "Iloilo", city: "Pavia", barangayList: [
        "Aganan",
        "Amparo",
        "Anilao",
        "Balabag",
        "Purok I (Poblacion)",
        "Purok II (Poblacion)",
        "Purok III (Poblacion)",
        "Purok IV (Poblacion)",
        "Cabugao Norte",
        "Cabugao Sur",
        "Jibao-an",
        "Mali-ao",
        "Pagsanga-an",
        "Pal-agon",
        "Pandac",
        "Tigum",
        "Ungka I",
        "Ungka II",
    ] },
    { province: "Iloilo", city: "Pototan", barangayList: [
        "Abangay",
        "Amamaros",
        "Bagacay",
        "Barasan",
        "Batuan",
        "Bongco",
        "Cahaguikican",
        "Callan",
        "Cansilayan",
        "Casalsagan",
        "Cato-ogan",
        "Cau-ayan",
        "Culob",
        "Danao",
        "Dapitan",
        "Dawis",
        "Dongsol",
        "Fundacion",
        "Guinacas",
        "Guibuangan",
        "Igang",
        "Intaluan",
        "Iwa Ilaud",
        "Iwa Ilaya",
        "Jamabalud",
        "Jebioc",
        "Lay-ahan",
        "Primitivo Ledesma Ward",
        "Lopez Jaena Ward (Poblacion)",
        "Lumbo",
        "Macatol",
        "Malusgod",
        "Naslo",
        "Nabitasan",
        "Naga",
        "Nanga",
        "Pajo",
        "Palanguia",
        "Fernando Parcon Ward (Poblacion)",
        "Pitogo",
        "Polot-an",
        "Purog",
        "Rumbang",
        "San Jose Ward (Poblacion)",
        "Sinuagan",
        "Tuburan",
        "Tumcon Ilaya",
        "Tumcon Ilaud",
        "Ubang",
        "Zarrague",
    ] },
    { province: "Iloilo", city: "San Dionisio", barangayList: [
        "Agdaliran",
        "Bagacay",
        "Batuan",
        "Bondulan",
        "Borongon",
        "Canas",
        "Capinang",
        "Amayong",
        "Cubay",
        "Cudionan",
        "Dugman",
        "Hacienda Conchita",
        "Madanlog",
        "Mandu-awak",
        "Moto",
        "Naborot",
        "Nipa",
        "Odiongan",
        "Pangi",
        "Pase",
        "Poblacion",
        "San Nicolas",
        "Santol",
        "Siempreviva",
        "Sua",
        "Talo-ato",
        "Tamangi",
        "Tiabas",
        "Tuble",
    ] },
    { province: "Iloilo", city: "San Enrique", barangayList: [
        "Abaca",
        "Asisig",
        "Bantayan",
        "Braulan",
        "Cabugao Nuevo",
        "Cabugao Viejo",
        "Camiri",
        "Catan-agan",
        "Compo",
        "Cubay",
        "Dacal",
        "Dumiles",
        "Garita",
        "Gines Nuevo",
        "Imbang Pequeño",
        "Imbesad-an s",
        "Iprog",
        "Lip-ac",
        "Madarag",
        "Mapili",
        "Paga",
        "Palje",
        "Poblacion Ilawod",
        "Poblacion Ilaya",
        "Quinolpan",
        "Rumagayray",
        "San Antonio",
        "Tambunac",
    ] },
    { province: "Iloilo", city: "San Joaquin", barangayList: [
        "Amboyu-an",
        "Andres Bonifacio",
        "Antalon",
        "Bad-as",
        "Bagumbayan",
        "Balabago",
        "Baybay",
        "Bayunan",
        "Bolbogan",
        "Bulho",
        "Bucaya",
        "Cadluman",
        "Cadoldolan",
        "Camia",
        "Camaba-an",
        "Cata-an",
        "Crossing Dapuyan",
        "Cubay",
        "Cumarascas",
        "Dacdacanan",
        "Danawan",
        "Doldol",
        "Dongoc",
        "Escalantera",
        "Ginot-an",
        "Huna",
        "Igaratong",
        "Igbaje",
        "Igbangcal",
        "Igbinangon",
        "Igburi",
        "Igcabutong",
        "Igcadlum",
        "Igcaphang",
        "Igcaratong",
        "Igcondao",
        "Igcores",
        "Igdagmay",
        "Igdomingding",
        "Iglilico",
        "Igpayong",
        "Jawod",
        "Langca",
        "Languanan",
        "Lawigan",
        "Lomboy",
        "Lopez Vito",
        "Mabini Norte",
        "Mabini Sur",
        "Manhara",
        "Maninila",
        "Masagud",
        "Matambog",
        "Mayunoc",
        "Montinola",
        "Nagquirisan",
        "Nadsadan",
        "Nagsipit",
        "New Gumawan",
        "Panatan",
        "Pitogo",
        "Purok 1 (Poblacion)",
        "Purok 2 (Poblacion)",
        "Purok 3 (Poblacion)",
        "Purok 4 (Poblacion)",
        "Purok 5 (Poblacion)",
        "Qui-anan",
        "Roma",
        "San Luis",
        "San Mateo Norte",
        "San Mateo Sur",
        "Santiago",
        "Sinogbuhan",
        "Siwaragan",
        "Lomboyan",
        "Santa Rita",
        "Talagutac",
        "Tapikan",
        "Taslan",
        "Tiglawa",
        "Tiolas",
        "To-og",
        "Torocadan",
        "Ulay",
        "Bonga",
        "Guibongan Bayunan",
    ] },
    { province: "Iloilo", city: "San Miguel", barangayList: [
        "Barangay 1 Poblacion (Roxas St.)",
        "Barangay 2 Poblacion (Salvilla Santo Rosario)",
        "Barangay 3 Poblacion (A.S. Suarez St. Zone 1)",
        "Barangay 4 Poblacion (A.S. Suarez East)",
        "Barangay 5 Poblacion (Santiago St. North)",
        "Barangay 6 Poblacion (Santiago St. South)",
        "Barangay 7 Poblacion (San Roque St. South)",
        "Barangay 8 Poblacion (Montaño-San Roque)",
        "Barangay 9 Poblacion (Salazar San Jose)",
        "Barangay 10 Poblacion (R.V. Sanchez St. South)",
        "Barangay 11 Poblacion (R.V. Sanchez St. North)",
        "Barangay 12 Poblacion (Sales Malaga Saliedo)",
        "Barangay 13 Poblacion (SantaRita-Saclauso St.)",
        "Barangay 14 Poblacion (San Miguel North)",
        "Barangay 15 Poblacion (San Miguel South)",
        "Barangay 16 Poblacion (San Agustin St.)",
        "Consolacion",
        "Igtambo",
        "San Antonio",
        "San Jose",
        "Santa Cruz",
        "Santa Teresa",
        "Santo Angel",
        "Santo Niño",
    ] },
    { province: "Iloilo", city: "San Rafael", barangayList: [
        "Aripdip",
        "Bagacay",
        "Calaigang",
        "Ilongbukid",
        "Poscolon",
        "San Andres",
        "San Dionisio",
        "San Florentino",
        "Poblacion",
    ] },
    { province: "Iloilo", city: "Santa Barbara", barangayList: [
        "Agusipan",
        "Agutayan",
        "Bagumbayan",
        "Balabag",
        "Balibagan Este",
        "Balibagan Oeste",
        "Ban-ag",
        "Bantay",
        "Barangay Zone I (Poblacion)",
        "Barangay Zone II (Poblacion)",
        "Barangay Zone III (Poblacion)",
        "Barangay Zone IV (Poblacion)",
        "Barangay Zone V (Poblacion)",
        "Barangay Zone VI (Poblacion)",
        "Barasan Este",
        "Barasan Oeste",
        "Binangkilan",
        "Bitaog-Taytay",
        "Bolong Este",
        "Bolong Oeste",
        "Buayahon",
        "Buyo",
        "Cabugao Norte",
        "Cabugao Sur",
        "Cadagmayan Norte",
        "Cadagmayan Sur",
        "Cafe",
        "Calaboa Este",
        "Calaboa Oeste",
        "Camambugan",
        "Canipayan",
        "Conaynay",
        "Daga",
        "Dalid",
        "Duyanduyan",
        "Gen. Martin T. Delgado",
        "Guno",
        "Inangayan",
        "Jibao-an",
        "Lacadon",
        "Lanag",
        "Lupa",
        "Magancina",
        "Malawog",
        "Mambuyo",
        "Manhayang",
        "Miraga-Guibuangan",
        "Nasugban",
        "Omambog",
        "Pal-agon",
        "Pungsod",
        "San Sebastian",
        "Sangcate",
        "Tagsing",
        "Talanghauan",
        "Talongadian",
        "Tigtig",
        "Tungay",
        "Tuburan",
        "Tugas",
    ] },
    { province: "Iloilo", city: "Sara", barangayList: [
        "Aguirre",
        "Aldeguer",
        "Alibayog",
        "Anoring",
        "Apelo",
        "Apologista",
        "Aposaga",
        "Arante",
        "Ardemil",
        "Aspera",
        "Aswe-Pabriaga",
        "Bagaygay",
        "Bakabak",
        "Batitao",
        "Bato",
        "Del Castillo",
        "Castor",
        "Crespo",
        "Devera",
        "Domingo",
        "Ferraris",
        "Gildore",
        "Improgo",
        "Juaneza",
        "Labigan",
        "Lanciola",
        "Latawan",
        "Malapaya",
        "Muyco",
        "Padios",
        "Pasig",
        "Poblacion Ilawod",
        "Poblacion Ilaya",
        "Poblacion Market",
        "Posadas",
        "Preciosa",
        "Salcedo",
        "San Luis",
        "Tady",
        "Tentay",
        "Villahermosa",
        "Zerrudo",
    ] },
    { province: "Iloilo", city: "Tigbauan", barangayList: [
        "Alupidian",
        "Atabayan",
        "Bagacay",
        "Baguingin",
        "Bagumbayan",
        "Bangkal",
        "Bantud",
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Barangay 6 (Poblacion)",
        "Barangay 7 (Poblacion)",
        "Barangay 8 (Poblacion)",
        "Barangay 9 (Poblacion)",
        "Barosong",
        "Barroc",
        "Bitas",
        "Bayuco",
        "Binaliuan Mayor",
        "Binaliuan Menor",
        "Buenavista",
        "Bugasongan",
        "Buyu-an",
        "Canabuan",
        "Cansilayan",
        "Cordova Norte",
        "Cordova Sur",
        "Danao",
        "Dapdap",
        "Dorong-an",
        "Guisian",
        "Isawan",
        "Isian",
        "Jamog",
        "Lanag",
        "Linobayan",
        "Lubog",
        "Nagba",
        "Namocon",
        "Napnapan Norte",
        "Napnapan Sur",
        "Olo Barroc",
        "Parara Norte",
        "Parara Sur",
        "San Rafael",
        "Sermon",
        "Sipitan",
        "Supa",
        "Tan Pael",
        "Taro",
    ] },
    { province: "Iloilo", city: "Tubungan", barangayList: [
        "Adgao",
        "Ago",
        "Ambarihon",
        "Ayubo",
        "Bacan",
        "Badiang",
        "Bagunanay",
        "Balicua",
        "Bantayanan",
        "Batga",
        "Bato",
        "Bikil",
        "Boloc",
        "Bondoc/Santo Niño",
        "Borong",
        "Buenavista",
        "Cadabdab",
        "Daga-ay",
        "Desposorio",
        "Igdampog Norte",
        "Igdampog Sur",
        "Igpaho",
        "Igtuble",
        "Ingay",
        "Isauan",
        "Jolason",
        "Jona",
        "Laag/San Vicente",
        "Lanag Norte",
        "Lanag Sur",
        "Male",
        "Mayang",
        "Molina",
        "Morcillas",
        "Nagba",
        "Navillan",
        "Pinamacalan",
        "San Jose",
        "Sibucauan",
        "Singon",
        "Tabat",
        "Tagpu-an",
        "Talento",
        "Teniente Benito",
        "Victoria",
        "Zone I Pob.",
        "Zone II Pob.",
        "Zone III Pob.",
    ] },
    { province: "Iloilo", city: "Zarraga", barangayList: [
        "Balud Lilo-an",
        "Balud I",
        "Balud II",
        "Dawis Centro",
        "Dawis Norte",
        "Dawis Sur",
        "Gines",
        "Inagdangan Centro",
        "Inagdangan Norte",
        "Inagdangan Sur",
        "Jalaud Norte",
        "Jalaud Sur",
        "Libongcogon",
        "Malunang",
        "Pajo",
        "Ilawod Poblacion",
        "Ilaya Poblacion",
        "Sambag",
        "Sigangao",
        "Talauguis",
        "Talibong",
        "Tubigan",
        "Tuburan",
        "Tuburan Sulbod",
    ] },
    // { province: "Isabela", city: "", barangayList: [] },
    // { province: "Kalinga", city: "", barangayList: [] },
    // { province: "La Union", city: "", barangayList: [] },
    { province: "Laguna", city: "Alaminos", barangayList: [
        "Del Carmen",
        "Palma",
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Barangay III (Poblacion)",
        "Barangay IV (Poblacion)",
        "San Agustin (Antipolo)",
        "San Andres",
        "San Benito (Palita)",
        "San Gregorio",
        "San Ildefonso",
        "San Juan",
        "San Miguel",
        "San Roque",
        "Santa Rosa",
    ] },
    { province: "Laguna", city: "Bay", barangayList: [
        "Bitin",
        "Calo",
        "Dila",
        "Maitim",
        "Masaya",
        "Paciano Rizal",
        "Puypuy",
        "San Antonio",
        "San Isidro",
        "Santa Cruz",
        "Santo Domingo",
        "Tagumpay",
        "Tranca",
        "San Agustin (Poblacion)",
        "San Nicolas (Poblacion)",
    ] },
    { province: "Laguna", city: "Biñan", barangayList: [
        "Biñan (Poblacion)",
        "Bungahan",
        "Santo Tomas (Calabuso)",
        "Canlalay",
        "Casile",
        "DeLa Paz",
        "Ganado",
        "San Francisco (Halang)",
        "Langkiwa",
        "Loma",
        "Malaban",
        "Malamig",
        "Mampalasan",
        "Platero",
        "Poblacion",
        "Santo Niño",
        "San Antonio",
        "San Jose",
        "San Vicente",
        "Soro-soro",
        "Santo Domingo",
        "Timbao",
        "Tubigan",
        "Zapote",
    ] },
    { province: "Laguna", city: "Cabuyao", barangayList: [
        "Baclaran",
        "Banay-Banay",
        "Banlic",
        "Bigaa",
        "Butong",
        "Casile",
        "Diezmo",
        "Gulod",
        "Mamatid",
        "Marinig",
        "Niugan",
        "Pittland",
        "Pulo",
        "Sala",
        "San Isidro",
        "Poblacion I",
        "Poblacion II",
        "Poblacion III",
    ] },
    { province: "Laguna", city: "Calamba", barangayList: [
        "Bagong Kalsada",
        "Bañadero",
        "Banlic",
        "Barandal",
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Barangay 6 (Poblacion)",
        "Barangay 7 (Poblacion)",
        "Batino",
        "Bubuyan",
        "Bucal",
        "Bunggo",
        "Burol",
        "Camaligan",
        "Canlubang",
        "Halang",
        "Hornalan",
        "Kay-Anlog",
        "La Mesa",
        "Laguerta",
        "Lawa",
        "Lecheria",
        "Lingga",
        "Looc",
        "Mabato",
        "Majada Labas",
        "Makiling",
        "Mapagong",
        "Masili",
        "Maunong",
        "Mayapa",
        "Milagrosa",
        "Paciano Rizal",
        "Palingon",
        "Palo-Alto",
        "Pansol",
        "Parian",
        "Prinza",
        "Punta",
        "Puting Lupa",
        "Real",
        "Saimsim",
        "Sampiruhan",
        "San Cristobal",
        "San Jose",
        "San Juan",
        "Sirang Lupa",
        "Sucol",
        "Turbina",
        "Ulango",
        "Uwisan",
    ] },
    { province: "Laguna", city: "Calauan", barangayList: [
        "Balayhangin",
        "Bangyas",
        "Dayap",
        "Hanggan",
        "Imok",
        "Lamot 1",
        "Lamot 2",
        "Limao",
        "Mabacan",
        "Masiit",
        "Paliparan",
        "Pérez",
        "Kanluran (Poblacion)",
        "Silangan (Poblacion)",
        "Prinza",
        "San Isidro",
        "Santo Tomás",
    ] },
    { province: "Laguna", city: "Cavinti", barangayList: [
        "Anglas",
        "Bangco",
        "Bukal",
        "Bulajo",
        "Cansuso",
        "Duhat ",
        "Inao-Awan",
        "Kanluran Talaongan",
        "Labayo",
        "Layasin",
        "Layug",
        "Lumot/Mahipon",
        "Paowin",
        "Poblacion ",
        "Sisilmin",
        "Silangan Talaongan",
        "Sumucab",
        "Tibatib",
        "Udia",
    ] },
    { province: "Laguna", city: "Famy", barangayList: [
        "Asana (Poblacion)",
        "Bacong-Sigsigan",
        "Bagong Pag-Asa (Poblacion)",
        "Balitoc",
        "Banaba (Poblacion)",
        "Batuhan",
        "Bulihan",
        "Caballero (Poblacion)",
        "Calumpang (Poblacion)",
        "Kapatalan",
        "Cuebang Bato",
        "Damayan (Poblacion)",
        "Kataypuanan",
        "Liyang",
        "Maate",
        "Magdalo (Poblacion)",
        "Mayatba",
        "Minayutan",
        "Salangbato",
        "Tunhac",
    ] },
    { province: "Laguna", city: "Kalayaan", barangayList: [
        "Longos",
        "San Antonio",
        "San Juan",
    ] },
    { province: "Laguna", city: "Liliw", barangayList: [
        "Bagong Anyo (Poblacion)",
        "Bayate",
        "Bongkol",
        "Bubukal",
        "Cabuyew",
        "Calumpang",
        "San Isidro",
        "Culoy",
        "Dagatan",
        "Daniw",
        "Dita",
        "Ibabang Palina",
        "Ibabang San Roque",
        "Ibabang Sungi",
        "Ibabang Taykin",
        "Ilayang Palina",
        "Ilayang San Roque",
        "Ilayang Sungi",
        "Ilayang Taykin",
        "Kanlurang Bukal",
        "Laguan",
        "Luquin",
        "Malabo-Kalantukan",
        "Masikap (Poblacion)",
        "Maslun (Poblacion)",
        "Mojon",
        "Novaliches",
        "Oples",
        "Pag-asa (Poblacion)",
        "Palayan",
        "Rizal (Poblacion)",
        "San Isidro",
        "Silangang Bukal",
        "Tuy-Baanan",
    ] },
    { province: "Laguna", city: "Los Baños", barangayList: [
        "Anos",
        "Bagong Silang",
        "Bambang",
        "Batong Malake",
        "Baybayin",
        "Bayog",
        "Lalakay",
        "Maahas",
        "Malinta",
        "Mayondon",
        "Putho-Tuntungin",
        "San Antonio",
        "Tadlac",
        "Timugan",
    ] },
    { province: "Laguna", city: "Luisiana", barangayList: [
        "De La Paz",
        "Barangay Zone I (Poblacion)",
        "Barangay Zone II (Poblacion)",
        "Barangay Zone III (Poblacion)",
        "Barangay Zone IV (Poblacion)",
        "Barangay Zone V (Poblacion)",
        "Barangay Zone VI (Poblacion)",
        "Barangay Zone VII (Poblacion)",
        "Barangay Zone VIII (Poblacion)",
        "San Antonio",
        "San Buenaventura",
        "San Diego",
        "San Isidro",
        "San José",
        "San Juan",
        "San Luis",
        "San Pablo",
        "San Pedro",
        "San Rafaél",
        "San Roque",
        "San Salvador",
        "Santo Domingo",
        "Santo Tomás",
    ] },
    { province: "Laguna", city: "Lumban", barangayList: [
        "Bagong Silang",
        "Balimbingan (Poblacion)",
        "Balubad",
        "Caliraya",
        "Concepcion",
        "Lewin",
        "Maracta (Poblacion)",
        "Maytalang I",
        "Maytalang II",
        "Primera Parang (Poblacion)",
        "Primera Pulo (Poblacion)",
        "Salac (Poblacion)",
        "Santo Niño (Poblacion)",
        "Segunda Parang (Poblacion)",
        "Segunda Pulo (Poblacion)",
        "Wawa",
    ] },
    { province: "Laguna", city: "Mabitac", barangayList: [
        "Amuyong",
        "Lambac (Poblacion)",
        "Lucong (Poblacion)",
        "Matalatala",
        "Nanguma",
        "Numero",
        "Paagahan",
        "Bayanihan (Poblacion)",
        "Libis ng Nayon (Poblacion)",
        "Maligaya (Poblacion)",
        "Masikap (Poblacion)",
        "Pag-Asa (Poblacion)",
        "Sinagtala (Poblacion)",
        "San Antonio",
        "San Miguel",
    ] },
    { province: "Laguna", city: "Magdalena", barangayList: [
        "Alipit",
        "Malaking Ambling",
        "Munting Ambling",
        "Baanan",
        "Balanac",
        "Bucal",
        "Buenavista",
        "Bungkol",
        "Buo[15]",
        "Burlungan",
        "Cigaras",
        "Ibabang Atingay",
        "Ibabang Butnong",
        "Ilayang Atingay",
        "Ilayang Butnong",
        "Ilog",
        "Malinao",
        "Maravilla",
        "Poblacion",
        "Sabang",
        "Salasad",
        "Tanawan",
        "Tipunan",
        "Halayhayin",
    ] },
    { province: "Laguna", city: "Majayjay", barangayList: [
        "Amonoy",
        "Bakia",
        "Balanac",
        "Balayong",
        "Banilad",
        "Banti",
        "Bitaoy",
        "Botocan",
        "Bukal",
        "Burgos",
        "Burol",
        "Coralao",
        "Gagalot",
        "Ibabang Banga",
        "Ibabang Bayucain",
        "Ilayang Banga",
        "Ilayang Bayucain",
        "Isabang",
        "Malinao",
        "May-It",
        "Munting Kawayan",
        "Olla",
        "Oobi",
        "Origuel (Poblacion)",
        "Panalaban",
        "Pangil",
        "Panglan",
        "Piit",
        "Pook",
        "Rizal",
        "San Francisco (Poblacion)",
        "San Isidro",
        "San Miguel (Poblacion)",
        "San Roque",
        "Santa Catalina (Poblacion)",
        "Suba",
        "Talortor",
        "Tanawan",
        "Taytay",
        "Villa Nogales",
    ] },
    { province: "Laguna", city: "Nagcarlan", barangayList: [
        "Abo",
        "Alibungbungan",
        "Alumbrado",
        "Balayong",
        "Balimbing",
        "Balinacon",
        "Bambang",
        "Banago",
        "Banca-banca",
        "Bangcuro",
        "Banilad",
        "Bayaquitos",
        "Buboy",
        "Buenavista",
        "Buhanginan",
        "Bukal",
        "Bunga",
        "Cabuyew",
        "Calumpang",
        "Kanluran Kabubuhayan",
        "Silangan Kabubuhayan",
        "Labangan",
        "Lawaguin",
        "Kanluran Lazaan",
        "Silangan Lazaan",
        "Lagulo",
        "Maiit",
        "Malaya",
        "Malinao",
        "Manaol",
        "Maravilla",
        "Nagcalbang",
        "Poblacion I (Poblacion)",
        "Poblacion II (Poblacion)",
        "Poblacion III (Poblacion)",
        "Oples",
        "Palayan",
        "Palina",
        "Sabang",
        "San Francisco",
        "Sibulan",
        "Silangan Napapatid",
        "Silangan Ilaya",
        "Sinipian",
        "Santa Lucia",
        "Sulsuguin",
        "Talahib",
        "Talangan",
        "Taytay",
        "Tipacan",
        "Wakat",
        "Yukos",
    ] },
    { province: "Laguna", city: "Paete", barangayList: [
        "Ibaba Del Sur",
        "Maytoong",
        "Ermita",
        "Quinale",
        "Ilaya Del Sur",
        "Ilaya Del Norte",
        "Bagumbayan",
        "Bangkusay",
        "Ibaba Del Norte",
    ] },
    { province: "Laguna", city: "Pagsanjan", barangayList: [
        "Anibong",
        "Biñan",
        "Buboy",
        "Cabanbanan",
        "Calusiche",
        "Dingin",
        "Lambac",
        "Layugan",
        "Magdapio",
        "Maulawin",
        "Pinagsaŋjan",
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Sabang",
        "Sampaloc",
        "San Isidro",
    ] },
    { province: "Laguna", city: "Pakil", barangayList: [
        "Baño (Poblacion)",
        "Banilan",
        "Burgos (Poblacion)",
        "Casa Real",
        "Casinsin",
        "Dorado",
        "Gonzales (Poblacion)",
        "Kabulusan",
        "Matikiw",
        "Rizal (Poblacion)",
        "Saray",
        "Taft (Poblacion)",
        "Tavera (Poblacion)",
    ] },
    { province: "Laguna", city: "Pangil", barangayList: [
        "Balian",
        "Isla (Poblacion)",
        "Natividad (Poblacion)",
        "San Jose (Poblacion)",
        "Sulib (Poblacion)",
        "Galalan",
        "Dambo",
        "Mabato-Azufre",
    ] },
    { province: "Laguna", city: "Pila", barangayList: [
        "Aplaya",
        "Bagong Pook",
        "Bukal",
        "Bulilan Norte (Poblacion)",
        "Bulilan Sur (Poblacion)",
        "Concepcion",
        "Labuin",
        "Linga",
        "Masico",
        "Mojon",
        "Pansol",
        "Pinagbayanan",
        "San Antonio",
        "San Miguel",
        "Santa Clara Norte (Poblacion)",
        "Santa Clara Sur (Poblacion)",
        "Tubuan",
    ] },
    { province: "Laguna", city: "Rizal", barangayList: [
        "Antipolo",
        "Entablado",
        "Laguan",
        "Pauli 1",
        "Pauli 2",
        "East Poblacion",
        "West Poblacion",
        "Pook",
        "Tala",
        "Talaga",
        "Tuy",
    ] },
    { province: "Laguna", city: "San Pablo", barangayList: [
        "I-A (Sambat)",
        "I-B",
        "II-A (Triangulo)",
        "II-B (Guadalupe)",
        "II-C (Unson)",
        "II-D (Bulante)",
        "II-E (San Anton)",
        "II-F (Villa Rey)",
        "III-A (Hermanos Belen)",
        "III-B",
        "III-C (Labak/De Roma)",
        "III-D (Villongco)",
        "III-E",
        "III-F (Balagtas)",
        "IV-A",
        "IV-B",
        "IV-C",
        "V-A",
        "V-B",
        "V-C",
        "V-D",
        "VI-A (Mavenida)",
        "VI-B",
        "VI-D (Lparkers)",
        "VI-E (YMCA)",
        "VII-A (P.Alcantara)",
        "VII-B",
        "VII-C",
        "VII-D",
        "VII-E",
        "Atisan",
        "Bagong Bayan (I-C)",
        "Bagong Pook (VI-C)",
        "Bautista",
        "Concepcion (Bunot)",
        "Del Remedio (Wawa)",
        "Dolores",
        "San Antonio 1 (Balanga)",
        "San Antonio 2 (Sapa)",
        "San Bartolome (Matang-ag)",
        "San Buenaventura (Palakpakin)",
        "San Crispin (Lumbangan)",
        "San Cristobal",
        "San Diego (Tiim)",
        "San Francisco (Calihan)",
        "San Gabriel (Butucan)",
        "San Gregorio",
        "San Ignacio",
        "San Isidro (Balagbag)",
        "San Joaquin",
        "San Jose (Malamig)",
        "San Juan",
        "San Lorenzo (Saluyan)",
        "San Lucas 1 (Malinaw)",
        "San Lucas 2",
        "San Marcos (Tikew)",
        "San Mateo",
        "San Miguel",
        "San Nicolas",
        "San Pedro",
        "San Rafael",
        "San Roque (Buluburan)",
        "San Vicente",
        "Santa Ana",
        "Santa Catalina (Sandig)",
        "Santa Cruz (Putol)",
        "Santa Elena",
        "Santa Filomena (Banlagin)",
        "Santa Isabel",
        "Santa Maria",
        "Santa Maria Magdalena (Boe)",
        "Santa Monica",
        "Santa Veronica (Bae)",
        "Santiago I (Bulaho)",
        "Santiago II",
        "Santisimo Rosario",
        "Santo Angel (Ilog)",
        "Santo Cristo",
        "Santo Niño (Arsum)",
        "Soledad (Macopa)",
    ] },
    { province: "Laguna", city: "San Pedro", barangayList: [
        "Bagong Silang",
        "Calendola",
        "Chrysanthemum",
        "Cuyab",
        "Estrella",
        "Fatima",
        "G.S.I.S.",
        "Landayan",
        "Langgam",
        "Laram",
        "Maharlika",
        "Magsaysay",
        "Narra",
        "Nueva",
        "Pacita 1",
        "Pacita 2",
        "Poblacion",
        "Riverside",
        "Rosario",
        "Sampaguita Village",
        "San Antonio",
        "San Roque",
        "San Vicente",
        "San Lorenzo Ruiz",
        "Santo Niño",
        "United Bayanihan",
        "United Better Living",
    ] },
    { province: "Laguna", city: "Santa Cruz", barangayList: [
        "Alipit",
        "Bagumbayan",
        "Bubukal",
        "Calios",
        "Duhat",
        "Gatid",
        "Jasaan",
        "Labuin",
        "Malinao",
        "Oogong",
        "Pagsawitan",
        "Palasan",
        "Patimbao",
        "Poblacion I",
        "Poblacion II",
        "Poblacion III",
        "Poblacion IV",
        "Poblacion V",
        "Poblacion VI New",
        "Poblacion VII New",
        "Poblacion VIII New",
        "San Jose",
        "San Juan",
        "San Pablo Norte",
        "San Pablo Sur",
        "Santisima Cruz",
        "Santo Angel Central",
        "Santo Angel Norte",
        "Santo Angel Sur",
    ] },
    { province: "Laguna", city: "Santa Maria", barangayList: [
        "Adia",
        "Bagong Pook",
        "Bagumbayan",
        "Bubucal",
        "Cabooan",
        "Calangay",
        "Cambuja",
        "Coralan",
        "Cueva",
        "Inayapan",
        "Jose P. Laurel, Sr.",
        "Jose P. Rizal",
        "Juan Santiago",
        "Kayhacat",
        "Macasipac",
        "Masinao",
        "Matalinting",
        "Pao-o",
        "Parang ng Buho",
        "Poblacion Uno",
        "Poblacion Dos",
        "Poblacion Tres",
        "Poblacion Quatro",
        "Talangka",
        "Tungkod",
    ] },
    { province: "Laguna", city: "Santa Rosa", barangayList: [
        "Aplaya",
        "Balibago",
        "Caingin",
        "Dila",
        "Dita",
        "Don Jose",
        "Ibaba",
        "Kanluran (Barangay Poblacion Uno)",
        "Labas",
        "Macabling",
        "Malitlit",
        "Malusak (Barangay Poblacion Dos)",
        "Market Area (Barangay Poblacion Tres)",
        "Pooc (Pook)",
        "Pulong Santa Cruz",
        "Santo Domingo",
        "Sinalhan",
        "Tagapo",
    ] },
    { province: "Laguna", city: "Siniloan", barangayList: [
        "Acevida",
        "Bagong Pag-Asa (Poblacion)",
        "Bagumbarangay (Poblacion)",
        "Buhay",
        "Gen. Luna",
        "Halayhayin",
        "Mendiola",
        "Kapatalan",
        "Laguio",
        "Liyang",
        "Llavac",
        "Pandeño",
        "Magsaysay",
        "Macatad",
        "Mayatba",
        "P. Burgos",
        "G. Redor (Poblacion)",
        "Salubungan",
        "Wawa",
        "J. Rizal (Poblacion)",
    ] },
    { province: "Laguna", city: "Victoria", barangayList: [
        "Banca-banca",
        "Daniw",
        "Masapang",
        "Nanhaya (Poblacion)",
        "Pagalangan",
        "San Benito",
        "San Felix",
        "San Francisco",
        "San Roque (Poblacion)",
    ] },
    // { province: "Lanao del Norte", city: "", barangayList: [] },
    // { province: "Lanao del Sur", city: "", barangayList: [] },
    { province: "Leyte", city: "Abuyog", barangayList: [
        "Alangilan",
        "Anibongon",
        "Buaya",
        "Bagacay",
        "Bahay",
        "Balinsasayao",
        "Balocawe",
        "Balocawehay",
        "Barayong",
        "Bayabas",
        "Bito (Pob.)",
        "Buenavista",
        "Bulak",
        "Buntay (Pob.)",
        "Bunga",
        "Burubud-an",
        "Cagbolo",
        "Can-aporong",
        "Canmarating",
        "Can-uguib (Pob.)",
        "Capilian",
        "Cadac-an",
        "Combis",
        "Dingle",
        "Guintagbucan (Pob.)",
        "Hampipila",
        "Katipunan",
        "Kikilo",
        "Laray",
        "Lawa-an",
        "Libertad",
        "Loyonsawang (Pob.)",
        "Mahagna (New Cagbolo)",
        "Mag-atubang",
        "Mahayahay",
        "Maitum",
        "Malaguicay",
        "Matagnao",
        "Nalibunan (Pob.)",
        "Nibga",
        "Odiongan",
        "Pagsang-an",
        "Paguite",
        "Parasanon",
        "Picas Sur",
        "Pilar",
        "Pinamanagan",
        "Salvasion",
        "San Francisco",
        "San Isidro",
        "San Roque",
        "Santa Fee (Pob.)",
        "Santa Lucia",
        "Santo Nino (Pob.)",
        "Tabigue",
        "Tadoc",
        "New Taligue",
        "Old Taligue",
        "Tib-o",
        "Tinalian",
        "Tinocolan",
        "Tuy-a",
        "Victory (Pob.)",
    ] },
    { province: "Leyte", city: "Alangalang", barangayList: [
        "Aslum",
        "Astorga (Burabod)",
        "Bato",
        "Binongto-an",
        "Binotong",
        "Blumentritt (Pob.)",
        "Bobonon",
        "Borseth",
        "Buenavista",
        "Bugho",
        "Buri",
        "Cabadsan",
        "Calaasan",
        "Cambahanon",
        "Cambolao",
        "Canvertudes",
        "Capiz",
        "Cavite",
        "Cogon",
        "Dapdap",
        "Divisoria",
        "Ekiran",
        "Hinapolon (Baras)",
        "Holy Child I (Pob.)",
        "Holy Child II (Pob.)",
        "Hubang",
        "Hupit",
        "Langit",
        "Lingayon",
        "Lourdes",
        "Lukay",
        "Magsaysay",
        "Milagrosa (Pob.)",
        "Mudboron",
        "P. Barrantes",
        "Peñalosa",
        "Pepita",
        "Salvacion",
        "Salvacion (Pob.)",
        "San Antonio",
        "San Antonio (Pob.)",
        "San Diego",
        "San Francisco East",
        "San Francisco West",
        "San Isidro",
        "San Pedro",
        "San Roque (Pob.)",
        "San Vicente",
        "Santiago",
        "Santo Niño (Pob.)",
        "Santol",
        "Tabangohay",
        "Tombo",
        "Veteranos",
    ] },
    { province: "Leyte", city: "Albuera", barangayList: [
        "Antipolo",
        "Balugo",
        "Benolho",
        "Cambalading",
        "Damula-an",
        "Doña Maria (Kangkuirina)",
        "Mahayag",
        "Mahayahay",
        "Pob.",
        "Salvacion",
        "San Pedro",
        "Seguinon",
        "Sherwood",
        "Tabgas",
        "Talisayan",
        "Tinag-an",
    ] },
    { province: "Leyte", city: "Babatngon", barangayList: [
        "Bacong",
        "Bagong Silang",
        "Biasong",
        "Guintigui-an",
        "Gov. E. Jaro (Bagahupi)",
        "Lukay",
        "Malibago",
        "Magcasuang",
        "Naga-asan",
        "Pagsulhugon",
        "Planza",
        "Pob. District I",
        "Pob. District II",
        "Pob. District III",
        "Pob. District IV",
        "Rizal I",
        "Rizal II",
        "San Agustin",
        "San Isidro",
        "San Ricardo",
        "Sangputan",
        "Taguite",
        "Uban",
        "Victory",
        "Villa Magsaysay",
    ] },
    { province: "Leyte", city: "Barugo", barangayList: [
        "Abango",
        "Amahit",
        "Balire",
        "Balud",
        "Bukid",
        "Bulod",
        "Busay",
        "Cabarasan",
        "Cabolo-an",
        "Calingcaguing",
        "Can-isak",
        "Canomantag",
        "Cuta",
        "Domogdog",
        "Duka",
        "Guindaohan",
        "Hiagsam",
        "Hilaba",
        "Hinugayan",
        "Ibag",
        "Minuhang",
        "Minuswang",
        "Pikas",
        "Pitogo",
        "Pob. Dist. I",
        "Pob. Dist. II",
        "Pob. Dist. III",
        "Pob. Dist. IV",
        "Pob. Dist. V",
        "Pob. Dist. VI (New Road)",
        "Pongso",
        "Roosevelt",
        "San Isidro",
        "San Roque",
        "Santa Rosa",
        "Santarin",
        "Tutug-an",
    ] },
    { province: "Leyte", city: "Bato", barangayList: [
        "Alegria",
        "Alejos",
        "Amagos",
        "Anahawan",
        "Bago",
        "Bagong Bayan District (Pob.)",
        "Buli",
        "Cebuana",
        "Daan Lungsod",
        "Dawahon",
        "Himamaa",
        "Dolho",
        "Domagocdoc",
        "Guerrero District (Pob.)",
        "Imelda",
        "Iniguihan District (Pob.)",
        "Kalanggaman District (Pob.)",
        "Katipunan",
        "Liberty",
        "Mabini",
        "Marcelo",
        "Naga",
        "Osmeña",
        "Plaridel",
        "Ponong",
        "Revilla",
        "San Agustin",
        "Santo Niño",
        "Tabunok",
        "Tagaytay",
        "Tinago District (Pob.)",
        "Tugas",
    ] },
    { province: "Leyte", city: "Baybay", barangayList: [
        "Altavista",
        "Ambacan",
        "Amguhan",
        "Ampihanon",
        "Balao",
        "Banahao",
        "Biasong",
        "Bidlinan",
        "Bitanhuan",
        "Bubon",
        "Buenavista",
        "Bunga",
        "Butigan",
        "Candadam (Sitio Crossing Diversion Road)",
        "Can-ipa",
        "Caridad",
        "Ciabu",
        "Cogon",
        "Gaas",
        "Gabas",
        "Gacat",
        "Guadalupe (Utod)",
        "Gubang",
        "Hibunawan",
        "Higulo-an",
        "Hilapnitan",
        "Hipusngo",
        "Igang",
        "Imelda",
        "Jaena",
        "Kabalasan",
        "Kabatuan",
        "Kabungaan",
        "Kagumay",
        "Kambonggan",
        "Kansungka",
        "Kantagnos",
        "Kilim",
        "Lintaon",
        "Maganhan",
        "Mahayahay",
        "Mailhi",
        "Maitum",
        "Makinhas",
        "Mapgap",
        "Marcos",
        "Maslug",
        "Matam-is",
        "Maybog",
        "Maypatag",
        "Monterico",
        "Monteverde",
        "Palhi",
        "Visca",
        "Pansagan",
        "Patag",
        "Plaridel",
        "Pob. Zone 1",
        "Pob. Zone 2",
        "Pob. Zone 3",
        "Pob. Zone 4",
        "Pob. Zone 5",
        "Pob. Zone 6",
        "Pob. Zone 7",
        "Pob. Zone 8",
        "Pob. Zone 9",
        "Pob. Zone 10",
        "Pob. Zone 11",
        "Pob. Zone 12",
        "Pob. Zone 13",
        "Pob. Zone 14",
        "Pob. Zone 15",
        "Pob. Zone 16",
        "Pob. Zone 17",
        "Pob. Zone 18",
        "Pob. Zone 19",
        "Pob. Zone 20",
        "Pob. Zone 21",
        "Pob. Zone 22",
        "Pob. Zone 23",
        "Pomponan",
        "Punta",
        "Saban",
        "Sapa",
        "San Agustin",
        "San Isidro",
        "San Juan",
        "Santa Cruz",
        "Cagnonoc",
        "Villa Mag-aso",
        "Villa Solidaridad",
        "Zacarito",
    ] },
    { province: "Leyte", city: "Burauen", barangayList: [
        "Abuyogon",
        "Anonang",
        "Arado",
        "Balao",
        "Balatson",
        "Balorinay",
        "Bobon",
        "Buenavista",
        "Buri",
        "Caanislagan",
        "Cadahunan",
        "Cagangon",
        "Cali",
        "Calsadahay",
        "Candag-on",
        "Cansiboy",
        "Catagbacan",
        "Dumalag",
        "Damulu-an",
        "Dina-ayan",
        "Esperansa",
        "Gamay",
        "Gitabla",
        "Hapunan",
        "Hibolunawan",
        "Hugpa East",
        "Hugpa West",
        "Ilihan",
        "Kalao",
        "Kagbana",
        "Kalipayan",
        "Kaparasanan",
        "Laguiwan",
        "Libas",
        "Limburan",
        "Logsongan",
        "Maabab",
        "Maghubas",
        "Mahagnao",
        "Malabca",
        "Malaguinabot",
        "Malaihao",
        "Matin-ao",
        "Moguing",
        "Pob. District I",
        "Pob. District II",
        "Pob. District III",
        "Pob. District IV",
        "Pob. District V",
        "Pob. District VI",
        "Pob. District VII",
        "Pob. District VIII",
        "Pob. District IX",
        "Paghudlan",
        "Paitan",
        "Pangdan",
        "Patag",
        "Patong",
        "Pawa",
        "Roxas",
        "Sambel",
        "San Esteban",
        "San Fernando",
        "San Jose East",
        "San Jose West",
        "San Pablo",
        "Tabuanon",
        "Tagadtaran",
        "Taghuyan",
        "Takin",
        "Tambis",
        "Tambuko",
        "Toloyao",
        "Villa Aurora",
        "Villa Corazon",
        "Villa Patria",
        "Villa Rosas",
    ] },
    { province: "Leyte", city: "Calubian", barangayList: [
        "Abanilla",
        "Anislagan",
        "Bunacan",
        "Cabalquinto",
        "Herrera (Cabalhin)",
        "Cabradilla",
        "Caneja",
        "Cantonghao",
        "Caroyocan",
        "Casiongan",
        "Cristina",
        "Dalumpines",
        "Don Luis",
        "Dulao",
        "Efe (Ul-og)",
        "Enage",
        "Espinosa",
        "Ferdinand E. Marcos",
        "Garganera",
        "Garrido",
        "Guadalupe",
        "Gutosan",
        "Igang",
        "Inalad",
        "Jubay",
        "Juson",
        "Kawayan Bogtong",
        "Kawayanan",
        "Kokoy Romualdez",
        "Labtic",
        "Laray",
        "Limite (Agas)",
        "Manuel Veloso",
        "Mahait",
        "Malobago",
        "Matagok",
        "Nierras",
        "Nipa",
        "Obispo",
        "Pagatpat",
        "Pangpang",
        "Patag",
        "Pates",
        "Pal-og",
        "Padoga",
        "Petrolio",
        "Pob.",
        "Railes",
        "Tabla",
        "Tagharigue",
        "Tuburan",
        "Villahermosa",
        "Villalon",
        "Villanueva",
    ] },
    { province: "Leyte", city: "Capoocan", barangayList: [
        "Balucanad",
        "Balud",
        "Balugo",
        "Cabul-an",
        "Culasian",
        "Gayad",
        "Guinadiongan",
        "Lemon",
        "Libertad",
        "Manloy",
        "Nauguisan",
        "Pinamopoan",
        "Pob. Zone I",
        "Pob. Zone II",
        "Potot",
        "San Joaquin",
        "Santo Niño",
        "Talairan",
        "Talisay",
        "Tolibao",
        "Visares",
    ] },
    { province: "Leyte", city: "Carigara", barangayList: [
        "Bagong Lipunan",
        "Balilit",
        "Barayong",
        "Barugohay Central",
        "Barugohay Norte",
        "Barugohay Sur",
        "Baybay (Pob.)",
        "Binibihan",
        "Bislig",
        "Caghalo",
        "Camansi",
        "Canal",
        "Candigahub",
        "Canfabi",
        "Canlampay",
        "Cogon",
        "Cutay",
        "Guindapunan East",
        "Guindapunan West",
        "Hiluctogan",
        "Jugaban (Pob.)",
        "Libo",
        "Lower Hiraan",
        "Lower Sogod",
        "Macalpi",
        "Manloy",
        "Nauguisan",
        "Paglaum",
        "Pangna",
        "Parag-um",
        "Parena (Parina)",
        "Piloro",
        "Ponong (Pob.)",
        "Rizal (Tagak East)",
        "Sagkahan",
        "San Isidro",
        "San Juan",
        "San Mateo (Pob.)",
        "Santa Fe",
        "Sawang (Pob.)",
        "Tagak",
        "Tangnan",
        "Tigbao",
        "Tinaguban",
        "Upper Hiraan",
        "Upper Sogod",
        "Uyawan",
        "Visoria (East)",
        "Visoria (West)",
    ] },
    { province: "Leyte", city: "Dagami", barangayList: [
        "Abaca",
        "Abre",
        "Balilit",
        "Balugo",
        "Banayon",
        "Bayabas",
        "Bolirao",
        "Buenavista",
        "Buntay",
        "Caanislagan",
        "Cabariwan",
        "Cabuloran",
        "Cabunga-an",
        "Calipayan",
        "Calsadahay",
        "Caluctogan",
        "Calutan",
        "Camono-an",
        "Candagara",
        "Canlingga",
        "Cansamada East",
        "Cansamada West",
        "Capulhan",
        "Digahongan",
        "Guinarona",
        "Hiabangan",
        "Hilabago",
        "Hinabuyan",
        "Hinologan",
        "Hitumnog",
        "Katipunan",
        "Lapu-lapu Pob. (Dist. 2)",
        "Lobe-lobe",
        "Lobe-lobe East",
        "Los Martires",
        "Lusad Pob. (Dist. 6)",
        "Macaalang",
        "Maliwaliw",
        "Maragondong",
        "Ormocay",
        "Palacio",
        "Panda",
        "Paraiso",
        "Patoc",
        "Plaridel",
        "Poponton",
        "Rizal",
        "Salvacion",
        "Sampaguita",
        "Sampao East Pob. (Dist. 9)",
        "Sampao West Pob. (Dist. 8)",
        "San Antonio Pob. (Dist. 5)",
        "San Benito",
        "San Jose Pob. (Dist. 1)",
        "San Roque Pob. (Dist. 3)",
        "Santa Mesa Pob. (Dist. 7)",
        "Santo Domingo",
        "Sawahon",
        "Sirab",
        "Tagkip",
        "Talinhugon",
        "Tin-ao",
        "Tunga Pob. (Dist. 4)",
        "Tuya",
        "Victoria",
    ] },
    { province: "Leyte", city: "Dulag", barangayList: [
        "Alegre",
        "Arado",
        "Bulod",
        "Batug",
        "Bolongtohan",
        "Cabacungan",
        "Cabarasan",
        "Cabatoan",
        "Calipayan",
        "Calubian",
        "Camitoc",
        "Camote",
        "Dacay",
        "Del Carmen",
        "Del Pilar",
        "Fatima",
        "General Roxas",
        "Luan",
        "Magsaysay",
        "Maricum",
        "Barbo (Pob. Sawang)",
        "Buntay (Pob. Sawang)",
        "Cambula (Pob. Sawang)",
        "Candao (Pob. Sawang)",
        "Catmonan (Pob. Sawang)",
        "Combis (Pob. Sawang)",
        "Highway (Pob. Sawang)",
        "Market Site (Pob. Sawang)",
        "San Miguel (Pob. Sawang)",
        "Serrano (Pob. Sawang)",
        "Sungi (Pob. Sawang)",
        "Rawis",
        "Rizal",
        "Romualdes",
        "Sabang Daguitan",
        "Salvacion",
        "San Agustin",
        "San Antonio",
        "San Isidro",
        "San Jose",
        "San Rafael",
        "San Vicente",
        "Tabu",
        "Tigbao",
        "Victory",
    ] },
    { province: "Leyte", city: "Hilongos", barangayList: [
        "Agutayan",
        "Atabay",
        "Baas",
        "Bagong Lipunan (BLISS)",
        "Bagumbayan",
        "Baliw",
        "Bantigue",
        "Bon-ot",
        "Bung-aw",
        "Cacao",
        "Campina",
        "Cantandog 1",
        "Cantandog 2",
        "Concepcion (Makinhas)",
        "Hampangan",
        "Himo-aw",
        "Hitudpan",
        "Imelda Marcos (Pong-on)",
        "Kang-iras",
        "Kanghaas",
        "Lamak",
        "Libertad",
        "Liberty",
        "Lunang",
        "Magnangoy",
        "Manaul",
        "Marangog",
        "Matapay",
        "Naval",
        "Owak",
        "Pa-a",
        "Central Pob. (Town Proper)",
        "Eastern Pob. (Town Proper)",
        "Western Pob. (Town Proper)",
        "Pontod",
        "Proteccion",
        "San Agustin",
        "San Antonio",
        "San Isidro",
        "San Juan",
        "San Roque (Taganas)",
        "Santa Cruz",
        "Santa Margarita",
        "Santo Niño",
        "Tabunok",
        "Tagnate",
        "Talisay",
        "Kanghaas",
        "Tambis",
        "Tejero",
        "Tuguipa",
        "Utanan",
    ] },
    { province: "Leyte", city: "Hindang", barangayList: [
        "Anahaw",
        "Anolon",
        "Baldoza",
        "Bontoc",
        "Bulacan",
        "Canha-ayon",
        "Capudlosan",
        "Himacugo",
        "Doos Del Norte",
        "Doos Del Sur",
        "Himokilan Island",
        "Katipunan",
        "Maasin",
        "Mabagon",
        "Mahilum",
        "Pob. 1",
        "Pob. 2",
        "San Vicente",
        "Tabok",
        "Tagbibi",
    ] },
    { province: "Leyte", city: "Inopacan", barangayList: [
        "Apid",
        "Cabulisan",
        "Caminto",
        "Can-angay",
        "Caulisihan",
        "Conalum",
        "De los Santos (Mahilum)",
        "Esperanza",
        "Guadalupe",
        "Guinsanga-an",
        "Hinabay",
        "Jubasan",
        "Linao",
        "Macagoco",
        "Maljo",
        "Marao",
        "Pob.",
        "Tahud",
        "Taotaon",
        "Tinago",
    ] },
    { province: "Leyte", city: "Isabel", barangayList: [
        "Anislag",
        "Antipolo",
        "Apale",
        "Bantigue",
        "Binog",
        "Bilwang",
        "Can-andan",
        "Cangag",
        "Consolacion",
        "Honan",
        "Libertad",
        "Mahayag",
        "Marvel (Pob.)",
        "Matlang",
        "Monte Alegre",
        "Puting Bato",
        "San Francisco",
        "San Roque",
        "Santa Cruz Relocation",
        "Santo Niño (Pob.)",
        "Santo Rosario",
        "Tabunok",
        "Tolingon",
        "Tubod",
    ] },
    { province: "Leyte", city: "Jaro", barangayList: [
        "Alahag",
        "Anibongon",
        "Atipolo",
        "Badiang",
        "Batug",
        "Bias-Zabala",
        "Buenavista",
        "Bukid",
        "Burabod",
        "Buri",
        "Caglawaan",
        "Canapu-an",
        "Canhandugan (formerly San Javier)",
        "Crossing Rubas",
        "Daro",
        "District I (Pob.)",
        "District II (Pob.)",
        "District III (Pob.)",
        "District IV (Pob.)",
        "Hiagsam",
        "Hibucawan",
        "Hibunawon (formerly Islabay)",
        "Kalinawan",
        "La Paz",
        "Licod",
        "Macanip",
        "Macopa",
        "Mag-aso",
        "Malobago",
        "Olotan",
        "Palanog (formerly Mooc)",
        "Pange",
        "Parasan",
        "Pitogo",
        "Sagkahan",
        "San Agustin",
        "San Pedro",
        "San Roque",
        "Santo Niño",
        "Sari-Sari",
        "Santa Cruz",
        "Tinambacan",
        "Tuba",
        "Uguiao",
        "Villa Conzoilo (Villa Consuelo)",
        "Villa Paz",
    ] },
    { province: "Leyte", city: "Javier (Bugho)", barangayList: [
        "Abuyogay",
        "Batug",
        "Binulho",
        "Bonifacio (Pundok)",
        "Calzada",
        "Cancayang",
        "Caranhug",
        "Caraye",
        "Casulungan",
        "Comatin",
        "Guindapunan",
        "Inayupan",
        "Laray",
        "Magsaysay",
        "Malitbogay",
        "Manarug",
        "Manlilisid",
        "Naliwatan",
        "Odiong",
        "Picas Norte (Curba)",
        "Pinocawan",
        "Pob. Zone 1",
        "Pob. Zone 2",
        "Rizal",
        "Santa Cruz (Katun-an)",
        "Talisayan",
        "San Sotero (Tambis)",
        "Ulhay",
    ] },
    { province: "Leyte", city: "Julita", barangayList: [
        "Alegria",
        "Anibong",
        "Aslum",
        "Balante",
        "Bongdo",
        "Bonifacio",
        "Bugho",
        "Calbasag",
        "Caridad",
        "Cuya-e",
        "Dita",
        "Gitabla",
        "Hindang",
        "Inawangan",
        "Jurao",
        "Pob. District I",
        "Pob. District II",
        "Pob. District III",
        "Pob. District IV",
        "San Andres",
        "San Pablo",
        "Santa Cruz",
        "Santo Niño",
        "Tagkip",
        "Tolosahay",
        "Villa Hermosa",
    ] },
    { province: "Leyte", city: "Kananga", barangayList: [
        "Aguiting",
        "Cacao",
        "Kawayan",
        "Hiluctogan",
        "Libertad",
        "Libongao",
        "Lim-ao",
        "Lonoy",
        "Mahawan",
        "Masarayao",
        "Monte Alegre",
        "Monte Bello",
        "Naghalin",
        "Natubgan",
        "Pob.",
        "Rizal",
        "San Ignacio",
        "San Isidro",
        "Santo Domingo",
        "Santo Niño",
        "Tagaytay",
        "Tongonan",
        "Tugbong",
    ] },
    { province: "Leyte", city: "La Paz", barangayList: [
        "Bagacay East",
        "Bagacay West",
        "Bongtod",
        "Bocawon",
        "Buracan",
        "Caabangan",
        "Cacao",
        "Cagngaran",
        "Calabnian",
        "Calaghusan",
        "Caltayan",
        "Canbañez",
        "Cogon",
        "Duyog",
        "Gimiranat East",
        "Gimiranat West",
        "Limba",
        "Lubi-lubi",
        "Luneta",
        "Mag-aso",
        "Moroboro",
        "Pansud",
        "Pawa",
        "Piliway",
        "Pob. District 1",
        "Pob. District 2",
        "Pob. District 3",
        "Pob. District 4",
        "Quiong",
        "Rizal",
        "San Victoray",
        "Santa Ana",
        "Santa Elena",
        "Tabang",
        "Tarugan",
    ] },
    { province: "Leyte", city: "Leyte", barangayList: [
        "Bachao",
        "Baco",
        "Bagaba-o",
        "Basud",
        "Belen",
        "Burabod",
        "Calaguise",
        "Consuegra",
        "Culasi",
        "Danus",
        "Elizabeth",
        "Kawayan",
        "Libas",
        "Maanda",
        "Macupa",
        "Mataloto",
        "Palarao",
        "Palid I (Ilawod)",
        "Palid II (Iraya)",
        "Parasan",
        "Pob.",
        "Salog",
        "Sambulawan",
        "Tag-abaca",
        "Tapol",
        "Tigbawan",
        "Tinocdugan",
        "Toctoc",
        "Ugbon",
        "Wague",
    ] },
    { province: "Leyte", city: "MacArthur", barangayList: [
        "Batug",
        "Burabod",
        "Capudlosan",
        "Casuntingan",
        "Causwagan",
        "Danao",
        "General Luna",
        "Kiling",
        "Lanawan",
        "Liwayway",
        "Maya",
        "Oguisan",
        "Osmeña",
        "Palale 1",
        "Palale 2",
        "Pob. District 1",
        "Pob. District 2",
        "Pob. District 3",
        "Pongon",
        "Quezon",
        "Romualdez",
        "Salvacion",
        "San Antonio",
        "San Isidro",
        "San Pedro",
        "San Vicente",
        "Santa Isabel",
        "Tin-awan",
        "Tuyo",
        "Doña Josefa",
        "Villa Imelda",
    ] },
    { province: "Leyte", city: "Mahaplag", barangayList: [] },
        "Campin",
        "Cuatro De Agosto",
        "Hilusig",
        "Himamara",
        "Hinaguimitan",
        "Liberacion",
        "Mabuhay",
        "Mabunga",
        "Magsuganao",
        "Mahayag",
        "Mahayahay",
        "Malinao",
        "Malipoon",
        "Palanogan",
        "Paril",
        "Pinamonoan",
        "Pob.",
        "Polahongon",
        "San Isidro",
        "San Juan",
        "Santa Cruz",
        "Tagaytay",
        "Uguis",
        "Union",
        "Upper Mahaplag",
        "Hiluctogan",
        "Maligaya",
        "Santo Niño",
    { province: "Leyte", city: "Matag-ob", barangayList: [
        "Balagtas",
        "Bonoy (Pob.)",
        "Bulak",
        "Cambadbad",
        "Candelaria",
        "Cansoso",
        "Imelda",
        "Malazarte",
        "Mansahaon",
        "Mansalip (Pob.)",
        "Masaba",
        "Naulayan",
        "Riverside (Pob.)",
        "San Dionisio",
        "San Guillermo",
        "San Marcelino",
        "San Sebastian",
        "San Vicente",
        "Santa Rosa",
        "Santo Rosario",
        "Talisay (Pob.)",
    ] },
    { province: "Leyte", city: "Matalom", barangayList: [
        "Agbanga",
        "Altavista",
        "Cahagnaan",
        "Calumpang",
        "Caningag",
        "Caridad Norte",
        "Caridad Sur",
        "Elevado",
        "Esperanza",
        "Hitoog",
        "Itum",
        "Lowan",
        "Monte Alegre",
        "President Garcia",
        "Punong",
        "San Isidro (Pob.)",
        "San Pedro (Pob.)",
        "Santo Niño (Pob.)",
        "Santa Fe (Tab-Ang)",
        "San Juan",
        "San Salvador",
        "San Vicente",
        "Santa Paz",
        "Tag-os",
        "Templanza",
        "Tigbao",
        "Waterloo",
        "Zaragoza",
        "Bagong Lipunan",
        "Taglibas Imelda",
    ] },
    { province: "Leyte", city: "Mayorga", barangayList: [
        "A. Bonifacio",
        "Mabini",
        "Burgos",
        "Calipayan",
        "Camansi",
        "General Antonio Luna",
        "Liberty",
        "Ormocay",
        "Pob. Zone 1",
        "Pob. Zone 2",
        "Pob. Zone 3",
        "San Roque",
        "Santa Cruz",
        "Talisay",
        "Union",
        "Wilson",
    ] },
    { province: "Leyte", city: "Merida", barangayList: [
        "Benabaye",
        "Cabaliwan",
        "Calunangan",
        "Calunasan",
        "Cambalong",
        "Can-unzo",
        "Canbantug",
        "Casilda",
        "Lamanoc",
        "Libas",
        "Libjo",
        "Lundag",
        "Macario",
        "Mahalit",
        "Mahayag",
        "Masumbang",
        "Mat-e",
        "Pob.",
        "Puerto Bello",
        "San Isidro",
        "San Jose",
        "Tubod",
    ] },
    { province: "Leyte", city: "Ormoc", barangayList: [
        "Airport",
        "Alegria",
        "Alta Vista",
        "Bagongbong",
        "Bagong Buhay",
        "Bantigue",
        "Barangay District 1 (Pob.)",
        "Barangay District 2 (Pob.)",
        "Barangay District 3 (Pob.)",
        "Barangay District 4 (Pob.)",
        "Barangay District 5 (Pob.)",
        "Barangay District 6 (Pob.)",
        "Barangay District 7 (Pob.)",
        "Barangay District 8 (Pob.)",
        "Barangay District 9 (Pob.)",
        "Barangay District 10 (Pob.)",
        "Barangay District 11 (Pob.)",
        "Barangay District 12 (Pob.)",
        "Barangay District 13 (Pob.)",
        "Barangay District 14 (Pob.)",
        "Barangay District 15 (Pob.)",
        "Barangay District 16 (Pob.)",
        "Barangay District 17 (Pob.)",
        "Barangay District 18 (Pob.)",
        "Barangay District 19 (Pob.)",
        "Barangay District 20 (Pob.)",
        "Barangay District 21 (Pob.)",
        "Barangay District 22 (Pob.)",
        "Barangay District 23 (Pob.)",
        "Barangay District 24 (Pob.)",
        "Barangay District 25 (Malbasag) (Pob.)",
        "Barangay District 26 (Isla Verde)(Pob.)",
        "Barangay District 27 (Pob.)",
        "Barangay District 28 (Pob.)",
        "Barangay District 29 (Nadongholan) (Pob.)",
        "Batuan",
        "Bayog",
        "Biliboy",
        "Cabaon-an",
        "Cabintan",
        "Cabulihan",
        "Cagbuhangin",
        "Camp Downes",
        "Can-adieng",
        "Can-untog",
        "Catmon",
        "Cogon Combado",
        "Concepcion",
        "Curva",
        "Danhug (Lili-on)",
        "Dayhagan",
        "Dolores",
        "Domonar",
        "Don Carlos B. Rivilla Sr. (Boroc)",
        "Don Felipe Larrazabal",
        "Don Potenciano Larrazabal",
        "Doña Feliza Z. Mejia",
        "Donghol",
        "Esperanza",
        "Gaas",
        "Green Valley",
        "Guintigui-an",
        "Hibunawon",
        "Hugpa",
        "Ipil",
        "Juaton",
        "Kadaohan",
        "Labrador (Balion)",
        "Lake Danao",
        "Lao",
        "Leondoni",
        "Libertad",
        "Liberty",
        "Licuma",
        "Liloan",
        "Linao",
        "Luna",
        "Mabato",
        "Mabini",
        "Macabug",
        "Magaswi",
        "Mahayag",
        "Mahayahay",
        "Manlilinao",
        "Margen",
        "Mas-in",
        "Matica-a",
        "Milagro",
        "Monterico",
        "Nasunogan",
        "Naungan",
        "Nueva Sociedad",
        "Nueva Vista",
        "Patag",
        "Punta",
        "Quezon, Jr.",
        "Rufina M. Tan (Rawis)",
        "Sabang Bao",
        "Salvacion",
        "San Antonio",
        "San Isidro",
        "San Jose",
        "San Juan",
        "San Pablo (Simangan)",
        "San Vicente",
        "Santo Niño",
        "Sumangga",
        "Tambulilid",
        "Tongonan",
        "Valencia",
    ] },
    { province: "Leyte", city: "Palo", barangayList: [
        "Anahaway",
        "Arado",
        "Baras",
        "Barayong",
        "Cabarasan Daku",
        "Cabarasan Guti",
        "Campetic",
        "Candahug",
        "Cangumbang",
        "Canhidoc",
        "Capirawan",
        "Castilla",
        "Cogon",
        "San Joaquin",
        "Gacao",
        "Guindapunan",
        "Libertad",
        "Naga-naga",
        "Pawing",
        "Buri (Pob. barangay)",
        "Cavite East (Pob. barangay)",
        "Cavite West (Pob.)",
        "Luntad (Pob.)",
        "Santa Cruz (Pob.)",
        "Salvacion",
        "San Agustin",
        "San Antonio",
        "San Isidro",
        "San Jose",
        "St. Michael (Pob.)",
        "Tacuranga",
        "Teraza",
        "San Fernando",
    ] },
    { province: "Leyte", city: "Palompon", barangayList: [
        "Baguinbin",
        "Belen",
        "Bitaog Pob. (Ypil III)",
        "Buenavista",
        "Caduhaan",
        "Cambakbak",
        "Cambinoy",
        "Cangcosme",
        "Cangmuya",
        "Canipaan",
        "Cantandoy",
        "Cantuhaon",
        "Catigahan",
        "Central 1 (Pob.)",
        "Central 2 (Pob.)",
        "Cruz",
        "Duljugan",
        "Guiwan 1 (Pob.)",
        "Guiwan 2 (Pob.)",
        "Himarco",
        "Hinablayan Pob. (Central 3)",
        "Hinagbuan",
        "Lat-osan",
        "Liberty",
        "Lomonon",
        "Mabini",
        "Magsaysay",
        "Masaba",
        "Mazawalo Pob. (Lili-on)",
        "Parilla",
        "Pinagdait Pob. (Ypil I)",
        "Pinaghi-usa Pob. (Ypil II)",
        "Plaridel",
        "Rizal",
        "Sabang",
        "San Guillermo",
        "San Isidro",
        "San Joaquin",
        "San Juan",
        "San Miguel",
        "San Pablo",
        "San Pedro",
        "San Roque",
        "Santiago",
        "Taberna",
        "Tabunok",
        "Tambis",
        "Tinabilan",
        "Tinago",
        "Tinubdan",
    ] },
    { province: "Leyte", city: "Pastrana", barangayList: [
        "Arabunog",
        "Aringit",
        "Bahay",
        "Cabaohan",
        "Calsadahay",
        "Cancaraja",
        "Canino-an",
        "Capilla",
        "Colawen",
        "Dumarag",
        "Guindapunan",
        "Halaba",
        "Jones",
        "Lanawan",
        "Lima",
        "Lourdes",
        "Macalpi-ay",
        "Malitbogay",
        "Manaybanay",
        "Maricum",
        "Patong",
        "District 1 (Pob.)",
        "District 2 (Pob.)",
        "District 3 (Pob.)",
        "District 4 (Pob.)",
        "Sapsap",
        "Socsocon",
        "Tingib",
        "Yapad",
    ] },
    { province: "Leyte", city: "San Isidro", barangayList: [
        "Banat-i",
        "Basud",
        "Bawod (Pob.)",
        "Biasong",
        "Bunacan",
        "Busay",
        "Cabungaan",
        "Capiñahan (Pob.)",
        "Crossing (Pob.)",
        "Daja-daku",
        "Daja-diot",
        "Hda. Maria",
        "Linao",
        "Matungao",
        "Paril",
        "San Miguel",
        "San Jose",
        "Taglawigan",
        "Tinago",
    ] },
    { province: "Leyte", city: "San Miguel", barangayList: [
        "Bagacay",
        "Bahay",
        "Bairan",
        "Cabatianuhan",
        "Canap",
        "Capilihan",
        "Caraycaray",
        "Libtong (East Pob.)",
        "Guinciaman",
        "Impo",
        "Kinalumsan",
        "Lukay",
        "Malaguinabot",
        "Malpag",
        "Mawodpawod",
        "Patong",
        "Pinarigusan",
        "San Andres",
        "Santa Cruz",
        "Santol",
        "Cayare (West Pob.)",
    ] },
    { province: "Leyte", city: "Santa Fe", barangayList: [
        "Baculanad",
        "Badiangay",
        "Bulod",
        "Catoogan",
        "Katipunan",
        "Milagrosa",
        "Pilit",
        "Pitogo",
        "Zone 1 (Pob.)",
        "Zone 2 (Pob.)",
        "Zone 3 (Pob.)",
        "San Isidro",
        "San Juan",
        "San Miguelay",
        "San Roque",
        "Tibak",
        "Victoria",
        "Cutay",
        "Gapas",
        "Zone 4 Pob. (Cabangcalan)",
    ] },
    { province: "Leyte", city: "Tabango", barangayList: [
        "Butason I",
        "Butason II",
        "Campokpok",
        "Catmon",
        "Gimarco",
        "Gibacungan",
        "Inangatan",
        "Manlawaan",
        "Omaganhan",
        "Pob.",
        "Santa Rosa",
        "Tabing",
        "Tugas",
    ] },
    { province: "Leyte", city: "Tabontabon", barangayList: [
        "Amandangay",
        "Aslum",
        "Balingasag",
        "Belisong",
        "Cambucao",
        "Capahuan",
        "Guingauan",
        "Jabong",
        "Mercaduhay",
        "Mering",
        "Mohon",
        "District I Pob. (Quezon)",
        "District II Pob. (Rizal)",
        "District III Pob. (Bonifacio)",
        "District IV Pob. (Macarthur)",
        "San Pablo (Mooc)",
    ] },
    { province: "Leyte", city: "Tacloban", barangayList: [
        "Barangay 1 Libertad",
        "Barangay 2 Jones",
        "Barangay 3",
        "Barangay 4 Libertad",
        "Barangay 5 T. Claudio",
        "Barangay 5-A T. Claudio",
        "Barangay 6",
        "Barangay 6-A Sto. Nino",
        "Barangay 7",
        "Barangay 8 T. Claudio",
        "Barangay 8-A",
        "Barangay 12 GE Palanog",
        "Barangay 13 Salazar/J. Romualdez",
        "Barangay 14",
        "Barangay 15",
        "Barangay 16",
        "Barangay 17",
        "Barangay 18",
        "Barangay 19",
        "Barangay 20",
        "Barangay 21 P. Burgos",
        "Barangay 22",
        "Barangay 23",
        "Barangay 23-A",
        "Barangay 24",
        "Barangay 25",
        "Barangay 26 P.Gomez",
        "Barangay 27",
        "Barangay 28",
        "Barangay 29 P.Gomez",
        "Barangay 30",
        "Barangay 31",
        "Barangay 32",
        "Barangay 33",
        "Barangay 34 Real",
        "Barangay 35",
        "Barangay 35-A",
        "Barangay 36 Sabang",
        "Barangay 36-A Sabang",
        "Barangay 37 Sea Wall",
        "Barangay 37-A G.E. Palanog Gawad Kalinga Village",
        "Barangay 38 Calvary Hill",
        "Barangay 39 Calvary Hill",
        "Barangay 40 Calvary Hill",
        "Barangay 41 Calvary Hill",
        "Barangay 42-A Quarry",
        "Barangay 42-B Quarry",
        "Barangay 43-A Quarry",
        "Barangay 43-B Quarry",
        "Barangay 44-A Quarry",
        "Barangay 44-B Quarry",
        "Barangay 45",
        "Barangay 46 Imelda/Juan Luna",
        "Barangay 47",
        "Barangay 48-A",
        "Barangay 48-B",
        "Barangay 49 Youngfield",
        "Barangay 50 Youngfield",
        "Barangay 50-A Youngfield",
        "Barangay 50-B Youngfield",
        "Barangay 51",
        "Barangay 51-A",
        "Barangay 52 Lucban Magallanes",
        "Barangay 53 Magallanes",
        "Barangay 54 Magallanes",
        "Barangay 54-A Magallanes",
        "Barangay 55 El Reposo",
        "Barangay 56 El Reposo",
        "Barangay 56-A El Reposo",
        "Barangay 57 Whitelane Sampaguita",
        "Barangay 58",
        "Barangay 59 Sagkahan Picas",
        "Barangay 59-A Sampaguita",
        "Barangay 59-B Sampaguita",
        "Barangay 59-E Sagkahan Picas",
        "Barangay 60 Sagkahan Aslum",
        "Barangay 60-A Sagkahan",
        "Barangay 61 Sagkahan",
        "Barangay 62 Sagkahan Saging",
        "Barangay 62-A Sagkahan Ilong",
        "Barangay 62-B Sagkahan Picas",
        "Barangay 63 Sagkahan Mangga",
        "Barangay 64 Sagkahan Bliss",
        "Barangay 65",
        "Barangay 66 Anibong",
        "Barangay 66-A Anibong",
        "Barangay 67 Anibong",
        "Barangay 68 Anibong",
        "Barangay 69 Anibong, Happy Land",
        "Barangay 70 Anibong, Rawis",
        "Barangay 71 Naga-naga",
        "Barangay 72 PHHC Seaside",
        "Barangay 73 PHHC Mountainside",
        "Barangay 74 Lower Nula-Tula",
        "Barangay 75 Fatima Village",
        "Barangay 76 Fatima Village",
        "Barangay 77 Fatima Village",
        "Barangay 78 Marasbaras",
        "Barangay 79 Marasbaras",
        "Barangay 80 Marasbaras",
        "Barangay 81 Marasbaras",
        "Barangay 82 Marasbaras",
        "Barangay 83 Paraiso",
        "Barangay 83-A Burayan",
        "Barangay 83-B San Jose, Cogon",
        "Barangay 83-C San Jose",
        "Barangay 84 San Jose",
        "Barangay 85 San Jose",
        "Barangay 86 San Jose",
        "Barangay 87 San Jose",
        "Barangay 88 San Jose",
        "Barangay 89 San Jose, Baybay",
        "Barangay 90 San Jose",
        "Barangay 91 Abucay",
        "Barangay 92 Apitong",
        "Barangay 93 Bagacay",
        "Barangay 94 Tigbao",
        "Barangay 94-A Basper",
        "Barangay 95 Caibaan",
        "Barangay 95-A Caibaan",
        "Barangay 96 Calanipawan",
        "Barangay 97 Cabalawan",
        "Barangay 98 Camansinay",
        "Barangay 99 Diit",
        "Barangay 100 San Roque",
        "Barangay 101 New Kawayan",
        "Barangay 102 Kawayan",
        "Barangay 103 Palanog",
        "Barangay 103-A San Paglaum",
        "Barangay 104 Salvacion",
        "Barangay 105 Suhi",
        "Barangay 106 Santo. Niño",
        "Barangay 107 Santa Elena",
        "Barangay 108 Tagapuro",
        "Barangay 109 V&G Subdivision",
        "Barangay 109-A V&G Subdivision",
        "Barangay 110 Utap",
    ] },
    { province: "Leyte", city: "Tanauan", barangayList: [
        "Ada",
        "Amanluran",
        "Arado",
        "Atipolo",
        "Balud",
        "Bangon",
        "Bantagan",
        "Baras",
        "Binolo",
        "Binongto-an",
        "Bislig",
        "Buntay (Poblacion)",
        "Cabalagnan",
        "Cabarasan Guti",
        "Cabonga-an",
        "Cabuynan",
        "Cahumayhumayan",
        "Calogcog",
        "Calsadahay",
        "Camire",
        "Canbalisara",
        "Canramos (Poblacion)",
        "Catigbian",
        "Catmon",
        "Cogon",
        "Guindag-an",
        "Guingauan",
        "Hilagpad",
        "Lapay",
        "Licod (Poblacion)",
        "Limbuhan Daku",
        "Limbuhan Guti",
        "Linao",
        "Kiling",
        "Magay",
        "Maghulod",
        "Malaguicay",
        "Maribi",
        "Mohon",
        "Pago",
        "Pasil",
        "Picas",
        "Sacme",
        "San Miguel (Poblacion)",
        "Salvador",
        "San Isidro",
        "San Roque (Poblacion)",
        "San Victor",
        "Santa Cruz",
        "Santa Elena",
        "Santo Niño (Haclagan) (Poblacion)",
        "Solano",
        "Talolora",
        "Tugop",
    ] },
    { province: "Leyte", city: "Tolosa", barangayList: [
        "Burak",
        "Canmogsay",
        "Cantariwis",
        "Capangihan",
        "Doña Brigida",
        "Imelda",
        "Malbog",
        "Olot",
        "Opong",
        "Poblacion",
        "Quilao",
        "San Roque",
        "San Vicente",
        "Tanghas",
        "Telegrafo",
    ] },
    { province: "Leyte", city: "Tunga", barangayList: [
        "Astorga (Barrio Upat)",
        "Balire",
        "Banawang",
        "San Antonio (Poblacion)",
        "San Pedro (Poblacion)",
        "San Roque (Poblacion)",
        "San Vicente (Poblacion)",
        "Santo Niño (Poblacion)",
    ] },
    { province: "Leyte", city: "Villaba", barangayList: [
        "Abijao",
        "Balite",
        "Bugabuga",
        "Cabungahan",
        "A.Tumamak",
        "Cagnocot",
        "Cahigan",
        "Calbugos",
        "Camporog",
        "Capinyahan",
        "Casili-on",
        "Catagbacan",
        "Fatima (Poblacion)",
        "Hibulangan",
        "Hinabuyan",
        "Iligay",
        "Jalas",
        "Jordan",
        "Libagong",
        "New Balanac",
        "Payao",
        "Poblacion Norte",
        "Poblacion Sur",
        "Sambulawan",
        "San Francisco",
        "Silad",
        "Sulpa",
        "Tabunok",
        "Tagbubunga",
        "Tinghub",
        "Bangkal",
        "Canquiason",
        "San Vicente",
        "Santa Cruz",
        "Suba",
    ] },
    // { province: "Maguindanao", city: "", barangayList: [] },
    // { province: "Marinduque", city: "", barangayList: [] },
    // { province: "Masbate", city: "", barangayList: [] },
    { province: "Misamis Occidental", city: "Aloran", barangayList: [
        "Balintonga",
        "Banisilon",
        "Burgos",
        "Calube",
        "Caputol",
        "Casusan",
        "Conat",
        "Culpan",
        "Dalisay (Poblacion)",
        "Dullan",
        "Ibabao (Poblacion)",
        "Tubod",
        "Labo",
        "Lawa-an",
        "Lobogon",
        "Lumbayao",
        "Makawa",
        "Manamong",
        "Matipaz",
        "Maular",
        "Mitazan",
        "Mohon",
        "Monterico",
        "Nabuna",
        "Palayan",
        "Pelong",
        "Ospital (poblacion)",
        "Roxas",
        "San Pedro",
        "Santa Ana",
        "Sinampongan",
        "Taguanao",
        "Tawi-tawi",
        "Toril",
        "Tuburan",
        "Zamora",
        "Macubon (Sina-ad)",
        "Tugaya",
    ] },
    { province: "Misamis Occidental", city: "Baliangao", barangayList: [
        "Del Pilar",
        "Landing",
        "Lumipac",
        "Lusot",
        "Mabini",
        "Magsaysay",
        "Misom",
        "Mitacas",
        "Naburos",
        "Northern Poblacion",
        "Punta Miray",
        "Punta Sulong",
        "Sinian",
        "Southern Poblacion",
        "Tugas",
    ] },
    { province: "Misamis Occidental", city: "Bonifacio", barangayList: [
        "Bag-ong Anonang",
        "Bagumbang",
        "Baybay",
        "Bolinsong",
        "Buenavista",
        "Buracan",
        "Calolot",
        "Dimalco",
        "Dullan",
        "Kanaokanao",
        "Liloan",
        "Linconan",
        "Lodiong",
        "Lower Usugan",
        "Mapurog (Migsale)",
        "Migpange",
        "Montol",
        "Pisa-an",
        "Poblacion",
        "Remedios",
        "Rufino Lumapas",
        "Sibuyon",
        "Tangab",
        "Tiaman",
        "Tusik",
        "Upper Usogan",
        "Demetrio Fernan",
    ] },
    { province: "Misamis Occidental", city: "Calamba", barangayList: [
        "Bonifacio",
        "Bunawan",
        "Calaran",
        "Dapacan Alto",
        "Dapacan Bajo",
        "Langub",
        "Libertad",
        "Magcamiguing",
        "Mamalad",
        "Mauswagon",
        "Northern Poblacion",
        "Salvador",
        "San Isidro",
        "Siloy",
        "Singalat",
        "Solinog",
        "Southwestern Poblacion",
        "Sulipat",
        "Don Bernardo A. Neri (Poblacion)",
    ] },
    { province: "Misamis Occidental", city: "Clarin", barangayList: [
        "Bernad",
        "Bito-on",
        "Cabunga-an",
        "Canibungan Daku",
        "Canibungan Putol",
        "Canipacan",
        "Dalingap",
        "Dela Paz",
        "Dolores",
        "Gata Daku",
        "Gata Diot",
        "Guba (Ozamis)",
        "Kinangay Norte",
        "Kinangay Sur",
        "Lapasan",
        "Lupagan",
        "Malibangcao",
        "Masabud",
        "Mialen",
        "Pan-ay",
        "Penacio",
        "Poblacion I",
        "Poblacion II",
        "Poblacion III",
        "Poblacion IV",
        "Segatic Daku",
        "Segatic Diot",
        "Sebasi",
        "Tinacla-an",
    ] },
    { province: "Misamis Occidental", city: "Concepcion", barangayList: [
        "Bagong Nayon",
        "Capule",
        "New Casul",
        "Guiban",
        "Laya-an",
        "Lingatongan",
        "Maligubaan",
        "Mantukoy",
        "Marugang",
        "Poblacion",
        "Pogan",
        "Small Potongan",
        "Soso-on",
        "Upper Dapitan",
        "Upper Dioyo",
        "Upper Potongan",
        "Upper Salimpono",
        "Virayan",
    ] },
    { province: "Misamis Occidental", city: "Don Victoriano Chiongbian", barangayList: [
        "Bagong Clarin",
        "Gandawan",
        "Lake Duminagat",
        "Lalud",
        "Lampasan",
        "Liboron",
        "Maramara",
        "Napangan",
        "Nueva Vista (Masawan)",
        "Petianan",
        "Tuno",
    ] },
    { province: "Misamis Occidental", city: "Jimenez", barangayList: [
        "Adorable",
        "Butuay",
        "Carmen",
        "Corrales",
        "Dicoloc",
        "Gata",
        "Guintomoyan",
        "Malibacsan",
        "Macabayao",
        "Matugas Alto",
        "Matugas Bajo",
        "Mialem",
        "Naga (Poblacion)",
        "Palilan",
        "Nacional (Poblacion)",
        "Rizal (Poblacion)",
        "San Isidro",
        "Santa Cruz (Poblacion)",
        "Sibaroc",
        "Sinara Alto",
        "Sinara Bajo",
        "Seti",
        "Tabo-o",
        "Taraka (Poblacion)",
    ] },
    { province: "Misamis Occidental", city: "Lopez Jaena", barangayList: [
        "Alegria",
        "Bagong Silang",
        "Biasong",
        "Bonifacio",
        "Burgos",
        "Dalacon",
        "Dampalan",
        "Estante",
        "Hasa-an",
        "Katipa",
        "Luzaran",
        "Macalibre Alto",
        "Macalibre Bajo",
        "Mahayahay",
        "Manguehan",
        "Mansabay Bajo",
        "Molatuhan Alto",
        "Molatuhan Bajo",
        "Peniel",
        "Eastern Poblacion",
        "Puntod",
        "Rizal",
        "Sibugon",
        "Sibula",
        "Don Andres Soriano",
        "Mabas",
        "Mansabay Alto",
        "Western Poblacion",
    ] },
    { province: "Misamis Occidental", city: "Oroquieta", barangayList: [
        "Apil",
        "Binuangan",
        "Bolibol",
        "Buenavista",
        "Bunga",
        "Buntawan",
        "Burgos",
        "Canubay",
        "Clarin Settlement",
        "Dolipos Bajo",
        "Dolipos Alto",
        "Dulapo",
        "Dullan Norte",
        "Dullan Sur",
        "Lower Lamac",
        "Layawan",
        "Lower Langcangan",
        "Lower Loboc",
        "Lower Rizal",
        "Malindang",
        "Mialen",
        "Mobod",
        "Ciriaco C. Pastrano (Nilabo)",
        "Paypayan",
        "Pines",
        "Poblacion I",
        "Poblacion II",
        "Proper Langcangan",
        "San Vicente Alto (Dagatan)",
        "San Vicente Bajo (Baybay Dagatan)",
        "Sebucal",
        "Senote",
        "Taboc Norte",
        "Taboc Sur",
        "Talairon",
        "Talic",
        "Toliyok",
        "Tipan",
        "Tuyabang Alto",
        "Tuyabang Bajo",
        "Tuyabang Proper",
        "Upper Langcangan",
        "Upper Lamac",
        "Upper Loboc",
        "Upper Rizal (Tipalac)",
        "Victoria",
        "Villaflor (Transville)",
    ] },
    { province: "Misamis Occidental", city: "Ozamiz", barangayList: [
        "50th District (Poblacion)",
        "Aguada (Poblacion)",
        "Bacolod",
        "Bagakay",
        "Balintawak",
        "Bañadero (Poblacion)",
        "Baybay San Roque",
        "Baybay Santa Cruz",
        "Baybay Triunfo",
        "Bongbong",
        "Calabayan",
        "Capucao C.",
        "Capucao P.",
        "Carangan",
        "Carmen (Misamis Annex)",
        "Catadman-Manabay",
        "Cavinte",
        "Cogon",
        "Dalapang",
        "Diguan",
        "Dimaluna",
        "Doña Consuelo",
        "Embargo",
        "Gala",
        "Gango",
        "Gotokan Daku",
        "Gotokan Diot",
        "Guimad",
        "Guingona",
        "Kinuman Norte",
        "Kinuman Sur",
        "Labinay",
        "Labo",
        "Lam-an",
        "Liposong",
        "Litapan",
        "Malaubang",
        "Manaka",
        "Maningcol",
        "Mentering",
        "Molicay",
        "Pantaon",
        "Pulot",
        "San Antonio",
        "Sangay Daku",
        "Sangay Diot",
        "Sinuza",
        "Stimson Abordo (Montol)",
        "Tabid",
        "Tinago",
        "Trigos",
    ] },
    { province: "Misamis Occidental", city: "Panaon", barangayList: [
        "Baga",
        "Bangko",
        "Camanucan",
        "Dela Paz",
        "Lutao",
        "Magsaysay",
        "Map-an",
        "Mohon",
        "Poblacion",
        "Punta",
        "Salimpuno",
        "San Andres",
        "San Juan",
        "San Roque",
        "Sumasap",
        "Villalin",
    ] },
    { province: "Misamis Occidental", city: "Plaridel", barangayList: [
        "Agunod",
        "Bato",
        "Buena Voluntad",
        "Calaca-an",
        "Cartagena Proper",
        "Catarman",
        "Cebulin",
        "Clarin",
        "Danao",
        "Deboloc",
        "Divisoria",
        "Eastern Looc",
        "Ilisan - 504",
        "Katipunan",
        "Kauswagan",
        "Lao Proper",
        "Lao Santa Cruz",
        "Looc Proper",
        "Mamanga Daku",
        "Mamanga Gamay",
        "Mangidkid",
        "New Cartagena",
        "New Look",
        "Northern Poblacion",
        "Panalsalan",
        "Puntod",
        "Quirino",
        "Santa Cruz",
        "Southern Looc",
        "Southern Poblacion",
        "Tipolo",
        "Unidos",
        "Usocan",
    ] },
    { province: "Misamis Occidental", city: "Sapang Dalaga", barangayList: [
        "Bautista",
        "Bitibut",
        "Boundary",
        "Caluya",
        "Capundag",
        "Casul",
        "Dalumpinas",
        "Dasa",
        "Dioyo",
        "Disoy",
        "El Paraiso",
        "Guinabot",
        "Libertad",
        "Locus",
        "Macabibo",
        "Manla",
        "Masubong",
        "Medallo",
        "Agapito Yap Sr. (Napilan)",
        "Poblacion",
        "Salimpuno",
        "San Agustin",
        "Sapang Ama",
        "Sinaad",
        "Sipac",
        "Sixto Velez Sr.",
        "Upper Bautista",
        "Ventura",
    ] },
    { province: "Misamis Occidental", city: "Sinacaban", barangayList: [
        "Bliss Project",
        "Cagay-anon",
        "Camanse",
        "Colupan Alto",
        "Colupan Bajo",
        "Dinas",
        "Estrella",
        "Katipunan",
        "Libertad Alto",
        "Libertad Bajo",
        "Poblacion",
        "San Isidro Alto",
        "San Isidro Bajo",
        "San Vicente",
        "Señor",
        "Sinonoc",
        "San Lorenzo Ruiz (Sungan)",
        "Tipan",
    ] },
    { province: "Misamis Occidental", city: "Tangub", barangayList: [
        "Silanga",
        "Aquino (Marcos)",
        "Santa Maria (Baga)",
        "Balatacan",
        "Baluk",
        "Banglay",
        "Mantic",
        "Mingcanaway",
        "Bintana",
        "Bocator",
        "Bongabong",
        "Caniangan",
        "Capalaran",
        "Catagan",
        "Barangay I - City Hall (Poblacion)",
        "Barangay II - Marilou Annex (Poblacion)",
        "Barangay IV - St. Michael (Poblacion)",
        "Isidro D. Tan (Dimalooc)",
        "Garang",
        "Guinabot",
        "Guinalaban",
        "Hoyohoy",
        "Kauswagan",
        "Kimat",
        "Labuyo",
        "Lorenzo Tan",
        "Barangay VI - Lower Polao (Poblacion)",
        "Lumban",
        "Maloro",
        "Barangay V - Malubog (Poblacion)",
        "Manga",
        "Maquilao",
        "Barangay III- Market Kalubian (Pob.)",
        "Matugnao",
        "Minsubong",
        "Owayan",
        "Paiton",
        "Panalsalan",
        "Pangabuan",
        "Prenza",
        "Salimpuno",
        "San Antonio",
        "San Apolinario",
        "San Vicente",
        "Santa Cruz",
        "Santo Niño",
        "Sicot",
        "Silanga",
        "Silangit",
        "Simasay",
        "Sumirap",
        "Taguite",
        "Tituron",
        "Tugas",
        "Barangay VII - Upper Polao (Poblacion)",
        "Villaba",
    ] },
    { province: "Misamis Occidental", city: "Tudela", barangayList: [
        "Balon",
        "Barra",
        "Basirang",
        "Bongabong",
        "Buenavista",
        "Cabol-anonan",
        "Cahayag",
        "Camating",
        "Canibungan Proper",
        "Casilak San Agustin",
        "Centro Hulpa (Poblacion)",
        "Centro Napu (Poblacion)",
        "Centro Upper (Poblacion)",
        "Colambutan Bajo",
        "Calambutan Settlement",
        "Duanguican",
        "Gala",
        "Gumbil",
        "Locso-on",
        "Maikay",
        "Maribojoc",
        "Mitugas",
        "Nailon",
        "Namut",
        "Napurog",
        "Pan-ay Diot",
        "San Nicolas",
        "Sebac",
        "Silongon",
        "Sinuza",
        "Taguima",
        "Tigdok",
        "Yahong",
    ] },
    { province: "Misamis Oriental", city: "Alubijid", barangayList: [
        "Baybay",
        "Benigwayan",
        "Calatcat",
        "Lagtang",
        "Lanao",
        "Loguilo",
        "Lourdes",
        "Lumbo",
        "Molocboloc",
        "Poblacion",
        "Sampatulog",
        "Sungay",
        "Talaba",
        "Taparak",
        "Tugasnon",
        "Tula",
    ] },
    { province: "Misamis Oriental", city: "Balingasag", barangayList: [
        "Balagnan",
        "Baliwagan",
        "San Francisco",
        "Binitinan",
        "Blanco",
        "Calawag",
        "Camuayan",
        "Cogon",
        "Dansuli",
        "Dumarait",
        "Hermano",
        "Kibanban",
        "Linabu",
        "Linggangao",
        "Mambayaan",
        "Mandangoa",
        "Napaliran",
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Barangay 6 (Poblacion)",
        "Quezon",
        "Rosario",
        "Samay",
        "San Isidro",
        "San Juan",
        "Talusan",
        "Waterfall",
    ] },
    { province: "Misamis Oriental", city: "Balingoan", barangayList: [
        "Baukbauk (Poblacion)",
        "Dahilig",
        "Kabangasan",
        "Kabulakan",
        "Kauswagan",
        "Lapinig (Poblacion)",
        "Mantangale",
        "Mapua",
        "San Alonzo",
    ] },
    { province: "Misamis Oriental", city: "Binuangan", barangayList: [
        "Dampias",
        "Kitamban",
        "Kitambis",
        "Mabini",
        "Mosangot",
        "Nabataan",
        "Poblacion",
        "Valdeconcha",
    ] },
    { province: "Misamis Oriental", city: "Cagayan de Oro", barangayList: [
        "Baikingon",
        "Balulang",
        "Bayabas",
        "Bayanga",
        "Besigan",
        "Bonbon",
        "Bulua",
        "Canito-an",
        "Carmen",
        "Dansolihon",
        "Iponan",
        "Kauswagan",
        "Lumbia",
        "Mambuaya",
        "Pagalungan",
        "Pagatpat",
        "Patag",
        "Pigsag-an",
        "San Simon",
        "Taglimao",
        "Tagpangi",
        "Tignapoloan",
        "Tuburan",
        "Tumpagon",
        "Agusan",
        "Balubal",
        "Bugo",
        "Camaman-an",
        "Consolacion",
        "Cugman",
        "F.S. Catanico",
        "Gusa",
        "Indahag",
        "Lapasan",
        "Macabalan",
        "Macasandig",
        "Nazareth",
        "Puerto",
        "Puntod",
        "Tablon",
        "Barangay 1",
        "Barangay 2",
        "Barangay 3",
        "Barangay 4",
        "Barangay 5",
        "Barangay 6",
        "Barangay 7",
        "Barangay 8",
        "Barangay 9",
        "Barangay 10",
        "Barangay 11",
        "Barangay 12",
        "Barangay 13",
        "Barangay 14",
        "Barangay 15",
        "Barangay 16",
        "Barangay 17",
        "Barangay 18",
        "Barangay 19",
        "Barangay 20",
        "Barangay 21",
        "Barangay 22",
        "Barangay 23",
        "Barangay 24",
        "Barangay 25",
        "Barangay 26",
        "Barangay 27",
        "Barangay 28",
        "Barangay 29",
        "Barangay 30",
        "Barangay 31",
        "Barangay 32",
        "Barangay 33",
        "Barangay 34",
        "Barangay 35",
        "Barangay 36",
        "Barangay 37",
        "Barangay 38",
        "Barangay 39",
        "Barangay 40",
    ] },
    { province: "Misamis Oriental", city: "Claveria", barangayList: [
        "Ani-e",
        "Aposkahoy",
        "Bulahan",
        "Cabacungan",
        "D.G. Pelaez",
        "Gumaod",
        "Hinaplanan",
        "Kalawitan",
        "Lanise",
        "Luna",
        "Madaguing",
        "Malagana",
        "Minalwang",
        "Mat-I",
        "Panampawan",
        "Parmbugas",
        "Patrocinio",
        "Plaridel",
        "Poblacion",
        "Punong",
        "Rizal",
        "Santa Cruz",
        "Tamboboan",
        "Tipolohon",
    ] },
    { province: "Misamis Oriental", city: "El Salvador", barangayList: [
        "Amoros",
        "Bolisong",
        "Cogon",
        "Himaya",
        "Hinigdaan",
        "Kalabaylabay",
        "Molugan",
        "Pedro S. Baculio (Bolo-Bolo)",
        "Poblacion",
        "Quibonbon",
        "Sambulawan",
        "San Francisco de Asis (Calongonan)",
        "Sinaloc",
        "Taytay",
        "Ulaliman",
    ] },
    { province: "Misamis Oriental", city: "Gingoog", barangayList: [
        "Agay-ayan",
        "Alagatan",
        "Anakan",
        "Bagubad",
        "Bakidbakid",
        "Bal-ason",
        "Bantaawan",
        "Binakalan",
        "Capitulangan",
        "Daan-Lungsod",
        "Dinawehan",
        "Eureka",
        "Hindangon",
        "Kalagonoy",
        "Kalipay",
        "Kamanikan",
        "Kianlagan",
        "Kibuging",
        "Kipuntos",
        "Lawaan",
        "Lawit",
        "Libertad",
        "Libon",
        "Lunao",
        "Lunotan",
        "Malibud",
        "Malinao",
        "Maribucao",
        "Mimbuntong",
        "Mimbalagon",
        "Mimbunga",
        "Minsapinit",
        "Murallon",
        "Odiongan",
        "Pangasihan",
        "Pigsaluhan",
        "Punong",
        "Ricoro",
        "Samay",
        "Sangalan",
        "San Jose",
        "San Juan",
        "San Luis",
        "San Miguel",
        "Santiago",
        "Tagpako",
        "Talisay",
        "Talon",
        "Tinabalan",
        "Tinulongan",
        "Barangay 1",
        "Barangay 2",
        "Barangay 3",
        "Barangay 4",
        "Barangay 5",
        "Barangay 6",
        "Barangay 7",
        "Barangay 8",
        "Barangay 9",
        "Barangay 10",
        "Barangay 11",
        "Barangay 12",
        "Barangay 13",
        "Barangay 14",
        "Barangay 15",
        "Barangay 16",
        "Barangay 17",
        "Barangay 18",
        "Barangay 18-A",
        "Barangay 19",
        "Barangay 20",
        "Barangay 21",
        "Barangay 22",
        "Barangay 22-A",
        "Barangay 23",
        "Barangay 24",
        "Barangay 24-A",
        "Barangay 25",
        "Barangay 26",
    ] },
    { province: "Misamis Oriental", city: "Gitagum", barangayList: [
        "Burnay",
        "Carlos P. Garcia",
        "Cogon",
        "Gregorio Pelaez (Lagutay)",
        "Kilangit",
        "Matangad",
        "Pangayawan",
        "Poblacion",
        "Quezon",
        "Tala-o",
        "Ulab",
    ] },
    { province: "Misamis Oriental", city: "Initao", barangayList: [
        "Aluna",
        "Andales",
        "Apas",
        "Calacapan",
        "Gimangpang",
        "Jampason",
        "Kamelon",
        "Kanitoan",
        "Oguis",
        "Pagahan",
        "Poblacion",
        "Pontacon",
        "San Pedro",
        "Sinalac",
        "Tawantawan",
        "Tubigan",
    ] },
    { province: "Misamis Oriental", city: "Jasaan", barangayList: [
        "Aplaya",
        "Bobuntugan",
        "Danao",
        "Ignacio S. Cruz",
        "Jampason",
        "Kimaya",
        "Corrales",
        "Lower Jasaan (Ubos)",
        "Luz Banzon (Kiog-ang)",
        "Natubo",
        "San Antonio",
        "San Isidro",
        "San Nicolas (Kilumba)",
        "Solana",
        "Upper Jasaan (Ibabaw)",
    ] },
    { province: "Misamis Oriental", city: "Kinoguitan", barangayList: [
        "Beray",
        "Bolisong",
        "Buko",
        "Kalitian",
        "Calubo",
        "Campo",
        "Esperanza",
        "Kagumahan",
        "Kitotok",
        "Panabol",
        "Poblacion",
        "Salicapawan",
        "Salubsob",
        "Suarez",
        "Sumalag",
    ] },
    { province: "Misamis Oriental", city: "Lagonglong", barangayList: [
        "Banglay",
        "Dampil",
        "Gaston",
        "Kabulawan",
        "Kauswagan",
        "Lumbo",
        "Manaol",
        "Poblacion",
        "Tabok",
        "Umagos",
    ] },
    { province: "Misamis Oriental", city: "Laguindingan", barangayList: [
        "Aromahon",
        "Gasi",
        "Kibaghot (San Isidro)",
        "Lapad",
        "Liberty",
        "Mauswagon",
        "Moog",
        "Poblacion",
        "Sambulawan",
        "Sinai",
        "Tubajon",
    ] },
    { province: "Misamis Oriental", city: "Libertad", barangayList: [
        "Dulong",
        "Gimaylan",
        "Kimalok",
        "Lubluban",
        "Poblacion",
        "Retablo",
        "Santo Niño",
        "Tangkub",
        "Taytayan",
    ] },
    { province: "Misamis Oriental", city: "Lugait", barangayList: [
        "Aya-aya",
        "Betahon",
        "Biga",
        "Calangahan",
        "Kaluknayan",
        "Talacogon (Lower Talacogon)",
        "Poblacion",
        "Upper Talacogon",
    ] },
    { province: "Misamis Oriental", city: "Magsaysay", barangayList: [
        "Abunda",
        "Artadi",
        "Bonifacio Aquiño",
        "Cabalawan",
        "Cabantian",
        "Cabubuhan",
        "Candiis",
        "Consuelo",
        "Damayuhan",
        "Gumabon",
        "Katipunan",
        "Kauswagan",
        "Kibungsod",
        "Mahayahay",
        "Mindulao",
        "Pag-asa",
        "Poblacion",
        "San Isidro",
        "San Vicente",
        "Santa Cruz",
        "Tama",
        "Tibon-tibon",
        "Tinaan",
        "Tulang (Cadena de Amor)",
        "Villa Felipa",
    ] },
    { province: "Misamis Oriental", city: "Manticao", barangayList: [
        "Argayoso",
        "Balintad",
        "Cabalantian",
        "Camanga",
        "Digkilaan",
        "Mahayahay",
        "Pagawan",
        "Paniangan",
        "Patag",
        "Poblacion",
        "Punta Silum",
        "Tuod",
        "Upper Malubog",
    ] },
    { province: "Misamis Oriental", city: "Medina", barangayList: [
        "Bangbang",
        "Bulwa",
        "Cabug",
        "Dig-aguyan",
        "Duka",
        "Gasa",
        "Maanas",
        "Mananum Bag-o",
        "Mananum Daan",
        "North Poblacion",
        "Pahindong",
        "Portulin",
        "San Isidro",
        "San Jose",
        "San Roque",
        "San Vicente",
        "South Poblacion",
        "Tambagan",
        "Tup-on",
    ] },
    { province: "Misamis Oriental", city: "Naawan", barangayList: [
        "Don Pedro",
        "Linangkayan",
        "Lubilan",
        "Mapulog",
        "Maputi",
        "Mat-i",
        "Patag",
        "Poblacion",
        "Tagbalogo",
        "Tuboran",
    ] },
    { province: "Misamis Oriental", city: "Opol", barangayList: [
        "Awang",
        "Bagocboc",
        "Barra",
        "Bonbon",
        "Cauyonan",
        "Igpit",
        "Limonda",
        "Luyong Bonbon",
        "Malanang",
        "Nangcaon",
        "Patag",
        "Poblacion",
        "Taboc",
        "Tingalan",
    ] },
    { province: "Misamis Oriental", city: "Salay", barangayList: [
        "Alipuaton",
        "Ampenican",
        "Bunal",
        "Casulog",
        "Dinagsaan",
        "Guinalaban",
        "Ili-ilihon",
        "Inobulan",
        "Looc",
        "Matampa",
        "Membuli",
        "Poblacion",
        "Salagsag",
        "Salay River I",
        "Salay River II",
        "Saray",
        "Tinagaan",
        "Yungod",
    ] },
    { province: "Misamis Oriental", city: "Sugbongcogon", barangayList: [
        "Alicomohan",
        "Ampianga",
        "Kaulayanan",
        "Kidampas",
        "Kiraging",
        "Mangga",
        "Mimbuahan",
        "Poblacion",
        "Santa Cruz",
        "Silad",
    ] },
    { province: "Misamis Oriental", city: "Tagoloan", barangayList: [
        "Baluarte",
        "Casinglot",
        "Gracia",
        "Mohon",
        "Natumolan",
        "Poblacion",
        "Rosario",
        "Santa Ana",
        "Santa Cruz",
        "Sugbongcogon",
    ] },
    { province: "Misamis Oriental", city: "Talisayan", barangayList: [
        "Bugdang",
        "Calamcam",
        "Casibole",
        "Macopa",
        "Magkarila",
        "Mahayag",
        "Mandahilag",
        "Mintabon",
        "Pangpangon",
        "Poblacion",
        "Pook",
        "Punta Santiago",
        "Puting Balas",
        "San Jose",
        "Santa Ines",
        "Sibantang",
        "Sindangan",
        "Tagbocboc",
    ] },
    { province: "Misamis Oriental", city: "Villanueva", barangayList: [
        "Balacanas",
        "Dayawan",
        "Katipunan",
        "Kimaya",
        "Poblacion 1",
        "Poblacion 2",
        "Poblacion 3",
        "San Martin",
        "Tambobong",
        "Imelda",
        "Looc",
    ] },
    // { province: "Mountain Province", city: "", barangayList: [] },
    { province: "Negros Occidental", city: "Bacolod", barangayList: [
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Población)",
        "Barangay 3 (Población)",
        "Barangay 4 (Población)",
        "Barangay 5 (Población)",
        "Barangay 6 (Población)",
        "Barangay 7 (Población)",
        "Barangay 8 (Población)",
        "Barangay 9 (Población)",
        "Barangay 10 (Población)",
        "Barangay 11 (Población)",
        "Barangay 12 (Población)",
        "Barangay 13 (Población)",
        "Barangay 14 (Población)",
        "Barangay 15 (Población)",
        "Barangay 16 (Población)",
        "Barangay 17 (Población)",
        "Barangay 18 (Población)",
        "Barangay 19 (Población)",
        "Barangay 20 (Población)",
        "Barangay 21 (Población)",
        "Barangay 22 (Población)",
        "Barangay 23 (Población)",
        "Barangay 24 (Población)",
        "Barangay 25 (Población)",
        "Barangay 26 (Población)",
        "Barangay 27 (Población)",
        "Barangay 28 (Población)",
        "Barangay 29 (Población)",
        "Barangay 30 (Población)",
        "Barangay 31 (Población)",
        "Barangay 32 (Población)",
        "Barangay 33 (Población)",
        "Barangay 34 (Población)",
        "Barangay 35 (Población)",
        "Barangay 36 (Población)",
        "Barangay 37 (Población)",
        "Barangay 38 (Población)",
        "Barangay 39 (Población)",
        "Barangay 40 (Población)",
        "Barangay 41 (Población)",
        "Alangilan",
        "Alijis",
        "Banago",
        "Bata",
        "Cabug",
        "Estefanía",
        "Felisa",
        "Granada",
        "Handumanan",
        "Mandalagan",
        "Mansilingan",
        "Montevista",
        "Pahanocoy",
        "Punta Taytay",
        "Singcang-Airport",
        "Sum-ag",
        "Taculing",
        "Tangub",
        "Villamonte",
        "Vista Alegre",
    ] },
    { province: "Negros Occidental", city: "Bago", barangayList: [
        "Abuanan",
        "Alianza",
        "Atipuluan",
        "Bacong-Montilla",
        "Bagroy",
        "Balingasag",
        "Binubuhan",
        "Busay",
        "Calumangan",
        "Caridad",
        "Don Jorge L. Araneta",
        "Dulao",
        "Ilijan",
        "Lag-Asan",
        "Ma-ao",
        "Mailum",
        "Malingin",
        "Napoles",
        "Pacol",
        "Poblacion",
        "Sagasa",
        "Tabunan",
        "Taloc",
        "Sampinit",
    ] },
    { province: "Negros Occidental", city: "Binalbagan", barangayList: [
        "Pagla-um (Poblacion)",
        "San Pedro (Poblacion)",
        "Santo Rosario (Poblacion)",
        "Amontay",
        "Bagroy",
        "Bi-ao",
        "Canmoros",
        "Enclaro",
        "Marina",
        "Payao (formerly Soledad)",
        "Progreso",
        "San Jose",
        "San Juan",
        "San Teodoro",
        "San Vicente",
        "Santol",
        "Remedios",
    ] },
    { province: "Negros Occidental", city: "Cadiz", barangayList: [
        "Andres Bonifacio",
        "Banquerohan",
        "Barangay 1 Pob. (Zone 1)",
        "Barangay 2 Pob. (Zone 2)",
        "Barangay 3 Pob. (Zone 3)",
        "Barangay 4 Pob. (Zone 4)",
        "Barangay 5 Pob. (Zone 5)",
        "Barangay 6 Pob. (Zone 6)",
        "Burgos",
        "Cabahug",
        "Cadiz Viejo",
        "Caduha-an",
        "Celestino Villacin",
        "Daga",
        "V. F. Gustilo",
        "Jerusalem",
        "Luna",
        "Mabini",
        "Magsaysay",
        "Sicaba",
        "Tiglawigan",
        "Tinampa-an",
    ] },
    { province: "Negros Occidental", city: "Calatrava", barangayList: [
        "Agpangi",
        "Ani-e",
        "Bagacay",
        "Bantayanon",
        "Buenavista",
        "Cabungahan",
        "Calampisawan",
        "Cambayobo",
        "Castellano",
        "Cruz",
        "Dolis",
        "Hilub-Ang",
        "Hinab-Ongan",
        "Ilaya",
        "Laga-an",
        "Lalong",
        "Lemery",
        "Lipat-on",
        "Lo-ok (Poblacion)",
        "Ma-aslob",
        "Macasilao",
        "Malanog",
        "Malatas",
        "Marcelo",
        "Mina-utok",
        "Menchaca",
        "Minapasuk",
        "Mahilum",
        "Paghumayan",
        "Pantao",
        "Patun-an",
        "Pinocutan",
        "Refugio",
        "San Benito",
        "San Isidro",
        "Suba (Poblacion)",
        "Telim",
        "Tigbao",
        "Tigbon",
        "Winaswasan",
    ] },
    { province: "Negros Occidental", city: "Candoni", barangayList: [
        "Agboy",
        "Banga",
        "Cabia-an",
        "Caningay",
        "Gatuslao",
        "Haba",
        "Payauan",
        "Poblacion East",
        "Poblacion West",
    ] },
    { province: "Negros Occidental", city: "Cauayan", barangayList: [
        "Abaca",
        "Baclao",
        "Basak",
        "Bulata",
        "Caliling",
        "Camalanda-an",
        "Camindangan",
        "Elihan",
        "Guiljungan",
        "Inayawan",
        "Isio",
        "Linaon",
        "Lumbia",
        "Mambugsay",
        "Man-uling",
        "Masaling",
        "Molobolo",
        "Poblacion",
        "Sura",
        "Talacdan",
        "Tambad",
        "Tiling",
        "Tomina",
        "Tuyom",
        "Yaoyao",
    ] },
    { province: "Negros Occidental", city: "Enrique B. Magalona", barangayList: [
        "Alacaygan",
        "Alicante",
        "Poblacion I (Barangay 1)",
        "Poblacion II (Barangay 2)",
        "Poblacion III (Barangay 3)",
        "Batea",
        "Consing",
        "Cudangdang",
        "Damgo",
        "Gahit",
        "Canlusong",
        "Latasan",
        "Madalag",
        "Manta-angan",
        "Nanca",
        "Pasil",
        "San Isidro",
        "San Jose",
        "Santo Niño",
        "Tabigue",
        "Tanza",
        "Tuburan",
        "Tomongtong",
    ] },
    { province: "Negros Occidental", city: "Escalante", barangayList: [
        "Alimango",
        "Balintawak",
        "Binaguiohan",
        "Buenavista",
        "Cervantes",
        "Dian-ay",
        "Hda. Fe",
        "Japitan",
        "Jonobjonob",
        "Langub",
        "Libertad",
        "Mabini",
        "Magsaysay",
        "Malasibog",
        "Old Poblacion",
        "Paitan",
        "Pinapugasan",
        "Rizal",
        "Tamlang",
        "Udtongan",
        "Washington",
    ] },
    { province: "Negros Occidental", city: "Himamaylan", barangayList: [
        "Aguisan",
        "Buenavista",
        "Cabadiangan",
        "Cabanbanan",
        "Carabalan",
        "Caradio-an",
        "Libacao",
        "Mambagaton",
        "Nabali-an",
        "Mahalang",
        "San Antonio",
        "Sara-et",
        "Su-ay",
        "Talaban",
        "To-oy",
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Barangay III (Poblacion)",
        "Barangay IV (Poblacion)",
    ] },
    { province: "Negros Occidental", city: "Hinigaran", barangayList: [
        "Anahaw",
        "Aranda",
        "Baga-as",
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Barangay III (Poblacion)",
        "Barangay IV (Poblacion)",
        "Bato",
        "Calapi",
        "Camalobalo",
        "Camba-og",
        "Cambugsa",
        "Candumarao",
        "Gargato",
        "Himaya",
        "Miranda",
        "Nanunga",
        "Narauis",
        "Palayog",
        "Paticui",
        "Pilar",
        "Quiwi",
        "Tagda",
        "Tuguis",
    ] },
    { province: "Negros Occidental", city: "Hinoba-an", barangayList: [
        "Alim",
        "Asia",
        "Bacuyangan",
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Bulwangan",
        "Culipapa",
        "Damutan",
        "Daug",
        "Po-ok",
        "San Rafael",
        "Sangke",
        "Talacagay",
    ] },
    { province: "Negros Occidental", city: "Ilog", barangayList: [
        "Andulauan",
        "Balicotoc",
        "Bocana",
        "Calubang",
        "Canlamay",
        "Consuelo",
        "Dancalan",
        "Delicioso",
        "Galicie",
        "Manalad",
        "Pinggot",
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Tabu",
        "Vista Alegre",
    ] },
    { province: "Negros Occidental", city: "Isabela", barangayList: [
        "Amin",
        "Banogbanog",
        "Bulad",
        "Bungahin",
        "Cabcab",
        "Camangcamang",
        "Camp Clark",
        "Cansalongon",
        "Guintubhan",
        "Libas",
        "Limalima",
        "Makilignit",
        "Mansablay",
        "Maytubig",
        "Panaquiao",
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Barangay 6 (Poblacion)",
        "Barangay 7 (Poblacion)",
        "Barangay 8 (Poblacion)",
        "Barangay 9 (Poblacion)",
        "Riverside",
        "Rumirang",
        "San Agustin",
        "Sebucawan",
        "Sikatuna",
        "Tinongan",
    ] },
    { province: "Negros Occidental", city: "Kabankalan", barangayList: [
        "Bantayan",
        "Binicuil",
        "Camansi",
        "Camingawan",
        "Camugao",
        "Carol-an",
        "Daan Banua",
        "Hilamonan",
        "Inapoy",
        "Linao",
        "Locotan",
        "Magballo",
        "Oringao",
        "Orong",
        "Pinaguinpinan",
        "Barangay 5 (Poblacion)",
        "Barangay 6 (Poblacion)",
        "Barangay 7 (Poblacion)",
        "Barangay 8 (Poblacion)",
        "Barangay 9 (Poblacion)",
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Salong",
        "Tabugon",
        "Tagoc",
        "Talubangi",
        "Tampalon",
        "Tan-Awan",
        "Tapi",
        "Tagukon",
    ] },
    { province: "Negros Occidental", city: "La Carlota", barangayList: [
        "Ara-al",
        "Ayungon",
        "Balabag",
        "Batuan",
        "Cubay",
        "Guintorilan",
        "Haguimit",
        "La Granja",
        "Nagasi",
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Barangay III (Poblacion)",
        "Barangay RSB (Consuelo)",
        "San Miguel",
        "Yubo",
    ] },
    { province: "Negros Occidental", city: "La Castellana", barangayList: [
        "Biaknabato",
        "Cabacungan",
        "Cabagnaan",
        "Camandag",
        "Lalagsan",
        "Manghanoy",
        "Mansalanao",
        "Masulog",
        "Nato",
        "Puso",
        "Robles (Poblacion)",
        "Sag-Ang",
        "Talaptap",
    ] },
    { province: "Negros Occidental", city: "Manapla", barangayList: [
        "Chambéry",
        "Barangay I (Poblacion)",
        "Barangay I-A (Poblacion)",
        "Barangay I-B (Poblacion)",
        "Barangay II (Poblacion)",
        "Barangay II-A (Poblacion)",
        "Punta Mesa",
        "Punta Salong",
        "Purisima",
        "San Pablo",
        "Santa Teresa",
        "Tortosa",
    ] },
    { province: "Negros Occidental", city: "Moises Padilla", barangayList: [
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Barangay 6 (Poblacion)",
        "Barangay 7 (Poblacion)",
        "Crossing Magallon",
        "Guinpana-an",
        "Inolingan (Hda. Salapid)",
        "Macagahay",
        "Magallon Cadre.",
        "Montilla",
        "Odiong",
        "Quintin Remo",
    ] },
    { province: "Negros Occidental", city: "Murcia", barangayList: [
        "Abo-abo",
        "Alegria",
        "Amayco",
        "Zone I (Poblacion)",
        "Zone II (Poblacion)",
        "Zone III (Poblacion)",
        "Zone IV (Poblacion)",
        "Zone V (Poblacion)",
        "Blumentritt",
        "Buenavista",
        "Caliban",
        "Canlandog",
        "Cansilayan",
        "Damsite",
        "Iglau-an",
        "Lopez Jaena",
        "Minoyan",
        "Pandanon (Silos)",
        "San Miguel",
        "Santa Cruz",
        "Santa Rosa",
        "Salvacion",
        "Talotog",
    ] },
    { province: "Negros Occidental", city: "Pontevedra", barangayList: [
        "Antipolo",
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Barangay III (Poblacion)",
        "Buenavista Gibong",
        "Buenavista Rizal",
        "Burgos",
        "Cambarus",
        "Canroma",
        "Don Salvador Benedicto",
        "General Malvar",
        "Gomez",
        "M. H. Del Pilar",
        "Mabini",
        "Miranda",
        "Pandan",
        "Recreo",
        "San Isidro",
        "San Juan",
        "Zamora",
    ] },
    { province: "Negros Occidental", city: "Pulupandan", barangayList: [
        "Barangay Zone 1-A (Pob. / Paco beach)",
        "Barangay Zone 4-A (Poblacion)",
        "Barangay Zone 1 (Pob. / Green beach)",
        "Barangay Zone 2 (Poblacion)",
        "Barangay Zone 3 (Poblacion)",
        "Barangay Zone 4 (Poblacion)",
        "Barangay Zone 5 (Poblacion)",
        "Barangay Zone 6 (Poblacion)",
        "Barangay Zone 7 (Poblacion)",
        "Canjusa",
        "Crossing Pulupandan",
        "Culo",
        "Mabini",
        "Pag-ayon",
        "Palaka Norte",
        "Palaka Sur",
        "Patic (Sitio Kalubhian)",
        "Tapong",
        "Ubay",
        "Utod",
    ] },
    { province: "Negros Occidental", city: "Sagay", barangayList: [
        "Andres Bonifacio",
        "Bato",
        "Baviera",
        "Bulanon",
        "Campo Himoga-an",
        "Campo Santiago",
        "Colonia Divina",
        "Rafaela Barrera",
        "Fabrica",
        "General Luna",
        "Himoga-an Baybay",
        "Lopez Jaena",
        "Malubon",
        "Maquiling",
        "Molocaboc",
        "Old Sagay",
        "Paraiso",
        "Plaridel",
        "Poblacion I (Barangay 1)",
        "Poblacion II (Barangay 2)",
        "Puey",
        "Rizal",
        "Taba-ao",
        "Tadlong",
        "Vito",
    ] },
    { province: "Negros Occidental", city: "Salvador Benedicto", barangayList: [
        "Bago (Lalung)",
        "Bagong Silang (Marcelo)",
        "Bunga",
        "Igmaya-an",
        "Kumaliskis",
        "Pandanon",
        "Pinowayan (Prosperidad)",
    ] },
    { province: "Negros Occidental", city: "San Carlos", barangayList: [
        "Bagonbon",
        "Buluangan",
        "Codcod",
        "Ermita (Sipaway)",
        "Guadalupe",
        "Nataban",
        "Palampas",
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Barangay III (Poblacion)",
        "Barangay IV (Poblacion)",
        "Barangay V (Poblacion)",
        "Barangay VI (Poblacion)",
        "Prosperidad",
        "Punao",
        "Quezon",
        "Rizal",
        "San Juan (Sipaway)",
    ] },
    { province: "Negros Occidental", city: "San Enrique", barangayList: [
        "Bagonawa",
        "Baliwagan",
        "Batuan",
        "Guintorilan",
        "Nayon",
        "Poblacion",
        "Sibucao",
        "Tabao Baybay",
        "Tabao Rizal",
    ] },
    { province: "Negros Occidental", city: "Silay", barangayList: [
        "Barangay I (Poblacion) (Urban Division)",
        "Barangay II (Poblacion) (Urban Division)",
        "Barangay III (cinco de Noviembre) (Poblacion) (Urban Division)",
        "Barangay IV (Poblacion) (Urban Division)",
        "Barangay V (Poblacion) (Urban Division)",
        "Barangay VI (Poblacion) (Hawaiian) (Rural Division)",
        "Eustaquio Lopez (Rural Division)",
        "Guimbala-on (Rural Division)",
        "Guinhalaran (Urban Division)",
        "Kapitan Ramon (Rural Division)",
        "Lantad (Rural Division)",
        "Mambulac (Urban Division)",
        "Rizal (Urban Division)",
        "Bagtic (Rural Division)",
        "Patag (Rural Division)",
        "Balaring (Rural Division)",
    ] },
    { province: "Negros Occidental", city: "Sipalay", barangayList: [
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Cabadiangan",
        "Camindangan",
        "Canturay",
        "Cartagena",
        "Cayhagan",
        "Gil Montilla",
        "Mambaroto",
        "Manlucahoc",
        "Maricalum",
        "Nabulao",
        "Nauhang",
        "San Jose",
    ] },
    { province: "Negros Occidental", city: "Talisay", barangayList: [
        "Bubog",
        "Cabatangan",
        "Zone 4-A (Poblacion)",
        "Zone 4 (Poblacion)",
        "Concepcion",
        "Dos Hermanas",
        "Efigenio Lizares",
        "Zone 7 (Poblacion)",
        "Zone 14-B (Poblacion)",
        "Zone 12-A (Poblacion)",
        "Zone 10 (Poblacion)",
        "Zone 5 (Poblacion)",
        "Zone 16 (Poblacion)",
        "Matab-ang",
        "Zone 9 (Poblacion)",
        "Zone 6 (Poblacion)",
        "Zone 14 (Poblacion)",
        "San Fernando",
        "Zone 15 (Poblacion)",
        "Zone 14-A (Poblacion)",
        "Zone 11 (Poblacion)o",
        "Zone 8 (Poblacion)",
        "Zone 12 (Poblacion)",
        "Zone 1 (Poblacion)",
        "Zone 2 (Poblacion)",
        "Zone 3 (Poblacion)",
        "Katilingban",
    ] },
    { province: "Negros Occidental", city: "Toboso", barangayList: [
        "Bandila",
        "Bug-ang",
        "General Luna",
        "Magticol",
        "Poblacion",
        "Salamanca",
        "San Isidro",
        "San Jose",
        "Tabun-ac",
    ] },
    { province: "Negros Occidental", city: "Valladolid", barangayList: [
        "Alijis",
        "Ayungon",
        "Bagumbayan",
        "Batuan",
        "Bayabas",
        "Central Tabao",
        "Doldol",
        "Guintorilan",
        "Lacaron",
        "Mabini",
        "Pacol",
        "Palaka",
        "Paloma",
        "Poblacion",
        "Sagua Banua",
        "Tabao Proper",
    ] },
    { province: "Negros Occidental", city: "Victorias", barangayList: [
        "Barangay I (Poblacion)",
        "Barangay II (Quezon; Pob.)",
        "Barangay III (Poblacion)",
        "Barangay IV (Poblacion)",
        "Barangay V (Poblacion)",
        "Barangay VI (Estrella/Salvacion; Pob.)",
        "Barangay VI-A (Boulevard/Villa Miranda/Sitio Cubay/Pasil)",
        "Barangay VII (Poblacion)",
        "Barangay VIII (Old Simboryo)",
        "Barangay IX (Daan Banwa)",
        "Barangay X (Estado)",
        "Barangay XI (Gawahon)",
        "Barangay XII",
        "Barangay XII (Gloryville)",
        "Barangay XIV",
        "Barangay XV West Caticlan",
        "Barangay XV-A East Caticlan",
        "Barangay XVI",
        "Barangay XVI-A",
        "Barangay XVII",
        "Barangay XVIII",
        "Barangay XVIII-A (Florencia, Kubay, Golf)",
        "Barangay XIX",
        "Barangay XIX-A (Canetown Subdivision)",
        "Barangay XX",
        "Barangay XXI",
    ] },
    { province: "Negros Oriental", city: "Amlan (Ayuquitan)", barangayList: [
        "Bio-os",
        "Jantianon",
        "Jugno",
        "Mag-abo",
        "Poblacion",
        "Silab",
        "Tambojangin",
        "Tandayag",
    ] },
    { province: "Negros Oriental", city: "Ayungon", barangayList: [
        "Amdus",
        "Anibong",
        "Atabay",
        "Awa-an",
        "Ban-ban",
        "Calagcalag",
        "Candana-ay",
        "Carol-an",
        "Gomentoc",
        "Inacban",
        "Iniban",
        "Jandalamanon",
        "Kilaban",
        "Lamigan",
        "Maaslum",
        "Mabato",
        "Manogtong",
        "Nabhang",
        "Poblacion",
        "Tambo",
        "Tampocon I",
        "Tampocon II",
        "Tibyawan",
        "Tiguib",
    ] },
    { province: "Negros Oriental", city: "Bacong", barangayList: [
        "Balayagmanok",
        "Banilad",
        "Buntis",
        "Buntod",
        "Calangag",
        "Combado",
        "Doldol",
        "Isugan",
        "Liptong",
        "Lutao",
        "Magsuhot",
        "Malabago",
        "Mampas",
        "North Poblacion",
        "Sacsac",
        "San Miguel",
        "South Poblacion",
        "Sulodpan",
        "Timbanga",
        "Timbao",
        "Tubod",
        "West Poblacion",
    ] },
    { province: "Negros Oriental", city: "Bais", barangayList: [
        "Barangay I (Poblacion)",
        "Barangay II (Poblacion)",
        "Basak",
        "Biñohon",
        "Cabanlutan",
        "Calasga-an",
        "Cambagahan",
        "Cambaguio",
        "Cambanjao",
        "Cambuilao",
        "Canlargo",
        "Canlargo II",
        "Canlargo III",
        "Capiñahan",
        "Consolacion",
        "Dansulan",
        "Hangyad",
        "La Paz",
        "Lo-oc",
        "Lonoy",
        "Mabunao",
        "Manlipac",
        "Mansangaban",
        "Okiot",
        "Olympia",
        "Panala-an",
        "Panam-angan",
        "Rosario",
        "Sab-ahan",
        "San Isidro",
        "Katacgahan (Tacgahan)",
        "Tagpo",
        "Talungon",
        "Tamisu",
        "Tamogong",
        "Tangculogan",
        "Valencia",
    ] },
    { province: "Negros Oriental", city: "Basay", barangayList: [
        "Actin",
        "Bal-os",
        "Bongalonan",
        "Cabalayongan",
        "Cabatuanan",
        "Linantayan",
        "Maglinao",
        "Nagbo-alao",
        "Olandao",
        "Poblacion",
    ] },
    { province: "Negros Oriental", city: "Bayawan (Tulong)", barangayList: [
        "Ali-is",
        "Banaybanay",
        "Banga",
        "Villasol (Bato)",
        "Boyco (Poblacion)",
        "Bugay",
        "Cabcabon",
        "Cansumalig",
        "Dawis",
        "Kalamtukan",
        "Kalumboyan",
        "Malabugas",
        "Mandu-ao",
        "Maninihon",
        "Minaba",
        "Nangka",
        "Narra",
        "Pagatban",
        "Poblacion",
        "San Jose",
        "San Miguel",
        "San Roque",
        "San Isidro",
        "Suba (poblacion)",
        "Tabuan",
        "Tayawan",
        "Tinago (poblacion)",
        "Ubos (poblacion)",
        "Villareal",
    ] },
    { province: "Negros Oriental", city: "Bindoy (Payabon)", barangayList: [
        "Atotes",
        "Batangan",
        "Bulod",
        "Cabcaban",
        "Cabugan",
        "Camudlas",
        "Canluto",
        "Danao",
        "Danawan",
        "Domolog",
        "Malaga",
        "Manseje",
        "Matobato",
        "Nagcasunog",
        "Nalundan",
        "Pangalaycayan",
        "Peñahan",
        "Poblacion (Payabon)",
        "Salong",
        "Tagaytay",
        "Tinaogan",
        "Tubod",
    ] },
    { province: "Negros Oriental", city: "Canlaon", barangayList: [
        "Bayog",
        "Binalbagan",
        "Bucalan",
        "Budlasan",
        "Linothangan",
        "Lumapao",
        "Mabigo (Poblacion)",
        "Malaiba",
        "Masulog",
        "Ninoy Aquino",
        "Panubigan",
        "Pula",
    ] },
    { province: "Negros Oriental", city: "Dauin", barangayList: [
        "Apo Island",
        "Anhawan",
        "Bagacay",
        "Baslay",
        "Batuhon Dacu",
        "Boloc-boloc",
        "Bulak",
        "Bunga",
        "Casile",
        "Libjo",
        "Lipayo",
        "Maayongtubig",
        "Mag-aso",
        "Magsaysay",
        "Malongcay Dacu",
        "Masaplod Norte",
        "Masaplod Sur",
        "Panubtuban",
        "Poblacion I",
        "Poblacion II",
        "Poblacion III",
        "Tugawe",
        "Tunga-tunga",
    ] },
    { province: "Negros Oriental", city: "Dumaguete", barangayList: [
        "Bagacay",
        "Bajumpandan",
        "Balugo",
        "Banilad",
        "Bantayan",
        "Barangay 1 (Tinago)",
        "Barangay 2 (Upper Lukewright)",
        "Barangay 3 (Business District)",
        "Barangay 4 (Rizal Boulevard)",
        "Barangay 5 (Silliman Area)",
        "Barangay 6 (Cambagroy)",
        "Barangay 7 (Mangga)",
        "Barangay 8 (Cervantes Extension)",
        "Batinguel",
        "Buñao",
        "Cadawinonan",
        "Calindagan",
        "Camanjac",
        "Candau-ay",
        "Cantil-e",
        "Daro",
        "Junob",
        "Looc",
        "Mangnao-Canal",
        "Motong",
        "Piapi",
        "Pulantubig",
        "Tabuc-tubig",
        "Taclobo",
        "Talay",
    ] },
    { province: "Negros Oriental", city: "Guihulngan", barangayList: [
        "Bakid",
        "Balogo",
        "Banwague",
        "Basak",
        "Binobohan",
        "Buenavista",
        "Bulado",
        "Calamba",
        "Calupa-an",
        "Hibaiyo",
        "Hilaitan",
        "Hinakpan",
        "Humayhumay",
        "Imelda",
        "Kagawasan",
        "Linantuyan",
        "Luz",
        "Mabunga",
        "Mckinley",
        "Nagsaha",
        "Magsaysay",
        "Malusay",
        "Mani-ak",
        "Padre Zamora",
        "Plagatasanon",
        "Planas",
        "Poblacion",
        "Sandayao",
        "Tacpao",
        "Tinayunan Beach",
        "Tinayunan Hill",
        "Trinidad",
        "Villegas",
    ] },
    { province: "Negros Oriental", city: "Jimalalud", barangayList: [
        "Aglahug",
        "Agutayon",
        "Apanangon",
        "Bae",
        "Bala-as",
        "Bangcal",
        "Banog",
        "Buto",
        "Cabang",
        "Camandayon",
        "Cangharay",
        "Canlahao",
        "Dayoyo",
        "Yli",
        "Lacaon",
        "Mahanlud",
        "Malabago",
        "Mambaid",
        "Mongpong",
        "Owacan",
        "Pacuan",
        "Panglaya-an",
        "North Poblacion",
        "South Poblacion",
        "Polopantao",
        "Sampiniton",
        "Talamban",
        "Tamao",
    ] },
    { province: "Negros Oriental", city: "La Libertad", barangayList: [
        "Aya",
        "Aniniao",
        "Bagtic ",
        "Biga-a",
        "Busilak",
        "Cangabo ",
        "Cantupa",
        "Eli",
        "Guihob ",
        "Kansumandig",
        "Mambulod",
        "Mandapaton",
        "Manghulyawon",
        "Manluminsag",
        "Mapalasan",
        "Maragondong",
        "Martilo ",
        "Nasungan",
        "Pacuan ",
        "Pangca",
        "Pisong ",
        "Pitogo",
        "Poblacion North",
        "Poblacion South",
        "San Jose ",
        "Solonggon",
        "Tala-on",
        "Talayong",
        "Elecia",
    ] },
    { province: "Negros Oriental", city: "Mabinay", barangayList: [
        "Abis",
        "Arebasore",
        "Bagtic",
        "Banban",
        "Barras",
        "Bato",
        "Bugnay",
        "Bulibulihan",
        "Bulwang",
        "Campanun-an",
        "Canggohob",
        "Cansal-ing",
        "Dagbasan",
        "Dahile",
        "Himocdongon",
        "Hagtu",
        "Inapoy",
        "Lamdas",
        "Lumbangan",
        "Luyang",
        "Manlingay",
        "Mayaposi",
        "Napasu-an",
        "New Namangka",
        "Old Namangka",
        "Pandanon",
        "Paniabonan",
        "Pantao",
        "Poblacion",
        "Samac",
        "Tadlong",
        "Tarâ",
    ] },
    { province: "Negros Oriental", city: "Manjuyod", barangayList: [
        "Alangilanan",
        "Balaas",
        "Bantolinao",
        "Bolisong",
        "Butong",
        "Campuyo",
        "Candabong",
        "Concepcion",
        "Dungo-an",
        "Kauswagan",
        "Libjo",
        "Lamogong",
        "Bagtic",
        "Maaslum",
        "Mandalupang",
        "Panciao",
        "Poblacion",
        "Sac-sac",
        "Salvacion",
        "San Isidro",
        "San Jose",
        "Santa Monica",
        "Suba",
        "Sundo-an",
        "Tanglad",
        "Tubod",
        "Tupas",
    ] },
    { province: "Negros Oriental", city: "Pamplona", barangayList: [
        "Abante",
        "Balayong",
        "Banawe",
        "Calicanan",
        "Datagon",
        "Fatima",
        "Inawasan",
        "Magsusunog",
        "Malalangsi",
        "Mamburao",
        "Mangoto",
        "Poblacion",
        "San Isidro",
        "Santa Agueda",
        "Simborio",
        "Yupisan",
    ] },
    { province: "Negros Oriental", city: "San Jose", barangayList: [
        "Basak",
        "Basiao",
        "Cambaloctot",
        "Cancawas",
        "Janayjanay",
        "Jilocon",
        "Naiba",
        "Poblacion",
        "San Roque",
        "Santo Niño",
        "Señora Ascion (Calo)",
        "Siapo",
        "Tampi",
        "Tapon Norte",
    ] },
    { province: "Negros Oriental", city: "Santa Catalina", barangayList: [
        "Alangilan",
        "Amio",
        "Buenavista",
        "Kabulacan",
        "Caigangan",
        "Caranoche",
        "Cawitan",
        "Fatima",
        "Mabuhay",
        "Manalongon",
        "Mansagomayon",
        "Milagrosa",
        "Nagbinlod",
        "Nagbalaye",
        "Obat",
        "Poblacion",
        "San Francisco",
        "San Jose",
        "San Miguel",
        "San Pedro",
        "Santo Rosario",
        "Talalak",
    ] },
    { province: "Negros Oriental", city: "Siaton", barangayList: [
        "Rural",
    ] },
    { province: "Negros Oriental", city: "Sibulan", barangayList: [
        "Coastal/Farm",
        "Hill/Farm",
    ] },
    { province: "Negros Oriental", city: "Tanjay", barangayList: [
        "Albiga",
        "Apoloy",
        "Bonawon",
        "Bonbonon",
        "Cabangahan",
        "Canaway",
        "Casala-an",
        "Caticugan",
        "Datag",
        "Giliga-on",
        "Inalad",
        "Malabuhan",
        "Maloh",
        "Mantiquil",
        "Mantuyop",
        "Napacao",
        "Poblacion I",
        "Poblacion II",
        "Poblacion III",
        "Poblacion IV",
        "Salag",
        "San Jose",
        "Sandulot",
        "Si-it",
        "Sumaliring",
        "Tayak",
    ] },
    { province: "Negros Oriental", city: "Tayasan", barangayList: [
        "Bacong",
        "Bago",
        "Banga",
        "Cabulotan",
        "Cambaye",
        "Dalaupon",
        "Guincalaban",
        "Ilaya",
        "Jilabangan",
        "Lag-it",
        "Linao",
        "Lutay",
        "Maglihe",
        "Matauta",
        "Magtuhao",
        "Matuog",
        "Numnum",
        "Palaslan",
        "Pindahan",
        "Pinalubngan",
        "Pinocawan",
        "Poblacion",
        "Santa Cruz",
        "Saying",
        "Soquib",
        "Tamao",
        "Tambulan",
        "Tanlad",
    ] },
    { province: "Negros Oriental", city: "Valencia (Luzurriaga)", barangayList: [
        "Apolong",
        "East Balabag",
        "West Balabag",
        "Balayagmanok",
        "Balili",
        "Balugo",
        "Bongbong",
        "Bong-ao",
        "Calayugan",
        "Cambucad",
        "Dobdob",
        "Jawa",
        "Caidiocan",
        "Liptong",
        "Lunga",
        "Malabo",
        "Malaunay",
        "Mampas",
        "Palinpinon",
        "North Poblacion",
        "South Poblacion",
        "Puhagan",
        "Pulangbato",
        "Sagbang",
    ] },
    { province: "Negros Oriental", city: "Vallehermoso", barangayList: [
        "Bagawines",
        "Bairan",
        "Don Espiridion Villegas",
        "Guba",
        "Cabulihan",
        "Macapso",
        "Malangsa",
        "Molobolo",
        "Maglahos",
        "Pinocauan",
        "Poblacion",
        "Puan",
        "Tabon",
        "Tagbino",
        "Ulay",
    ] },
    { province: "Negros Oriental", city: "Zamboanguita", barangayList: [
        "Basak",
        "Calango",
        "Lutoban",
        "Malongcay Diot",
        "Maluay",
        "Mayabon",
        "Nabago",
        "Nasig-id",
        "Najandig",
        "Poblacion",
    ] },
    // { province: "Northern Samar", city: "", barangayList: [] },
    // { province: "Nueva Ecija", city: "", barangayList: [] },
    // { province: "Nueva Vizcaya", city: "", barangayList: [] },
    // { province: "Occidental Mindoro", city: "", barangayList: [] },
    // { province: "Oriental Mindoro", city: "", barangayList: [] },
    // { province: "Palawan", city: "", barangayList: [] },
    // { province: "Pampanga", city: "", barangayList: [] },
    // { province: "Pangasinan", city: "", barangayList: [] },
    { province: "Quezon", city: "Jomalig", barangayList: [
        "Bukal",
        "Casuguran",
        "Gango",
        "Talisoy (Poblacion)",
        "Apad",
    ] },
    { province: "Quezon", city: "Patnanungan", barangayList: [
        "Amaga",
        "Busdak",
        "Kilogan",
        "Luod",
        "Patnanungan Norte",
        "Patnanungan Sur (Poblacion)",
        "Tapul",
    ] },
    { province: "Quezon", city: "Burdeos", barangayList: [
        "Aluyon",
        "Amot",
        "Anibawan",
        "Bonifacio",
        "Cabugao",
        "Cabungalunan (including Anirong Island and Anawan Island)",
        "Calutcot (with surrounding islands)",
        "Caniwan",
        "Carlagan (including Buguitan Island)",
        "Mabini",
        "Palasan (including Icol and Cabalao islands)",
        "Poblacion",
        "San Rafael",
    ] },
    { province: "Quezon", city: "Polillo", barangayList: [
        "Anawan",
        "Atulayan",
        "Balesin",
        "Bañadero",
        "Binibitinan",
        "Bislian",
        "Bucao",
        "Canicanian",
        "Kalubakis",
        "Languyin",
        "Libjo",
        "Pamatdan",
        "Pilion",
        "Pinaglubayan",
        "Poblacion",
        "Sabang",
        "Salipsip",
        "Sibulan",
        "Taluong",
        "Tamulaya-Anibong",
    ] },
    { province: "Quezon", city: "Panukulan", barangayList: [
        "Balungay",
        "Bato",
        "Bonbon",
        "Calasumanga",
        "Kinalagti",
        "Libo",
        "Lipata",
        "Matangkap",
        "Milawid",
        "Pagitan",
        "Pandan",
        "Rizal",
        "San Juan (Poblacion)",
    ] },
    { province: "Quezon", city: "General Nakar", barangayList: [
        "Anoling",
        "Banglos",
        "Batangan",
        "Catablingan",
        "Canaway",
        "Lumutan",
        "Mahabang Lalim",
        "Maigang",
        "Maligaya",
        "Magsikap",
        "Minahan Norte",
        "Minahan Sur",
        "Pagsangahan",
        "Pamplona",
        "Pisa",
        "Poblacion",
        "Sablang",
        "San Marcelino",
        "Umiray",
    ] },
    { province: "Quezon", city: "Infanta", barangayList: [
        "Abiawin",
        "Agos-agos",
        "Alitas",
        "Amolongin",
        "Anibong",
        "Antikin",
        "Bacong",
        "Balobo",
        "Bantilan",
        "Banugao",
        "Batican",
        "Binonoan",
        "Binulasan",
        "Boboin",
        "Catambungan",
        "Cawaynin",
        "Comon",
        "Dinahican",
        "Gumian",
        "Ilog",
        "Ingas",
        "Langgas",
        "Libjo",
        "Lual",
        "Magsaysay",
        "Maypulot",
        "Miswa",
        "Pilaway",
        "Pinaglapatan",
        "Poblacion 1",
        "Poblacion 38",
        "Poblacion 39",
        "Pulo",
        "Silangan",
        "Tongohin",
        "Tudturan",
    ] },
    { province: "Quezon", city: "Real", barangayList: [
        "Poblacion I (Barangay 1)",
        "Capalong",
        "Cawayan",
        "Kiloloron",
        "Llavac",
        "Lubayat",
        "Malapad",
        "Maragondon",
        "Pandan",
        "Tanauan",
        "Tignoan",
        "Ungos",
        "Poblacion 61 (Barangay 2)",
        "Maunlad",
        "Bagong Silang",
        "Masikap",
        "Tagumpay",
    ] },
    { province: "Quezon", city: "Mauban", barangayList: [
        "Bagong Bayan (Poblacion)",
        "Daungan (Poblacion)",
        "Lual (Poblacion)",
        "Mabato (Poblacion)",
        "Rizaliana (Poblacion)",
        "Sadsaran (Poblacion)",
        "Abo-abo",
        "Alitap",
        "Baao",
        "Balaybalay",
        "Bató",
        "Cagbalete I",
        "Cagbalete II",
        "Cagsiay I",
        "Cagsiay II",
        "Cagsiay III",
        "Concepción",
        "Liwayway",
        "Lucutan",
        "Lual Rural",
        "Luya-luya",
        "Macasin",
        "Polo",
        "Remedios I",
        "Remedios II",
        "Rosario",
        "San Gabriel (formerly Tubog)",
        "San Isidro",
        "San José",
        "San Lorenzo",
        "San Miguel",
        "San Rafael",
        "San Roque",
        "San Vicente",
        "Santa Lucía",
        "Santo Ángel",
        "Santo Niño",
        "Santol",
        "Soledad",
        "Tapucan",
    ] },
    { province: "Quezon", city: "Sampaloc", barangayList: [
        "Alupay",
        "Apasan",
        "Banot",
        "Bataan",
        "Bayongon (Poblacion)",
        "Bilucao",
        "Caldong",
        "Ibabang Owain (Poblacion)",
        "Ilayang Owain (Poblacion)",
        "Mamala",
        "San Bueno",
        "San Isidro (Poblacion)",
        "San Roque (Poblacion)",
        "Taquico",
    ] },
    { province: "Quezon", city: "Lucban", barangayList: [
        "Abang",
        "Aliliw",
        "Atulinao",
        "Ayuti (Poblacion)",
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Barangay 6 (Poblacion)",
        "Barangay 7 (Poblacion)",
        "Barangay 8 (Poblacion)",
        "Barangay 9 (Poblacion)",
        "Barangay 10 (Poblacion)",
        "Igang",
        "Kabatete",
        "Kakawit",
        "Kalangay",
        "Kalyaat",
        "Kilib",
        "Kulapi",
        "Mahabang Parang",
        "Malupak",
        "Manasa",
        "May-It",
        "Nagsinamo",
        "Nalunao",
        "Palola",
        "Piis",
        "Samil",
        "Tiawe",
        "Tinamnan",
    ] },
    { province: "Quezon", city: "Tayabas", barangayList: [
        "Alitao",
        "Alsam Ibaba",
        "Alsam Ilaya",
        "Alupay",
        "Angeles Zone I (Poblacion)",
        "Angeles Zone II",
        "Angeles Zone III",
        "Angeles Zone IV",
        "Angustias Zone I (Poblacion)",
        "Angustias Zone II",
        "Angustias Zone III",
        "Angustias Zone IV",
        "Anos",
        "Ayaas",
        "Baguio",
        "Banilad",
        "Ibabang Bukal",
        "Ilayang Bukal",
        "Calantas",
        "Calumpang",
        "Camaysa",
        "Dapdap",
        "Kanlurang Domoit",
        "Silangang Domoit",
        "Gibanga",
        "Ibas",
        "Ilasan Ibaba",
        "Ilasan Ilaya",
        "Ipilan",
        "Isabang",
        "Katigan Kanluran",
        "Katigan Silangan",
        "Lakawan",
        "Lalo",
        "Lawigue",
        "Lita",
        "Malaoa",
        "Masin",
        "Mate",
        "Mateuna",
        "Mayowe",
        "Ibabang Nangka",
        "Ilayang Nangka",
        "Opias",
        "Ibabang Palale",
        "Ilayang Palale",
        "Kanlurang Palale",
        "Silangang Palale",
        "Pandakaki",
        "Pook",
        "Potol",
        "San Diego Zone I (Poblacion)",
        "San Diego Zone II (Pob)",
        "San Diego Zone III",
        "San Diego Zone IV",
        "San Isidro Zone I (Poblacion)",
        "San Isidro Zone II",
        "San Isidro Zone III",
        "San Isidro Zone IV",
        "San Roque Zone I (Poblacion)",
        "San Roque Zone II",
        "Talolong",
        "Tamlong",
        "Tongko",
        "Valencia",
        "Wakas",
    ] },
    { province: "Quezon", city: "Pagbilao", barangayList: [
        "Alupaye",
        "Añato",
        "Antipolo",
        "Bantigue",
        "Bigo",
        "Binahaan",
        "Bukal",
        "Ibabang Bagumbungan",
        "Ibabang Palsabangon (detour)",
        "Ibabang Polo",
        "Ikirin",
        "Ilayang Bagumbungan",
        "Ilayang Palsabangon",
        "Ilayang Polo",
        "Kanlurang Malicboy",
        "Mapagong",
        "Mayhay",
        "Pinagbayanan",
        "Barangay 1 Castillo (Poblacion)",
        "Barangay 2 Daungan (Poblacion)",
        "Barangay 3 Del Carmen (Poblacion)",
        "Barangay 4 Parang (Poblacion)",
        "Barangay 5 Santa Catalina (Poblacion)",
        "Barangay 6 Tambak (Poblacion)",
        "Silangang Malicboy",
        "Talipan",
        "Tukalan",
    ] },
    { province: "Quezon", city: "Lucena", barangayList: [
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Barangay 6 (Poblacion)",
        "Barangay 7 (Poblacion)",
        "Barangay 8 (Poblacion)",
        "Barangay 9 (Poblacion)",
        "Barangay 10 (Poblacion)",
        "Barangay 11 (Poblacion)",
        "Barra",
        "Bocohan",
        "Cotta",
        "Gulang-Gulang",
        "Dalahican",
        "Domoit",
        "Ibabang Dupay",
        "Ibabang Iyam",
        "Ibabang Talim",
        "Ilayang Dupay",
        "Ilayang Iyam",
        "Ilayang Talim",
        "Isabang",
        "Market View",
        "Mayao Castillo",
        "Mayao Crossing",
        "Mayao Kanluran",
        "Mayao Parada",
        "Mayao Silangan",
        "Ransohan",
        "Salinas",
        "Talao-Talao",
    ] },
    { province: "Quezon", city: "Sariaya", barangayList: [
        "Antipolo",
        "Balubal",
        "Bignay 1",
        "Bignay 2",
        "Bucal",
        "Canda",
        "Castañas",
        "Concepcion 1",
        "Concepcion Banahaw",
        "Concepcion Palasan",
        "Concepcion Pinagbakuran",
        "Gibanga",
        "Guisguis San Roque",
        "Guisguis Talon",
        "Janagdong 1",
        "Janagdong 2",
        "Limbon",
        "Lutucan 1",
        "Lutucan Bata",
        "Lutucan Malabag",
        "Mamala 1",
        "Mamala 2",
        "Manggalang 1",
        "Manggalang Bantilan",
        "Manggalang Kiling",
        "Manggalang Tulo-Tulo",
        "Montecillo",
        "Morong",
        "Pili",
        "Poblacion 1",
        "Poblacion 2",
        "Poblacion 3",
        "Poblacion 4",
        "Poblacion 5",
        "Poblacion 6",
        "Sampaloc 1",
        "Sampaloc 2",
        "Sampaloc Bogon",
        "Santo Cristo",
        "Talaan Aplaya",
        "Talaan Pantoc",
        "Tumbaga 1",
        "Tumbaga 2",
    ] },
    { province: "Quezon", city: "Candelaria", barangayList: [
        "Buenavista East",
        "Buenavista West",
        "Bukal Norte",
        "Bukal Sur",
        "Kinatihan I",
        "Kinatihan II",
        "Malabanban Norte",
        "Malabanban Sur",
        "Mangilag Norte",
        "Mangilag Sur",
        "Masalukot I",
        "Masalukot II",
        "Masalukot III",
        "Masalukot IV",
        "Masalukot V",
        "Masin Norte",
        "Masin Sur",
        "Mayabobo",
        "Pahinga Norte",
        "Pahinga Sur",
        "Poblacion",
        "San Andres",
        "San Isidro",
        "Santa Catalina Norte",
        "Santa Catalina Sur",
    ] },
    { province: "Quezon", city: "Dolores", barangayList: [
        "Antonino (Ayusan)",
        "Bagong Anyo (Poblacion)",
        "Bayanihan (Poblacion)",
        "Bulakin 1",
        "Bulakin 2",
        "Bungoy",
        "Cabatang",
        "Dagatan",
        "Kinabuhayan",
        "Maligaya (Poblacion)",
        "Manggahan",
        "Pinagdanlayan",
        "Putol",
        "San Mateo",
        "Santa Lucia",
        "Silanganan (Poblacion)",
    ] },
    { province: "Quezon", city: "Tiaong", barangayList: [
        "Anastacia",
        "Aquino",
        "Ayusan I",
        "Ayusan II",
        "Behia",
        "Bukal",
        "Bula",
        "Bulakin",
        "Cabatang",
        "Cabay",
        "Del Rosario",
        "Lagalag",
        "Lalig",
        "Lumingon",
        "Lusacan",
        "Paiisa",
        "Palagaran",
        "Poblacion I",
        "Poblacion II",
        "Poblacion III",
        "Poblacion IV",
        "Quipot",
        "San Agustin",
        "San Isidro",
        "San Jose",
        "San Juan",
        "San Pedro",
        "Tagbakin",
        "Talisay",
        "Tamisian",
        "San Francisco",
    ] },
    { province: "Quezon", city: "San Antonio", barangayList: [
        "Arawan",
        "Bagong Niing",
        "Balat Atis",
        "Briones",
        "Bulihan",
        "Buliran",
        "Callejon",
        "Corazon",
        "Del Valle",
        "Loob",
        "Magsaysay",
        "Matipunso",
        "Niing",
        "Poblacion",
        "Pulo",
        "Pury",
        "Sampaga",
        "Sampaguita",
        "San Jose",
        "Sinturisan",
    ] },
    { province: "Quezon", city: "Padre Burgos", barangayList: [
        "Cabuyao Norte",
        "Cabuyao Sur",
        "Danlagan",
        "Duhat",
        "Hinguiwin",
        "Kinagunan Ibaba",
        "Kinagunan Ilaya",
        "Lipata",
        "Marao",
        "Marquez",
        "Burgos (Poblacion)",
        "Campo (Poblacion)",
        "Basiao (Poblacion)",
        "Punta (Poblacion)",
        "Rizal",
        "San Isidro",
        "San Vicente",
        "Sipa",
        "Tulay Buhangin",
        "Villapaz",
        "Walay",
        "Yawe",
    ] },
    { province: "Quezon", city: "Agdangan", barangayList: [
        "Binagbag",
        "Dayap",
        "Ibabang Kinagunan",
        "Ilayang Kinagunan",
        "Kanlurang Calutan",
        "Kanlurang Maligaya",
        "Salvacion",
        "Silangang Calutan",
        "Silangang Maligaya",
        "Sildora",
        "Poblacion I",
        "Poblacion II",
    ] },
    { province: "Quezon", city: "Unisan", barangayList: [
        "Almacén",
        "Balagtás",
        "Balanacan",
        "Bulo Ibabâ",
        "Bulo Ilaya",
        "Bonifacio",
        "Burgos",
        "Caigdál",
        "General Luna",
        "Kalilayan Ibabâ",
        "Cabulihan Ibabâ",
        "Mairok Ibaba",
        "Kalilayan Ilaya",
        "Cabulihan Ilaya",
        "Mabini",
        "Mairok Ilayang",
        "Malvar",
        "Maputat",
        "Muliguin",
        "Pagaguasan",
        "Panaon Ibabâ",
        "Panaon Ilaya",
        "Pláridel",
        "F. De Jesús (Poblacion)",
        "R. Lapu-lapu (Poblacion)",
        "Raja Solimán (Poblacion)",
        "R. Magsaysay (Poblacion)",
        "Poctol",
        "Punta",
        "Rizal Ibabâ",
        "Rizal Ilaya",
        "San Roque",
        "Socorro",
        "Tagumpay",
        "Tubas",
        "Tubigan",
    ] },
    { province: "Quezon", city: "Pitogo", barangayList: [
        "Amontay",
        "Cometa",
        "Biga",
        "Bilucao",
        "Cabulihan",
        "Cawayanin",
        "Gangahin",
        "Ibabang Burgos",
        "Ibabang Pacatin",
        "Ibabang Piña",
        "Ibabang Soliyao",
        "Ilayang Burgos",
        "Ilayang Pacatin",
        "Ilayang Piña",
        "Ilayang Soliyao",
        "Nag-Cruz",
        "Osmeña",
        "Payte",
        "Pinagbayanan",
        "Masaya (Poblacion)",
        "Manggahan (Poblacion)",
        "Dulong Bayan (Poblacion)",
        "Pag-Asa (Poblacion)",
        "Castillo (Poblacion)",
        "Maaliw (Poblacion)",
        "Mayubok (Poblacion)",
        "Pamilihan (Poblacion)",
        "Dalampasigan (Poblacion)",
        "Poctol",
        "Quezon",
        "Quinagasan",
        "Rizalino",
        "Saguinsinan",
        "Sampaloc",
        "San Roque",
        "Sisirin",
        "Sumag Este",
        "Sumag Norte",
        "Sumag Weste",
    ] },
    { province: "Quezon", city: "Macalelon", barangayList: [
        "Amontay",
        "Anos",
        "Buyao",
        "Candangal",
        "Calantas",
        "Lahing",
        "Luctob/Townsite",
        "Mabini Ibaba",
        "Mabini Ilaya",
        "Malabahay",
        "Mambog",
        "Olongtao Ibaba",
        "Olongtao Ilaya",
        "Padre Herrera",
        "Pajarillo",
        "Pinagbayanan",
        "Rodriguez (Poblacion)",
        "Rizal (Poblacion)",
        "Castillo (Poblacion)",
        "Pag-Asa (Poblacion)",
        "Masipag (Poblacion)",
        "Damayan (Poblacion)",
        "San Isidro",
        "San Jose",
        "San Nicolas",
        "San Vicente",
        "Taguin",
        "Tubigan Ibaba",
        "Tubigan Ilaya",
        "Vista Hermosa",
    ] },
    { province: "Quezon", city: "General Luna", barangayList: [
        "Bacong Ibaba",
        "Bacong Ilaya",
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Barangay 6 (Poblacion)",
        "Barangay 7 (Poblacion)",
        "Barangay 8 (Poblacion)",
        "Barangay 9 (Poblacion)",
        "Lavides",
        "Magsaysay",
        "Malaya",
        "Nieva",
        "Recto",
        "San Ignacio Ibaba",
        "San Ignacio Ilaya",
        "San Isidro Ibaba",
        "San Isidro Ilaya",
        "San Jose",
        "San Nicolas",
        "San Vicente",
        "Santa Maria Ibaba",
        "Santa Maria Ilaya",
        "Sumilang",
        "Villarica",
    ] },
    { province: "Quezon", city: "Catanauan", barangayList: [
        "Ajos",
        "Anusan",
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Barangay 6 (Poblacion)",
        "Barangay 7 (Poblacion)",
        "Barangay 8 (Poblacion)",
        "Barangay 9 (Poblacion)",
        "Barangay 10(Poblacion)",
        "Bolo",
        "Bulagsong",
        "Camandiison",
        "Canculajao",
        "Catumbo",
        "Cawayanin Ibaba",
        "Cawayanin Ilaya",
        "Cutcutan",
        "Dahican",
        "Doongan Ibaba",
        "Doongan Ilaya",
        "Gatasan",
        "Macpac",
        "Madulao",
        "Matandang Sabang Kanluran",
        "Matandang Sabang Silangan",
        "Milagrosa",
        "Navitas",
        "Pacabit",
        "San Antonio Magcupa",
        "San Antonio Pala",
        "San Isidro",
        "San Jose (Anyao)",
        "San Pablo (Suha)",
        "San Roque (Uoyon)",
        "San Vicente Kanluran",
        "San Vicente Silangan",
        "Santa Maria (Dao)",
        "Tagabas Ibaba",
        "Tagabas Ilaya",
        "Tagbacan Ibaba",
        "Tagbacan Ilaya",
        "Tagbacan Silangan",
        "Tuhian",
    ] },
    { province: "Quezon", city: "Buenavista", barangayList: [
        "Bagong Silang",
        "Batabat Norte",
        "Batabat Sur",
        "Buenavista",
        "Bukal",
        "Bulo",
        "Cabong",
        "Cadlit",
        "Catulin",
        "Cawa",
        "De La Paz",
        "Del Rosario",
        "Hagonghong",
        "Ibabang Wasay",
        "Ilayang Wasay",
        "Lilukin",
        "Mabini",
        "Mabutag",
        "Magallanes",
        "Maligaya (Esperanza)",
        "Manlana",
        "Masaya",
        "Poblacion",
        "Rizal",
        "Sabang Pinamasagan",
        "Sabang Piris",
        "San Diego",
        "San Isidro Ibaba",
        "San Isidro Ilaya",
        "San Pablo",
        "San Pedro (Villa Rodrigo)",
        "San Vicente",
        "Siain",
        "Villa Aurora",
        "Villa Batabat",
        "Villa Magsaysay",
        "Villa Veronica",
    ] },
    { province: "Quezon", city: "San Narciso", barangayList: [
        "Abuyon",
        "Andres Bonifacio",
        "Bani",
        "Binay",
        "Buenavista",
        "Busokbusokan",
        "Calwit",
        "Guinhalinan",
        "Lakdayan",
        "Maguiting",
        "Manlampong",
        "Pagkakaisa (Poblacion)",
        "Maligaya (Poblacion)",
        "Bayanihan (Poblacion)",
        "Pagdadamayan (Poblacion)",
        "Punta",
        "Rizal",
        "San Isidro",
        "San Juan",
        "San Vicente",
        "Vigo Central",
        "Villa Aurin (Pinagsama)",
        "Villa Reyes",
        "White Cliff",
    ] },
    { province: "Quezon", city: "Mulanay", barangayList: [
        "Ajos",
        "Amuguis",
        "Anonang",
        "Bagong Silang",
        "Bagupaye",
        "Barangay Poblacion 1",
        "Barangay Poblacion 2",
        "Barangay Poblacion 3",
        "Barangay Poblacion 4",
        "Bolo",
        "Buenavista",
        "Burgos",
        "Butanyog",
        "Canuyep",
        "F. Nanadiego",
        "Ibabang Cambuga",
        "Ibabang Yuni",
        "Ilayang Cambuga (Mabini)",
        "Ilayang Yuni",
        "Latangan",
        "Magsaysay",
        "Matataja",
        "Pakiing",
        "Patabog",
        "Sagongon",
        "San Isidro",
        "San Pedro",
        "Santa Rosa",
    ] },
    { province: "Quezon", city: "San Francisco", barangayList: [
        "Butangiad",
        "Casay",
        "Cawayan I",
        "Cawayan II",
        "Huyon-Uyon",
        "Ibabang Tayuman (Busdak)",
        "Ilayang Tayuman",
        "Inabuan",
        "Nasalaan",
        "Pagsangahan",
        "Poblacion",
        "Pugon",
        "Silongin",
        "Don Juan Vercelos (Utod)",
        "Mabunga",
        "Santo Niño",
    ] },
    { province: "Quezon", city: "San Andres", barangayList: [
        "Alibihaban",
        "Camflora",
        "Mangero",
        "Pansoy",
        "Tala",
        "Talisay",
        "Poblacion",
    ] },
    { province: "Quezon", city: "Perez", barangayList: [
        "Maabot",
        "Mainit Norte",
        "Mainit Sur",
        "Pambuhan",
        "Pinagtubigan Este",
        "Pinagtubigan Weste",
        "Pagkakaisa Pob. (Barangay 1)",
        "Mapagmahal Pob. (Barangay 2)",
        "Bagong Pag-Asa Pob. (Barangay 3)",
        "Bagong Silang Pob. (Barangay 4)",
        "Rizal",
        "Sangirin",
        "Villamanzano Norte",
        "Villamanzano Sur",
    ] },
    { province: "Quezon", city: "Alabat", barangayList: [
        "Angeles",
        "Bacong",
        "Balungay",
        "Buenavista",
        "Caglate",
        "Camagong",
        "Gordon",
        "Pambilan Norte",
        "Pambilan Sur",
        "Barangay 1 (Poblacion)",
        "Barangay 2 (Poblacion)",
        "Barangay 3 (Poblacion)",
        "Barangay 4 (Poblacion)",
        "Barangay 5 (Poblacion)",
        "Villa Esperanza",
        "Villa Jesus Este",
        "Villa Jesus Weste",
        "Villa Norte",
        "Villa Victoria",
    ] },
    { province: "Quezon", city: "Quezon", barangayList: [
        "Aurora",
        "Baresbes",
        "Bonifacio",
        "Buliwao",
        "Calaocan",
        "Caliat",
        "Dagupan",
        "Darubba",
        "Maasin",
        "Maddiangat",
        "Nalubbuhan",
        "Runruno",
    ] },
    { province: "Quezon", city: "Atimonan", barangayList: [
        "Angeles",
        "Balubad",
        "Balugohin",
        "Barangay Zone 1 (Poblacion)",
        "Barangay Zone 2 (Poblacion)",
        "Barangay Zone 3 (Poblacion)",
        "Barangay Zone 4 (Poblacion)",
        "Buhangin",
        "Caridad Ibaba",
        "Caridad Ilaya",
        "Habingan",
        "Inaclagan",
        "Inalig",
        "Kilait",
        "Kulawit",
        "Lakip",
        "Lubi",
        "Lumutan",
        "Magsaysay",
        "Malinao Ibaba",
        "Malinao Ilaya",
        "Malusak",
        "Manggalayan Bundok",
        "Manggalayan Labak",
        "Matanag",
        "Montes Balaon",
        "Montes Kallagan",
        "Ponon",
        "Rizal",
        "San Andres Bundok",
        "San Andres Labak",
        "San Isidro",
        "San Jose Balatok",
        "San Rafael",
        "Santa Catalina",
        "Sapaan",
        "Sokol",
        "Tagbakin",
        "Talaba",
        "Tinandog",
        "Villa Ibaba",
        "Villa Ilaya",
    ] },
    { province: "Quezon", city: "Plaridel", barangayList: [
        "Concepcion",
        "Duhat",
        "Ilaya",
        "Ilosong",
        "Tanauan",
        "Central (Poblacion)",
        "Paang Bundok (Poblacion)",
        "Paaralan or Pampaaralan (Poblacion)",
        "M. L. Tumagay (Poblacion)",
    ] },
    { province: "Quezon", city: "Gumaca", barangayList: [
        "Adia Bitaog",
        "Anonangin",
        "Bagong Buhay (Poblacion)",
        "Bamban",
        "Bantad",
        "Batong Dalig",
        "Biga",
        "Binambang",
        "Buensuceso",
        "Bungahan",
        "Butaguin",
        "Calumangin",
        "Camohaguin",
        "Casasahan Ibaba",
        "Casasahan Ilaya",
        "Cawayan",
        "Gayagayaan",
        "Gitnang Barrio",
        "Hardinan",
        "Inaclagan",
        "Inagbuhan Ilaya",
        "Hagakhakin",
        "Labnig",
        "Laguna",
        "Lagyo",
        "Mabini(Poblacion)",
        "Mabunga",
        "Malabtog",
        "Manlayaan",
        "Marcelo H. Del Pilar",
        "Mataas Na Bundok",
        "Maunlad (Poblacion)",
        "Pagsabangan",
        "Panikihan",
        "Peñafrancia (Poblacion)",
        "Pipisik (Poblacion)",
        "Progreso",
        "Rizal (Poblacion)",
        "Rosario",
        "San Agustin",
        "San Diego (Poblacion)",
        "San Diego (Bukid)",
        "San Isidro Kanluran",
        "San Isidro Silangan",
        "San Juan De Jesus",
        "San Vicente",
        "Sastre",
        "Tabing Dagat (Poblacion)",
        "Tumayan",
        "Villa Arcaya",
        "Villa Bota",
        "Villa Fuerte",
        "Villa Mendoza",
        "Villa Nava",
        "Villa Padua",
        "Villa Perez",
        "Villa Principe",
        "Villa Tañada",
        "Villa Victoria",
    ] },
    { province: "Quezon", city: "Lopez", barangayList: [
        "Burgos (Poblacion)",
        "Danlagan (Poblacion)",
        "Gomez (Poblacion)",
        "Magsaysay (Poblacion)",
        "Rizal (Poblacion)",
        "San Lorenzo Ruiz (Poblacion)",
        "Talolong (Poblacion)",
        "Bacungan",
        "Bagacay",
        "Banabahin Ibaba",
        "Banabahin Ilaya",
        "Bayabas",
        "Bebito",
        "Bigajo",
        "Binahian A",
        "Binahian B",
        "Binahian C",
        "Buenavista",
        "Buyacanin",
        "Cagacag",
        "Calantipayan",
        "Calumpang",
        "Canda Ibaba",
        "Canda Ilaya",
        "Cawayan",
        "Cawayanin",
        "Cogorin Ibaba",
        "Cogorin Ilaya",
        "Concepcion",
        "De La Paz",
        "Del Rosario",
        "Esperanza Ibaba",
        "Esperanza Ilaya",
        "Guihay",
        "Guinuangan",
        "Guites",
        "Hondagua",
        "Ilayang Ilog A",
        "Ilayang Ilog B",
        "Inalusan",
        "Jongo",
        "Lalaguna",
        "Lourdes",
        "Mabanban",
        "Mabini",
        "Magallanes",
        "Maguilayan",
        "Mahayod-Hayod",
        "Mal-ay",
        "Mandoog",
        "Manguisian",
        "Matinik",
        "Monteclaro",
        "Pamampangin",
        "Pansol",
        "Peñafrancia",
        "Pisipis",
        "Rizal (Rural)",
        "Roma",
        "Rosario",
        "Samat",
        "San Andres",
        "San Antonio",
        "San Francisco A",
        "San Francisco B",
        "San Isidro",
        "San Jose",
        "San Miguel (Dao)",
        "San Pedro",
        "San Rafael",
        "San Roque",
        "Silang",
        "Santa Catalina",
        "Santa Elena",
        "Santa Jacobe",
        "Santa Lucia",
        "Santa Maria",
        "Santa Rosa",
        "Santa Teresa",
        "Santo Niño Ibaba",
        "Santo Niño Ilaya",
        "Sugod",
        "Sumalang",
        "Tan-ag Ibaba",
        "Tan-ag Ilaya",
        "Tocalin",
        "Vegaflor",
        "Vergaña",
        "Veronica",
        "Villa Aurora",
        "Villa Espina",
        "Villageda",
        "Villahermosa",
        "Villamonte",
        "Villanacaob",
    ] },
    { province: "Quezon", city: "Calauag", barangayList: [
        "Agoho",
        "Anahawan",
        "Anas",
        "Apad Lutao",
        "Apad Quezon",
        "Apad Taisan",
        "Atulayan",
        "Baclaran (Poblacion)",
        "Bagong Silang",
        "Balibago",
        "Bangkuruhan",
        "Bantolinao",
        "Barangay Uno (Poblacion)",
        "Barangay Dos (Poblacion)",
        "Barangay Tres (Poblacion)",
        "Barangay Cuatro (Poblacion)",
        "Barangay Cinco (Poblacion)",
        "Bigaan",
        "Binutas (Santa Brigida)",
        "Biyan",
        "Bukal",
        "Buli",
        "Dapdap",
        "Dominlog",
        "Doña Aurora",
        "Guinosayan",
        "Ipil",
        "Kalibo (Santa Cruz)",
        "Kapaluhan",
        "Katangtang",
        "Kigtan",
        "Kinamaligan",
        "Kinalin Ibaba",
        "Kinalin Ilaya",
        "Kumaludkud",
        "Kunalum",
        "Kuyaoyao",
        "Lagay",
        "Lainglaingan",
        "Lungib",
        "Mabini",
        "Madlangdungan",
        "Maglipad (Rosario)",
        "Maligaya",
        "Mambaling",
        "Manhulugin",
        "Marilag (Punaya)",
        "Mulay",
        "Pandanan",
        "Pansol",
        "Patihan",
        "Pinagbayanan (Poblacion)",
        "Pinagkamaligan (Poblacion)",
        "Pinagsakayan",
        "Pinagtalleran (Poblacion)",
        "Rizal Ibaba",
        "Rizal Ilaya",
        "Sabang Uno (Poblacion)",
        "Sabang Dos (Poblacion)",
        "Salvacion",
        "San Quintin",
        "San Roque Ibaba",
        "San Roque Ilaya",
        "Santa Cecilia",
        "Santa Maria (Poblacion)",
        "Santa Milagrosa",
        "Santa Rosa",
        "Santo Angel (Pangahoy)",
        "Santo Domingo",
        "Sinag",
        "Sumilang",
        "Sumulong",
        "Tabansak",
        "Talingting",
        "Tamis",
        "Tikiwan",
        "Tiniguiban",
        "Villa Magsino",
        "Villa San Isidro",
        "Viñas",
        "Yaganak",
    ] },
    { province: "Quezon", city: "Guinayangan", barangayList: [
        "A. Mabini",
        "Aloneros",
        "Arbismen",
        "Bagong Silang",
        "Balinarin",
        "Bukal Maligaya",
        "Cabibihan",
        "Cabong Norte",
        "Cabong Sur",
        "Calimpak",
        "Capuluan Central",
        "Capuluan Tulon",
        "Dancalan Caimawan",
        "Dancalan Central",
        "Danlagan Batis",
        "Danlagan Cabayao",
        "Danlagan Central",
        "Danlagan Reserva",
        "Del Rosario",
        "Dungawan Central",
        "Dungawan Paalyunan",
        "Dungawan Pantay",
        "Ermita",
        "Gapas",
        "Himbubulo Este",
        "Himbubulo Weste",
        "Hinabaan",
        "Ligpit Bantayan",
        "Lubigan",
        "Magallanes",
        "Magsaysay",
        "Manggagawa",
        "Manggalang",
        "Manlayo",
        "Poblacion",
        "Salacan",
        "San Antonio",
        "San Isidro",
        "San Jose",
        "San Lorenzo",
        "San Luis I",
        "San Luis II",
        "San Miguel",
        "San Pedro I",
        "San Pedro II",
        "San Roque",
        "Santa Cruz",
        "Santa Maria",
        "Santa Teresita",
        "Sintones",
        "Sisi",
        "Tikay",
        "Triumpo",
        "Villa Hiwasayan",
    ] },
    { province: "Quezon", city: "Tagkawayan", barangayList: [
        "Aldavoc",
        "Aliji",
        "Bagong Silang",
        "Bambán",
        "Bosigon",
        "Bukál",
        "Cabuguang",
        "Cagascas",
        "Casispalan",
        "Colong-colong",
        "Del Rosario",
        "Cabibihan",
        "Candalapdap",
        "Katimo",
        "Kinatakutan",
        "Landing",
        "Laurel",
        "Magsaysáy",
        "Maguibuay",
        "Mahinta",
        "Malbog",
        "Manato Central",
        "Manato Station",
        "Mangayao",
        "Mansilay",
        "Mapulot",
        "Muntíng Parang",
        "Payapà",
        "Población",
        "Rizal",
        "Sabang",
        "San Diego",
        "San Francisco",
        "San Isidro",
        "San Roque",
        "San Vicente",
        "Santa Cecilia",
        "Santa Monica",
        "Santo Niño I",
        "Santo Niño II",
        "Santo Tomás",
        "Seguiwan",
        "Tabason",
        "Tunton",
        "Victoria",
    ] },
    { province: "Quirino", city: "Aglipay", barangayList: [
        "Dagupan",
        "Dumabel",
        "Dungo (Osmeña)",
        "Guinalbin",
        "Ligaya",
        "Palacian",
        "Pinaripad Sur",
        "Progreso (Poblacion)",
        "Ramos",
        "Rang-ayan",
        "San Antonio",
        "San Francisco",
        "San Leonardo",
        "San Ramon",
        "Victoria",
        "Villa Pagaduan",
        "Villa Santiago",
        "Alicia",
        "Cabugao",
        "Diodol",
        "Nagabgaban",
        "Pinaripad Norte",
        "San Benigno",
        "San Manuel",
        "Villa Ventura",
    ] },
    { province: "Quirino", city: "Cabarroguis", barangayList: [
        "Banuar",
        "Burgos",
        "Calaocan",
        "Del Pilar",
        "Dibibi",
        "Dingasan",
        "Eden",
        "Gomez",
        "Gundaway",
        "Mangandingay",
        "San Marcos",
        "Santo Domingo",
        "Tucod",
        "Villa Peña",
        "Villamor",
        "Villarose",
        "Zamora",
    ] },
    { province: "Quirino", city: "Diffun", barangayList: [
        "Andres Bonifacio (Poblacion)",
        "Aurora East (Poblacion)",
        "Aurora West (Poblacion)",
        "Baguio Village",
        "Balagbag",
        "Bannawag",
        "Cajel",
        "Campamento",
        "Diego Silang",
        "Sittio Der-an",
        "Don Mariano Perez, Sr.",
        "Doña Imelda",
        "Dumanisi",
        "Gabriela Silang",
        "Gulac",
        "Guribang",
        "Ifugao Village",
        "Isidro Paredes",
        "Rizal (Poblacion)",
        "Liwayway",
        "Luttuad",
        "Magsaysay",
        "Makate",
        "Maria Clara",
        "Rafael Palma (Don Sergio Osm)",
        "Ricarte Norte",
        "Ricarte Sur",
        "San Antonio",
        "San Isidro",
        "San Pascual",
        "Villa Pascua",
        "Aklan Village",
        "Gregorio Pimentel",
        "Don Faustino Pagaduan",
    ] },
    { province: "Quirino", city: "Maddela", barangayList: [
        "Abbag",
        "Balligui",
        "Buenavista",
        "Cabaruan",
        "Cabua-an",
        "Cofcaville",
        "Diduyon",
        "Dipintin",
        "Divisoria Norte",
        "Divisoria Sur (Bisangal)",
        "Dumabato Norte",
        "Dumabato Sur",
        "Lusod",
        "Manglad",
        "Pedlisan",
        "Poblacion Norte",
        "Poblacion Sur",
        "San Bernabe",
        "San Dionisio I",
        "San Martin",
        "San Pedro",
        "San Salvador",
        "Santo Niño",
        "Santo Tomas",
        "Villa Gracia",
        "Villa Hermosa Sur",
        "Villa Hermosa Norte",
        "Ysmael",
        "Villa Agullana",
        "Villa Jose V Ylanan",
        "Jose Ancheta",
        "Santa Maria",
    ] },
    { province: "Quirino", city: "Nagtipunan", barangayList: [
        "Anak",
        "Dipantan",
        "Dissimungal",
        "Guino (Giayan)",
        "Keat",
        "La Conwap (Guingin)",
        "Landingan",
        "Mataddi",
        "Matmad",
        "Ponggo (Urban)",
        "San Dionisio II",
        "San Pugo",
        "San Ramos",
        "Sangbay",
        "Wasid",
        "Asaklat",
    ] },
    { province: "Quirino", city: "Saguday", barangayList: [
        "Cardenas",
        "Dibul",
        "Gamis",
        "La Paz",
        "Magsaysay (Poblacion)",
        "Rizal (Poblacion)",
        "Salvacion",
        "Santo Tomas",
        "Tres Reyes",
    ] },
    { province: "Rizal", city: "Angono", barangayList: [
        "Bagumbayan",
        "Kalayaan",
        "Mahabang Parang",
        "Poblacion Ibaba",
        "Poblacion Itaas",
        "San Isidro",
        "San Pedro",
        "San Roque",
        "San Vicente",
        "Santo Niño",
    ] },
    { province: "Rizal", city: "Antipolo", barangayList: [
        "Bagong Nayon",
        "Beverly Hills",
        "Calawis",
        "Cupang",
        "Dalig",
        "Dela Paz (Poblacion)",
        "Inarawan",
        "Mambugan",
        "Mayamot",
        "Muntindilaw[24]",
        "San Isidro (Poblacion)",
        "San Jose (Poblacion)",
        "San Juan",
        "San Luis",
        "San Roque (Poblacion)",
        "Santa Cruz",
    ] },
    { province: "Rizal", city: "Baras", barangayList: [
        "Evangelista",
        "Rizal (Poblacion)",
        "San Jose",
        "San Salvador",
        "Santiago",
        "Concepcion",
        "San Juan",
        "San Miguel",
        "Mabini",
        "Pinugay",
    ] },
    { province: "Rizal", city: "Binangonan", barangayList: [
        "Bangad",
        "Batingan",
        "Bilibiran",
        "Binitagan",
        "Bombong",
        "Buhangin",
        "Calumpang",
        "Ginoong Sanay",
        "Gulod",
        "Habagatan",
        "Ithan",
        "Janosa",
        "Kalawaan",
        "Kalinawan",
        "Kasile",
        "Kaytome",
        "Kinaboogan",
        "Kinagatan",
        "Layunan",
        "Libid",
        "Libis",
        "Limbon-limbon",
        "Lunsad",
        "Macamot",
        "Mahabang Parang",
        "Malakaban",
        "Mambog",
        "Pag-asa",
        "Palangoy",
        "Pantok",
        "Pila Pila",
        "Pinagdilawan",
        "Pipindan",
        "Rayap",
        "San Carlos",
        "Sapang",
        "Tabon",
        "Tagpos",
        "Tatala",
        "Tayuman",
    ] },
    { province: "Rizal", city: "Cainta", barangayList: [
        "San Andres (Pob.)",
        "San Isidro",
        "San Juan",
        "San Roque",
        "Santa Rosa",
        "Santo Domingo",
        "Santo Niño",
    ] },
    { province: "Rizal", city: "Cardona", barangayList: [
        "Calahan",
        "Dalig",
        "Del Remedio",
        "Iglesia",
        "Looc",
        "Nagsulo",
        "Patunhay",
        "Real (Poblacion)",
        "Sampad",
        "San Roque (Poblacion)",
        "Ticulio",
        "Balibago",
        "Boor",
        "Lambac",
        "Malanggam-Calubacan",
        "Navotas",
        "Subay",
        "Tuna",
    ] },
    { province: "Rizal", city: "Jalajala", barangayList: [
        "Bagumbong",
        "Bayugo",
        "Second District (Poblacion)",
        "Third District (Poblacion)",
        "Lubo",
        "Pagkalinawan",
        "Palaypalay",
        "Punta",
        "Sipsipin",
        "First (Special) District (Poblacion)",
        "Paalaman",
    ] },
    { province: "Rizal", city: "Morong", barangayList: [
        "Bombongan",
        "Caniogan-Calero-Lanang (CCL)",
        "Lagundi",
        "Maybancal",
        "San Guillermo/ San Guilmo",
        "San Pedro (Poblacion)",
        "San Jose (Poblacion)",
        "San Juan (Poblacion)",
    ] },
    { province: "Rizal", city: "Pililla", barangayList: [
        "Bagumbayan (Poblacion)",
        "Halayhayin",
        "Hulo (Poblacion)",
        "Imatong (Poblacion)",
        "Malaya",
        "Niogan",
        "Quisao",
        "Wawa (Poblacion)",
        "Takungan (Poblacion)",
    ] },
    { province: "Rizal", city: "Rodriguez", barangayList: [
        "Balite",
        "Burgos",
        "Geronimo",
        "Macabud",
        "Manggahan",
        "Mascap",
        "Puray",
        "Rosario",
        "San Isidro",
        "San Jose",
        "San Rafael",
    ] },
    { province: "Rizal", city: "San Mateo", barangayList: [
        "Ampid 1",
        "Ampid 2",
        "Banaba",
        "Dulong Bayan 1",
        "Dulong Bayan 2",
        "Guinayang",
        "Guitnang Bayan 1",
        "Guitnang Bayan 2",
        "Gulod Malaya",
        "Malanday",
        "Maly",
        "Pintong Bukawe",
        "Santa Ana",
        "Santo Niño",
        "Silangan",
    ] },
    { province: "Rizal", city: "Tanay", barangayList: [
        "Cayabu",
        "Cuyambay",
        "Daraitan",
        "Katipunan-Bayani (Pob.)",
        "Kay Buto (Poblacion)",
        "Laiban",
        "Mag-Ampon (Poblacion)",
        "Mamuyao",
        "Madilay-dilay[9]",
        "Pinagkamaligan (Poblacion)",
        "Plaza Aldea (Poblacion)",
        "Sampaloc",
        "San Andres[10][11]",
        "San Isidro (Poblacion)",
        "Santa Inez",
        "Santo Niño",
        "Tabing Ilog (Poblacion)",
        "Tandang Kutyo (Poblacion)",
        "Tinucan",
        "Wawa (Poblacion)",
    ] },
    { province: "Rizal", city: "Taytay", barangayList: [
        "Dolores (Poblacion)",
        "Barangay Muzon",
        "San Isidro",
        "San Juan",
        "Santa Ana",
    ] },
    { province: "Rizal", city: "Teresa", barangayList: [
        "Bagumbayan",
        "Dalig",
        "Dulumbayan",
        "May-Iba",
        "Poblacion",
        "Prinza",
        "San Gabriel",
        "San Roque",
        "Calumpang Santo Cristo",
    ] },
    // { province: "Romblon", city: "", barangayList: [] },
    // { province: "Samar", city: "", barangayList: [] },
    // { province: "Sarangani", city: "", barangayList: [] },
    // { province: "Siquijor", city: "", barangayList: [] },
    // { province: "Sorsogon", city: "", barangayList: [] },
    // { province: "South Cotabato", city: "", barangayList: [] },
    { province: "Southern Leyte", city: "Anahawan", barangayList: [
        "Amagusan",
        "Calintaan",
        "Canlabian",
        "Capacuhan",
        "Kagingkingan",
        "Lewing",
        "Lo-ok",
        "Mahalo",
        "Mainit",
        "Manigawong",
        "Poblacion",
        "San Vicente",
        "Tagup-on",
        "Cogon",
    ] },
    { province: "Southern Leyte", city: "Bontoc", barangayList: [
        "Anahao",
        "Banahao",
        "Baugo",
        "Beniton",
        "Buenavista",
        "Bunga",
        "Casao",
        "Catmon",
        "Catoogan",
        "Cawayanan",
        "Dao",
        "Divisoria",
        "Esperanza",
        "Guinsangaan",
        "Hibagwan",
        "Hilaan",
        "Himakilo",
        "Hitawos",
        "Lanao",
        "Lawgawan",
        "Mahayahay",
        "Malbago",
        "Mauylab",
        "Olisihan",
        "Paku",
        "Pamahawan",
        "Pamigsian",
        "Pangi",
        "Poblacion",
        "Pong-on",
        "Sampongon",
        "San Ramon",
        "San Vicente",
        "Santa Cruz",
        "Santo Niño",
        "Taa",
        "Talisay",
        "Taytagan",
        "Tuburan",
        "Union",
    ] },
    { province: "Southern Leyte", city: "Hinunangan", barangayList: [
        "Ambacon",
        "Badiangon",
        "Bangcas A",
        "Bangcas B",
        "Biasong",
        "Bugho",
        "Calag-itan",
        "Calayugan",
        "Calinao",
        "Canipaan",
        "Catublian",
        "Ilaya",
        "Ingan",
        "Labrador",
        "Libas",
        "Lumbog",
        "Manalog",
        "Manlico",
        "Matin-ao",
        "Nava",
        "Nueva Esperanza",
        "Otama",
        "Palongpong",
        "Panalaron",
        "Patong",
        "Poblacion",
        "Pondol",
        "Salog",
        "Salvacion",
        "San Pablo Island",
        "San Pedro Island",
        "Santo Niño I",
        "Santo Niño II",
        "Tahusan",
        "Talisay",
        "Tawog",
        "Toptop",
        "Tuburan",
        "Union",
        "Upper Bantawon",
    ] },
    { province: "Southern Leyte", city: "Hinundayan", barangayList: [
        "Amaga",
        "Ambao",
        "An-an",
        "Baculod",
        "Biasong",
        "Bugho (Green Valley)",
        "Cabulisan",
        "Cat-iwing",
        "District I (Poblacion)",
        "District II (Poblacion)",
        "District III (Poblacion)",
        "Hubasan",
        "Lungsodaan",
        "Navalita",
        "Plaridel",
        "Sabang",
        "Sagbok",
    ] },
    { province: "Southern Leyte", city: "Libagon", barangayList: [
        "Biasong",
        "Bogasong",
        "Cawayan",
        "Gakat",
        "Jubas (Poblacion)",
        "Magkasag",
        "Mayuga",
        "Nahaong",
        "Nahulid",
        "Otikon",
        "Pangi",
        "Punta",
        "Talisay (Poblacion)",
        "Tigbao",
    ] },
    { province: "Southern Leyte", city: "Liloan", barangayList: [
        "Amaga",
        "Anilao",
        "Bahay",
        "Cagbungalon",
        "Cali-an",
        "Fatima",
        "Caligangan",
        "Catig/Caritas Village",
        "Candayuman",
        "Estela",
        "Gud-an",
        "Guintoylan",
        "Himayangan",
        "Ilag",
        "Magaupas",
        "Malangsa",
        "Pres. Quezon (Maugoc)",
        "Molopolo",
        "Pandan",
        "Poblacion",
        "President Roxas (Nailong)",
        "San Isidro",
        "San Roque",
        "Tabugon",
    ] },
    { province: "Southern Leyte", city: "Limasawa", barangayList: [
        "Cabulihan",
        "Lugsongan",
        "Magallanes (Poblacion)",
        "San Agustin (Tawid)",
        "San Bernardo (Tigib)",
        "Triana",
    ] },
    // { province: "Southern Leyte", city: "Maasin", barangayList: [] },
    { province: "Southern Leyte", city: "Macrohon", barangayList: [
        "Aguinaldo",
        "Amparo",
        "Asuncion",
        "Bagong Silang",
        "Buscayan",
        "Cambaro",
        "Canlusay",
        "Danao",
        "Flordeliz",
        "Guadalupe",
        "Ichon",
        "Ilihan",
        "Laray",
        "Lower Villa Jacinta",
        "Mabini",
        "Mohon",
        "Molopolo",
        "Rizal",
        "Salvador",
        "San Isidro",
        "San Joaquin",
        "San Roque",
        "San Vicente (Poblacion)",
        "San Vicente (Upper San Roque)",
        "Santa Cruz (Poblacion)",
        "Santo Niño",
        "Santo Rosario (Poblacion)",
        "Sindangan",
        "Upper Ichon (Lumbang)",
        "Upper Villa Jacinta",
    ] },
    { province: "Southern Leyte", city: "Malitbog", barangayList: [
        "Abgao",
        "Aurora",
        "Benit",
        "Caaga",
        "Cabul-anonan (Poblacion)(people call this Tondo)",
        "Cadaruhan",
        "Candatag",
        "Cantamuac",
        "Caraatan",
        "Concepcion",
        "Guinabonan",
        "Iba",
        "Lambonao",
        "Maningning",
        "Maujo",
        "Pasil (Poblacion)",
        "Sabang",
        "San Antonio (Poblacion)",
        "San Isidro",
        "Santo Niño",
        "San Jose",
        "San Roque",
        "San Vicente",
        "Sangahon",
        "Santa Cruz",
        "Taliwa (Poblacion)",
        "Tigbawan I",
        "Tigbawan II",
        "Timba",
        "Asuncion",
        "Cadaruhan Sur",
        "Fatima",
        "Juangon",
        "Kauswagan",
        "Mahayahay",
        "New Katipunan",
        "Pancil",
    ] },
    { province: "Southern Leyte", city: "Padre Burgos", barangayList: [
        "Buenavista",
        "Bunga",
        "Cantutang",
        "Dinahugan",
        "Laca",
        "Lungsodaan",
        "Poblacion",
        "San Juan",
        "Santa Sofia",
        "Santo Rosario",
        "Tangkaan",
    ] },
    { province: "Southern Leyte", city: "Pintuyan", barangayList: [
        "Nueva Estrella Norte",
        "Nueva Estrella Sur",
        "Dan-an",
        "Catbawan",
        "Manglit",
        "Son-ok I",
        "Son-ok II",
        "Caubang",
        "Ponod",
        "Poblacion Ibabao",
        "Poblacion Ubos",
        "Buenavista",
        "Badiang",
        "Balongbalong",
        "Bulawan",
        "Canlawis",
        "Cogon",
        "Lobo",
        "Mainit",
        "Tautag",
        "Ponciano D. Equipilag",
        "San Roque",
        "Santa Cruz",
    ] },
    { province: "Southern Leyte", city: "Saint Bernard", barangayList: [
        "Atuyan",
        "Ayahag",
        "Bantawon ",
        "Bolodbolod",
        "Nueva Esperanza (Cabac-an)",
        "Cabagawan (Maria Asuncion)",
        "Carnaga",
        "Catmon",
        "Guinsaugon",
        "Himatagon (Poblacion)",
        "Himbangan",
        "Himos-onan",
        "Hinabian",
        "Hindag-an",
        "Kauswagan ",
        "Libas",
        "Lipanto",
        "Magatas",
        "Magbagacay",
        "Mahayag",
        "Mahayahay",
        "Malibago",
        "Malinao",
        "New Guinsaugon",
        "Panian",
        "San Isidro",
        "Santa Cruz",
        "Sug-angon ",
        "Tabon-tabon",
        "Tambis I",
        "Tambis II",
    ] },
    { province: "Southern Leyte", city: "San Francisco", barangayList: [
        "Anislagon",
        "Bongbong",
        "Central (Poblacion)",
        "Dakit (Poblacion)",
        "Habay",
        "Marayag",
        "Napantao",
        "Pinamudlan",
        "Santa Paz Norte",
        "Santa Paz Sur",
        "Sudmon",
        "Tinaan",
        "Tuno",
        "Ubos (Poblacion)",
        "Bongawisan",
        "Cuasi",
        "Gabi",
        "Cahayag",
        "Malico",
        "Pasanon",
        "Punta",
        "Santa Cruz",
    ] },
    { province: "Southern Leyte", city: "San Juan (Cabalian)", barangayList: [
        "Agay-ay",
        "Basak",
        "Bobon A",
        "Bobon B",
        "Dayanog",
        "Garrido",
        "Minoyho",
        "Osao",
        "Pong-oy",
        "San Jose (Poblacion)",
        "San Roque",
        "San Vicente",
        "Santa Cruz (Poblacion)",
        "Santa Filomena",
        "Santo Niño (Poblacion)",
        "Somoje",
        "Sua",
        "Timba",
    ] },
    { province: "Southern Leyte", city: "San Ricardo", barangayList: [
        "Benit",
        "Bitoon",
        "Cabutan",
        "Camang",
        "Esperanza",
        "Pinut-an",
        "Poblacion (Santiago)",
        "San Antonio (Alangalang)",
        "San Ramon",
        "Saub",
        "Timba",
        "Esperanza Dos",
        "Kinachawa",
        "Inolinan",
        "Looc",
        "Demog",
    ] },
    { province: "Southern Leyte", city: "Silago", barangayList: [
        "Balagawan",
        "Catmon",
        "Hingatungan",
        "Imelda",
        "Katipunan",
        "Laguma",
        "Mercedes",
        "Poblacion District I",
        "Poblcaion District II",
        "Puntana",
        "Salvacion",
        "Sap-ang",
        "Sudmon",
        "Tuba-on",
        "Tubod",
    ] },
    { province: "Southern Leyte", city: "Sogod", barangayList: [
        "Benit",
        "Buac Daku",
        "Buac Gamay",
        "Cabadbaran",
        "Concepcion",
        "Consolacion",
        "Dagsa",
        "Hibod-hibod",
        "Hindangan",
        "Hipantag",
        "Javier",
        "Kahupian",
        "Kanangkaan",
        "Kauswagan",
        "La Purisima Concepcion",
        "Libas",
        "Lum-an",
        "Mabicay",
        "Mac",
        "Magatas",
        "Mahayahay",
        "Malinao",
        "Maria Plana",
        "Milagroso",
        "Olisihan",
        "Pancho Villa",
        "Pandan",
        "Rizal",
        "Salvacion",
        "San Francisco Mabuhay",
        "San Isidro",
        "San Jose",
        "San Juan",
        "San Miguel",
        "San Pedro",
        "San Roque",
        "San Vicente",
        "Santa Maria",
        "Suba",
        "Tampoong",
        "Zone I",
        "Zone II",
        "Zone III",
        "Zone IV",
        "Zone V",
    ] },
    { province: "Southern Leyte", city: "Tomas Oppus", barangayList: [
        "Anahawan",
        "Banday (Poblacion)",
        "Biasong",
        "Bogo (Poblacion)",
        "Cabascan",
        "Camansi",
        "Cambite",
        "Canlupao",
        "Carnaga",
        "Cawayan",
        "Higosoan",
        "Hinagtikan",
        "Hinapo",
        "Hugpa",
        "Iniguihan",
        "Looc",
        "Luan",
        "Maanyag",
        "Mag-ata",
        "Mapgap",
        "Maslog",
        "Ponong",
        "Rizal",
        "San Agustin (Lotaw)",
        "San Antonio (Calayugan)",
        "San Isidro",
        "San Miguel",
        "San Roque",
        "Tinago",
    ] },
    // { province: "Sultan Kudarat", city: "", barangayList: [] },
    // { province: "Sulu", city: "", barangayList: [] },
    // { province: "Surigao del Norte", city: "", barangayList: [] },
    // { province: "Surigao del Sur", city: "", barangayList: [] },
    // { province: "Tarlac", city: "", barangayList: [] },
    // { province: "Tawi-Tawi", city: "", barangayList: [] },
    { province: "Zambales", city: "Botolan", barangayList: [
        "Bancal",
        "Bangan",
        "Batonlapoc",
        "Belbel",
        "Beneg",
        "Binuclutan",
        "Burgos",
        "Cabatuan",
        "Capayawan",
        "Carael",
        "Danacbunga",
        "Maguisguis",
        "Malomboy",
        "Mambog",
        "Moraza",
        "Nacolcol",
        "Owaog-Nibloc",
        "Paco",
        "Palis",
        "Panan",
        "Parel",
        "Paudpod",
        "Poonbato",
        "Porac",
        "San Isidro",
        "San Juan",
        "San Miguel",
        "Santiago",
        "Tampo",
        "Taugtog",
        "Villar",
    ] },
    { province: "Zambales", city: "Cabangan", barangayList: [
        "Anonang",
        "Apo-apo",
        "Arew",
        "Banuambayo",
        "Cadmang-Reserva",
        "Camiling",
        "Casabaan",
        "Del Carmen",
        "Dolores",
        "Felmida-Diaz",
        "Laoag",
        "Lomboy",
        "Longos",
        "Mabanglit",
        "New San Juan",
        "San Antonio",
        "San Isidro",
        "San Juan",
        "San Rafael",
        "Santa Rita",
        "Santo Niño",
        "Tondo",
    ] },
    { province: "Zambales", city: "Candelaria", barangayList: [
        "Babancal",
        "Binabalian",
        "Catol",
        "Dampay",
        "Lauis",
        "Libertador",
        "Malabon (San Roque)",
        "Malimanga",
        "Pamibian",
        "Panayonan",
        "Pinagrealan",
        "Poblacion",
        "Sinabacan",
        "Taposo",
        "Uacon",
        "Yamot",
    ] },
    { province: "Zambales", city: "Castillejos", barangayList: [
        "Balaybay",
        "Buenavista",
        "Del Pilar",
        "Looc",
        "Magsaysay",
        "Nagbayan",
        "Nagbunga",
        "San Agustin",
        "San Jose (Poblacion)",
        "San Juan (Poblacion)",
        "San Nicolas",
        "San Pablo (Poblacion)",
        "San Roque",
        "Santa Maria",
    ] },
    { province: "Zambales", city: "Iba", barangayList: [
        "Amungan (partly urban)",
        "Bangantalinga (rural)",
        "Dirita-Baloguen (partly urban)",
        "Lipay-Dingin-Panibuatan (rural)",
        "Palanginan (highly urban)",
        "San Agustin (rural)",
        "Santa Barbara (rural)",
        "Santo Rosario (rural)",
        "Zone 1 Pob. (highly urban)",
        "Zone 2 Pob. (urban)",
        "Zone 3 Pob. (urban)",
        "Zone 4 Pob. (urban)",
        "Zone 5 Pob. (urban)",
        "Zone 6 Pob. (urban)",
    ] },
    { province: "Zambales", city: "Masinloc", barangayList: [
        "Baloganon",
        "Bamban",
        "Bani",
        "Collat",
        "Inhobol",
        "North Poblacion",
        "San Lorenzo",
        "San Salvador",
        "Santa Rita",
        "Santo Rosario",
        "South Poblacion",
        "Taltal",
        "Tapuac",
    ] },
    { province: "Zambales", city: "Olongapo", barangayList: [
        "New Asinan",
        "New Banicain",
        "Barretto",
        "East Bajac-bajac",
        "East Tapinac",
        "Gordon Heights",
        "Kalaklan",
        "Mabayuan",
        "New Cabalan",
        "New Ilalim",
        "New Kababae",
        "New Kalalake",
        "Old Cabalan",
        "Pag-asa",
        "Santa Rita",
        "West Bajac-bajac",
        "West Tapinac",
    ] },
    { province: "Zambales", city: "Palauig", barangayList: [
        "Alwa",
        "Bato",
        "Bulawen",
        "Cauyan",
        "East Poblacion",
        "Garreta",
        "Libaba",
        "Liozon",
        "Lipay",
        "Locloc",
        "Macarang",
        "Magalawa",
        "Pangolingan",
        "Salaza",
        "San Juan",
        "Santo Niño",
        "Santo Tomas",
        "San Vicente",
        "West Poblacion",
    ] },
    { province: "Zambales", city: "San Antonio", barangayList: [
        "Angeles",
        "Antipolo",
        "Burgos (Poblacion)",
        "East Dirita",
        "Luna (Poblacion)",
        "Pundaquit",
        "Rizal (Poblacion) (Sentro Pueblo)",
        "San Esteban",
        "San Gregorio (Poblacion)",
        "San Juan (Poblacion) (Sitio Mabanban)",
        "San Miguel",
        "San Nicolas (Poblacion)",
        "Santiago (Poblacion) (Pamatawan)",
        "West Dirita",
    ] },
    { province: "Zambales", city: "San Felipe", barangayList: [
        "Amagna (Poblacion)",
        "Apostol (Poblacion)",
        "Balincaguing",
        "Farañal (Poblacion)",
        "Feria (Poblacion)",
        "Maloma",
        "Manglicmot (Poblacion)",
        "Rosete (Poblacion)",
        "San Rafael",
        "Santo Niño",
        "Sindol",
    ] },
    { province: "Zambales", city: "San Marcelino", barangayList: [
        "Aglao",
        "Buhawen",
        "Burgos (Poblacion)",
        "Central (Poblacion)",
        "Consuelo Norte",
        "Consuelo Sur (Poblacion)",
        "La Paz (Poblacion)",
        "Laoag",
        "Linasin",
        "Linusungan",
        "Lucero (Poblacion)",
        "Nagbunga",
        "Rabanes",
        "Rizal (Poblacion)",
        "San Guillermo (Poblacion)",
        "San Isidro (Poblacion)",
        "San Rafael",
        "Santa Fe",
    ] },
    { province: "Zambales", city: "San Narciso", barangayList: [
        "Alusiis",
        "Beddeng",
        "Candelaria (Poblacion)",
        "Dallipawen",
        "Grullo",
        "La Paz",
        "Libertad (Poblacion)",
        "Namatacan",
        "Natividad (Poblacion)",
        "Omaya",
        "Paite",
        "Patrocinio (Poblacion)",
        "San Jose (Poblacion)",
        "San Juan (Poblacion)",
        "San Pascual (Poblacion)",
        "San Rafael (Poblacion)",
        "Siminublan",
    ] },
    { province: "Zambales", city: "Santa Cruz", barangayList: [
        "Babuyan",
        "Bangcol",
        "Bayto",
        "Biay",
        "Bolitoc",
        "Bulawon",
        "Canaynayan",
        "Gama",
        "Guinabon",
        "Guisguis",
        "Lipay",
        "Lomboy",
        "Lucapon North",
        "Lucapon South",
        "Malabago",
        "Naulo",
        "Pagatpat",
        "Pamonoran",
        "Poblacion North",
        "Poblacion South",
        "Sabang",
        "San Fernando",
        "Tabalong",
        "Tubotubo North",
        "Tubotubo South",
    ] },
    { province: "Zambales", city: "Subic", barangayList: [
        "Aningway-Sacatihan",
        "Asinan (Poblacion)",
        "Asinan Proper",
        "Baraca-Camachile (Poblacion)",
        "Batiawan",
        "Calapacuan",
        "Calapandayan (Poblacion)",
        "Cawag",
        "Ilwas (Poblacion)",
        "Mangan-Vaca",
        "Matain",
        "Naugsol",
        "Pamatawan",
        "San Isidro",
        "Santo Tomas",
        "Wawandue (Poblacion)",
    ] },
    // { province: "Zamboanga del Norte", city: "", barangayList: [] },
    // { province: "Zamboanga del Sur", city: "", barangayList: [] },
    // { province: "Zamboanga Sibugay", city: "", barangayList: [] },
    { province: "Metro Manila", city: "Caloocan", barangayList: [
        "Barangay 1",
        "Barangay 10",
        "Barangay 100",
        "Barangay 101",
        "Barangay 102",
        "Barangay 103",
        "Barangay 104",
        "Barangay 105",
        "Barangay 106",
        "Barangay 107",
        "Barangay 108",
        "Barangay 109",
        "Barangay 11",
        "Barangay 110",
        "Barangay 111",
        "Barangay 112",
        "Barangay 113",
        "Barangay 114",
        "Barangay 115",
        "Barangay 116",
        "Barangay 117",
        "Barangay 118",
        "Barangay 119",
        "Barangay 12",
        "Barangay 120",
        "Barangay 121",
        "Barangay 122",
        "Barangay 123",
        "Barangay 124",
        "Barangay 125",
        "Barangay 126",
        "Barangay 127",
        "Barangay 128",
        "Barangay 129",
        "Barangay 13",
        "Barangay 130",
        "Barangay 131",
        "Barangay 132",
        "Barangay 133",
        "Barangay 134",
        "Barangay 135",
        "Barangay 136",
        "Barangay 137",
        "Barangay 138",
        "Barangay 139",
        "Barangay 14",
        "Barangay 140",
        "Barangay 141",
        "Barangay 142",
        "Barangay 143",
        "Barangay 144",
        "Barangay 145",
        "Barangay 146",
        "Barangay 147",
        "Barangay 148",
        "Barangay 149",
        "Barangay 15",
        "Barangay 150",
        "Barangay 151",
        "Barangay 152",
        "Barangay 153",
        "Barangay 154",
        "Barangay 155",
        "Barangay 156",
        "Barangay 157",
        "Barangay 158",
        "Barangay 159",
        "Barangay 16",
        "Barangay 160",
        "Barangay 161",
        "Barangay 162",
        "Barangay 163",
        "Barangay 164",
        "Barangay 165",
        "Barangay 166",
        "Barangay 167",
        "Barangay 168",
        "Barangay 169",
        "Barangay 17",
        "Barangay 170",
        "Barangay 171",
        "Barangay 172",
        "Barangay 173",
        "Barangay 174",
        "Barangay 175",
        "Barangay 176",
        "Barangay 177",
        "Barangay 178",
        "Barangay 179",
        "Barangay 18",
        "Barangay 180",
        "Barangay 181",
        "Barangay 182",
        "Barangay 183",
        "Barangay 184",
        "Barangay 185",
        "Barangay 186",
        "Barangay 187",
        "Barangay 188",
        "Barangay 19",
        "Barangay 2",
        "Barangay 20",
        "Barangay 21",
        "Barangay 22",
        "Barangay 23",
        "Barangay 24",
        "Barangay 25",
        "Barangay 26",
        "Barangay 27",
        "Barangay 28",
        "Barangay 29",
        "Barangay 3",
        "Barangay 30",
        "Barangay 31",
        "Barangay 32",
        "Barangay 33",
        "Barangay 34",
        "Barangay 35",
        "Barangay 36",
        "Barangay 37",
        "Barangay 38",
        "Barangay 39",
        "Barangay 4",
        "Barangay 40",
        "Barangay 41",
        "Barangay 42",
        "Barangay 43",
        "Barangay 44",
        "Barangay 45",
        "Barangay 46",
        "Barangay 47",
        "Barangay 48",
        "Barangay 49",
        "Barangay 5",
        "Barangay 50",
        "Barangay 51",
        "Barangay 52",
        "Barangay 53",
        "Barangay 54",
        "Barangay 55",
        "Barangay 56",
        "Barangay 57",
        "Barangay 58",
        "Barangay 59",
        "Barangay 6",
        "Barangay 60",
        "Barangay 61",
        "Barangay 62",
        "Barangay 63",
        "Barangay 64",
        "Barangay 65",
        "Barangay 66",
        "Barangay 67",
        "Barangay 68",
        "Barangay 69",
        "Barangay 7",
        "Barangay 70",
        "Barangay 71",
        "Barangay 72",
        "Barangay 73",
        "Barangay 74",
        "Barangay 75",
        "Barangay 76",
        "Barangay 77",
        "Barangay 78",
        "Barangay 79",
        "Barangay 8",
        "Barangay 80",
        "Barangay 81",
        "Barangay 82",
        "Barangay 83",
        "Barangay 84",
        "Barangay 85",
        "Barangay 86",
        "Barangay 87",
        "Barangay 88",
        "Barangay 89",
        "Barangay 9",
        "Barangay 90",
        "Barangay 91",
        "Barangay 92",
        "Barangay 93",
        "Barangay 94",
        "Barangay 95",
        "Barangay 96",
        "Barangay 97",
        "Barangay 98",
        "Barangay 99",
    ] },
    { province: "Metro Manila", city: "Las Piñas", barangayList: [
        "Almanza Dos",
        "Almanza Uno",
        "B. F. International Village",
        "Daniel Fajardo",
        "Elias Aldana",
        "Ilaya",
        "Manuyo Dos",
        "Manuyo Uno",
        "Pamplona Dos",
        "Pamplona Tres",
        "Pamplona Uno",
        "Pilar",
        "Pulang Lupa Dos",
        "Pulang Lupa Uno",
        "Talon Dos",
        "Talon Kuatro",
        "Talon Singko",
        "Talon Tres",
        "Talon Uno",
        "Zapote",
    ] },
    { province: "Metro Manila", city: "Makati", barangayList: [
        "Bangkal",
        "Bel-Air",
        "Carmona",
        "Cembo",
        "Comembo",
        "Dasmariñas",
        "East Rembo",
        "Forbes Park",
        "Guadalupe Nuevo",
        "Guadalupe Viejo",
        "Kasilawan",
        "La Paz",
        "Magallanes",
        "Olympia",
        "Palanan",
        "Pembo",
        "Pinagkaisahan",
        "Pio Del Pilar",
        "Pitogo",
        "Poblacion",
        "Post Proper Northside",
        "Post Proper Southside",
        "Rizal",
        "San Antonio",
        "San Isidro",
        "San Lorenzo",
        "Santa Cruz",
        "Singkamas",
        "South Cembo",
        "Tejeros",
        "Urdaneta",
        "Valenzuela",
        "West Rembo",
    ] },
    { province: "Metro Manila", city: "Malabon", barangayList: [
        "Acacia",
        "Baritan",
        "Bayan-Bayanan",
        "Catmon",
        "Concepcion",
        "Dampalit",
        "Flores",
        "Hulong Duhat",
        "Ibaba",
        "Longos",
        "Maysilo",
        "Muzon",
        "Niugan",
        "Panghulo",
        "Potrero",
        "San Agustin",
        "Santolan",
        "Tañong",
        "Tinajeros",
        "Tonsuya",
        "Tugatog",
    ] },
    { province: "Metro Manila", city: "Mandaluyong", barangayList: [
        "Addition Hills",
        "Bagong Silang",
        "Barangka Drive",
        "Barangka Ibaba",
        "Barangka Ilaya",
        "Barangka Itaas",
        "Buayang Bato",
        "Burol",
        "Daang Bakal",
        "Hagdang Bato Itaas",
        "Hagdang Bato Libis",
        "Harapin Ang Bukas",
        "Highway Hills",
        "Hulo",
        "Mabini-J. Rizal",
        "Malamig",
        "Mauway",
        "Namayan",
        "New Zañiga",
        "Old Zañiga",
        "Pag-asa",
        "Plainview",
        "Pleasant Hills",
        "Poblacion",
        "San Jose",
        "Vergara",
    ] },
    { province: "Metro Manila", city: "Manila City", barangayList: [
        "Barangay 287",
        "Barangay 288",
        "Barangay 289",
        "Barangay 290",
        "Barangay 291",
        "Barangay 292",
        "Barangay 293",
        "Barangay 294",
        "Barangay 295",
        "Barangay 296",
        "Barangay 659",
        "Barangay 659-A",
        "Barangay 660",
        "Barangay 660-A",
        "Barangay 661",
        "Barangay 663",
        "Barangay 663-A",
        "Barangay 664",
        "Barangay 666",
        "Barangay 667",
        "Barangay 668",
        "Barangay 669",
        "Barangay 670",
        "Barangay 654",
        "Barangay 655",
        "Barangay 656",
        "Barangay 657",
        "Barangay 658",
        "Barangay 688",
        "Barangay 689",
        "Barangay 690",
        "Barangay 691",
        "Barangay 692",
        "Barangay 693",
        "Barangay 694",
        "Barangay 695",
        "Barangay 696",
        "Barangay 697",
        "Barangay 698",
        "Barangay 699",
        "Barangay 700",
        "Barangay 701",
        "Barangay 702",
        "Barangay 703",
        "Barangay 704",
        "Barangay 705",
        "Barangay 706",
        "Barangay 707",
        "Barangay 708",
        "Barangay 709",
        "Barangay 710",
        "Barangay 711",
        "Barangay 712",
        "Barangay 713",
        "Barangay 714",
        "Barangay 715",
        "Barangay 716",
        "Barangay 717",
        "Barangay 718",
        "Barangay 719",
        "Barangay 720",
        "Barangay 721",
        "Barangay 722",
        "Barangay 723",
        "Barangay 724",
        "Barangay 725",
        "Barangay 726",
        "Barangay 727",
        "Barangay 728",
        "Barangay 729",
        "Barangay 730",
        "Barangay 731",
        "Barangay 732",
        "Barangay 733",
        "Barangay 734",
        "Barangay 735",
        "Barangay 736",
        "Barangay 737",
        "Barangay 738",
        "Barangay 739",
        "Barangay 740",
        "Barangay 741",
        "Barangay 742",
        "Barangay 743",
        "Barangay 744",
        "Barangay 662",
        "Barangay 664-A",
        "Barangay 671",
        "Barangay 672",
        "Barangay 673",
        "Barangay 674",
        "Barangay 675",
        "Barangay 676",
        "Barangay 677",
        "Barangay 678",
        "Barangay 679",
        "Barangay 680",
        "Barangay 681",
        "Barangay 682",
        "Barangay 683",
        "Barangay 684",
        "Barangay 685",
        "Barangay 686",
        "Barangay 687",
        "Barangay 809",
        "Barangay 810",
        "Barangay 811",
        "Barangay 812",
        "Barangay 813",
        "Barangay 814",
        "Barangay 815",
        "Barangay 816",
        "Barangay 817",
        "Barangay 818",
        "Barangay 819",
        "Barangay 820",
        "Barangay 821",
        "Barangay 822",
        "Barangay 823",
        "Barangay 824",
        "Barangay 825",
        "Barangay 826",
        "Barangay 827",
        "Barangay 828",
        "Barangay 829",
        "Barangay 830",
        "Barangay 831",
        "Barangay 832",
        "Barangay 833",
        "Barangay 834",
        "Barangay 835",
        "Barangay 836",
        "Barangay 837",
        "Barangay 838",
        "Barangay 839",
        "Barangay 840",
        "Barangay 841",
        "Barangay 842",
        "Barangay 843",
        "Barangay 844",
        "Barangay 845",
        "Barangay 846",
        "Barangay 847",
        "Barangay 848",
        "Barangay 849",
        "Barangay 850",
        "Barangay 851",
        "Barangay 852",
        "Barangay 853",
        "Barangay 855",
        "Barangay 856",
        "Barangay 857",
        "Barangay 858",
        "Barangay 859",
        "Barangay 860",
        "Barangay 861",
        "Barangay 862",
        "Barangay 863",
        "Barangay 864",
        "Barangay 865",
        "Barangay 867",
        "Barangay 868",
        "Barangay 869",
        "Barangay 870",
        "Barangay 871",
        "Barangay 872",
        "Barangay 649",
        "Barangay 650",
        "Barangay 651",
        "Barangay 652",
        "Barangay 653",
        "Barangay 306",
        "Barangay 307",
        "Barangay 308",
        "Barangay 309",
        "Barangay 383",
        "Barangay 384",
        "Barangay 385",
        "Barangay 386",
        "Barangay 387",
        "Barangay 388",
        "Barangay 389",
        "Barangay 390",
        "Barangay 391",
        "Barangay 392",
        "Barangay 393",
        "Barangay 394",
        "Barangay 395",
        "Barangay 396",
        "Barangay 397",
        "Barangay 398",
        "Barangay 399",
        "Barangay 400",
        "Barangay 401",
        "Barangay 402",
        "Barangay 403",
        "Barangay 404",
        "Barangay 405",
        "Barangay 406",
        "Barangay 407",
        "Barangay 408",
        "Barangay 409",
        "Barangay 410",
        "Barangay 411",
        "Barangay 412",
        "Barangay 413",
        "Barangay 414",
        "Barangay 415",
        "Barangay 416",
        "Barangay 417",
        "Barangay 418",
        "Barangay 419",
        "Barangay 420",
        "Barangay 421",
        "Barangay 422",
        "Barangay 423",
        "Barangay 424",
        "Barangay 425",
        "Barangay 426",
        "Barangay 427",
        "Barangay 428",
        "Barangay 429",
        "Barangay 430",
        "Barangay 431",
        "Barangay 432",
        "Barangay 433",
        "Barangay 434",
        "Barangay 435",
        "Barangay 436",
        "Barangay 437",
        "Barangay 438",
        "Barangay 439",
        "Barangay 440",
        "Barangay 441",
        "Barangay 442",
        "Barangay 443",
        "Barangay 444",
        "Barangay 445",
        "Barangay 446",
        "Barangay 447",
        "Barangay 448",
        "Barangay 449",
        "Barangay 450",
        "Barangay 451",
        "Barangay 452",
        "Barangay 453",
        "Barangay 454",
        "Barangay 455",
        "Barangay 456",
        "Barangay 457",
        "Barangay 458",
        "Barangay 459",
        "Barangay 460",
        "Barangay 461",
        "Barangay 462",
        "Barangay 463",
        "Barangay 464",
        "Barangay 465",
        "Barangay 466",
        "Barangay 467",
        "Barangay 468",
        "Barangay 469",
        "Barangay 470",
        "Barangay 471",
        "Barangay 472",
        "Barangay 473",
        "Barangay 474",
        "Barangay 475",
        "Barangay 476",
        "Barangay 477",
        "Barangay 478",
        "Barangay 479",
        "Barangay 480",
        "Barangay 481",
        "Barangay 482",
        "Barangay 483",
        "Barangay 484",
        "Barangay 485",
        "Barangay 486",
        "Barangay 487",
        "Barangay 488",
        "Barangay 489",
        "Barangay 490",
        "Barangay 491",
        "Barangay 492",
        "Barangay 493",
        "Barangay 494",
        "Barangay 495",
        "Barangay 496",
        "Barangay 497",
        "Barangay 498",
        "Barangay 499",
        "Barangay 500",
        "Barangay 501",
        "Barangay 502",
        "Barangay 503",
        "Barangay 504",
        "Barangay 505",
        "Barangay 506",
        "Barangay 507",
        "Barangay 508",
        "Barangay 509",
        "Barangay 510",
        "Barangay 511",
        "Barangay 512",
        "Barangay 513",
        "Barangay 514",
        "Barangay 515",
        "Barangay 516",
        "Barangay 517",
        "Barangay 518",
        "Barangay 519",
        "Barangay 520",
        "Barangay 521",
        "Barangay 522",
        "Barangay 523",
        "Barangay 524",
        "Barangay 525",
        "Barangay 526",
        "Barangay 527",
        "Barangay 528",
        "Barangay 529",
        "Barangay 530",
        "Barangay 531",
        "Barangay 532",
        "Barangay 533",
        "Barangay 534",
        "Barangay 535",
        "Barangay 536",
        "Barangay 537",
        "Barangay 538",
        "Barangay 539",
        "Barangay 540",
        "Barangay 541",
        "Barangay 542",
        "Barangay 543",
        "Barangay 544",
        "Barangay 545",
        "Barangay 546",
        "Barangay 547",
        "Barangay 548",
        "Barangay 549",
        "Barangay 550",
        "Barangay 551",
        "Barangay 552",
        "Barangay 553",
        "Barangay 554",
        "Barangay 555",
        "Barangay 556",
        "Barangay 557",
        "Barangay 558",
        "Barangay 559",
        "Barangay 560",
        "Barangay 561",
        "Barangay 562",
        "Barangay 563",
        "Barangay 564",
        "Barangay 565",
        "Barangay 566",
        "Barangay 567",
        "Barangay 568",
        "Barangay 569",
        "Barangay 570",
        "Barangay 571",
        "Barangay 572",
        "Barangay 573",
        "Barangay 574",
        "Barangay 575",
        "Barangay 576",
        "Barangay 577",
        "Barangay 578",
        "Barangay 579",
        "Barangay 580",
        "Barangay 581",
        "Barangay 582",
        "Barangay 583",
        "Barangay 584",
        "Barangay 585",
        "Barangay 586",
        "Barangay 587",
        "Barangay 587-A",
        "Barangay 588",
        "Barangay 589",
        "Barangay 590",
        "Barangay 591",
        "Barangay 592",
        "Barangay 593",
        "Barangay 594",
        "Barangay 595",
        "Barangay 596",
        "Barangay 597",
        "Barangay 598",
        "Barangay 599",
        "Barangay 600",
        "Barangay 601",
        "Barangay 602",
        "Barangay 603",
        "Barangay 604",
        "Barangay 605",
        "Barangay 606",
        "Barangay 607",
        "Barangay 608",
        "Barangay 609",
        "Barangay 610",
        "Barangay 611",
        "Barangay 612",
        "Barangay 613",
        "Barangay 614",
        "Barangay 615",
        "Barangay 616",
        "Barangay 617",
        "Barangay 618",
        "Barangay 619",
        "Barangay 620",
        "Barangay 621",
        "Barangay 622",
        "Barangay 623",
        "Barangay 624",
        "Barangay 625",
        "Barangay 626",
        "Barangay 627",
        "Barangay 628",
        "Barangay 629",
        "Barangay 630",
        "Barangay 631",
        "Barangay 632",
        "Barangay 633",
        "Barangay 634",
        "Barangay 635",
        "Barangay 636",
        "Barangay 637",
        "Barangay 638",
        "Barangay 639",
        "Barangay 640",
        "Barangay 641",
        "Barangay 642",
        "Barangay 643",
        "Barangay 644",
        "Barangay 645",
        "Barangay 646",
        "Barangay 647",
        "Barangay 648",
        "Barangay 268",
        "Barangay 269",
        "Barangay 270",
        "Barangay 271",
        "Barangay 272",
        "Barangay 273",
        "Barangay 274",
        "Barangay 275",
        "Barangay 276",
        "Barangay 281",
        "Barangay 282",
        "Barangay 283",
        "Barangay 284",
        "Barangay 285",
        "Barangay 286",
        "Barangay 745",
        "Barangay 746",
        "Barangay 747",
        "Barangay 748",
        "Barangay 749",
        "Barangay 750",
        "Barangay 751",
        "Barangay 752",
        "Barangay 753",
        "Barangay 754",
        "Barangay 755",
        "Barangay 756",
        "Barangay 757",
        "Barangay 758",
        "Barangay 759",
        "Barangay 760",
        "Barangay 761",
        "Barangay 762",
        "Barangay 763",
        "Barangay 764",
        "Barangay 765",
        "Barangay 766",
        "Barangay 767",
        "Barangay 768",
        "Barangay 769",
        "Barangay 770",
        "Barangay 771",
        "Barangay 772",
        "Barangay 773",
        "Barangay 774",
        "Barangay 775",
        "Barangay 776",
        "Barangay 777",
        "Barangay 778",
        "Barangay 779",
        "Barangay 780",
        "Barangay 781",
        "Barangay 782",
        "Barangay 783",
        "Barangay 784",
        "Barangay 785",
        "Barangay 786",
        "Barangay 787",
        "Barangay 788",
        "Barangay 789",
        "Barangay 790",
        "Barangay 791",
        "Barangay 792",
        "Barangay 793",
        "Barangay 794",
        "Barangay 795",
        "Barangay 796",
        "Barangay 797",
        "Barangay 798",
        "Barangay 799",
        "Barangay 800",
        "Barangay 801",
        "Barangay 802",
        "Barangay 803",
        "Barangay 804",
        "Barangay 805",
        "Barangay 806",
        "Barangay 807",
        "Barangay 808",
        "Barangay 818-A",
        "Barangay 866",
        "Barangay 873",
        "Barangay 874",
        "Barangay 875",
        "Barangay 876",
        "Barangay 877",
        "Barangay 878",
        "Barangay 879",
        "Barangay 880",
        "Barangay 881",
        "Barangay 882",
        "Barangay 883",
        "Barangay 884",
        "Barangay 885",
        "Barangay 886",
        "Barangay 887",
        "Barangay 888",
        "Barangay 889",
        "Barangay 890",
        "Barangay 891",
        "Barangay 892",
        "Barangay 893",
        "Barangay 894",
        "Barangay 895",
        "Barangay 896",
        "Barangay 897",
        "Barangay 898",
        "Barangay 899",
        "Barangay 900",
        "Barangay 901",
        "Barangay 902",
        "Barangay 903",
        "Barangay 904",
        "Barangay 905",
        "Barangay 297",
        "Barangay 298",
        "Barangay 299",
        "Barangay 300",
        "Barangay 301",
        "Barangay 302",
        "Barangay 303",
        "Barangay 304",
        "Barangay 305",
        "Barangay 310",
        "Barangay 311",
        "Barangay 312",
        "Barangay 313",
        "Barangay 314",
        "Barangay 315",
        "Barangay 316",
        "Barangay 317",
        "Barangay 318",
        "Barangay 319",
        "Barangay 320",
        "Barangay 321",
        "Barangay 322",
        "Barangay 323",
        "Barangay 324",
        "Barangay 325",
        "Barangay 326",
        "Barangay 327",
        "Barangay 328",
        "Barangay 329",
        "Barangay 330",
        "Barangay 331",
        "Barangay 332",
        "Barangay 333",
        "Barangay 334",
        "Barangay 335",
        "Barangay 336",
        "Barangay 337",
        "Barangay 338",
        "Barangay 339",
        "Barangay 340",
        "Barangay 341",
        "Barangay 342",
        "Barangay 343",
        "Barangay 344",
        "Barangay 345",
        "Barangay 346",
        "Barangay 347",
        "Barangay 348",
        "Barangay 349",
        "Barangay 350",
        "Barangay 351",
        "Barangay 352",
        "Barangay 353",
        "Barangay 354",
        "Barangay 355",
        "Barangay 356",
        "Barangay 357",
        "Barangay 358",
        "Barangay 359",
        "Barangay 360",
        "Barangay 361",
        "Barangay 362",
        "Barangay 363",
        "Barangay 364",
        "Barangay 365",
        "Barangay 366",
        "Barangay 367",
        "Barangay 368",
        "Barangay 369",
        "Barangay 370",
        "Barangay 371",
        "Barangay 372",
        "Barangay 373",
        "Barangay 374",
        "Barangay 375",
        "Barangay 376",
        "Barangay 377",
        "Barangay 378",
        "Barangay 379",
        "Barangay 380",
        "Barangay 381",
        "Barangay 382",
        "Barangay 1",
        "Barangay 2",
        "Barangay 3",
        "Barangay 4",
        "Barangay 5",
        "Barangay 6",
        "Barangay 7",
        "Barangay 8",
        "Barangay 9",
        "Barangay 10",
        "Barangay 11",
        "Barangay 12",
        "Barangay 13",
        "Barangay 14",
        "Barangay 15",
        "Barangay 16",
        "Barangay 17",
        "Barangay 18",
        "Barangay 19",
        "Barangay 20",
        "Barangay 25",
        "Barangay 26",
        "Barangay 28",
        "Barangay 29",
        "Barangay 30",
        "Barangay 31",
        "Barangay 32",
        "Barangay 33",
        "Barangay 34",
        "Barangay 35",
        "Barangay 36",
        "Barangay 37",
        "Barangay 38",
        "Barangay 39",
        "Barangay 41",
        "Barangay 42",
        "Barangay 43",
        "Barangay 44",
        "Barangay 45",
        "Barangay 46",
        "Barangay 47",
        "Barangay 48",
        "Barangay 49",
        "Barangay 50",
        "Barangay 51",
        "Barangay 52",
        "Barangay 53",
        "Barangay 54",
        "Barangay 55",
        "Barangay 56",
        "Barangay 57",
        "Barangay 58",
        "Barangay 59",
        "Barangay 60",
        "Barangay 61",
        "Barangay 62",
        "Barangay 63",
        "Barangay 64",
        "Barangay 65",
        "Barangay 66",
        "Barangay 67",
        "Barangay 68",
        "Barangay 69",
        "Barangay 70",
        "Barangay 71",
        "Barangay 72",
        "Barangay 73",
        "Barangay 74",
        "Barangay 75",
        "Barangay 76",
        "Barangay 77",
        "Barangay 78",
        "Barangay 79",
        "Barangay 80",
        "Barangay 81",
        "Barangay 82",
        "Barangay 83",
        "Barangay 84",
        "Barangay 85",
        "Barangay 86",
        "Barangay 87",
        "Barangay 88",
        "Barangay 89",
        "Barangay 90",
        "Barangay 91",
        "Barangay 92",
        "Barangay 93",
        "Barangay 94",
        "Barangay 95",
        "Barangay 96",
        "Barangay 97",
        "Barangay 98",
        "Barangay 99",
        "Barangay 100",
        "Barangay 101",
        "Barangay 102",
        "Barangay 103",
        "Barangay 104",
        "Barangay 105",
        "Barangay 106",
        "Barangay 107",
        "Barangay 108",
        "Barangay 109",
        "Barangay 110",
        "Barangay 111",
        "Barangay 112",
        "Barangay 116",
        "Barangay 117",
        "Barangay 118",
        "Barangay 119",
        "Barangay 120",
        "Barangay 121",
        "Barangay 122",
        "Barangay 123",
        "Barangay 124",
        "Barangay 125",
        "Barangay 126",
        "Barangay 127",
        "Barangay 128",
        "Barangay 129",
        "Barangay 130",
        "Barangay 131",
        "Barangay 132",
        "Barangay 133",
        "Barangay 134",
        "Barangay 135",
        "Barangay 136",
        "Barangay 137",
        "Barangay 138",
        "Barangay 139",
        "Barangay 140",
        "Barangay 141",
        "Barangay 142",
        "Barangay 143",
        "Barangay 144",
        "Barangay 145",
        "Barangay 146",
        "Barangay 147",
        "Barangay 148",
        "Barangay 149",
        "Barangay 150",
        "Barangay 151",
        "Barangay 152",
        "Barangay 153",
        "Barangay 154",
        "Barangay 155",
        "Barangay 156",
        "Barangay 157",
        "Barangay 158",
        "Barangay 159",
        "Barangay 160",
        "Barangay 161",
        "Barangay 162",
        "Barangay 163",
        "Barangay 164",
        "Barangay 165",
        "Barangay 166",
        "Barangay 167",
        "Barangay 168",
        "Barangay 169",
        "Barangay 170",
        "Barangay 171",
        "Barangay 172",
        "Barangay 173",
        "Barangay 174",
        "Barangay 175",
        "Barangay 176",
        "Barangay 177",
        "Barangay 178",
        "Barangay 179",
        "Barangay 180",
        "Barangay 181",
        "Barangay 182",
        "Barangay 183",
        "Barangay 184",
        "Barangay 185",
        "Barangay 186",
        "Barangay 187",
        "Barangay 188",
        "Barangay 189",
        "Barangay 190",
        "Barangay 191",
        "Barangay 192",
        "Barangay 193",
        "Barangay 194",
        "Barangay 195",
        "Barangay 196",
        "Barangay 197",
        "Barangay 198",
        "Barangay 199",
        "Barangay 200",
        "Barangay 201",
        "Barangay 202",
        "Barangay 202-A",
        "Barangay 203",
        "Barangay 204",
        "Barangay 205",
        "Barangay 206",
        "Barangay 207",
        "Barangay 208",
        "Barangay 209",
        "Barangay 210",
        "Barangay 211",
        "Barangay 212",
        "Barangay 213",
        "Barangay 214",
        "Barangay 215",
        "Barangay 216",
        "Barangay 217",
        "Barangay 218",
        "Barangay 219",
        "Barangay 220",
        "Barangay 221",
        "Barangay 222",
        "Barangay 223",
        "Barangay 224",
        "Barangay 225",
        "Barangay 226",
        "Barangay 227",
        "Barangay 228",
        "Barangay 229",
        "Barangay 230",
        "Barangay 231",
        "Barangay 232",
        "Barangay 233",
        "Barangay 234",
        "Barangay 235",
        "Barangay 236",
        "Barangay 237",
        "Barangay 238",
        "Barangay 239",
        "Barangay 240",
        "Barangay 241",
        "Barangay 242",
        "Barangay 243",
        "Barangay 244",
        "Barangay 245",
        "Barangay 246",
        "Barangay 247",
        "Barangay 248",
        "Barangay 249",
        "Barangay 250",
        "Barangay 251",
        "Barangay 252",
        "Barangay 253",
        "Barangay 254",
        "Barangay 255",
        "Barangay 256",
        "Barangay 257",
        "Barangay 258",
        "Barangay 259",
        "Barangay 260",
        "Barangay 261",
        "Barangay 262",
        "Barangay 263",
        "Barangay 264",
        "Barangay 265",
        "Barangay 266",
        "Barangay 267",
    ] },
    { province: "Metro Manila", city: "Marikina", barangayList: [
        "Barangka",
        "Calumpang",
        "Concepcion Dos",
        "Concepcion Uno",
        "Fortune",
        "Industrial Valley",
        "Jesus De La Peña",
        "Malanday",
        "Marikina Heights (Concepcion)",
        "Nangka",
        "Parang",
        "San Roque",
        "Santa Elena",
        "Santo Niño",
        "Tañong",
        "Tumana",
    ] },
    { province: "Metro Manila", city: "Muntinlupa", barangayList: [
        "Alabang",
        "Bayanan",
        "Buli",
        "Cupang",
        "New Alabang Village",
        "Poblacion",
        "Putatan",
        "Sucat",
        "Tunasan",
    ] },
    { province: "Metro Manila", city: "Navotas", barangayList: [
        "Bagumbayan North",
        "Bagumbayan South",
        "Bangculasi",
        "Daanghari",
        "Navotas East",
        "Navotas West",
        "North Bay Boulevard North",
        "North Bay Boulevard South (incl. Proper, Kaunlaran, Dagat-dagatan)",
        "San Jose",
        "San Rafael Village",
        "San Roque",
        "Sipac-Almacen",
        "Tangos (incl. Tangos North, Tangos South)",
        "Tanza (incl. Tanza 1, Tanza 2)",

    ] },
    { province: "Metro Manila", city: "Parañaque", barangayList: [
        "Baclaran",
        "B. F. Homes",
        "Don Bosco",
        "Don Galo",
        "La Huerta",
        "Marcelo Green Village",
        "Merville",
        "Moonwalk",
        "San Antonio",
        "San Dionisio",
        "San Isidro",
        "San Martin De Porres",
        "Santo Niño",
        "Sun Valley",
        "Tambo",
        "Vitalez",
    ] },
    { province: "Metro Manila", city: "Pasay", barangayList: [
        "Barangay 1",
        "Barangay 2",
        "Barangay 3",
        "Barangay 4",
        "Barangay 5",
        "Barangay 6",
        "Barangay 7",
        "Barangay 8",
        "Barangay 9",
        "Barangay 10",
        "Barangay 100",
        "Barangay 101",
        "Barangay 102",
        "Barangay 103",
        "Barangay 104",
        "Barangay 105",
        "Barangay 106",
        "Barangay 107",
        "Barangay 108",
        "Barangay 109",
        "Barangay 11",
        "Barangay 110",
        "Barangay 111",
        "Barangay 112",
        "Barangay 113",
        "Barangay 114",
        "Barangay 115",
        "Barangay 116",
        "Barangay 117",
        "Barangay 118",
        "Barangay 119",
        "Barangay 12",
        "Barangay 120",
        "Barangay 121",
        "Barangay 122",
        "Barangay 123",
        "Barangay 124",
        "Barangay 125",
        "Barangay 126",
        "Barangay 127",
        "Barangay 128",
        "Barangay 129",
        "Barangay 13",
        "Barangay 130",
        "Barangay 131",
        "Barangay 132",
        "Barangay 133",
        "Barangay 134",
        "Barangay 135",
        "Barangay 136",
        "Barangay 137",
        "Barangay 138",
        "Barangay 139",
        "Barangay 14",
        "Barangay 140",
        "Barangay 141",
        "Barangay 142",
        "Barangay 143",
        "Barangay 144",
        "Barangay 145",
        "Barangay 146",
        "Barangay 147",
        "Barangay 148",
        "Barangay 149",
        "Barangay 15",
        "Barangay 150",
        "Barangay 151",
        "Barangay 152",
        "Barangay 153",
        "Barangay 154",
        "Barangay 155",
        "Barangay 156",
        "Barangay 157",
        "Barangay 158",
        "Barangay 159",
        "Barangay 16",
        "Barangay 160",
        "Barangay 161",
        "Barangay 162",
        "Barangay 163",
        "Barangay 164",
        "Barangay 165",
        "Barangay 166",
        "Barangay 167",
        "Barangay 168",
        "Barangay 169",
        "Barangay 17",
        "Barangay 170",
        "Barangay 171",
        "Barangay 172",
        "Barangay 173",
        "Barangay 174",
        "Barangay 175",
        "Barangay 176",
        "Barangay 177",
        "Barangay 178",
        "Barangay 179",
        "Barangay 18",
        "Barangay 180",
        "Barangay 181",
        "Barangay 182",
        "Barangay 183",
        "Barangay 184",
        "Barangay 185",
        "Barangay 186",
        "Barangay 187",
        "Barangay 188",
        "Barangay 189",
        "Barangay 19",
        "Barangay 190",
        "Barangay 191",
        "Barangay 192",
        "Barangay 193",
        "Barangay 194",
        "Barangay 195",
        "Barangay 196",
        "Barangay 197",
        "Barangay 198",
        "Barangay 199",
        "Barangay 20",
        "Barangay 200",
        "Barangay 201",
        "Barangay 21",
        "Barangay 22",
        "Barangay 23",
        "Barangay 24",
        "Barangay 25",
        "Barangay 26",
        "Barangay 27",
        "Barangay 28",
        "Barangay 29",
        "Barangay 30",
        "Barangay 31",
        "Barangay 32",
        "Barangay 33",
        "Barangay 34",
        "Barangay 35",
        "Barangay 36",
        "Barangay 37",
        "Barangay 38",
        "Barangay 39",
        "Barangay 40",
        "Barangay 41",
        "Barangay 42",
        "Barangay 43",
        "Barangay 44",
        "Barangay 45",
        "Barangay 46",
        "Barangay 47",
        "Barangay 48",
        "Barangay 49",
        "Barangay 50",
        "Barangay 51",
        "Barangay 52",
        "Barangay 53",
        "Barangay 54",
        "Barangay 55",
        "Barangay 56",
        "Barangay 57",
        "Barangay 58",
        "Barangay 59",
        "Barangay 60",
        "Barangay 61",
        "Barangay 62",
        "Barangay 63",
        "Barangay 64",
        "Barangay 65",
        "Barangay 66",
        "Barangay 67",
        "Barangay 68",
        "Barangay 69",
        "Barangay 70",
        "Barangay 71",
        "Barangay 72",
        "Barangay 73",
        "Barangay 74",
        "Barangay 75",
        "Barangay 76",
        "Barangay 77",
        "Barangay 78",
        "Barangay 79",
        "Barangay 80",
        "Barangay 81",
        "Barangay 82",
        "Barangay 83",
        "Barangay 84",
        "Barangay 85",
        "Barangay 86",
        "Barangay 87",
        "Barangay 88",
        "Barangay 89",
        "Barangay 90",
        "Barangay 91",
        "Barangay 92",
        "Barangay 93",
        "Barangay 94",
        "Barangay 95",
        "Barangay 96",
        "Barangay 97",
        "Barangay 98",
        "Barangay 99",
    ] },
    { province: "Metro Manila", city: "Pasig", barangayList: [
        "Bagong Ilog",
        "Bagong Katipunan",
        "Bambang",
        "Buting",
        "Caniogan",
        "Dela Paz",
        "Kalawaan",
        "Kapasigan",
        "Kapitolyo",
        "Malinao",
        "Manggahan (incl. Napico)",
        "Maybunga",
        "Oranbo",
        "Palatiw",
        "Pinagbuhatan",
        "Pineda",
        "Rosario",
        "Sagad",
        "San Antonio",
        "San Joaquin",
        "San Jose",
        "San Miguel",
        "San Nicolas",
        "Santa Cruz",
        "Santa Lucia",
        "Santa Rosa",
        "Santolan",
        "Santo Tomas",
        "Sumilang",
        "Ugong",
    ] },
    { province: "Metro Manila", city: "Pateros", barangayList: [
        "Aguho",
        "Magtanggol",
        "Martires del 96",
        "Poblacion",
        "San Pedro",
        "San Roque",
        "Santa Ana",
        "Santo Rosario-Kanluran",
        "Santo Rosario-Silangan",
        "Tabacalera",
    ] },
    { province: "Metro Manila", city: "Quezon City", barangayList: [
        "Alicia",
        "Amihan",
        "Apolonio Samson",
        "Aurora",
        "Baesa",
        "Bagbag",
        "Bagong Lipunan Ng Crame",
        "Bagong Pag-asa",
        "Bagong Silangan",
        "Bagumbayan",
        "Bagumbuhay",
        "Bahay Toro",
        "Balingasa",
        "Balong Bato",
        "Batasan Hills",
        "Bayanihan",
        "Blue Ridge A",
        "Blue Ridge B",
        "Botocan",
        "Bungad",
        "Camp Aguinaldo",
        "Capri",
        "Central",
        "Claro",
        "Commonwealth",
        "Culiat",
        "Damar",
        "Damayan",
        "Damayang Lagi",
        "Del Monte",
        "Dioquino Zobel",
        "Doña Imelda",
        "Doña Josefa",
        "Don Manuel",
        "Duyan-Duyan",
        "East Kamias",
        "E. Rodriguez",
        "Escopa I",
        "Escopa II",
        "Escopa III",
        "Escopa IV",
        "Fairview",
        "Greater Lagro",
        "Gulod",
        "Holy Spirit",
        "Horseshoe",
        "Immaculate Concepcion",
        "Kaligayahan",
        "Kalusugan",
        "Kamuning",
        "Katipunan",
        "Kaunlaran",
        "Kristong Hari",
        "Krus Na Ligas",
        "Laging Handa",
        "Libis",
        "Lourdes",
        "Loyola Heights",
        "Maharlika",
        "Malaya",
        "Mangga",
        "Manresa",
        "Mariana",
        "Mariblo",
        "Marilag",
        "Masagana",
        "Masambong",
        "Matandang Balara",
        "Milagrosa",
        "Nagkaisang Nayon",
        "Nayong Kanluran",
        "New Era (Constitution Hills)",
        "North Fairview",
        "Novaliches Proper",
        "N. S. Amoranto (Gintong Silahis)",
        "Obrero",
        "Old Capitol Site",
        "Paang Bundok",
        "Pag-ibig Sa Nayon",
        "Paligsahan",
        "Paltok",
        "Pansol",
        "Paraiso",
        "Pasong Putik Proper (Pasong Putik)",
        "Pasong Tamo",
        "Payatas",
        "Phil-Am",
        "Pinagkaisahan",
        "Pinyahan",
        "Project 6",
        "Quirino 2-A",
        "Quirino 2-B",
        "Quirino 2-C",
        "Quirino 3-A",
        "Ramon Magsaysay",
        "Roxas",
        "Sacred Heart",
        "Saint Ignatius",
        "Saint Peter",
        "Salvacion",
        "San Agustin",
        "San Antonio",
        "San Bartolome",
        "Sangandaan",
        "San Isidro",
        "San Isidro Labrador",
        "San Jose",
        "San Martin De Porres",
        "San Roque",
        "Santa Cruz",
        "Santa Lucia",
        "Santa Monica",
        "Santa Teresita",
        "Santo Cristo",
        "Santo Domingo (Matalahib)",
        "Santol",
        "Santo Niño",
        "San Vicente",
        "Sauyo",
        "Sienna",
        "Sikatuna Village",
        "Silangan",
        "Socorro",
        "South Triangle",
        "Tagumpay",
        "Talayan",
        "Talipapa",
        "Tandang Sora",
        "Tatalon",
        "Teachers Village East",
        "Teachers Village West",
        "Ugong Norte",
        "Unang Sigaw",
        "U.P. Campus",
        "U.P. Village",
        "Valencia",
        "Vasra",
        "Veterans Village",
        "Villa Maria Clara",
        "West Kamias",
        "West Triangle",
        "White Plains",
    ] },
    { province: "Metro Manila", city: "San Juan", barangayList: [
        "Addition Hills",
        "Balong–Bato",
        "Batis",
        "Corazón de Jesús",
        "Ermitaño",
        "Greenhills",
        "Isabelita",
        "Kabayanan",
        "Little Baguio",
        "Maytunas",
        "Onse",
        "Pasadeña",
        "Pedro Cruz",
        "Progreso",
        "Rivera",
        "Saint Joseph (Halo-Halo)",
        "Salapán",
        "San Perfecto",
        "Santa Lucia",
        "Tibagan",
        "West Crame",
    ] },
    { province: "Metro Manila", city: "Taguig", barangayList: [
        "Bagumbayan",
        "Bambang",
        "Calzada",
        "Central Bicutan",
        "Central Signal Village (Signal Village)",
        "Fort Bonifacio",
        "Hagonoy",
        "Ibayo-Tipas",
        "Katuparan",
        "Ligid-Tipas",
        "Lower Bicutan",
        "Maharlika Village",
        "Napindan",
        "New Lower Bicutan",
        "North Daang Hari",
        "North Signal Village",
        "Palingon",
        "Pinagsama",
        "San Miguel",
        "Santa Ana",
        "South Daang Hari",
        "South Signal Village",
        "Tanyag (Bagong Tanyag)",
        "Tuktukan",
        "Upper Bicutan",
        "Ususan",
        "Wawa",
        "Western Bicutan",
    ] },
    { province: "Metro Manila", city: "Valenzuela", barangayList: [
        "Arkong Bato",
        "Bagbaguin",
        "Balangkas",
        "Bignay",
        "Bisig",
        "Canumay East",
        "Canumay West",
        "Coloong",
        "Dalandanan",
        "Hen. T. De Leon",
        "Isla",
        "Karuhatan",
        "Lawang Bato",
        "Lingunan",
        "Mabolo",
        "Malanday",
        "Malinta",
        "Mapulang Lupa",
        "Marulas",
        "Maysan",
        "Palasan",
        "Parada",
        "Pariancillo Villa",
        "Paso De Blas",
        "Pasolo",
        "Poblacion",
        "Pulo",
        "Punturin",
        "Rincon",
        "Tagalag",
        "Ugong",
        "Viente Reales",
        "Wawang Pulo",
    ] },
];